export const diseaseCatalog = [
  // Infectious and Parasitic Diseases (A00-B99)
  { type: "DISEASE", disorder: "Infectious Gastroenteritis, Unspecified", ICD10: "A09" },
  { type: "DISEASE", disorder: "Typhoid Fever", ICD10: "A01.0" },
  { type: "DISEASE", disorder: "Tuberculosis of Lung", ICD10: "A15.0" },
  { type: "DISEASE", disorder: "Septicemia (Sepsis)", ICD10: "A41.9" },
  { type: "DISEASE", disorder: "Herpes Simplex Infection, Unspecified", ICD10: "B00.9" },
  { type: "DISEASE", disorder: "Varicella (Chickenpox) without complication", ICD10: "B01.9" },
  { type: "DISEASE", disorder: "Zoster (Shingles) without complication", ICD10: "B02.9" },
  { type: "DISEASE", disorder: "Viral Hepatitis B, Chronic", ICD10: "B18.1" },
  { type: "DISEASE", disorder: "Viral Hepatitis C, Chronic", ICD10: "B18.2" },
  { type: "DISEASE", disorder: "HIV Disease, Unspecified", ICD10: "B20" },
  { type: "DISEASE", disorder: "Infectious Mononucleosis", ICD10: "B27.9" },
  { type: "DISEASE", disorder: "Dermatophytosis (Tinea) of Body", ICD10: "B35.4" },
  { type: "DISEASE", disorder: "Candidiasis of Vulva and Vagina", ICD10: "B37.3" },
  { type: "DISEASE", disorder: "Echinococcosis, Unspecified", ICD10: "B67.9" },

  // Neoplasms (C00-D49)
  { type: "DISEASE", disorder: "Malignant Neoplasm of Breast", ICD10: "C50.9" },
  { type: "DISEASE", disorder: "Malignant Neoplasm of Bronchus and Lung", ICD10: "C34.9" },
  { type: "DISEASE", disorder: "Malignant Neoplasm of Colon", ICD10: "C18.9" },
  { type: "DISEASE", disorder: "Malignant Neoplasm of Prostate", ICD10: "C61" },
  { type: "DISEASE", disorder: "Malignant Neoplasm of Stomach", ICD10: "C16.9" },
  { type: "DISEASE", disorder: "Basal Cell Carcinoma of Skin", ICD10: "C44.91" },
  { type: "DISEASE", disorder: "Squamous Cell Carcinoma of Skin", ICD10: "C44.92" },
  { type: "DISEASE", disorder: "Malignant Melanoma of Skin", ICD10: "C43.9" },
  { type: "DISEASE", disorder: "Lipoma (Benign Lipomatous Neoplasm)", ICD10: "D17.9" },
  { type: "DISEASE", disorder: "Uterine Leiomyoma (Fibroids)", ICD10: "D25.9" },

  // Blood and Immune Diseases (D50-D89)
  { type: "DISEASE", disorder: "Iron Deficiency Anemia", ICD10: "D50.9" },
  { type: "DISEASE", disorder: "Vitamin B12 Deficiency Anemia", ICD10: "D51.9" },
  { type: "DISEASE", disorder: "Folate Deficiency Anemia", ICD10: "D52.9" },
  { type: "DISEASE", disorder: "Thalassemia, Unspecified", ICD10: "D56.9" },
  { type: "DISEASE", disorder: "Sickle-Cell Anemia without crisis", ICD10: "D57.1" },
  { type: "DISEASE", disorder: "Purpura and Coagulation Defects", ICD10: "D69.9" },
  { type: "DISEASE", disorder: "Sarcoidosis, Unspecified", ICD10: "D86.9" },

  // Endocrine, Nutritional and Metabolic Diseases (E00-E89)
  { type: "DISEASE", disorder: "Hypothyroidism, Unspecified", ICD10: "E03.9" },
  { type: "DISEASE", disorder: "Hyperthyroidism (Thyrotoxicosis)", ICD10: "E05.9" },
  { type: "DISEASE", disorder: "Type 1 Diabetes Mellitus", ICD10: "E10.9" },
  { type: "DISEASE", disorder: "Type 2 Diabetes Mellitus", ICD10: "E11.9" },
  { type: "DISEASE", disorder: "Hypoglycemia, Unspecified", ICD10: "E16.2" },
  { type: "DISEASE", disorder: "Hyperparathyroidism, Unspecified", ICD10: "E21.3" },
  { type: "DISEASE", disorder: "Cushing's Syndrome, Unspecified", ICD10: "E24.9" },
  { type: "DISEASE", disorder: "Polycystic Ovarian Syndrome (PCOS)", ICD10: "E28.2" },
  { type: "DISEASE", disorder: "Vitamin D Deficiency", ICD10: "E55.9" },
  { type: "DISEASE", disorder: "Obesity, Unspecified", ICD10: "E66.9" },
  { type: "DISEASE", disorder: "Hyperlipidemia, Unspecified", ICD10: "E78.5" },
  { type: "DISEASE", disorder: "Hypercholesterolemia, Pure", ICD10: "E78.0" },
  { type: "DISEASE", disorder: "Hypertriglyceridemia, Pure", ICD10: "E78.1" },
  { type: "DISEASE", disorder: "Metabolic Syndrome", ICD10: "E88.81" },
  { type: "DISEASE", disorder: "Gout, Unspecified", ICD10: "M10.9" },

  // Mental and Behavioral Disorders (F01-F99)
  { type: "DISEASE", disorder: "Dementia in Alzheimer's Disease", ICD10: "F03.90" },
  { type: "DISEASE", disorder: "Alcohol Dependence Syndrome", ICD10: "F10.2" },
  { type: "DISEASE", disorder: "Schizophrenia, Unspecified", ICD10: "F20.9" },
  { type: "DISEASE", disorder: "Bipolar Affective Disorder", ICD10: "F31.9" },
  { type: "DISEASE", disorder: "Major Depressive Disorder", ICD10: "F32.9" },
  { type: "DISEASE", disorder: "Generalized Anxiety Disorder", ICD10: "F41.1" },
  { type: "DISEASE", disorder: "Panic Disorder without Agoraphobia", ICD10: "F41.0" },
  { type: "DISEASE", disorder: "Obsessive-Compulsive Disorder", ICD10: "F42.9" },
  { type: "DISEASE", disorder: "Post-Traumatic Stress Disorder (PTSD)", ICD10: "F43.1" },
  { type: "DISEASE", disorder: "Somatoform Disorder, Unspecified", ICD10: "F45.9" },
  { type: "DISEASE", disorder: "Anorexia Nervosa", ICD10: "F50.0" },
  { type: "DISEASE", disorder: "Insomnia, Non-organic", ICD10: "F51.0" },

  // Nervous System Diseases (G00-G99)
  { type: "DISEASE", disorder: "Bacterial Meningitis", ICD10: "G00.9" },
  { type: "DISEASE", disorder: "Parkinson's Disease", ICD10: "G20" },
  { type: "DISEASE", disorder: "Alzheimer's Disease, Unspecified", ICD10: "G30.9" },
  { type: "DISEASE", disorder: "Multiple Sclerosis", ICD10: "G35" },
  { type: "DISEASE", disorder: "Epilepsy, Unspecified", ICD10: "G40.9" },
  { type: "DISEASE", disorder: "Migraine, Unspecified", ICD10: "G43.9" },
  { type: "DISEASE", disorder: "Cluster Headache Syndrome", ICD10: "G44.0" },
  { type: "DISEASE", disorder: "Tension-type Headache", ICD10: "G44.2" },
  { type: "DISEASE", disorder: "Transient Ischemic Attack (TIA)", ICD10: "G45.9" },
  { type: "DISEASE", disorder: "Sleep Apnea, Central", ICD10: "G47.31" },
  { type: "DISEASE", disorder: "Sleep Apnea, Obstructive", ICD10: "G47.33" },
  { type: "DISEASE", disorder: "Trigeminal Neuralgia", ICD10: "G50.0" },
  { type: "DISEASE", disorder: "Bell's Palsy (Facial Nerve)", ICD10: "G51.0" },
  { type: "DISEASE", disorder: "Carpal Tunnel Syndrome", ICD10: "G56.0" },
  { type: "DISEASE", disorder: "Polyneuropathy, Unspecified", ICD10: "G62.9" },

  // Eye and Adnexa Diseases (H00-H59)
  { type: "DISEASE", disorder: "Hordeolum (Stye)", ICD10: "H00.0" },
  { type: "DISEASE", disorder: "Blepharitis, Unspecified", ICD10: "H01.0" },
  { type: "DISEASE", disorder: "Conjunctivitis, Acute Atopic", ICD10: "H10.1" },
  { type: "DISEASE", disorder: "Conjunctivitis, Mucopurulent", ICD10: "H10.0" },
  { type: "DISEASE", disorder: "Pterygium of Eye", ICD10: "H11.0" },
  { type: "DISEASE", disorder: "Corneal Ulcer", ICD10: "H16.0" },
  { type: "DISEASE", disorder: "Cataract, Unspecified", ICD10: "H26.9" },
  { type: "DISEASE", disorder: "Retinal Detachment", ICD10: "H33.2" },
  { type: "DISEASE", disorder: "Macular Degeneration, Age-related", ICD10: "H35.3" },
  { type: "DISEASE", disorder: "Diabetic Retinopathy", ICD10: "H36.0" },
  { type: "DISEASE", disorder: "Glaucoma, Primary Open-angle", ICD10: "H40.1" },
  { type: "DISEASE", disorder: "Glaucoma, Acute Angle-closure", ICD10: "H40.2" },
  { type: "DISEASE", disorder: "Myopia (Nearsightedness)", ICD10: "H52.1" },
  { type: "DISEASE", disorder: "Hypermetropia (Farsightedness)", ICD10: "H52.0" },
  { type: "DISEASE", disorder: "Astigmatism", ICD10: "H52.2" },

  // Ear and Mastoid Diseases (H60-H95)
  { type: "DISEASE", disorder: "Otitis Externa, Unspecified", ICD10: "H60.9" },
  { type: "DISEASE", disorder: "Otitis Media, Acute Suppurative", ICD10: "H66.0" },
  { type: "DISEASE", disorder: "Otitis Media, Serous", ICD10: "H65.9" },
  { type: "DISEASE", disorder: "Impacted Cerumen (Earwax)", ICD10: "H61.2" },
  { type: "DISEASE", disorder: "Perforation of Tympanic Membrane", ICD10: "H72.9" },
  { type: "DISEASE", disorder: "Vertigo, Benign Paroxysmal Positional", ICD10: "H81.1" },
  { type: "DISEASE", disorder: "Meniere's Disease", ICD10: "H81.0" },
  { type: "DISEASE", disorder: "Tinnitus, Unspecified", ICD10: "H93.1" },
  { type: "DISEASE", disorder: "Hearing Loss, Sensorineural", ICD10: "H90.3" },
  { type: "DISEASE", disorder: "Hearing Loss, Conductive", ICD10: "H90.0" },

  // Cardiovascular System Diseases (I00-I99)
  { type: "DISEASE", disorder: "Essential (Primary) Hypertension", ICD10: "I10" },
  { type: "DISEASE", disorder: "Hypertensive Heart Disease", ICD10: "I11.9" },
  { type: "DISEASE", disorder: "Angina Pectoris, Unspecified", ICD10: "I20.9" },
  { type: "DISEASE", disorder: "Acute Myocardial Infarction", ICD10: "I21.9" },
  { type: "DISEASE", disorder: "Coronary Artery Disease (CAD)", ICD10: "I25.1" },
  { type: "DISEASE", disorder: "Pulmonary Embolism", ICD10: "I26.9" },
  { type: "DISEASE", disorder: "Atrial Fibrillation and Flutter", ICD10: "I48.9" },
  { type: "DISEASE", disorder: "Supraventricular Tachycardia (SVT)", ICD10: "I47.1" },
  { type: "DISEASE", disorder: "Heart Failure, Congestive", ICD10: "I50.9" },
  { type: "DISEASE", disorder: "Cerebral Infarction (Stroke)", ICD10: "I63.9" },
  { type: "DISEASE", disorder: "Atherosclerosis of Aorta", ICD10: "I70.0" },
  { type: "DISEASE", disorder: "Peripheral Vascular Disease (PVD)", ICD10: "I73.9" },
  { type: "DISEASE", disorder: "Deep Vein Thrombosis (DVT)", ICD10: "I82.4" },
  { type: "DISEASE", disorder: "Varicose Veins of Lower Extremities", ICD10: "I83.9" },
  { type: "DISEASE", disorder: "Hemorrhoids, Unspecified", ICD10: "I84.9" },
  { type: "DISEASE", disorder: "Hypotension, Idiopathic", ICD10: "I95.0" },

  // Respiratory System Diseases (J00-J99)
  { type: "DISEASE", disorder: "Acute Nasopharyngitis (Common Cold)", ICD10: "J00" },
  { type: "DISEASE", disorder: "Acute Sinusitis, Unspecified", ICD10: "J01.9" },
  { type: "DISEASE", disorder: "Acute Pharyngitis, Unspecified", ICD10: "J02.9" },
  { type: "DISEASE", disorder: "Acute Tonsillitis, Unspecified", ICD10: "J03.9" },
  { type: "DISEASE", disorder: "Acute Laryngitis", ICD10: "J04.0" },
  { type: "DISEASE", disorder: "Acute Obstructive Laryngitis (Croup)", ICD10: "J05.0" },
  { type: "DISEASE", disorder: "Influenza due to unidentified virus", ICD10: "J11" },
  { type: "DISEASE", disorder: "Pneumonia, Unspecified", ICD10: "J18.9" },
  { type: "DISEASE", disorder: "Acute Bronchitis, Unspecified", ICD10: "J20.9" },
  { type: "DISEASE", disorder: "Chronic Sinusitis, Unspecified", ICD10: "J32.9" },
  { type: "DISEASE", disorder: "Allergic Rhinitis, Unspecified", ICD10: "J30.9" },
  { type: "DISEASE", disorder: "Nasal Polyp, Unspecified", ICD10: "J33.9" },
  { type: "DISEASE", disorder: "Deviated Nasal Septum", ICD10: "J34.2" },
  { type: "DISEASE", disorder: "Chronic Obstructive Pulmonary Disease (COPD)", ICD10: "J44.9" },
  { type: "DISEASE", disorder: "Asthma, Unspecified", ICD10: "J45.9" },
  { type: "DISEASE", disorder: "Bronchiectasis", ICD10: "J47.9" },
  { type: "DISEASE", disorder: "Pneumothorax, Unspecified", ICD10: "J93.9" },
  { type: "DISEASE", disorder: "Pleural Effusion, Unspecified", ICD10: "J90" },

  // Gastrointestinal System Diseases (K00-K93)
  { type: "DISEASE", disorder: "Stomatitis and related lesions", ICD10: "K12.1" },
  { type: "DISEASE", disorder: "Gastro-Esophageal Reflux Disease (GERD)", ICD10: "K21.9" },
  { type: "DISEASE", disorder: "Gastric Ulcer, Unspecified", ICD10: "K25.9" },
  { type: "DISEASE", disorder: "Duodenal Ulcer, Unspecified", ICD10: "K26.9" },
  { type: "DISEASE", disorder: "Gastritis, Unspecified", ICD10: "K29.7" },
  { type: "DISEASE", disorder: "Dyspepsia (Indigestion)", ICD10: "K30" },
  { type: "DISEASE", disorder: "Acute Appendicitis", ICD10: "K35.8" },
  { type: "DISEASE", disorder: "Inguinal Hernia, Unspecified", ICD10: "K40.9" },
  { type: "DISEASE", disorder: "Umbilical Hernia", ICD10: "K42.9" },
  { type: "DISEASE", disorder: "Crohn's Disease, Unspecified", ICD10: "K50.9" },
  { type: "DISEASE", disorder: "Ulcerative Colitis, Unspecified", ICD10: "K51.9" },
  { type: "DISEASE", disorder: "Irritable Bowel Syndrome (IBS)", ICD10: "K58.9" },
  { type: "DISEASE", disorder: "Constipation, Unspecified", ICD10: "K59.0" },
  { type: "DISEASE", disorder: "Anal Fissure, Acute", ICD10: "K60.0" },
  { type: "DISEASE", disorder: "Anal Fistula", ICD10: "K60.3" },
  { type: "DISEASE", disorder: "Diverticulitis of Colon", ICD10: "K57.9" },
  { type: "DISEASE", disorder: "Alcoholic Liver Disease", ICD10: "K70.9" },
  { type: "DISEASE", disorder: "Fatty Liver (Non-alcoholic)", ICD10: "K76.0" },
  { type: "DISEASE", disorder: "Cirrhosis of Liver, Unspecified", ICD10: "K74.6" },
  { type: "DISEASE", disorder: "Cholelithiasis (Gallstones)", ICD10: "K80.8" },
  { type: "DISEASE", disorder: "Acute Cholecystitis", ICD10: "K81.0" },
  { type: "DISEASE", disorder: "Acute Pancreatitis", ICD10: "K85.9" },

  // Skin and Subcutaneous Tissue Diseases (L00-L99)
  { type: "DISEASE", disorder: "Impetigo", ICD10: "L01.0" },
  { type: "DISEASE", disorder: "Cellulitis, Unspecified", ICD10: "L03.9" },
  { type: "DISEASE", disorder: "Abscess of Skin, Unspecified", ICD10: "L02.9" },
  { type: "DISEASE", disorder: "Pemphigus Vulgaris", ICD10: "L10.0" },
  { type: "DISEASE", disorder: "Atopic Dermatitis (Eczema)", ICD10: "L20.9" },
  { type: "DISEASE", disorder: "Seborrheic Dermatitis", ICD10: "L21.9" },
  { type: "DISEASE", disorder: "Diaper Dermatitis", ICD10: "L22" },
  { type: "DISEASE", disorder: "Allergic Contact Dermatitis", ICD10: "L23.9" },
  { type: "DISEASE", disorder: "Psoriasis Vulgaris", ICD10: "L40.0" },
  { type: "DISEASE", disorder: "Pityriasis Rosea", ICD10: "L42" },
  { type: "DISEASE", disorder: "Lichen Planus", ICD10: "L43.9" },
  { type: "DISEASE", disorder: "Urticaria (Hives), Unspecified", ICD10: "L50.9" },
  { type: "DISEASE", disorder: "Sunburn", ICD10: "L55.9" },
  { type: "DISEASE", disorder: "Acne Vulgaris", ICD10: "L70.0" },
  { type: "DISEASE", disorder: "Rosacea, Unspecified", ICD10: "L71.9" },
  { type: "DISEASE", disorder: "Alopecia Areata", ICD10: "L63.9" },
  { type: "DISEASE", disorder: "Ingrowing Nail", ICD10: "L60.0" },
  { type: "DISEASE", disorder: "Vitiligo", ICD10: "L80" },
  { type: "DISEASE", disorder: "Seborrheic Keratolysis", ICD10: "L82.9" },
  { type: "DISEASE", disorder: "Melasma", ICD10: "L81.1" },

  // Musculoskeletal and Connective Tissue Diseases (M00-M99)
  { type: "DISEASE", disorder: "Rheumatoid Arthritis, Unspecified", ICD10: "M06.9" },
  { type: "DISEASE", disorder: "Osteoarthritis of Knee", ICD10: "M17.9" },
  { type: "DISEASE", disorder: "Osteoarthritis of Hip", ICD10: "M16.9" },
  { type: "DISEASE", disorder: "Systemic Lupus Erythematosus (SLE)", ICD10: "M32.9" },
  { type: "DISEASE", disorder: "Ankylosing Spondylitis", ICD10: "M45.9" },
  { type: "DISEASE", disorder: "Spondylosis, Unspecified", ICD10: "M47.9" },
  { type: "DISEASE", disorder: "Cervical Disc Disorder", ICD10: "M50.9" },
  { type: "DISEASE", disorder: "Lumbar Disc Disorder (Sciatica)", ICD10: "M51.1" },
  { type: "DISEASE", disorder: "Low Back Pain", ICD10: "M54.5" },
  { type: "DISEASE", disorder: "Fibromyalgia", ICD10: "M79.7" },
  { type: "DISEASE", disorder: "Shoulder Impingement Syndrome", ICD10: "M75.4" },
  { type: "DISEASE", disorder: "Plantar Fasciitis", ICD10: "M72.2" },
  { type: "DISEASE", disorder: "Osteoporosis without fracture", ICD10: "M81.0" },

  // Genitourinary System Diseases (N00-N99)
  { type: "DISEASE", disorder: "Nephrotic Syndrome, Unspecified", ICD10: "N04.9" },
  { type: "DISEASE", disorder: "Chronic Kidney Disease (CKD), Stage 3", ICD10: "N18.3" },
  { type: "DISEASE", disorder: "Chronic Kidney Disease (CKD), Unspecified", ICD10: "N18.9" },
  { type: "DISEASE", disorder: "Calculus of Kidney (Stone)", ICD10: "N20.0" },
  { type: "DISEASE", disorder: "Calculus of Ureter", ICD10: "N20.1" },
  { type: "DISEASE", disorder: "Cystitis, Acute", ICD10: "N30.0" },
  { type: "DISEASE", disorder: "Urinary Tract Infection (UTI), Unspecified", ICD10: "N39.0" },
  { type: "DISEASE", disorder: "Benign Prostatic Hyperplasia (BPH)", ICD10: "N40.0" },
  { type: "DISEASE", disorder: "Prostatitis, Acute", ICD10: "N41.0" },
  { type: "DISEASE", disorder: "Hydrocele, Unspecified", ICD10: "N43.3" },
  { type: "DISEASE", disorder: "Endometriosis, Unspecified", ICD10: "N80.9" },
  { type: "DISEASE", disorder: "Ovarian Cyst, Unspecified", ICD10: "N83.2" },
  { type: "DISEASE", disorder: "Pelvic Inflammatory Disease (PID)", ICD10: "N73.9" },
  { type: "DISEASE", disorder: "Dysmenorrhea, Unspecified", ICD10: "N94.6" },
  { type: "DISEASE", disorder: "Menopausal States", ICD10: "N95.1" },

  // Factors influencing health status (Z00-Z99)
  { type: "DISEASE", disorder: "General Medical Examination", ICD10: "Z00.0" },
  { type: "DISEASE", disorder: "Encounter for Vaccination", ICD10: "Z23" },
  { type: "DISEASE", disorder: "Pregnancy, Confirmed", ICD10: "Z32.01" },
  { type: "DISEASE", disorder: "Antenatal Care, Normal Pregnancy", ICD10: "Z34.9" },
  { type: "DISEASE", disorder: "Surgical Aftercare", ICD10: "Z48.9" },
  { type: "DISEASE", disorder: "Family History of Malignant Neoplasm", ICD10: "Z80.9" },
  { type: "DISEASE", disorder: "Long-term (current) use of anticoagulants", ICD10: "Z79.01" },
  { type: "DISEASE", disorder: "Long-term (current) use of insulin", ICD10: "Z79.4" },

  // --- ADDITIONAL EXTENSIVE DISEASE DIRECTORY (TRUSTED RESOURCES) ---

  // Cardiology & Vascular
  { type: "DISEASE", disorder: "Mitral Valve Prolapse", ICD10: "I34.1" },
  { type: "DISEASE", disorder: "Aortic Stenosis", ICD10: "I35.0" },
  { type: "DISEASE", disorder: "Aortic Insufficiency", ICD10: "I35.1" },
  { type: "DISEASE", disorder: "Left Bundle Branch Block", ICD10: "I44.7" },
  { type: "DISEASE", disorder: "Right Bundle Branch Block", ICD10: "I45.10" },
  { type: "DISEASE", disorder: "First Degree AV Block", ICD10: "I44.0" },
  { type: "DISEASE", disorder: "Premature Ventricular Contractions (PVCs)", ICD10: "I49.3" },
  { type: "DISEASE", disorder: "Premature Atrial Contractions (PACs)", ICD10: "I49.1" },
  { type: "DISEASE", disorder: "Orthostatic Hypotension", ICD10: "I95.1" },
  { type: "DISEASE", disorder: "Raynaud's Syndrome", ICD10: "I73.00" },
  { type: "DISEASE", disorder: "Cardiomyopathy, Unspecified", ICD10: "I42.9" },
  { type: "DISEASE", disorder: "Pericarditis, Acute", ICD10: "I30.9" },

  // Pulmonology
  { type: "DISEASE", disorder: "Sarcoidosis of Lungs", ICD10: "D86.0" },
  { type: "DISEASE", disorder: "Interstitial Pulmonary Disease", ICD10: "J84.9" },
  { type: "DISEASE", disorder: "Pleural Effusion (non-inflammatory)", ICD10: "J90" },
  { type: "DISEASE", disorder: "Chronic Bronchitis, Simple", ICD10: "J41.0" },
  { type: "DISEASE", disorder: "Emphysema, Unspecified", ICD10: "J43.9" },
  { type: "DISEASE", disorder: "Hypoxemia", ICD10: "R09.02" },
  { type: "DISEASE", disorder: "Hypercapnia", ICD10: "R06.4" },
  { type: "DISEASE", disorder: "Pleurisy without effusion", ICD10: "R09.1" },

  // Gastroenterology
  { type: "DISEASE", disorder: "Esophageal Varices", ICD10: "I85.0" },
  { type: "DISEASE", disorder: "Barrett's Esophagus", ICD10: "K22.70" },
  { type: "DISEASE", disorder: "Achalasia of Cardia", ICD10: "K22.0" },
  { type: "DISEASE", disorder: "Mallory-Weiss Syndrome", ICD10: "K22.6" },
  { type: "DISEASE", disorder: "Celiac Disease", ICD10: "K90.0" },
  { type: "DISEASE", disorder: "Malabsorption, Unspecified", ICD10: "K90.9" },
  { type: "DISEASE", disorder: "Chronic Gastritis", ICD10: "K29.50" },
  { type: "DISEASE", disorder: "Duodenitis, Unspecified", ICD10: "K29.80" },
  { type: "DISEASE", disorder: "Proctitis, Unspecified", ICD10: "K62.89" },
  { type: "DISEASE", disorder: "Functional Dyspepsia", ICD10: "K30" },
  { type: "DISEASE", disorder: "Gallbladder Polyp", ICD10: "K82.4" },
  { type: "DISEASE", disorder: "Chronic Pancreatitis", ICD10: "K86.1" },

  // Endocrinology & Metabolic
  { type: "DISEASE", disorder: "Hashimoto's Thyroiditis", ICD10: "E06.3" },
  { type: "DISEASE", disorder: "Graves' Disease", ICD10: "E05.00" },
  { type: "DISEASE", disorder: "Thyroid Nodule, Toxic", ICD10: "E05.10" },
  { type: "DISEASE", disorder: "Thyroid Cyst", ICD10: "E04.1" },
  { type: "DISEASE", disorder: "Addison's Disease (Adrenal Insufficiency)", ICD10: "E27.1" },
  { type: "DISEASE", disorder: "Hyperprolactinemia", ICD10: "E22.1" },
  { type: "DISEASE", disorder: "Diabetes Insipidus", ICD10: "E23.2" },
  { type: "DISEASE", disorder: "Hypopituitarism", ICD10: "E23.0" },
  { type: "DISEASE", disorder: "Vitamin B1 Deficiency (Beriberi)", ICD10: "E51.1" },
  { type: "DISEASE", disorder: "Vitamin C Deficiency (Scurvy)", ICD10: "E54" },
  { type: "DISEASE", disorder: "Magnesium Deficiency", ICD10: "E61.2" },
  { type: "DISEASE", disorder: "Zinc Deficiency", ICD10: "E61.8" },
  { type: "DISEASE", disorder: "Iron Overload (Hemochromatosis)", ICD10: "E83.110" },
  { type: "DISEASE", disorder: "Hypercalcemia", ICD10: "E83.52" },
  { type: "DISEASE", disorder: "Hypocalcemia", ICD10: "E83.51" },
  { type: "DISEASE", disorder: "Hyperkalemia", ICD10: "E87.5" },
  { type: "DISEASE", disorder: "Hypokalemia", ICD10: "E87.6" },
  { type: "DISEASE", disorder: "Hyponatremia", ICD10: "E87.1" },

  // Neurology
  { type: "DISEASE", disorder: "Vascular Dementia", ICD10: "F01.50" },
  { type: "DISEASE", disorder: "Lewy Body Dementia", ICD10: "G31.83" },
  { type: "DISEASE", disorder: "Huntington's Disease", ICD10: "G10" },
  { type: "DISEASE", disorder: "Amyotrophic Lateral Sclerosis (ALS)", ICD10: "G12.21" },
  { type: "DISEASE", disorder: "Myasthenia Gravis", ICD10: "G70.00" },
  { type: "DISEASE", disorder: "Guillain-Barre Syndrome", ICD10: "G61.0" },
  { type: "DISEASE", disorder: "Normal Pressure Hydrocephalus", ICD10: "G91.2" },
  { type: "DISEASE", disorder: "Narcolepsy", ICD10: "G47.419" },
  { type: "DISEASE", disorder: "Restless Legs Syndrome", ICD10: "G25.81" },
  { type: "DISEASE", disorder: "Essential Tremor", ICD10: "G25.0" },
  { type: "DISEASE", disorder: "Peripheral Neuropathy, Diabetic", ICD10: "E11.40" },
  { type: "DISEASE", disorder: "Post-herpetic Neuralgia", ICD10: "B02.22" },

  // Dermatology (Specific)
  { type: "DISEASE", disorder: "Basal Cell Carcinoma, Nodular", ICD10: "C44.91" },
  { type: "DISEASE", disorder: "Actinic Keratosis", ICD10: "L57.0" },
  { type: "DISEASE", disorder: "Dysplastic Nevus", ICD10: "D22.9" },
  { type: "DISEASE", disorder: "Seborrheic Keratosis", ICD10: "L82.1" },
  { type: "DISEASE", disorder: "Keloid Scar", ICD10: "L91.0" },
  { type: "DISEASE", disorder: "Hypertrophic Scar", ICD10: "L91.0" },
  { type: "DISEASE", disorder: "Miloa (Whiteheads)", ICD10: "L72.0" },
  { type: "DISEASE", disorder: "Keratosis Pilaris", ICD10: "L85.8" },
  { type: "DISEASE", disorder: "Dishidrotic Eczema (Pompholyx)", ICD10: "L30.1" },
  { type: "DISEASE", disorder: "Nummular Dermatitis", ICD10: "L30.0" },
  { type: "DISEASE", disorder: "Stasis Dermatitis", ICD10: "I83.10" },
  { type: "DISEASE", disorder: "Lichen Simplex Chronicus", ICD10: "L28.0" },
  { type: "DISEASE", disorder: "Granuloma Annulare", ICD10: "L92.0" },
  { type: "DISEASE", disorder: "Pyogenic Granuloma", ICD10: "L98.0" },
  { type: "DISEASE", disorder: "Tinea Versicolor", ICD10: "B36.0" },
  { type: "DISEASE", disorder: "Onychomycosis (Nail Fungus)", ICD10: "B35.1" },
  { type: "DISEASE", disorder: "Alopecia, Androgenic (Male pattern)", ICD10: "L64.9" },
  { type: "DISEASE", disorder: "Telogen Effluvium", ICD10: "L65.0" },
  { type: "DISEASE", disorder: "Hirsutism", ICD10: "L68.0" },

  // Orthopedics & Rheumatology
  { type: "DISEASE", disorder: "Seronegative Arthritis", ICD10: "M02.9" },
  { type: "DISEASE", disorder: "Psoriatic Arthritis", ICD10: "L40.50" },
  { type: "DISEASE", disorder: "Reactive Arthritis", ICD10: "M02.9" },
  { type: "DISEASE", disorder: "Polymyalgia Rheumatica", ICD10: "M35.3" },
  { type: "DISEASE", disorder: "Sjogren's Syndrome", ICD10: "M35.00" },
  { type: "DISEASE", disorder: "Scleroderma, Systemic", ICD10: "M34.9" },
  { type: "DISEASE", disorder: "Bursitis of Shoulder", ICD10: "M75.50" },
  { type: "DISEASE", disorder: "Bursitis of Hip (Trochanteric)", ICD10: "M70.60" },
  { type: "DISEASE", disorder: "Lateral Epicondylitis (Tennis Elbow)", ICD10: "M77.10" },
  { type: "DISEASE", disorder: "Medial Epicondylitis (Golfer's Elbow)", ICD10: "M77.00" },
  { type: "DISEASE", disorder: "De Quervain's Tenosynovitis", ICD10: "M65.4" },
  { type: "DISEASE", disorder: "Trigger Finger", ICD10: "M65.30" },
  { type: "DISEASE", disorder: "Ganglion Cyst", ICD10: "M67.40" },
  { type: "DISEASE", disorder: "Baker's Cyst (Popliteal)", ICD10: "M71.20" },
  { type: "DISEASE", disorder: "Patellofemoral Pain Syndrome", ICD10: "M22.2X9" },
  { type: "DISEASE", disorder: "Meniscal Tear, Chronic", ICD10: "M23.20" },

  // Nephrology & Urology
  { type: "DISEASE", disorder: "IgA Nephropathy", ICD10: "N02.8" },
  { type: "DISEASE", disorder: "Polycystic Kidney Disease", ICD10: "Q61.3" },
  { type: "DISEASE", disorder: "Renal Artery Stenosis", ICD10: "I70.1" },
  { type: "DISEASE", disorder: "Hydronephrosis, Unspecified", ICD10: "N13.30" },
  { type: "DISEASE", disorder: "Interstitial Cystitis", ICD10: "N30.10" },
  { type: "DISEASE", disorder: "Overactive Bladder", ICD10: "N32.81" },
  { type: "DISEASE", disorder: "Urinary Incontinence, Stress", ICD10: "N39.3" },
  { type: "DISEASE", disorder: "Urinary Incontinence, Urge", ICD10: "N39.41" },
  { type: "DISEASE", disorder: "Epididymitis, Unspecified", ICD10: "N45.9" },
  { type: "DISEASE", disorder: "Varicocele", ICD10: "I86.1" },
  { type: "DISEASE", disorder: "Phimosis", ICD10: "N47.1" },

  // OBGYN & Women's Health
  { type: "DISEASE", disorder: "Amenorrhea, Primary", ICD10: "N91.0" },
  { type: "DISEASE", disorder: "Amenorrhea, Secondary", ICD10: "N91.1" },
  { type: "DISEASE", disorder: "Abnormal Uterine Bleeding (AUB)", ICD10: "N93.9" },
  { type: "DISEASE", disorder: "Adenomyosis", ICD10: "N80.0" },
  { type: "DISEASE", disorder: "Pelvic Organ Prolapse", ICD10: "N81.9" },
  { type: "DISEASE", disorder: "Bartholin's Cyst", ICD10: "N75.0" },
  { type: "DISEASE", disorder: "Mastitis, Non-lactational", ICD10: "N61.0" },
  { type: "DISEASE", disorder: "Fibrocystic Breast Changes", ICD10: "N60.1" },
  { type: "DISEASE", disorder: "Pre-eclampsia, Unspecified", ICD10: "O14.90" },
  { type: "DISEASE", disorder: "Gestational Diabetes", ICD10: "O24.41" },

  // Pediatrics
  { type: "DISEASE", disorder: "Hand, Foot, and Mouth Disease", ICD10: "B08.4" },
  { type: "DISEASE", disorder: "Roseola Infantum", ICD10: "B08.2" },
  { type: "DISEASE", disorder: "Scarlet Fever", ICD10: "A38.9" },
  { type: "DISEASE", disorder: "Whooping Cough (Pertussis)", ICD10: "A37.90" },
  { type: "DISEASE", disorder: "Croup (Laryngotracheobronchitis)", ICD10: "J05.0" },
  { type: "DISEASE", disorder: "Bronchiolitis, Acute", ICD10: "J21.9" },
  { type: "DISEASE", disorder: "Kawasaki Disease", ICD10: "M30.3" },
  { type: "DISEASE", disorder: "ADHD, Combined Type", ICD10: "F90.2" },
  { type: "DISEASE", disorder: "Autism Spectrum Disorder", ICD10: "F84.0" },
  { type: "DISEASE", disorder: "Enuresis (Bedwetting)", ICD10: "F98.0" },

  // Hematology
  { type: "DISEASE", disorder: "Polycythemia Vera", ICD10: "D45" },
  { type: "DISEASE", disorder: "Essential Thrombocythemia", ICD10: "D47.3" },
  { type: "DISEASE", disorder: "Myelodisplastic Syndrome", ICD10: "D46.9" },
  { type: "DISEASE", disorder: "Leukemia, Acute Myeloid (AML)", ICD10: "C92.00" },
  { type: "DISEASE", disorder: "Leukemia, Chronic Lymphocytic (CLL)", ICD10: "C91.10" },
  { type: "DISEASE", disorder: "Multiple Myeloma", ICD10: "C90.00" },
  { type: "DISEASE", disorder: "Von Willebrand Disease", ICD10: "D68.0" },
  { type: "DISEASE", disorder: "Hemophilia A", ICD10: "D66" },

  // Ophthalmology & ENT
  { type: "DISEASE", disorder: "Keratoconus", ICD10: "H18.60" },
  { type: "DISEASE", disorder: "Optic Neuritis", ICD10: "H46.9" },
  { type: "DISEASE", disorder: "Strabismus, Unspecified", ICD10: "H50.9" },
  { type: "DISEASE", disorder: "Cholesteatoma of Middle Ear", ICD10: "H71.90" },
  { type: "DISEASE", disorder: "Otosclerosis", ICD10: "H80.9" },
  { type: "DISEASE", disorder: "Labyrinthitis", ICD10: "H83.09" },

  // Common Signs & Symptoms (R-codes)
  { type: "DISEASE", disorder: "Fever, Unspecified", ICD10: "R50.9" },
  { type: "DISEASE", disorder: "Chest Pain, Unspecified", ICD10: "R07.9" },
  { type: "DISEASE", disorder: "Shortness of Breath (Dyspnea)", ICD10: "R06.0" },
  { type: "DISEASE", disorder: "Cough, Unspecified", ICD10: "R05" },
  { type: "DISEASE", disorder: "Abdominal Pain, Generalized", ICD10: "R10.84" },
  { type: "DISEASE", disorder: "Abdominal Pain, Right Upper Quadrant", ICD10: "R10.11" },
  { type: "DISEASE", disorder: "Abdominal Pain, Right Lower Quadrant", ICD10: "R10.31" },
  { type: "DISEASE", disorder: "Nausea and Vomiting", ICD10: "R11.2" },
  { type: "DISEASE", disorder: "Dizziness and Giddiness", ICD10: "R42" },
  { type: "DISEASE", disorder: "Headache, Unspecified", ICD10: "R51" },
  { type: "DISEASE", disorder: "Fatigue and Malaise", ICD10: "R53.8" },
  { type: "DISEASE", disorder: "Syncope and Collapse (Fainting)", ICD10: "R55" },
  { type: "DISEASE", disorder: "Lymphadenopathy, Unspecified", ICD10: "R59.9" },
  { type: "DISEASE", disorder: "Edema, Unspecified", ICD10: "R60.9" },
  { type: "DISEASE", disorder: "Palpitations", ICD10: "R00.2" },
  { type: "DISEASE", disorder: "Dysuria (Painful Urination)", ICD10: "R30.0" },
  { type: "DISEASE", disorder: "Hematuria (Blood in Urine)", ICD10: "R31.9" },
  { type: "DISEASE", disorder: "Jaundice, Unspecified", ICD10: "R17" },
  { type: "DISEASE", disorder: "Ascites", ICD10: "R18.8" },
  { type: "DISEASE", disorder: "Weight Loss, Abnormal", ICD10: "R63.4" },
  
  // --- ADDITIONAL EXTENSIVE DISEASE DIRECTORY (TRUSTED RESOURCES) ---
  
  // Infectious Diseases (A-B)
  { type: "DISEASE", disorder: "Brucellosis (Malta Fever)", ICD10: "A23.9" },
  { type: "DISEASE", disorder: "Leishmaniasis, Cutaneous", ICD10: "B55.1" },
  { type: "DISEASE", disorder: "Leishmaniasis, Visceral (Kala-azar)", ICD10: "B55.0" },
  { type: "DISEASE", disorder: "Malarial Infection, Falciparum", ICD10: "B50.9" },
  { type: "DISEASE", disorder: "Malarial Infection, Vivax", ICD10: "B51.9" },
  { type: "DISEASE", disorder: "Hydatid Cyst of Liver", ICD10: "B67.0" },
  { type: "DISEASE", disorder: "Amebiasis, Intestinal", ICD10: "A06.0" },
  { type: "DISEASE", disorder: "Amebic Liver Abscess", ICD10: "A06.4" },
  { type: "DISEASE", disorder: "Giardiasis", ICD10: "A07.1" },
  { type: "DISEASE", disorder: "Cholera", ICD10: "A00.9" },
  { type: "DISEASE", disorder: "Toxoplasmosis, Unspecified", ICD10: "B58.9" },
  { type: "DISEASE", disorder: "Schistosomiasis (Bilharziasis)", ICD10: "B65.9" },
  { type: "DISEASE", disorder: "Scabies", ICD10: "B86" },
  { type: "DISEASE", disorder: "Pediculosis (Head Lice)", ICD10: "B85.0" },
  { type: "DISEASE", disorder: "Viral Warts (Verrucca)", ICD10: "B07.9" },
  { type: "DISEASE", disorder: "Molluscum Contagiosum", ICD10: "B08.1" },

  // Endocrine & Metabolism (E)
  { type: "DISEASE", disorder: "Hypocalcemia", ICD10: "E83.51" },
  { type: "DISEASE", disorder: "Hypercalcemia", ICD10: "E83.52" },
  { type: "DISEASE", disorder: "Hypomagnesemia", ICD10: "E61.2" },
  { type: "DISEASE", disorder: "Vitamin B12 Deficiency", ICD10: "E53.8" },
  { type: "DISEASE", disorder: "Vitamin C Deficiency (Scurvy)", ICD10: "E54" },
  { type: "DISEASE", disorder: "Rickets, Active", ICD10: "E55.0" },
  { type: "DISEASE", disorder: "Gynaecomastia", ICD10: "N62" },
  { type: "DISEASE", disorder: "Hyperprolactinaemia", ICD10: "E22.1" },
  { type: "DISEASE", disorder: "Adrenal Insufficiency, Primary", ICD10: "E27.1" },
  { type: "DISEASE", disorder: "Pheochromocytoma", ICD10: "C74.1" },
  { type: "DISEASE", disorder: "Pituitary Adenoma", ICD10: "D35.2" },

  // Cardiology (I)
  { type: "DISEASE", disorder: "Mitral Valve Prolapse", ICD10: "I34.1" },
  { type: "DISEASE", disorder: "Mitral Stenosis", ICD10: "I05.0" },
  { type: "DISEASE", disorder: "Aortic Stenosis", ICD10: "I35.0" },
  { type: "DISEASE", disorder: "Aortic Regurgitation", ICD10: "I35.1" },
  { type: "DISEASE", disorder: "Infective Endocarditis", ICD10: "I33.0" },
  { type: "DISEASE", disorder: "Pericarditis, Acute", ICD10: "I30.9" },
  { type: "DISEASE", disorder: "Pericardial Effusion", ICD10: "I31.3" },
  { type: "DISEASE", disorder: "Cardiomyopathy, Dilated", ICD10: "I42.0" },
  { type: "DISEASE", disorder: "Cardiomyopathy, Hypertrophic", ICD10: "I42.1" },
  { type: "DISEASE", disorder: "Wolf-Parkinson-White (WPW)", ICD10: "I45.6" },
  { type: "DISEASE", disorder: "Paroxysmal SVT", ICD10: "I47.1" },
  { type: "DISEASE", disorder: "Bundle Branch Block, Left", ICD10: "I44.7" },
  { type: "DISEASE", disorder: "Bundle Branch Block, Right", ICD10: "I45.10" },

  // Respiratory (J)
  { type: "DISEASE", disorder: "Bronchiectasis", ICD10: "J47.9" },
  { type: "DISEASE", disorder: "Pulmonary Fibrosis, Idiopathic", ICD10: "J84.112" },
  { type: "DISEASE", disorder: "Sarcoidosis of Lung", ICD10: "D86.0" },
  { type: "DISEASE", disorder: "Pleurisy", ICD10: "R09.1" },
  { type: "DISEASE", disorder: "Emphysema, Unspecified", ICD10: "J43.9" },
  { type: "DISEASE", disorder: "Sleep Apnea, Obstructive", ICD10: "G47.33" },

  // Neurology (G)
  { type: "DISEASE", disorder: "Myasthenia Gravis", ICD10: "G70.0" },
  { type: "DISEASE", disorder: "Guillain-Barre Syndrome", ICD10: "G61.0" },
  { type: "DISEASE", disorder: "Trigeminal Neuralgia", ICD10: "G50.0" },
  { type: "DISEASE", disorder: "Cluster Headache", ICD10: "G44.0" },
  { type: "DISEASE", disorder: "Dystonia, Unspecified", ICD10: "G24.9" },
  { type: "DISEASE", disorder: "Essential Tremor", ICD10: "G25.0" },
  { type: "DISEASE", disorder: "Transient Global Amnesia", ICD10: "G45.4" },

  // Dermatology (L)
  { type: "DISEASE", disorder: "Pemphigus Vulgaris", ICD10: "L10.0" },
  { type: "DISEASE", disorder: "Bullous Pemphigoid", ICD10: "L12.0" },
  { type: "DISEASE", disorder: "Erythema Multiforme", ICD10: "L51.9" },
  { type: "DISEASE", disorder: "Stevens-Johnson Syndrome", ICD10: "L51.1" },
  { type: "DISEASE", disorder: "Toxic Epidermal Necrolysis", ICD10: "L51.2" },
  { type: "DISEASE", disorder: "Lichen Sclerosus", ICD10: "L90.0" },
  { type: "DISEASE", disorder: "Granuloma Annulare", ICD10: "L92.0" },
  { type: "DISEASE", disorder: "Pyoderma Gangrenosum", ICD10: "L88" },
  { type: "DISEASE", disorder: "Hidradenitis Suppurativa", ICD10: "L73.2" },

  // Rheumatology & Orthopedics (M)
  { type: "DISEASE", disorder: "Systemic Sclerosis (Scleroderma)", ICD10: "M34.9" },
  { type: "DISEASE", disorder: "Polymyositis", ICD10: "M33.2" },
  { type: "DISEASE", disorder: "Dermatomyositis", ICD10: "M33.9" },
  { type: "DISEASE", disorder: "Behcet's Disease", ICD10: "M35.2" },
  { type: "DISEASE", disorder: "Polyarteritis Nodosa", ICD10: "M30.0" },
  { type: "DISEASE", disorder: "Giant Cell Arteritis (Temporal)", ICD10: "M31.6" },
  { type: "DISEASE", disorder: "Polymyalgia Rheumatica", ICD10: "M35.3" },
  { type: "DISEASE", disorder: "Paget's Disease of Bone", ICD10: "M88.9" },
  { type: "DISEASE", disorder: "Avascular Necrosis of Femoral Head", ICD10: "M87.05" },

  // Haematology (D)
  { type: "DISEASE", disorder: "Aplastic Anemia", ICD10: "D61.9" },
  { type: "DISEASE", disorder: "Thalassemia Major", ICD10: "D56.1" },
  { type: "DISEASE", disorder: "G6PD Deficiency", ICD10: "D55.0" },
  { type: "DISEASE", disorder: "Immune Thrombocytopenic Purpura (ITP)", ICD10: "D69.3" },
  { type: "DISEASE", disorder: "Haemophilia A", ICD10: "D66" },
  { type: "DISEASE", disorder: "Haemophilia B", ICD10: "D67" },
  { type: "DISEASE", disorder: "Von Willebrand Disease", ICD10: "D68.0" },
  { type: "DISEASE", disorder: "Polycythemia Vera", ICD10: "D45" },

  // Urology & Nephrology (N)
  { type: "DISEASE", disorder: "Polycystic Kidney Disease, Adult", ICD10: "Q61.3" },
  { type: "DISEASE", disorder: "Renal Artery Stenosis", ICD10: "I70.1" },
  { type: "DISEASE", disorder: "Goodpasture's Syndrome", ICD10: "M31.0" },
  { type: "DISEASE", disorder: "Ureteric Colic", ICD10: "N23" },
  { type: "DISEASE", disorder: "Prostatitis, Chronic", ICD10: "N41.1" },
  { type: "DISEASE", disorder: "Varicocele", ICD10: "I86.1" },
  { type: "DISEASE", disorder: "Hydrocele", ICD10: "N43.3" },
  { type: "DISEASE", disorder: "Testicular Torsion", ICD10: "N44.0" },

  // Signs & Symptoms (R)
  { type: "DISEASE", disorder: "Haemoptysis (Coughing blood)", ICD10: "R04.2" },
  { type: "DISEASE", disorder: "Haematemesis (Vomiting blood)", ICD10: "K92.0" },
  { type: "DISEASE", disorder: "Melaena (Dark stool)", ICD10: "K92.1" },
  { type: "DISEASE", disorder: "Dysphagia (Difficulty swallowing)", ICD10: "R13.1" },
  { type: "DISEASE", disorder: "Ascites", ICD10: "R18.8" },
  { type: "DISEASE", disorder: "Splenomegaly", ICD10: "R16.1" },
  { type: "DISEASE", disorder: "Hepatomegaly", ICD10: "R16.0" },
  { type: "DISEASE", disorder: "Clubbing of Fingers", ICD10: "R68.3" },

  // --- COMPREHENSIVE ADDITIONS: DERMATOLOGY, VENEREAL, INFECTIONS, TRAUMA & INJURIES ---
  
  // Sexually Transmitted & Venereal Diseases (A50-A64)
  { type: "DISEASE", disorder: "Syphilis, Early (Primary/Secondary)", ICD10: "A51.9" },
  { type: "DISEASE", disorder: "Syphilis, Late (Tertiary)", ICD10: "A52.9" },
  { type: "DISEASE", disorder: "Gonococcal Infection, Unspecified (Gonorrhea)", ICD10: "A54.9" },
  { type: "DISEASE", disorder: "Chlamydial Infection of Genital Tract", ICD10: "A56.0" },
  { type: "DISEASE", disorder: "Chancroid", ICD10: "A57" },
  { type: "DISEASE", disorder: "Granuloma Inguinale (Donovanosis)", ICD10: "A58" },
  { type: "DISEASE", disorder: "Trichomoniasis", ICD10: "A59.9" },
  { type: "DISEASE", disorder: "Anogenital Herpesviral Infection", ICD10: "A60.0" },
  { type: "DISEASE", disorder: "Anogenital Venereal Warts (HPV)", ICD10: "A63.0" },
  { type: "DISEASE", disorder: "Pelvic Inflammatory Disease (PID) - Gonococcal", ICD10: "A54.24" },
  
  // Extended Infectious & Parasitic Diseases
  { type: "DISEASE", disorder: "Mumps", ICD10: "B26.9" },
  { type: "DISEASE", disorder: "Rubella (German Measles)", ICD10: "B06.9" },
  { type: "DISEASE", disorder: "Measles", ICD10: "B05.9" },
  { type: "DISEASE", disorder: "Tetanus", ICD10: "A35" },
  { type: "DISEASE", disorder: "Diphtheria", ICD10: "A36.9" },
  { type: "DISEASE", disorder: "Malaria, Unspecified", ICD10: "B54" },
  { type: "DISEASE", disorder: "Toxocariasis", ICD10: "B83.0" },
  { type: "DISEASE", disorder: "Ascariasis", ICD10: "B77.9" },
  { type: "DISEASE", disorder: "Enterobiasis (Pinworm)", ICD10: "B80" },
  { type: "DISEASE", disorder: "Taeniasis (Tapeworm)", ICD10: "B68.9" },
  { type: "DISEASE", disorder: "Cytomegalovirus (CMV) Disease", ICD10: "B25.9" },
  { type: "DISEASE", disorder: "Epstein-Barr Virus (EBV) Infection", ICD10: "B27.0" },
  { type: "DISEASE", disorder: "COVID-19, Virus Identified", ICD10: "U07.1" },
  { type: "DISEASE", disorder: "Monkeypox", ICD10: "B04" },
  { type: "DISEASE", disorder: "Rabies", ICD10: "A82.9" },
  { type: "DISEASE", disorder: "Dengue Fever", ICD10: "A90" },
  { type: "DISEASE", disorder: "Typhus Fever", ICD10: "A75.9" },

  // Extended Dermatology
  { type: "DISEASE", disorder: "Tinea Capitis (Scalp Ringworm)", ICD10: "B35.0" },
  { type: "DISEASE", disorder: "Tinea Corporis (Body Ringworm)", ICD10: "B35.4" },
  { type: "DISEASE", disorder: "Tinea Pedis (Athlete's Foot)", ICD10: "B35.3" },
  { type: "DISEASE", disorder: "Tinea Cruris (Jock Itch)", ICD10: "B35.6" },
  { type: "DISEASE", disorder: "Candidiasis of Skin and Nail", ICD10: "B37.2" },
  { type: "DISEASE", disorder: "Erysipelas", ICD10: "A46" },
  { type: "DISEASE", disorder: "Folliculitis", ICD10: "L73.9" },
  { type: "DISEASE", disorder: "Furuncle (Boil)", ICD10: "L02.9" },
  { type: "DISEASE", disorder: "Carbuncle", ICD10: "L02.9" },
  { type: "DISEASE", disorder: "Impetigo Contagiosa", ICD10: "L01.0" },
  { type: "DISEASE", disorder: "Erythema Nodosum", ICD10: "L52" },
  { type: "DISEASE", disorder: "Pityriasis Versicolor", ICD10: "B36.0" },
  { type: "DISEASE", disorder: "Contact Dermatitis, Allergic", ICD10: "L23.9" },
  { type: "DISEASE", disorder: "Contact Dermatitis, Irritant", ICD10: "L24.9" },
  { type: "DISEASE", disorder: "Pemphigoid", ICD10: "L12.9" },
  { type: "DISEASE", disorder: "Erythema Multiforme Major", ICD10: "L51.1" },
  { type: "DISEASE", disorder: "Pruritus, Unspecified", ICD10: "L29.9" },
  { type: "DISEASE", disorder: "Xerosis Cutis (Dry Skin)", ICD10: "L85.3" },
  { type: "DISEASE", disorder: "Hyperhidrosis", ICD10: "L74.519" },
  { type: "DISEASE", disorder: "Keloid Scar", ICD10: "L91.0" },

  // Trauma & Injuries (S00-T98)
  { type: "DISEASE", disorder: "Superficial Injury of Head (Abrasion/Contusion)", ICD10: "S00.9" },
  { type: "DISEASE", disorder: "Open Wound of Head", ICD10: "S01.9" },
  { type: "DISEASE", disorder: "Fracture of Skull", ICD10: "S02.9" },
  { type: "DISEASE", disorder: "Concussion", ICD10: "S06.0" },
  { type: "DISEASE", disorder: "Fracture of Cervical Vertebra", ICD10: "S12.9" },
  { type: "DISEASE", disorder: "Whiplash Injury", ICD10: "S13.4" },
  { type: "DISEASE", disorder: "Fracture of Rib(s)", ICD10: "S22.3" },
  { type: "DISEASE", disorder: "Fracture of Clavicle (Collarbone)", ICD10: "S42.0" },
  { type: "DISEASE", disorder: "Dislocation of Shoulder Joint", ICD10: "S43.0" },
  { type: "DISEASE", disorder: "Fracture of Humerus", ICD10: "S42.3" },
  { type: "DISEASE", disorder: "Fracture of Radius / Ulna (Forearm)", ICD10: "S52.9" },
  { type: "DISEASE", disorder: "Fracture of Carpal Bone (Wrist)", ICD10: "S62.1" },
  { type: "DISEASE", disorder: "Sprain and Strain of Wrist", ICD10: "S63.5" },
  { type: "DISEASE", disorder: "Fracture of Femur", ICD10: "S72.9" },
  { type: "DISEASE", disorder: "Fracture of Tibia / Fibula (Lower Leg)", ICD10: "S82.9" },
  { type: "DISEASE", disorder: "Tear of Meniscus (Knee)", ICD10: "S83.2" },
  { type: "DISEASE", disorder: "Sprain and Strain of Ankle", ICD10: "S93.4" },
  { type: "DISEASE", disorder: "Fracture of Foot / Toe", ICD10: "S92.9" },
  { type: "DISEASE", disorder: "Crush Injury of Hand", ICD10: "S67.2" },
  { type: "DISEASE", disorder: "Crush Injury of Foot", ICD10: "S97.8" },
  { type: "DISEASE", disorder: "Burn of First Degree, Unspecified site", ICD10: "T30.1" },
  { type: "DISEASE", disorder: "Burn of Second Degree, Unspecified site", ICD10: "T30.2" },
  { type: "DISEASE", disorder: "Burn of Third Degree, Unspecified site", ICD10: "T30.3" },
  { type: "DISEASE", disorder: "Corrosion / Chemical Burn", ICD10: "T30.4" },
  { type: "DISEASE", disorder: "Frostbite", ICD10: "T35.7" },
  { type: "DISEASE", disorder: "Foreign Body in Eye", ICD10: "T15.9" },
  { type: "DISEASE", disorder: "Foreign Body in Ear", ICD10: "T16" },
  { type: "DISEASE", disorder: "Foreign Body in Respiratory Tract", ICD10: "T17.9" },
  { type: "DISEASE", disorder: "Foreign Body in Alimentary Tract", ICD10: "T18.9" },
  { type: "DISEASE", disorder: "Toxic Effect of Carbon Monoxide", ICD10: "T58" },
  { type: "DISEASE", disorder: "Snake Bite, Venomous", ICD10: "T63.0" },
  { type: "DISEASE", disorder: "Scorpion Sting", ICD10: "T63.2" },
  { type: "DISEASE", disorder: "Insect Bite / Sting (Nonvenomous)", ICD10: "W57" },
  { type: "DISEASE", disorder: "Anaphylactic Shock (Severe Allergic Reaction)", ICD10: "T78.2" },
  { type: "DISEASE", disorder: "Drowning and Nonfatal Submersion", ICD10: "T75.1" },

  // --- EXTENDED: RARE DISEASES & GENETIC SYNDROMES (ORPHAN DISEASES) ---
  { type: "DISEASE", disorder: "Amyloidosis, Unspecified", ICD10: "E85.9" },
  { type: "DISEASE", disorder: "Gaucher Disease", ICD10: "E75.22" },
  { type: "DISEASE", disorder: "Pompe Disease (Glycogen Storage Disease II)", ICD10: "E74.02" },
  { type: "DISEASE", disorder: "Fabry Disease", ICD10: "E75.21" },
  { type: "DISEASE", disorder: "Mucopolysaccharidosis (MPS)", ICD10: "E76.3" },
  { type: "DISEASE", disorder: "Ehlers-Danlos Syndrome", ICD10: "Q79.6" },
  { type: "DISEASE", disorder: "Marfan Syndrome", ICD10: "Q87.4" },
  { type: "DISEASE", disorder: "Phenylketonuria (PKU)", ICD10: "E70.0" },
  { type: "DISEASE", disorder: "Wilson's Disease", ICD10: "E83.0" },
  { type: "DISEASE", disorder: "Prader-Willi Syndrome", ICD10: "Q87.1" },
  { type: "DISEASE", disorder: "Angelman Syndrome", ICD10: "Q93.5" },
  { type: "DISEASE", disorder: "Rett Syndrome", ICD10: "F84.2" },
  { type: "DISEASE", disorder: "Cystic Fibrosis", ICD10: "E84.9" },
  { type: "DISEASE", disorder: "Spinal Muscular Atrophy (SMA)", ICD10: "G12.0" },
  { type: "DISEASE", disorder: "Duchenne Muscular Dystrophy (DMD)", ICD10: "G71.0" },
  { type: "DISEASE", disorder: "Huntington's Disease", ICD10: "G10" },

  // --- EXTENDED: REPRODUCTIVE SYSTEM & INFERTILITY DISEASES ---
  { type: "DISEASE", disorder: "Female Infertility, Unspecified", ICD10: "N97.9" },
  { type: "DISEASE", disorder: "Male Infertility, Unspecified", ICD10: "N46" },
  { type: "DISEASE", disorder: "Azoospermia", ICD10: "N46.0" },
  { type: "DISEASE", disorder: "Oligospermia", ICD10: "N46.1" },
  { type: "DISEASE", disorder: "Primary Ovarian Insufficiency (Premature Menopause)", ICD10: "E28.3" },
  { type: "DISEASE", disorder: "Polycystic Ovary Syndrome (PCOS)", ICD10: "E28.2" },
  { type: "DISEASE", disorder: "Endometriosis of Uterus (Adenomyosis)", ICD10: "N80.0" },
  { type: "DISEASE", disorder: "Deep Infiltrating Endometriosis", ICD10: "N80.9" },
  { type: "DISEASE", disorder: "Uterine Synechiae (Asherman's Syndrome)", ICD10: "N85.6" },
  { type: "DISEASE", disorder: "Hydrosalpinx / Tubal Blockage", ICD10: "N70.1" },
  { type: "DISEASE", disorder: "Habitual Aborter (Recurrent Pregnancy Loss)", ICD10: "N96" },
  { type: "DISEASE", disorder: "Ectopic Pregnancy, Unspecified", ICD10: "O00.9" },
  { type: "DISEASE", disorder: "Vaginismus (Non-organic)", ICD10: "F52.5" },
  { type: "DISEASE", disorder: "Erectile Dysfunction (Organic)", ICD10: "N39.2" },
  { type: "DISEASE", disorder: "Premature Ejaculation", ICD10: "F52.4" },
  { type: "DISEASE", disorder: "Hypogonadotropic Hypogonadism (e.g. Kallmann Syndrome)", ICD10: "E23.0" },
  { type: "DISEASE", disorder: "Klinefelter Syndrome", ICD10: "Q98.4" },
  { type: "DISEASE", disorder: "Turner Syndrome", ICD10: "Q96.9" },

  // --- EXTENDED: COMMON EVERYDAY INFECTIONS (RESPIRATORY & URINARY) ---
  { type: "DISEASE", disorder: "Streptococcal Tonsillitis (Strep Throat)", ICD10: "J03.0" },
  { type: "DISEASE", disorder: "Acute Follicular Tonsillitis", ICD10: "J03.90" },
  { type: "DISEASE", disorder: "Chronic Tonsillitis", ICD10: "J35.01" },
  { type: "DISEASE", disorder: "Peritonsillar Abscess (Quinsy)", ICD10: "J36" },
  { type: "DISEASE", disorder: "Influenza A", ICD10: "J10.1" },
  { type: "DISEASE", disorder: "Influenza B", ICD10: "J10.1" },
  { type: "DISEASE", disorder: "H1N1 Influenza (Swine Flu)", ICD10: "J09.X2" },
  { type: "DISEASE", disorder: "Parainfluenza Virus Infection", ICD10: "B34.0" },
  { type: "DISEASE", disorder: "Respiratory Syncytial Virus (RSV) Infection", ICD10: "J12.1" },
  { type: "DISEASE", disorder: "Acute Bacterial Rhinosinusitis", ICD10: "J01.90" },
  { type: "DISEASE", disorder: "Acute Otitis Media (AOM), Bilateral", ICD10: "H66.93" },
  { type: "DISEASE", disorder: "Acute Tracheitis", ICD10: "J04.10" },
  { type: "DISEASE", disorder: "Mycoplasma Pneumonia", ICD10: "J15.7" },
  { type: "DISEASE", disorder: "Acute Pyelonephritis (Kidney Infection)", ICD10: "N10" },
  { type: "DISEASE", disorder: "Chronic Pyelonephritis", ICD10: "N11.9" },
  { type: "DISEASE", disorder: "Cystitis, Hemorrhagic", ICD10: "N30.2" },
  { type: "DISEASE", disorder: "Urethritis, Non-gonococcal (NGU)", ICD10: "N34.1" },
  { type: "DISEASE", disorder: "Asymptomatic Bacteriuria", ICD10: "N39.0" },
  { type: "DISEASE", disorder: "Catheter-Associated Urinary Tract Infection (CAUTI)", ICD10: "T83.511A" },
  { type: "DISEASE", disorder: "Candidal Cystitis", ICD10: "B37.41" },
  { type: "DISEASE", disorder: "Bacterial Vaginosis (BV)", ICD10: "N76.0" },

  // --- COMPREHENSIVE DERMATOLOGY (SKIN DISEASES) ---
  { type: "DISEASE", disorder: "Bullous Pemphigoid", ICD10: "L12.0" },
  { type: "DISEASE", disorder: "Dermatitis Herpetiformis", ICD10: "L13.0" },
  { type: "DISEASE", disorder: "Epidermolysis Bullosa", ICD10: "Q81.9" },
  { type: "DISEASE", disorder: "Pityriasis Rubra Pilaris", ICD10: "L44.0" },
  { type: "DISEASE", disorder: "Lichen Sclerosus et Atrophicus", ICD10: "L90.0" },
  { type: "DISEASE", disorder: "Granuloma Annulare", ICD10: "L92.0" },
  { type: "DISEASE", disorder: "Hidradenitis Suppurativa (Acne Inversa)", ICD10: "L73.2" },
  { type: "DISEASE", disorder: "Pyoderma Gangrenosum", ICD10: "L88" },
  { type: "DISEASE", disorder: "Acanthosis Nigricans", ICD10: "L81.0" },
  { type: "DISEASE", disorder: "Alopecia Totalis / Universalis", ICD10: "L63.1" },
  { type: "DISEASE", disorder: "Androgenetic Alopecia", ICD10: "L64.9" },
  { type: "DISEASE", disorder: "Telogen Effluvium", ICD10: "L65.0" },
  { type: "DISEASE", disorder: "Hirsutism", ICD10: "L68.0" },
  { type: "DISEASE", disorder: "Porphyria Cutanea Tarda", ICD10: "E80.1" },
  { type: "DISEASE", disorder: "Discoid Lupus Erythematosus", ICD10: "L93.0" },
  { type: "DISEASE", disorder: "Morphea (Localized Scleroderma)", ICD10: "L94.0" },
  { type: "DISEASE", disorder: "Actinic Keratosis", ICD10: "L57.0" },
  { type: "DISEASE", disorder: "Keratoacanthoma", ICD10: "L85.8" },
  { type: "DISEASE", disorder: "Basal Cell Carcinoma, Nodular", ICD10: "C44.91" },
  { type: "DISEASE", disorder: "Basal Cell Carcinoma, Superficial", ICD10: "C44.91" },
  { type: "DISEASE", disorder: "Mycosis Fungoides (Cutaneous T-cell Lymphoma)", ICD10: "C84.00" },
  { type: "DISEASE", disorder: "Kaposi's Sarcoma", ICD10: "C46.0" },
  { type: "DISEASE", disorder: "Pediculosis Capitis (Head Lice)", ICD10: "B85.0" },
  { type: "DISEASE", disorder: "Pediculosis Pubis (Crab Lice)", ICD10: "B85.3" },
  { type: "DISEASE", disorder: "Molluscum Contagiosum", ICD10: "B08.1" },
  { type: "DISEASE", disorder: "Viral Warts (Verruca Vulgaris)", ICD10: "B07.9" },
  { type: "DISEASE", disorder: "Herpes Zoster (Shingles)", ICD10: "B02.9" },
  { type: "DISEASE", disorder: "Herpes Simplex (Cold Sores)", ICD10: "B00.9" },
  { type: "DISEASE", disorder: "Erythema Infectiosum (Fifth Disease)", ICD10: "B08.3" },

  // --- COMPREHENSIVE VENEREAL DISEASES (STDs) ---
  { type: "DISEASE", disorder: "Lymphogranuloma Venereum (LGV)", ICD10: "A55" },
  { type: "DISEASE", disorder: "Ureaplasma Urealyticum Infection", ICD10: "A63.8" },
  { type: "DISEASE", disorder: "Mycoplasma Genitalium Infection", ICD10: "A63.8" },
  { type: "DISEASE", disorder: "Pelvic Inflammatory Disease (PID) due to Chlamydia", ICD10: "A56.11" },
  { type: "DISEASE", disorder: "Epididymitis due to Chlamydia", ICD10: "A56.19" },
  { type: "DISEASE", disorder: "Gonococcal Epididymitis", ICD10: "A54.21" },
  { type: "DISEASE", disorder: "Gonococcal Proctitis", ICD10: "A54.6" },
  { type: "DISEASE", disorder: "Chlamydial Proctitis", ICD10: "A56.3" },
  { type: "DISEASE", disorder: "Condyloma Acuminata (Genital Warts)", ICD10: "A63.0" },

  // --- EXTENDED: UROLOGY & NEPHROLOGY (URINARY SYSTEM) ---
  { type: "DISEASE", disorder: "Nephrolithiasis (Kidney Stones)", ICD10: "N20.0" },
  { type: "DISEASE", disorder: "Ureterolithiasis (Ureteral Stones)", ICD10: "N20.1" },
  { type: "DISEASE", disorder: "Bladder Calculus (Cystolithiasis)", ICD10: "N21.0" },
  { type: "DISEASE", disorder: "Overactive Bladder (OAB)", ICD10: "N32.81" },
  { type: "DISEASE", disorder: "Urinary Incontinence, Stress", ICD10: "N39.3" },
  { type: "DISEASE", disorder: "Urinary Incontinence, Urge", ICD10: "N39.41" },
  { type: "DISEASE", disorder: "Urinary Incontinence, Overflow", ICD10: "N39.490" },
  { type: "DISEASE", disorder: "Benign Prostatic Hyperplasia (BPH)", ICD10: "N40.1" },
  { type: "DISEASE", disorder: "Prostate Cancer", ICD10: "C61" },
  { type: "DISEASE", disorder: "Bladder Cancer (Urothelial Carcinoma)", ICD10: "C67.9" },
  { type: "DISEASE", disorder: "Renal Cell Carcinoma (Kidney Cancer)", ICD10: "C64" },
  { type: "DISEASE", disorder: "Interstitial Cystitis (Painful Bladder Syndrome)", ICD10: "N30.10" },
  { type: "DISEASE", disorder: "Urethral Stricture", ICD10: "N35.9" },
  { type: "DISEASE", disorder: "Vesicoureteral Reflux (VUR)", ICD10: "N13.70" },
  { type: "DISEASE", disorder: "Hydronephrosis", ICD10: "N13.30" },
  { type: "DISEASE", disorder: "Epididymo-Orchitis", ICD10: "N45.9" },
  { type: "DISEASE", disorder: "Hydrocele (Tunica Vaginalis)", ICD10: "N43.3" },
  { type: "DISEASE", disorder: "Spermatocele", ICD10: "N43.4" },
  { type: "DISEASE", disorder: "Phimosis", ICD10: "N47.1" },
  { type: "DISEASE", disorder: "Paraphimosis", ICD10: "N47.2" },
  { type: "DISEASE", disorder: "Balanoposthitis", ICD10: "N48.1" },
  { type: "DISEASE", disorder: "Testicular Torsion", ICD10: "N44.00" },

  // --- EXTENDED: GYNECOLOGY (FEMALE REPRODUCTIVE SYSTEM) ---
  { type: "DISEASE", disorder: "Uterine Fibroids (Leiomyoma)", ICD10: "D25.9" },
  { type: "DISEASE", disorder: "Ovarian Cyst, Functional", ICD10: "N83.20" },
  { type: "DISEASE", disorder: "Ovarian Cyst, Dermoid (Teratoma)", ICD10: "D27.9" },
  { type: "DISEASE", disorder: "Ovarian Cyst, Hemorrhagic", ICD10: "N83.201" },
  { type: "DISEASE", disorder: "Cervical Dysplasia / CIN", ICD10: "N87.9" },
  { type: "DISEASE", disorder: "Pelvic Organ Prolapse (Uterovaginal)", ICD10: "N81.4" },
  { type: "DISEASE", disorder: "Cystocele (Anterior Prolapse)", ICD10: "N81.10" },
  { type: "DISEASE", disorder: "Rectocele (Posterior Prolapse)", ICD10: "N81.6" },
  { type: "DISEASE", disorder: "Bartholin's Cyst", ICD10: "N75.0" },
  { type: "DISEASE", disorder: "Bartholin's Abscess", ICD10: "N75.1" },
  { type: "DISEASE", disorder: "Atrophic Vaginitis", ICD10: "N95.2" },
  { type: "DISEASE", disorder: "Trichomoniasis (Vaginal)", ICD10: "A59.01" },
  { type: "DISEASE", disorder: "Primary Dysmenorrhea", ICD10: "N94.4" },
  { type: "DISEASE", disorder: "Secondary Dysmenorrhea", ICD10: "N94.5" },
  { type: "DISEASE", disorder: "Menorrhagia (Heavy Menstrual Bleeding)", ICD10: "N92.0" },
  { type: "DISEASE", disorder: "Abnormal Uterine Bleeding (AUB)", ICD10: "N93.9" },
  { type: "DISEASE", disorder: "Premenstrual Syndrome (PMS)", ICD10: "N94.3" },
  { type: "DISEASE", disorder: "Premenstrual Dysphoric Disorder (PMDD)", ICD10: "F32.4" },
  { type: "DISEASE", disorder: "Vulvodynia", ICD10: "N94.810" },
  { type: "DISEASE", disorder: "Menopausal / Climacteric States", ICD10: "N95.1" },

  // --- EXTENDED: GASTROENTEROLOGY (DIGESTIVE SYSTEM) ---
  { type: "DISEASE", disorder: "GERD with Esophagitis", ICD10: "K21.0" },
  { type: "DISEASE", disorder: "Eosinophilic Esophagitis", ICD10: "K20.0" },
  { type: "DISEASE", disorder: "Achalasia of Cardia", ICD10: "K22.0" },
  { type: "DISEASE", disorder: "Barrett's Esophagus", ICD10: "K22.70" },
  { type: "DISEASE", disorder: "Gastric Ulcer (Acute/Chronic)", ICD10: "K25.9" },
  { type: "DISEASE", disorder: "Duodenal Ulcer (Acute/Chronic)", ICD10: "K26.9" },
  { type: "DISEASE", disorder: "Zollinger-Ellison Syndrome", ICD10: "E16.4" },
  { type: "DISEASE", disorder: "Celiac Disease (Gluten Enteropathy)", ICD10: "K90.0" },
  { type: "DISEASE", disorder: "Crohn's Disease", ICD10: "K50.9" },
  { type: "DISEASE", disorder: "Ulcerative Colitis", ICD10: "K51.9" },
  { type: "DISEASE", disorder: "Microscopic Colitis", ICD10: "K52.89" },
  { type: "DISEASE", disorder: "Irritable Bowel Syndrome with Diarrhea (IBS-D)", ICD10: "K58.0" },
  { type: "DISEASE", disorder: "Irritable Bowel Syndrome with Constipation (IBS-C)", ICD10: "K58.1" },
  { type: "DISEASE", disorder: "Diverticulosis of Colon", ICD10: "K57.30" },
  { type: "DISEASE", disorder: "Diverticulitis of Colon", ICD10: "K57.32" },
  { type: "DISEASE", disorder: "Ischemic Colitis", ICD10: "K55.9" },
  { type: "DISEASE", disorder: "Pseudomembranous Colitis (C. diff)", ICD10: "A04.7" },
  { type: "DISEASE", disorder: "Internal Hemorrhoids", ICD10: "I84.2" },
  { type: "DISEASE", disorder: "External Hemorrhoids", ICD10: "I84.5" },
  { type: "DISEASE", disorder: "Anal Fissure / Anal Fistula", ICD10: "K60.2" },
  { type: "DISEASE", disorder: "Primary Biliary Cholangitis (PBC)", ICD10: "K74.3" },
  { type: "DISEASE", disorder: "Primary Sclerosing Cholangitis (PSC)", ICD10: "K83.0" },
  { type: "DISEASE", disorder: "Autoimmune Hepatitis", ICD10: "K75.4" },
  { type: "DISEASE", disorder: "Non-Alcoholic Fatty Liver Disease (NAFLD)", ICD10: "K76.0" },
  { type: "DISEASE", disorder: "Liver Cirrhosis", ICD10: "K74.60" },
  { type: "DISEASE", disorder: "Portal Hypertension", ICD10: "K76.6" },
  { type: "DISEASE", disorder: "Hepatic Encephalopathy", ICD10: "K72.90" },
  { type: "DISEASE", disorder: "Hepatocellular Carcinoma (HCC)", ICD10: "C22.0" },
  { type: "DISEASE", disorder: "Acute Pancreatitis", ICD10: "K85.9" },
  { type: "DISEASE", disorder: "Chronic Pancreatitis", ICD10: "K86.1" },
  { type: "DISEASE", disorder: "Pancreatic Cancer", ICD10: "C25.9" },

  // --- EXTENDED: PULMONOLOGY (RESPIRATORY SYSTEM) ---
  { type: "DISEASE", disorder: "Asthma, Unspecified", ICD10: "J45.909" },
  { type: "DISEASE", disorder: "Asthma, Severe Persistent", ICD10: "J45.50" },
  { type: "DISEASE", disorder: "Chronic Obstructive Pulmonary Disease (COPD)", ICD10: "J44.9" },
  { type: "DISEASE", disorder: "Emphysema", ICD10: "J43.9" },
  { type: "DISEASE", disorder: "Chronic Bronchitis", ICD10: "J42" },
  { type: "DISEASE", disorder: "Bronchiectasis", ICD10: "J47.9" },
  { type: "DISEASE", disorder: "Idiopathic Pulmonary Fibrosis (IPF)", ICD10: "J84.112" },
  { type: "DISEASE", disorder: "Sarcoidosis of Lung", ICD10: "D86.0" },
  { type: "DISEASE", disorder: "Pneumoconiosis (Asbestosis, Silicosis)", ICD10: "J64" },
  { type: "DISEASE", disorder: "Hypersensitivity Pneumonitis", ICD10: "J67.9" },
  { type: "DISEASE", disorder: "Pulmonary Embolism (PE)", ICD10: "I26.99" },
  { type: "DISEASE", disorder: "Pulmonary Arterial Hypertension (PAH)", ICD10: "I27.0" },
  { type: "DISEASE", disorder: "Obstructive Sleep Apnea (OSA)", ICD10: "G47.33" },
  { type: "DISEASE", disorder: "Central Sleep Apnea", ICD10: "G47.31" },
  { type: "DISEASE", disorder: "Acute Respiratory Distress Syndrome (ARDS)", ICD10: "J80" },
  { type: "DISEASE", disorder: "Pleural Effusion", ICD10: "J90" },
  { type: "DISEASE", disorder: "Pneumothorax", ICD10: "J93.9" },
  { type: "DISEASE", disorder: "Non-Small Cell Lung Cancer (NSCLC)", ICD10: "C34.90" },
  { type: "DISEASE", disorder: "Small Cell Lung Cancer (SCLC)", ICD10: "C34.90" },
  { type: "DISEASE", disorder: "Pulmonary Tuberculosis", ICD10: "A15.0" },
  { type: "DISEASE", disorder: "Pulmonary Aspergillosis", ICD10: "B44.1" },

  // --- EXTENDED: ENDOCRINOLOGY (GLANDS & HORMONES) ---
  { type: "DISEASE", disorder: "Hashimoto's Thyroiditis (Autoimmune Hypothyroidism)", ICD10: "E06.3" },
  { type: "DISEASE", disorder: "Graves' Disease (Toxic Diffuse Goiter)", ICD10: "E05.00" },
  { type: "DISEASE", disorder: "Toxic Multinodular Goiter", ICD10: "E05.20" },
  { type: "DISEASE", disorder: "Thyroid Nodule", ICD10: "E04.1" },
  { type: "DISEASE", disorder: "Papillary Thyroid Carcinoma", ICD10: "C73" },
  { type: "DISEASE", disorder: "Type 1 Diabetes Mellitus, Uncontrolled", ICD10: "E10.65" },
  { type: "DISEASE", disorder: "Type 2 Diabetes Mellitus without complications", ICD10: "E11.9" },
  { type: "DISEASE", disorder: "Gestational Diabetes Mellitus (GDM)", ICD10: "O24.410" },
  { type: "DISEASE", disorder: "Cushing's Syndrome", ICD10: "E24.9" },
  { type: "DISEASE", disorder: "Addison's Disease (Primary Adrenal Insufficiency)", ICD10: "E27.1" },
  { type: "DISEASE", disorder: "Primary Hyperaldosteronism (Conn's Syndrome)", ICD10: "E26.01" },
  { type: "DISEASE", disorder: "Pheochromocytoma", ICD10: "C74.10" },
  { type: "DISEASE", disorder: "Prolactinoma (Pituitary Adenoma)", ICD10: "D35.2" },
  { type: "DISEASE", disorder: "Acromegaly and Pituitary Gigantism", ICD10: "E22.0" },
  { type: "DISEASE", disorder: "Central Diabetes Insipidus", ICD10: "E23.2" },
  { type: "DISEASE", disorder: "Primary Hyperparathyroidism", ICD10: "E21.0" },
  { type: "DISEASE", disorder: "Hypoparathyroidism", ICD10: "E20.9" },
  { type: "DISEASE", disorder: "Multiple Endocrine Neoplasia (MEN)", ICD10: "E31.20" },

  // --- EXTENDED: RHEUMATOLOGY & JOINT DISEASES ---
  { type: "DISEASE", disorder: "Rheumatoid Arthritis, Seropositive", ICD10: "M05.9" },
  { type: "DISEASE", disorder: "Rheumatoid Arthritis, Seronegative", ICD10: "M06.09" },
  { type: "DISEASE", disorder: "Osteoarthritis of Knee", ICD10: "M17.9" },
  { type: "DISEASE", disorder: "Osteoarthritis of Hip", ICD10: "M16.9" },
  { type: "DISEASE", disorder: "Systemic Lupus Erythematosus (SLE)", ICD10: "M32.9" },
  { type: "DISEASE", disorder: "Ankylosing Spondylitis", ICD10: "M45.9" },
  { type: "DISEASE", disorder: "Psoriatic Arthritis", ICD10: "L40.50" },
  { type: "DISEASE", disorder: "Reactive Arthritis (Reiter's Disease)", ICD10: "M02.30" },
  { type: "DISEASE", disorder: "Gout (Acute / Chronic)", ICD10: "M10.9" },
  { type: "DISEASE", disorder: "Pseudogout (CPPD)", ICD10: "M11.20" },
  { type: "DISEASE", disorder: "Sjogren's Syndrome", ICD10: "M35.00" },
  { type: "DISEASE", disorder: "Systemic Sclerosis (Scleroderma)", ICD10: "M34.9" },
  { type: "DISEASE", disorder: "Polymyalgia Rheumatica (PMR)", ICD10: "M35.3" },
  { type: "DISEASE", disorder: "Giant Cell Arteritis (Temporal Arteritis)", ICD10: "M31.6" },
  { type: "DISEASE", disorder: "Fibromyalgia", ICD10: "M79.7" },
  { type: "DISEASE", disorder: "Behcet's Disease", ICD10: "M35.2" },
  { type: "DISEASE", disorder: "Polyarteritis Nodosa (PAN)", ICD10: "M30.0" },
  { type: "DISEASE", disorder: "Dermatomyositis / Polymyositis", ICD10: "M33.90" },
  { type: "DISEASE", disorder: "Septic Arthritis", ICD10: "M00.9" },
  { type: "DISEASE", disorder: "Avascular Necrosis (Osteonecrosis)", ICD10: "M87.00" },
  { type: "DISEASE", disorder: "Paget's Disease of Bone", ICD10: "M88.9" },

  // --- EXTENDED: TRAUMA, WOUNDS, BURNS & INJURIES ---
  { type: "DISEASE", disorder: "Superficial Injury (Abrasion/Contusion/Bruise)", ICD10: "T14.0" },
  { type: "DISEASE", disorder: "Open Wound of Head / Scalp Laceration", ICD10: "S01.90" },
  { type: "DISEASE", disorder: "Open Wound of Face", ICD10: "S01.8" },
  { type: "DISEASE", disorder: "Open Wound of Neck", ICD10: "S11.9" },
  { type: "DISEASE", disorder: "Open Wound of Chest / Thorax", ICD10: "S21.9" },
  { type: "DISEASE", disorder: "Open Wound of Abdomen / Lower Back", ICD10: "S31.9" },
  { type: "DISEASE", disorder: "Open Wound of Upper Limb (Arm/Hand)", ICD10: "S11.9" },
  { type: "DISEASE", disorder: "Open Wound of Lower Limb (Leg/Foot)", ICD10: "S81.9" },
  { type: "DISEASE", disorder: "Laceration with Foreign Body", ICD10: "T14.1" },
  { type: "DISEASE", disorder: "Puncture Wound", ICD10: "T14.1" },
  { type: "DISEASE", disorder: "Animal Bite (Dog/Cat/Other)", ICD10: "W54.0" },
  { type: "DISEASE", disorder: "Human Bite", ICD10: "W50" },
  { type: "DISEASE", disorder: "Crush Injury of Extremities", ICD10: "T14.7" },
  { type: "DISEASE", disorder: "Traumatic Amputation (Digit or Limb)", ICD10: "T14.6" },
  { type: "DISEASE", disorder: "Burn, First Degree (Erythema)", ICD10: "T30.1" },
  { type: "DISEASE", disorder: "Burn, Second Degree (Blisters)", ICD10: "T30.2" },
  { type: "DISEASE", disorder: "Burn, Third Degree (Full-thickness)", ICD10: "T30.3" },
  { type: "DISEASE", disorder: "Chemical Burn", ICD10: "T30.4" },
  { type: "DISEASE", disorder: "Electrical Burn / Shock", ICD10: "T75.4" },
  { type: "DISEASE", disorder: "Concussion (Mild Traumatic Brain Injury)", ICD10: "S06.0X0" },
  { type: "DISEASE", disorder: "Traumatic Subdural / Epidural Hemorrhage", ICD10: "S06.5X9" },
  { type: "DISEASE", disorder: "Traumatic Pneumothorax / Hemothorax", ICD10: "S27.2" },
  { type: "DISEASE", disorder: "Blunt Abdominal Trauma (Splenic/Liver rupture)", ICD10: "S36.9" },
  { type: "DISEASE", disorder: "Whiplash Injury of Neck", ICD10: "S13.4" },
  { type: "DISEASE", disorder: "Sprain / Strain of Joint (Ankle, Knee, Wrist)", ICD10: "T14.3" },
  { type: "DISEASE", disorder: "Dislocation of Joint (Shoulder, Elbow, Patella)", ICD10: "T14.3" },
  { type: "DISEASE", disorder: "Fracture of Skull / Facial Bones", ICD10: "S02.9" },
  { type: "DISEASE", disorder: "Fracture of Clavicle / Scapula", ICD10: "S42.9" },
  { type: "DISEASE", disorder: "Fracture of Ribs / Sternum", ICD10: "S22.9" },
  { type: "DISEASE", disorder: "Fracture of Upper Limb (Humerus/Radius/Ulna)", ICD10: "S52.9" },
  { type: "DISEASE", disorder: "Fracture of Pelvis", ICD10: "S32.8" },
  { type: "DISEASE", disorder: "Fracture of Femur / Hip", ICD10: "S72.9" },
  { type: "DISEASE", disorder: "Fracture of Lower Limb (Tibia/Fibula/Ankle)", ICD10: "S82.9" },
  { type: "DISEASE", disorder: "Spinal Cord Injury", ICD10: "T09.3" },
  // Additional Custom Diagnoses added manually
  { type: "DISEASE", disorder: "Upper Respiratory Tract Infection, Unspecified (URTI)", ICD10: "J06.9" },
  { type: "DISEASE", disorder: "Lower Respiratory Tract Infection, Unspecified (LRTI)", ICD10: "J22" },
  { type: "DISEASE", disorder: "Acute Pharyngitis", ICD10: "J02.9" },
  { type: "DISEASE", disorder: "Acute Tonsillitis", ICD10: "J03.9" },
  { type: "DISEASE", disorder: "Common Cold", ICD10: "J00" },
  { type: "DISEASE", disorder: "Gastroenteritis", ICD10: "A09" },
  { type: "DISEASE", disorder: "Urinary Tract Infection, Unspecified (UTI)", ICD10: "N39.0" },
  { type: "DISEASE", disorder: "Vitamin D Deficiency", ICD10: "E55.9" },
  { type: "DISEASE", disorder: "Anemia, Unspecified", ICD10: "D64.9" },
  { type: "DISEASE", disorder: "Hyperlipidemia", ICD10: "E78.5" },
  { type: "DISEASE", disorder: "Measles (Rubeola) / الحصبة", ICD10: "B05.9" },
  { type: "DISEASE", disorder: "Rubella (German Measles) / الحصبة الألمانية", ICD10: "B06.9" },
  { type: "DISEASE", disorder: "Roseola Infantum (Sixth Disease) / الوردية", ICD10: "B08.2" },
  { type: "DISEASE", disorder: "Erythema Infectiosum (Fifth Disease) / الداء الخامس", ICD10: "B08.3" },
  { type: "DISEASE", disorder: "Hand, Foot, and Mouth Disease / مرض اليد والقدم والفم", ICD10: "B08.4" },
  { type: "DISEASE", disorder: "Mumps / النكاف", ICD10: "B26.9" },
  { type: "DISEASE", disorder: "Molluscum Contagiosum / المليساء المعدية", ICD10: "B08.1" },
  { type: "DISEASE", disorder: "Scarlet Fever / الحمى القرمزية", ICD10: "A38.9" },
  { type: "DISEASE", disorder: "Impetigo / القوباء", ICD10: "L01.0" },
  { type: "DISEASE", disorder: "Atopic Dermatitis (Eczema) / إكزيما الأطفال", ICD10: "L20.9" },
  { type: "DISEASE", disorder: "Diaper Dermatitis (Diaper Rash) / طفح الحفاض", ICD10: "L22" },
  { type: "DISEASE", disorder: "Seborrheic Dermatitis (Cradle Cap) / قرف اللبن", ICD10: "L21.0" },
  { type: "DISEASE", disorder: "Viral Exanthem, Unspecified / طفح فيروسي غير محدد", ICD10: "B09" },
  { type: "DISEASE", disorder: "Pityriasis Rosea / النخالية الوردية", ICD10: "L42" },
  { type: "DISEASE", disorder: "Tinea Corporis (Ringworm) / الفطريات الجسدية", ICD10: "B35.4" },
  { type: "DISEASE", disorder: "Tinea Capitis / فطريات الرأس", ICD10: "B35.0" },
  { type: "DISEASE", disorder: "Pediculosis Capitis (Head Lice) / قمل الرأس", ICD10: "B85.0" },
  { type: "DISEASE", disorder: "Scabies / الجرب", ICD10: "B86" },
  { type: "DISEASE", disorder: "Gingivostomatitis (Herpes Simplex) / التهاب الفم واللثة الهربسي", ICD10: "B00.2" },
  { type: "DISEASE", disorder: "Herpangina / الخناق الهربسي", ICD10: "B08.5" }
];

export const bnfCatalog = [
  // ==========================================
  // CHAPTER 1: GASTRO-INTESTINAL SYSTEM
  // ==========================================
  { 
    name: "Omeprazole", 
    defaultDose: "20 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "28 days", 
    indication: "GORD, dyspepsia, gastric ulcers", 
    category: "Gastro-intestinal",
    info: "Proton Pump Inhibitor (PPI). Inhibits gastric acid secretion. Take 30-60 mins before breakfast.",
    sideEffects: "Headache, GI upset (diarrhea/constipation), flatulence, abdominal pain.",
    contraindications: "Hypersensitivity, co-administration with nelfinavir."
  },
  { 
    name: "Lansoprazole", 
    defaultDose: "30 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "28 days", 
    indication: "Acid reflux, gastric and duodenal ulcers", 
    category: "Gastro-intestinal",
    info: "Proton Pump Inhibitor. Reduces gastric acidity. Take on an empty stomach.",
    sideEffects: "Diarrhea, nausea, headache, skin rash, dry mouth.",
    contraindications: "Hypersensitivity to PPIs."
  },
  { 
    name: "Pantoprazole", 
    defaultDose: "40 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "28 days", 
    indication: "Reflux esophagitis, Zollinger-Ellison syndrome", 
    category: "Gastro-intestinal",
    info: "Proton Pump Inhibitor. Preferred PPI when paciente is on Clopidogrel (less CYP2C19 interaction).",
    sideEffects: "GI disturbance, sleep disorders, fracture risk over long-term use.",
    contraindications: "Hypersensitivity."
  },
  { 
    name: "Loperamide", 
    defaultDose: "2 mg", 
    defaultFreq: "PRN after loose stool", 
    defaultDuration: "Acute", 
    indication: "Acute diarrhea, symptomatic management", 
    category: "Gastro-intestinal",
    info: "Antimotility agent. Opioid receptor agonist in muscle wall of the bowel.",
    sideEffects: "Constipation, dizziness, abdominal cramps, flatulence.",
    contraindications: "Active ulcerative colitis, antibiotic-associated colitis, dysentery (blood in stool)."
  },
  { 
    name: "Ranitidine", 
    defaultDose: "150 mg", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "14 days", 
    indication: "Gastric ulcers, benign duodenal ulcers", 
    category: "Gastro-intestinal",
    info: "Histamine H2-receptor antagonist. Inhibits basal and stimulated gastric acid secretion.",
    sideEffects: "Constipation, diarrhea, fatigue, muscle pain.",
    contraindications: "Porphyria history."
  },
  { 
    name: "Famotidine", 
    defaultDose: "20 mg", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "14 days", 
    indication: "Gastric acidity, dyspepsia", 
    category: "Gastro-intestinal",
    info: "H2-receptor antagonist. Potent selective block of acid secretion.",
    sideEffects: "Arrhythmia (extremely rare), dry mouth, headaches.",
    contraindications: "Known hypersensitivity."
  },
  { 
    name: "Domperidone", 
    defaultDose: "10 mg", 
    defaultFreq: "TDS (Three times / day)", 
    defaultDuration: "Short term", 
    indication: "Nausea and vomiting", 
    category: "Gastro-intestinal",
    info: "Dopamine antagonist. Prokinetic. Increases lower esophageal sphincter pressure.",
    sideEffects: "Dry mouth, anxiety, QT interval prolongation risk.",
    contraindications: "Cardiac conduction delays, severe hepatic impairment, GI hemorrhage or obstruction."
  },
  { 
    name: "Metoclopramide", 
    defaultDose: "10 mg", 
    defaultFreq: "TDS (Three times / day)", 
    defaultDuration: "5 days", 
    indication: "Nausea, vomiting, gastroparesis", 
    category: "Gastro-intestinal",
    info: "D2 antagonist. Risks of extrapyramidal side effects. Limit use to max 5 days.",
    sideEffects: "Drowsiness, restlessness, acute dystonia, tardive dyskinesia.",
    contraindications: "Pheochromocytoma, GI perforation, epilepsy, children under 1 year."
  },
  { 
    name: "Ondansetron", 
    defaultDose: "4 mg", 
    defaultFreq: "TDS (Three times / day)", 
    defaultDuration: "PRN", 
    indication: "Chemotherapy-induced or post-operative nausea", 
    category: "Gastro-intestinal",
    info: "5-HT3 receptor antagonist. Highly potent antiemetic.",
    sideEffects: "Headache, warmth/flushing, constipation, transient ECG changes.",
    contraindications: "Congenital long QT syndrome, concurrent apomorphine use."
  },
  { 
    name: "Mebeverine", 
    defaultDose: "135 mg", 
    defaultFreq: "TDS (Three times / day)", 
    defaultDuration: "30 days", 
    indication: "Irritable bowel syndrome (IBS)", 
    category: "Gastro-intestinal",
    info: "Antispasmodic. Direct smooth muscle relaxant without systemic anticholinergic side effects.",
    sideEffects: "Allergic reactions (urticaria, angioedema) - rare.",
    contraindications: "Paralytic ileus."
  },
  { 
    name: "Lactulose", 
    defaultDose: "15 ml", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "14 days", 
    indication: "Constipation, hepatic encephalopathy", 
    category: "Gastro-intestinal",
    info: "Osmotic laxative. Fermented by colonic bacteria into organic acids to draw water.",
    sideEffects: "Flatulence, abdominal discomfort, nausea, electrolyte imbalance (with overuse).",
    contraindications: "Galactosaemia, gastrointestinal obstruction."
  },
  { 
    name: "Senna", 
    defaultDose: "15 mg", 
    defaultFreq: "ON (At night)", 
    defaultDuration: "7 days", 
    indication: "Short-term treatment of acute constipation", 
    category: "Gastro-intestinal",
    info: "Stimulant laxative. Direct action on enteric nervous plexus to increase peristalsis.",
    sideEffects: "Abdominal cramps, hypokalemia (prolonged use), melanosis coli.",
    contraindications: "Intestinal obstruction, acute inflammatory bowel disease, undiagnosed abdominal pain."
  },

  // ==========================================
  // CHAPTER 2: CARDIOVASCULAR SYSTEM
  // ==========================================
  { 
    name: "Amlodipine", 
    defaultDose: "5 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Hypertension, chronic stable angina", 
    category: "Cardiovascular",
    info: "Dihydropyridine Calcium Channel Blocker (CCB). Relaxes vascular smooth muscle.",
    sideEffects: "Peripheral ankle edema, headache, flushing, fatigue, palpitations.",
    contraindications: "Cardiogenic shock, severe aortic stenosis, unstable angina."
  },
  { 
    name: "Ramipril", 
    defaultDose: "2.5 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Hypertension, heart failure, post-MI protection", 
    category: "Cardiovascular",
    info: "Angiotensin-Converting Enzyme (ACE) Inhibitor. Blocks bradykinin breakdown. Renal protective.",
    sideEffects: "Dry cough, hyperkalemia, acute kidney injury risk, angioedema.",
    contraindications: "Pregnancy, history of angioedema, bilateral renal artery stenosis."
  },
  { 
    name: "Lisinopril", 
    defaultDose: "10 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Hypertension, heart failure, post-myocardial infarction", 
    category: "Cardiovascular",
    info: "ACE inhibitor. Monitor renal function and serum potassium.",
    sideEffects: "Dry cough, orthostatic hypotension, renal impairment.",
    contraindications: "Pregnancy, prior angioedema."
  },
  { 
    name: "Losartan", 
    defaultDose: "50 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Hypertension, diabetic nephropathy in Type 2 DM", 
    category: "Cardiovascular",
    info: "Angiotensin II Receptor Blocker (ARB). Alternative for patients who complain of dry cough with ACE-i.",
    sideEffects: "Hyperkalemia, dizziness, orthostatic hypotension, renal impairment.",
    contraindications: "Pregnancy, concurrent aliskiren in diabetic patients."
  },
  { 
    name: "Candesartan", 
    defaultDose: "8 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Hypertension, heart failure with reduced ejection fraction", 
    category: "Cardiovascular",
    info: "Potent ARB. Promotes vasodilation and reduces aldosterone levels.",
    sideEffects: "Hypotension, hyperkalemia, renal impairment.",
    contraindications: "Pregnancy, severe hepatic impairment, cholestasis."
  },
  { 
    name: "Bisoprolol", 
    defaultDose: "2.5 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Heart failure, stable chronic angina, hypertension", 
    category: "Cardiovascular",
    info: "Beta-1 selective Adrenoceptor Antagonist. Negative inotrope. Slows heart rate.",
    sideEffects: "Bradycardia, cold extremities, fatigue, bronchospasm, sleep disturbances.",
    contraindications: "Asthma, severe COPD, heart block (2nd/3rd degree), decompensated heart failure."
  },
  { 
    name: "Atenolol", 
    defaultDose: "50 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Hypertension, angina, arrhythmias", 
    category: "Cardiovascular",
    info: "Water-soluble Beta-blocker. Avoid abrupt withdrawal.",
    sideEffects: "Fatigue, bradycardia, cold extremities, sleep apnea worsening.",
    contraindications: "Asthma, bradycardia (<45-50 bpm), cardiogenic shock."
  },
  { 
    name: "Propranolol", 
    defaultDose: "40 mg", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "Chronic", 
    indication: "Therapeutic tremor, migraine prophylaxis, anxiety, portal HTN", 
    category: "Cardiovascular",
    info: "Non-selective Beta-blocker. Highly lipid soluble. Competes for central CNS receptors.",
    sideEffects: "Vivid dreams, bradycardia, cold extremities, bronchospasm.",
    contraindications: "Asthma, bronchospasm history, sick sinus syndrome."
  },
  { 
    name: "Atorvastatin", 
    defaultDose: "20 mg", 
    defaultFreq: "ON (At night)", 
    defaultDuration: "Chronic", 
    indication: "Hyperlipidemia, primary/secondary cardiovascular prevention", 
    category: "Cardiovascular",
    info: "HMG-CoA Reductase Inhibitor. Highly efficacious statin. Lowers LDL-C.",
    sideEffects: "Myalgia/myopathy, elevated LFTs, headache, GI upset.",
    contraindications: "Active liver disease, pregnancy, persistent unexplained Transaminase elevations."
  },
  { 
    name: "Simvastatin", 
    defaultDose: "40 mg", 
    defaultFreq: "ON (At night)", 
    defaultDuration: "Chronic", 
    indication: "Hypercholesterolaemia", 
    category: "Cardiovascular",
    info: "Statin. Has significant CYP3A4 drug interactions. Advise patient to avoid grapefruit juice.",
    sideEffects: "Myalgia, rhabdomyolysis (rare), hepatotoxicity.",
    contraindications: "Pregnancy, concurrent use of strong CYP3A4 inhibitors (e.g. clarithromycin)."
  },
  { 
    name: "Aspirin (Low Dose)", 
    defaultDose: "75 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Secondary prevention of thrombotic cerebrovascular/cardiovascular disease", 
    category: "Cardiovascular",
    info: "Antiplatelet. Cox-1 inhibitor. Suppresses Thromboxane A2 production.",
    sideEffects: "Gastrointestinal hemorrhage, dyspepsia, bronchospasm (aspirin-sensitive asthma).",
    contraindications: "Active peptic ulceration, hemophilia, children under 16 (Reye's syndrome)."
  },
  { 
    name: "Clopidogrel", 
    defaultDose: "75 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Secondary prevention of MI, stroke, peripheral arterial disease", 
    category: "Cardiovascular",
    info: "Antiplatelet. Prodrug activating through CYP2C19. Irreversible P2Y12 inhibitor.",
    sideEffects: "Bleeding, bruising, gastrointestinal discomfort, diarrhea.",
    contraindications: "Active pathological bleeding (e.g., peptic ulcer, intracranial hemorrhage)."
  },
  { 
    name: "Warfarin", 
    defaultDose: "As per INR", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Atrial fibrillation, mechanical heart valves, DVT/PE prophylaxis", 
    category: "Cardiovascular",
    info: "Vitamin K Antagonist. Highly variable dosing. Targets INR 2.0-3.0 or 2.5-3.5.",
    sideEffects: "Hemorrhage, purple toes syndrome, skin necrosis.",
    contraindications: "Pregnancy (teratogenic), active severe bleeding, severe uncontrolled hypertension."
  },
  { 
    name: "Rivaroxaban", 
    defaultDose: "20 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Non-valvular atrial fibrillation, DVT/PE treatment", 
    category: "Cardiovascular",
    info: "DOAC. Direct Factor Xa Inhibitor. No routine INR monitoring required. Take with food.",
    sideEffects: "Bleeding, anemia, wound secretion, elevated transaminases.",
    contraindications: "Active clinically significant bleeding, hepatic disease associated with coagulopathy."
  },
  { 
    name: "Apixaban", 
    defaultDose: "5 mg", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "Chronic", 
    indication: "AF stroke prevention, DVT/PE therapy", 
    category: "Cardiovascular",
    info: "DOAC. Direct Factor Xa inhibitor. Favorable safety profile with lower major GI bleeding rates.",
    sideEffects: "Bruising, epistaxis, hematuria, hemoptysis.",
    contraindications: "Severe hepatic impairment, active hemorrhage."
  },
  { 
    name: "Furosemide", 
    defaultDose: "40 mg", 
    defaultFreq: "OD (Mane)", 
    defaultDuration: "Chronic", 
    indication: "Fluid overload, congestive heart failure, pulmonary edema", 
    category: "Cardiovascular",
    info: "Loop Diuretic. Inhibits Na-K-2Cl cotransporter in ascending loop of Henle.",
    sideEffects: "Hypokalemia, hyponatremia, dehydration, gout/hyperuricemia, ototoxicity (high dose).",
    contraindications: "Anuria, severe hyporenal state, renal failure due to nephrotoxic agents."
  },
  { 
    name: "Spironolactone", 
    defaultDose: "25 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "NYHA Class II-IV Heart Failure, primary aldosteronism, ascites", 
    category: "Cardiovascular",
    info: "Aldosterone receptor antagonist. Potassium-sparing diuretic. Monitor K levels.",
    sideEffects: "Hyperkalemia, gynecomastia, menstrual irregularities, acute kidney injury.",
    contraindications: "Anuria, acute renal failure, Addison's disease, baseline hyperkalemia (>5.0 mmol/L)."
  },
  { 
    name: "Digoxin", 
    defaultDose: "125 mcg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Atrial fibrillation with rapid ventricular rate, severe heart failure", 
    category: "Cardiovascular",
    info: "Cardiac glycoside. Positive inotrope, negative chronotrope. Narrow therapeutic index.",
    sideEffects: "Nausea, vomiting, green-yellow visual halos, bradycardia, confusion.",
    contraindications: "Ventricular fibrillation, hypertrophic obstructive cardiomyopathy (HOCM)."
  },
  { 
    name: "Amiodarone", 
    defaultDose: "200 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Tachyarrhythmias, prophylaxis of VT/VF", 
    category: "Cardiovascular",
    info: "Class III Antiarrhythmic. Highly iodine-rich. Accumulates in tissues. Long half-life.",
    sideEffects: "Thyroid dysfunction, pulmonary fibrosis, corneal microdeposits, blue skin discoloration.",
    contraindications: "Sinus bradycardia, SA/AV blocks without pacemaker, thyroid disease history."
  },

  // ==========================================
  // CHAPTER 3: RESPIRATORY SYSTEM
  // ==========================================
  { 
    name: "Salbutamol Inhaler", 
    defaultDose: "100 mcg (2 puffs)", 
    defaultFreq: "PRN (As needed)", 
    defaultDuration: "Chronic", 
    indication: "Asthma or COPD bronchodilation, acute relief", 
    category: "Respiratory",
    info: "Short-Acting Beta-2 Agonist (SABA). Fast-acting rescue medicine.",
    sideEffects: "Tremor, tachycardia, palpitations, hypokalemia (high dosage), headache.",
    contraindications: "Hypersensitivity to inhaled propellant."
  },
  { 
    name: "Clenil Modulite", 
    defaultDose: "100 mcg (2 puffs)", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "Chronic", 
    indication: "Prophylaxis of mild, moderate, or severe asthma", 
    category: "Respiratory",
    info: "Inhaled Corticosteroid (ICS). Reduce swelling and inflammation in lungs. Rinse mouth after use.",
    sideEffects: "Oral candidiasis (thrush), dysphonia (hoarse voice), sore throat, cough.",
    contraindications: "Active pulmonary tuberculosis."
  },
  { 
    name: "Symbicort (Budesonide/Formoterol)", 
    defaultDose: "200/6 mcg (1 puff)", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "Chronic", 
    indication: "Asthma chronic management, severe COPD", 
    category: "Respiratory",
    info: "Combination Inhaled Corticosteroid (ICS) + Long-Acting Beta-2 Agonist (LABA).",
    sideEffects: "Tremors, palpitations, oral thrush, mild pneumonia risk in COPD.",
    contraindications: "Hypersensitivity to budesonide/lactose."
  },
  { 
    name: "Prednisolone", 
    defaultDose: "40 mg", 
    defaultFreq: "OD (Mane)", 
    defaultDuration: "5 days", 
    indication: "Acute severe asthma exacerbation, severe COPD exacerbation", 
    category: "Respiratory",
    info: "Systemic oral glucocorticoid. Standard acute short-burst therapy. Take in morning to prevent insomnia.",
    sideEffects: "Hyperglycemia, fluid retention, mood swings, increased appetite, sleep issues.",
    contraindications: "Systemic fungal infection, untreated systemic infections."
  },
  { 
    name: "Tiotropium (HandiHaler)", 
    defaultDose: "18 mcg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "COPD maintenance treatment, severe asthma adjunctive", 
    category: "Respiratory",
    info: "Long-Acting Muscarinic Antagonist (LAMA). Dry powder inhaler. Anticholinergic.",
    sideEffects: "Dry mouth, urinary retention, blurred vision, constipation.",
    contraindications: "Hypersensitivity to atropine or milk proteins."
  },
  { 
    name: "Montelukast", 
    defaultDose: "10 mg", 
    defaultFreq: "ON (At night)", 
    defaultDuration: "Chronic", 
    indication: "Asthma prophylaxis, seasonal allergic rhinitis", 
    category: "Respiratory",
    info: "Leukotriene receptor antagonist. Effective for exercise-induced bronchospasm. Take at night.",
    sideEffects: "Neuropsychiatric changes (hallucinations, aggressive behavior), headache, abdominal pain.",
    contraindications: "Hypersensitivity."
  },

  // ==========================================
  // CHAPTER 4: NERVOUS SYSTEM & PAIN
  // ==========================================
  { 
    name: "Paracetamol", 
    defaultDose: "1 g", 
    defaultFreq: "QDS (Four times / day)", 
    defaultDuration: "PRN", 
    indication: "Mild-to-moderate pain, pyrexia", 
    category: "Nervous System & Pain",
    info: "Analgesic and antipyretic. Do not exceed 4g (4000mg) per 24 hours. Hepatotoxicity risk in overdose.",
    sideEffects: "Extremely rare in therapeutic doses; cutaneous hypersensitivity (rare).",
    contraindications: "Severe hepatic impairment."
  },
  { 
    name: "Ibuprofen", 
    defaultDose: "400 mg", 
    defaultFreq: "TDS (Three times / day)", 
    defaultDuration: "5 days", 
    indication: "Mild-to-moderate pain, inflammatory conditions", 
    category: "Nervous System & Pain",
    info: "NSAID. Non-selective COX-1 & COX-2 inhibitor. Take with food or milk.",
    sideEffects: "Dyspepsia, peptic ulcer, renal impairment, fluid retention, gastrointestinal bleed.",
    contraindications: "Active GI ulceration, severe heart failure, severe renal impairment, 3rd trimester pregnancy."
  },
  { 
    name: "Naproxen", 
    defaultDose: "500 mg", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "5 days", 
    indication: "Rheumatoid arthritis, osteoarthritis, acute MSK disorders, gout", 
    category: "Nervous System & Pain",
    info: "NSAID. Longer half-life than ibuprofen. Co-prescribe PPI in elderly or high GI-risk patients.",
    sideEffects: "Gastrointestinal bleeding, epigastric pain, headache, fluid retention.",
    contraindications: "Active duodenal ulcer, severe heart failure."
  },
  { 
    name: "Diclofenac", 
    defaultDose: "50 mg", 
    defaultFreq: "TDS (Three times / day)", 
    defaultDuration: "5 days", 
    indication: "Acute post-operative pain, soft tissue trauma, acute gout spasm", 
    category: "Nervous System & Pain",
    info: "NSAID. Potent anti-inflammatory. Contraindicated in cardiovascular diseases.",
    sideEffects: "Fluid retention, hepatic enzyme elevation, ulcerogenesis.",
    contraindications: "Ischaemic heart disease, cerebrovascular disease, peripheral arterial disease, NYHA II-IV HF."
  },
  { 
    name: "Celecoxib", 
    defaultDose: "100 mg", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "Chronic", 
    indication: "Osteoarthritis, Rheumatoid arthritis, Ankylosing spondylitis", 
    category: "Nervous System & Pain",
    info: "Selective COX-2 Inhibitor. Reduced gastrointestinal side effects compared to non-selective NSAIDs.",
    sideEffects: "Sinusitis, peripheral edema, abdominal pain, indigestion.",
    contraindications: "Ischemic heart disease, active peptic ulcer, sulfonamide allergy."
  },
  { 
    name: "Codeine Phosphate", 
    defaultDose: "30 mg", 
    defaultFreq: "QDS (Four times / day)", 
    defaultDuration: "PRN", 
    indication: "Moderate pain unresponsive to simple analgesics", 
    category: "Nervous System & Pain",
    info: "Weak opioid agonist. Partially converted to morphine via CYP2D6. Ultra-rapid metabolizer risks.",
    sideEffects: "Constipation, nausea, sedation, respiratory depression, physical dependance.",
    contraindications: "Respiratory depression, coma, acute ulcerative colitis, children under 12."
  },
  { 
    name: "Tramadol Hydrochloride", 
    defaultDose: "50 mg", 
    defaultFreq: "QDS (Four times / day)", 
    defaultDuration: "PRN", 
    indication: "Moderate-to-severe acute or chronic pain", 
    category: "Nervous System & Pain",
    info: "Atypical opioid agonist & weak serotonin/noradrenaline reuptake inhibitor. Seizure risk.",
    sideEffects: "Nausea, dizziness, dry mouth, somnolence, sweating, lowered seizure threshold.",
    contraindications: "Uncontrolled epilepsy, concurrent MAOIs, acute alcohol intoxication."
  },
  { 
    name: "Amitriptyline", 
    defaultDose: "10 mg", 
    defaultFreq: "ON (At night)", 
    defaultDuration: "Chronic", 
    indication: "Neuropathic pain, chronic tension-type headache prophylaxis", 
    category: "Nervous System & Pain",
    info: "Tricyclic Antidepressant (TCA). Sub-antidepressant dose used for neuropathy.",
    sideEffects: "Dry mouth, drowsiness, urinary retention, blurred vision, orthostatic hypotension.",
    contraindications: "Acute recovery phase of myocardial infarction, heart blocks, manic phase."
  },
  { 
    name: "Gabapentin", 
    defaultDose: "300 mg", 
    defaultFreq: "TDS (Three times / day)", 
    defaultDuration: "Chronic", 
    indication: "Peripheral neuropathic pain, epilepsy (focal seizures)", 
    category: "Nervous System & Pain",
    info: "GABA analogue. Structurally related to GABA but does not act on GABA receptors directly.",
    sideEffects: "Somnolence, ataxia, dizziness, peripheral edema, viral infection susceptibility.",
    contraindications: "Acute pancreatitis."
  },
  { 
    name: "Pregabalin", 
    defaultDose: "75 mg", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "Chronic", 
    indication: "Peripheral/central neuropathic pain, generalized anxiety disorder, epilepsy", 
    category: "Nervous System & Pain",
    info: "Class C Controlled Drug. High potential for misuse. Monitor renal clearance.",
    sideEffects: "Weight gain, somnolence, dry mouth, peripheral edema, visual disturbances.",
    contraindications: "Hypersensitivity."
  },
  { 
    name: "Sertraline", 
    defaultDose: "50 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Major depressive disorder, panic disorder, obsessive-compulsive disorder", 
    category: "CNS & Psychiatry",
    info: "Selective Serotonin Reuptake Inhibitor (SSRI). First-line antidepressant. Patient counseling on early anxiety escalation.",
    sideEffects: "Nausea, diarrhea, insomnia, sexual dysfunction, hyponatremia, Serotonin Syndrome.",
    contraindications: "Concurrent MAOI inhibitors, unstable epilepsy."
  },
  { 
    name: "Citalopram", 
    defaultDose: "20 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Depressive illness, panic disorder", 
    category: "CNS & Psychiatry",
    info: "SSRI. High dose linked with dose-dependent QT interval prolongation.",
    sideEffects: "Dry mouth, excess sweating, sexual dysfunction, fatigue, nausea.",
    contraindications: "QT-interval prolongation, concurrent QT-prolonging medicines."
  },
  { 
    name: "Fluoxetine", 
    defaultDose: "20 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Depression, bulimia nervosa, OCD", 
    category: "CNS & Psychiatry",
    info: "SSRI with exceptionally long half-life. Ideal if compliance is an issue.",
    sideEffects: "Insomnia, transient diarrhea, decreased appetite, skin rashes.",
    contraindications: "Uncontrolled cardiac failure."
  },
  { 
    name: "Diazepam", 
    defaultDose: "2 mg", 
    defaultFreq: "TDS (Three times / day)", 
    defaultDuration: "7 days", 
    indication: "Severe disabling acute anxiety, acute muscle spasm, alcohol withdrawal", 
    category: "CNS & Psychiatry",
    info: "Benzodiazepine. Facilitates GABA binding. Controlled drug. Limit to max 2-4 weeks to prevent tolerance.",
    sideEffects: "Somnolence, muscle weakness, confusion, physical dependence, ataxia.",
    contraindications: "Respiratory depression, sleep apnea, severe hepatic impairment, myasthenia gravis."
  },
  { 
    name: "Zopiclone", 
    defaultDose: "7.5 mg", 
    defaultFreq: "ON (At night)", 
    defaultDuration: "7 days", 
    indication: "Short-term management of severe debilitating insomnia", 
    category: "CNS & Psychiatry",
    info: "Z-drug. GABA receptor positive modulator. Avoid long-term prescribing.",
    sideEffects: "Bitter taste, dry mouth, next-day drowsiness, confusion.",
    contraindications: "Respiratory failure, sleep apnea, neuromuscular disorders."
  },
  { 
    name: "Mirtazapine", 
    defaultDose: "15 mg", 
    defaultFreq: "ON (At night)", 
    defaultDuration: "Chronic", 
    indication: "Major depressive episode", 
    category: "CNS & Psychiatry",
    info: "Noradrenergic and specific serotonergic antidepressant (NaSSA). Sedating antihistamine action at 15mg.",
    sideEffects: "Somnolence, increased appetite, substantial weight gain, dry mouth.",
    contraindications: "Concurrent MAO inhibitors."
  },

  // ==========================================
  // CHAPTER 5: INFECTIONS (ANTI-INFECTIVES)
  // ==========================================
  { 
    name: "Amoxicillin", 
    defaultDose: "500 mg", 
    defaultFreq: "TDS (Three times / day)", 
    defaultDuration: "5 days", 
    indication: "Uncomplicated community-acquired pneumonia, acute sinusitis, otitis media", 
    category: "Infections",
    info: "Beta-lactam beta-lactamase sensitive Penicillin. Disrupts bacterial cell wall synthesis.",
    sideEffects: "Diarrhea, skin rash, nausea, hypersensitivity reactions.",
    contraindications: "True penicillin allergy."
  },
  { 
    name: "Co-amoxiclav", 
    defaultDose: "625 mg", 
    defaultFreq: "TDS (Three times / day)", 
    defaultDuration: "7 days", 
    indication: "Complicated UTIs, human/animal bites, dental abscess w/ cellulitis", 
    category: "Infections",
    info: "Combination penicillin (Amoxicillin) + Beta-lactamase inhibitor (Clavulanic acid).",
    sideEffects: "Diarrhea, oral thrush, transient transaminase increases, cholestatic jaundice (rare).",
    contraindications: "Penicillin allergy, history of amoxicillin-associated jaundice/hepatic impairment."
  },
  { 
    name: "Phenoxymethylpenicillin (Penicillin V)", 
    defaultDose: "500 mg", 
    defaultFreq: "QDS (Four times / day)", 
    defaultDuration: "10 days", 
    indication: "Streptococcal tonsillitis/pharyngitis, rheum fever prophylaxis", 
    category: "Infections",
    info: "Narrow-spectrum natural penicillin. Poor oral bio-availability compared to Amoxicillin. Take on empty stomach.",
    sideEffects: "Abdominal discomfort, urticaria, diarrhea.",
    contraindications: "Penicillin hypersensitivity."
  },
  { 
    name: "Flucloxacillin", 
    defaultDose: "500 mg", 
    defaultFreq: "QDS (Four times / day)", 
    defaultDuration: "7 days", 
    indication: "Cellulitis, impetigo, surgical site bone & joint infections", 
    category: "Infections",
    info: "Penicillinase-resistant natural penicillin. Indicated for penicillin-resistant Staphylococcal infections.",
    sideEffects: "GI symptoms, cholestatic hepatitis (can manifest up to weeks after stopping), rash.",
    contraindications: "Penicillin hypersensitivity, history of flucloxacillin-induced liver dysfunction."
  },
  { 
    name: "Clarithromycin", 
    defaultDose: "500 mg", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "7 days", 
    indication: "Lower/upper respiratory tract infections, H. pylori eradication", 
    category: "Infections",
    info: "Macrolide Antibiotic. Competes on 50S ribosomal subunit. Inhibits CYP3A4.",
    sideEffects: "Cholestatic diarrhea, metallic taste, nausea, QT prolongation.",
    contraindications: "QT-prolongation, clinically significant electrolyte disturbances, concurrent CYP3A4 substrates (e.g., simvastatin)."
  },
  { 
    name: "Erythromycin", 
    defaultDose: "500 mg", 
    defaultFreq: "QDS (Four times / day)", 
    defaultDuration: "7 days", 
    indication: "Respiratory infections, acne, penicillin allergy alternative", 
    category: "Infections",
    info: "Macrolide antibiotic. Strong GI prokinetic effect.",
    sideEffects: "Abdominal cramping (very common), nausea, diarrhea, cholestatic jaundice.",
    contraindications: "Concurrent astemizole, terfenadine, or simvastatin."
  },
  { 
    name: "Azithromycin", 
    defaultDose: "500 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "3 days", 
    indication: "Uncomplicated genital chlamydial infection, traveler's diarrhea", 
    category: "Infections",
    info: "Macrolide with long intracellular half-life. Standard 3-day course equivalent to 7 days of erythromycin.",
    sideEffects: "Hearing loss (prolonged high doses), loose diarrhea, nausea.",
    contraindications: "Hepatic dysfunction history."
  },
  { 
    name: "Doxycycline", 
    defaultDose: "100 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "7 days", 
    indication: "Exacerbation of chronic bronchitis, chlamydia, Lyme disease, acne vulgaris", 
    category: "Infections",
    info: "Tetracycline antibiotic. Reversible 30S subunit blockade. Avoid antacids & dairy within 2h. Protect skin from sunburn.",
    sideEffects: "Photosensitivity, esophageal irritation, teeth permanent discoloration (avoid in under 12s/pregnancy).",
    contraindications: "Pregnancy, lactating parents, children under 12."
  },
  { 
    name: "Ciprofloxacin", 
    defaultDose: "500 mg", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "7 days", 
    indication: "Pseudomonal infections, complicated UTI, severe acute gastroenteritis", 
    category: "Infections",
    info: "Fluoroquinolone. Inhibits DNA gyrase. Tendon rupture, aortic dissection precautions.",
    sideEffects: "Dyspepsia, QT prolongation, tendonitis, tendon rupture, peripheral neuropathy.",
    contraindications: "History of tendon disorders related to fluoroquinolone administration."
  },
  { 
    name: "Nitrofurantoin", 
    defaultDose: "100 mg (M/R)", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "3 days", 
    indication: "Acute uncomplicated lower urinary tract infection (cystitis)", 
    category: "Infections",
    info: "Urinary tract antiseptic. First-line for simple cystitis. Active only in urine. Ineffective if eGFR <30.",
    sideEffects: "Nausea, flatulence, peripheral neuropathy, dark yellow/brown urine, pulmonary fibrosis (chronic use).",
    contraindications: "Renal impairment (eGFR <30), term pregnancy (infant risk of hemolytic anemia)."
  },
  { 
    name: "Trimethoprim", 
    defaultDose: "200 mg", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "3 days", 
    indication: "Uncomplicated urinary tract infections", 
    category: "Infections",
    info: "Dihydrofolate reductase inhibitor. Restricts folate synthesis.",
    sideEffects: "Pruritus, skin rashes, hyperkalemia, megaloblastic anemia.",
    contraindications: "Severe blood dyscrasias, folate-deficient anemia, pregnancy."
  },
  { 
    name: "Cephalexin", 
    defaultDose: "500 mg", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "7 days", 
    indication: "Mild-to-moderate skin & soft tissue infections, recurrent UTI prophylaxis", 
    category: "Infections",
    info: "First-generation cephalosporin. Cross-sensitivity in ~5-10% of penicillin-sensitive individuals.",
    sideEffects: "Diarrhea, eosinophilia, pseudomembranous colitis.",
    contraindications: "Severe cephalosporin hypersensitivity."
  },
  { 
    name: "Metronidazole", 
    defaultDose: "400 mg", 
    defaultFreq: "TDS (Three times / day)", 
    defaultDuration: "5 days", 
    indication: "Anaerobic bacterial infections, bacterial vaginosis, trichomoniasis, giardiasis", 
    category: "Infections",
    info: "Nitroimidazole antimicrobic. Direct toxic cellular DNA blockade. Instruct patient to avoid alcohol.",
    sideEffects: "Metallic taste, disulfiram-like reaction (with alcohol), peripheral neuropathy (long-term).",
    contraindications: "Active neurological disease, severe hepatic impairment, first trimester pregnancy."
  },
  { 
    name: "Fluconazole", 
    defaultDose: "150 mg", 
    defaultFreq: "Single Dose", 
    defaultDuration: "1 day", 
    indication: "Vaginal candidiasis (thrush), mucosal candidiasis", 
    category: "Infections",
    info: "Triazole Antifungal. Inhibits fungal cytochrome P450 lipid synthesis. Elevated drug interactions.",
    sideEffects: "Abdominal pain, rash, transient liver enzyme increases.",
    contraindications: "Concurrent QT-prolonging drugs (e.g. cisapride, quinidine)."
  },
  { 
    name: "Aciclovir", 
    defaultDose: "400 mg", 
    defaultFreq: "TDS (Three times / day)", 
    defaultDuration: "5 days", 
    indication: "Genital or mucocutaneous Herpes Simplex, Varicella Zoster virus", 
    category: "Infections",
    info: "Nucleoside analogue antiviral. Inhibits viral DNA polymerase. Hydrate client to avoid renal crystalluria.",
    sideEffects: "Nausea, vomiting, headache, acute kidney injury (infusion).",
    contraindications: "Hypersensitivity."
  },

  // ==========================================
  // CHAPTER 6: ENDOCRINE SYSTEM
  // ==========================================
  { 
    name: "Metformin", 
    defaultDose: "500 mg", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "Chronic", 
    indication: "Type 2 Diabetes Mellitus first-line therapy", 
    category: "Endocrine",
    info: "Biguanide. Enhances insulin sensitivity and reduces hepatic glucose production. Take with food.",
    sideEffects: "Anorexia, abdominal pain, diarrhea, metallic taste, lactic acidosis (rare).",
    contraindications: "Severe renal impairment (eGFR <30), decompensated heart failure, metabolic acidosis."
  },
  { 
    name: "Gliclazide", 
    defaultDose: "40 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Type 2 Diabetes Mellitus when metformin insufficient", 
    category: "Endocrine",
    info: "Sulfonylurea. Stimulates pancreatic beta cell insulin secretion. Counseling on hypoglycemia metrics.",
    sideEffects: "Hypoglycemia, weight gain, temporary visual disturbances at initiation.",
    contraindications: "Type 1 diabetes, ketoacidosis, severe hepatic/renal impairment."
  },
  { 
    name: "Levothyroxine", 
    defaultDose: "100 mcg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Primary hypothyroidism, TSH suppression", 
    category: "Endocrine",
    info: "Thyroid hormone T4 replacement. Take 30-60 mins before breakfast on empty stomach with water.",
    sideEffects: "Symptoms of hyperthyroidism (arrhythmia, tremor, insomnia, sweating) if over-replaced.",
    contraindications: "Adrenal insufficiency (untreated), thyrotoxicosis."
  },
  { 
    name: "Dapagliflozin", 
    defaultDose: "10 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Type 2 diabetes, HFrEF, chronic kidney disease", 
    category: "Endocrine",
    info: "SGLT2 Inhibitor. Blocks renal glucose reabsorption in proximal tubule. Osmotic diuresis.",
    sideEffects: "UTIs, genital mycotic infections (thrush), polyuria, euglycemic ketoacidosis (rare).",
    contraindications: "Active bladder cancer, severe renal failure on dialysis."
  },
  { 
    name: "Alendronic Acid", 
    defaultDose: "70 mg", 
    defaultFreq: "Once weekly", 
    defaultDuration: "Chronic", 
    indication: "Postmenopausal osteoporosis, corticosteroid-induced osteoporosis", 
    category: "Endocrine",
    info: "Bisphosphonate. Inhibits osteoclasts. Stand/sit upright for 30 mins after taking; swallow whole with tap water.",
    sideEffects: "Esophagitis, atypical femoral fractures, osteonecrosis of jaw.",
    contraindications: "Abnormalities of esophagus, inability to stand/sit upright for 30 mins, hypocalcemia."
  },

  // ==========================================
  // CHAPTER 7: GENITOURINARY & OBSTETRICS
  // ==========================================
  { 
    name: "Tamsulosin", 
    defaultDose: "400 mcg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Benign prostatic hyperplasia urinary difficulties", 
    category: "Genitourinary",
    info: "Alpha-1a Selective Adrenoceptor Antagonist. Smooth muscle relaxer of bladder neck and prostate.",
    sideEffects: "Postural/orthostatic hypotension, retrograde ejaculation, floppy iris syndrome during cataract surgery.",
    contraindications: "Postural hypotension history, severe hepatic insufficiency."
  },
  { 
    name: "Sildenafil", 
    defaultDose: "50 mg", 
    defaultFreq: "PRN (1 hour before activity)", 
    defaultDuration: "PRN", 
    indication: "Erectile dysfunction, pulmonary hypertension", 
    category: "Genitourinary",
    info: "PDE-5 Inhibitor. Activates nitric oxide vasodilatory routes. Strictly avoid co-prescribing nitrates.",
    sideEffects: "Headache, flush, nasal congestion, blue-color visual distortion, dyspepsia.",
    contraindications: "Concurrent Nitrate therapy, unstable angina, recent MI, non-arteritic interior ischemic neuropathy."
  },

  // ==========================================
  // CHAPTER 8: DERMATOLOGY & TOPICAL PREPARATIONS
  // ==========================================
  {
    name: "Hydrocortisone 1% Cream",
    defaultDose: "15g Tube",
    defaultFreq: "Apply thin layer to affected area twice daily",
    defaultDuration: "7 days",
    indication: "Mild eczema, contact dermatitis, insect bites",
    category: "Dermatology",
    info: "Mild Topical Corticosteroid. Reduces inflammatory response. Apply thin layer sparingly.",
    sideEffects: "Local skin burning, thinning (prolonged use), pigmentation alterations.",
    contraindications: "Untreated cutaneous infections, rosacea, acne."
  },
  {
    name: "Betamethasone Valerate 0.1% Cream (Betnovate)",
    defaultDose: "30g Tube",
    defaultFreq: "Apply thin layer to affected area 1-2 times daily",
    defaultDuration: "14 days",
    indication: "Moderate to severe eczema, psoriasis, lichen planus",
    category: "Dermatology",
    info: "Potent Topical Corticosteroid. Suppresses skin inflammation and immune-mediated cell proliferation.",
    sideEffects: "Skin atrophy, striae, telangiectasia, secondary local infections.",
    contraindications: "Viral/fungal skin infections, perioral dermatitis, extensive plaque psoriasis."
  },
  {
    name: "Clobetasol Propionate 0.05% Ointment (Dermovate)",
    defaultDose: "30g Tube",
    defaultFreq: "Apply thin layer to affected area twice daily sparingly",
    defaultDuration: "7 days",
    indication: "Very severe inflammatory skin conditions, resistant eczema, psoriasis",
    category: "Dermatology",
    info: "Super-potent Topical Corticosteroid. Intended for short-term courses on non-facial sites.",
    sideEffects: "Severe skin thinning, systemic systemic absorption leading to Cushing's, contact allergy.",
    contraindications: "Children under 1 year, extensive plaques, pustular psoriasis, facial administration."
  },
  {
    name: "Fusidic Acid 2% Cream (Fucidin)",
    defaultDose: "15g Tube",
    defaultFreq: "Apply to affected area 3 times daily",
    defaultDuration: "7 days",
    indication: "Bacterial skin infections, impetigo, erythrasma, folliculitis",
    category: "Dermatology",
    info: "Topical Antibiotic. Inhibits bacterial protein synthesis. active against Gram+ pathogens.",
    sideEffects: "Mild local hypersensitivity, stinging, pruritus.",
    contraindications: "Hypersensitivity, deep-seated systemic wound infections."
  },
  {
    name: "Fusidic Acid 2% + Hydrocortisone 1% Cream (Fucidin H)",
    defaultDose: "15g Tube",
    defaultFreq: "Apply to affected area twice daily",
    defaultDuration: "7 days",
    indication: "Eczema or dermatitis where bacterial infection is present or suspected",
    category: "Dermatology",
    info: "Co-formulated topical corticosteroid and antibacterial agent. Ideal for infected atopic dermatitis.",
    sideEffects: "Local irritation, allergic contact dermatitis, mild atrophy under occlusion.",
    contraindications: "Primary skin infections (viral, tuberculous, fungal), rosacea."
  },
  {
    name: "Mupirocin 2% Ointment (Bactroban)",
    defaultDose: "15g Tube",
    defaultFreq: "Apply to affected area 3 times daily",
    defaultDuration: "10 days",
    indication: "Bacterial skin infections, MRSA nasal eradication, furunculosis",
    category: "Dermatology",
    info: "Antibacterial agent. Inhibits bacterial isoleucyl-tRNA synthetase. High activity against Staph and Strep.",
    sideEffects: "Burning feeling, local skin itching, dry skin.",
    contraindications: "Hypersensitivity, open systemic deep wounds."
  },
  {
    name: "Clotrimazole 1% Cream (Canesten)",
    defaultDose: "20g Tube",
    defaultFreq: "Apply to affected area 2-3 times daily",
    defaultDuration: "14 days",
    indication: "Fungal skin infections, candidiasis, ringworm, athlete's foot",
    category: "Dermatology",
    info: "Imidazole Antifungal. Alters cell membrane permeability of susceptible fungi. Continue 14 days after resolution.",
    sideEffects: "Local skin redness, stinging, raw sensation, peeling skin.",
    contraindications: "Known hypersensitivity."
  },
  {
    name: "Ketoconazole 2% Shampoo (Nizoral)",
    defaultDose: "120ml Bottle",
    defaultFreq: "Wash scalp twice weekly, leave for 5 mins before rinsing",
    defaultDuration: "4 weeks",
    indication: "Seborrheic dermatitis, pityriasis versicolor, dandruff",
    category: "Dermatology",
    info: "Broad-spectrum synthetic imidazole antifungal agent. Specifically targets Malassezia species.",
    sideEffects: "Hair texture alterations, local irritation, dry scalp.",
    contraindications: "Hypersensitivity."
  },
  {
    name: "Terbinafine 1% Cream (Lamisil)",
    defaultDose: "15g Tube",
    defaultFreq: "Apply to affected area once or twice daily",
    defaultDuration: "7 days",
    indication: "Fungal infections, tinea pedis, tinea corporis, tinea cruris",
    category: "Dermatology",
    info: "Allylamine antifungal agent. Highly lipophilic and keratophilic. Inhibits squalene epoxidase.",
    sideEffects: "Pruritus, skin peeling, erythema at application site.",
    contraindications: "Hypersensitivity."
  },
  {
    name: "Permethrin 5% Cream (Lyclear)",
    defaultDose: "30g Tube",
    defaultFreq: "Apply to entire body from neck down, wash off after 8-12 hours",
    defaultDuration: "Single application (repeat in 7 days if needed)",
    indication: "Scabies infestation, crab lice",
    category: "Dermatology",
    info: "Scabicide / Pyrethroid insecticide. Neurotoxic to Sarcoptes scabiei mites. Ensure whole family is treated.",
    sideEffects: "Transient skin burning or stinging, paresthesia, skin erythema.",
    contraindications: "Hypersensitivity to pyrethrins, neonates under 2 months."
  },
  {
    name: "Benzoyl Peroxide 5% Gel (Acnecide)",
    defaultDose: "40g Tube",
    defaultFreq: "Apply thin layer to affected areas once or twice daily",
    defaultDuration: "12 weeks",
    indication: "Acne vulgaris",
    category: "Dermatology",
    info: "Antibacterial and keratolytic topical agent. Releases oxidizing free radicals killing C. acnes. Bleaches fabrics.",
    sideEffects: "Dry skin, severe peeling, burning, contact dermatitis, erythema.",
    contraindications: "Hypersensitivity, broken skin or open wounds."
  },
  {
    name: "Adapalene 0.1% Gel (Differin)",
    defaultDose: "30g Tube",
    defaultFreq: "Apply thin layer to affected areas once daily at night",
    defaultDuration: "12 weeks",
    indication: "Mild to moderate acne vulgaris",
    category: "Dermatology",
    info: "Third-generation Topical Retinoid. Modulates cellular differentiation, keratinization, and inflammatory processes.",
    sideEffects: "Erythema, scaling, skin dryness, transient burning sensation.",
    contraindications: "Pregnancy, breastfeeding, eczema or broken skin barrier."
  },
  {
    name: "Tretinoin 0.05% Cream (Retin-A)",
    defaultDose: "20g Tube",
    defaultFreq: "Apply thin layer to affected areas once daily at night",
    defaultDuration: "12 weeks",
    indication: "Acne vulgaris, photoaging, hyperpigmentation",
    category: "Dermatology",
    info: "First-generation topical retinoid. Interacts with RAR nuclear receptors to accelerate keratocyte turnover.",
    sideEffects: "Significant scaling, stinging, photosensitivity, erythema.",
    contraindications: "Pregnancy/lactation, family history of cutaneous epithelioma."
  },
  {
    name: "Tacrolimus 0.1% Ointment (Protopic)",
    defaultDose: "30g Tube",
    defaultFreq: "Apply thin layer to affected area twice daily",
    defaultDuration: "Chronic / Intermittent",
    indication: "Moderate to severe atopic dermatitis (second-line, non-steroidal)",
    category: "Dermatology",
    info: "Topical Calcineurin Inhibitor. T-cell activation inhibitor. Safe for face & eyelids; does not cause skin atrophy.",
    sideEffects: "Skin burning or warm sensation, pruritus, transient tingling, alcohol intolerance.",
    contraindications: "Immunocompromised status, active skin virus infections."
  },
  {
    name: "Urea 10% Cream (Dermalibour / Cetaphil)",
    defaultDose: "100g Jar",
    defaultFreq: "Apply liberally to dry skin areas 2-3 times daily or as needed",
    defaultDuration: "Ongoing",
    indication: "Dry, rough, scaly skin conditions, ichthyosis, eczema pruritus",
    category: "Dermatology",
    info: "Dermatological Humectant and Emollient. Enhances water-binding capacity of the stratum corneum.",
    sideEffects: "Mild stinging or irritation when applied to inflamed/cracked areas.",
    contraindications: "Acute oozing eczema, open lesions."
  },
  {
    name: "Aqueous Cream (Cetomacrogol Emollient)",
    defaultDose: "500g Tub",
    defaultFreq: "Apply as often as required as stabilizer moisturizer or soap substitute",
    defaultDuration: "Ongoing",
    indication: "Eczema, dry skin emollient, soap alternative",
    category: "Dermatology",
    info: "Light standard soap substitute and protective emollient for highly sensitive, eczematous skin.",
    sideEffects: "Local skin irritation (often related to SLS content).",
    contraindications: "Known allergy to individual components."
  },
  {
    name: "Calamine Topical Cream / Lotion",
    defaultDose: "200ml Bottle",
    defaultFreq: "Apply to affected area 3-4 times daily as needed for itch",
    defaultDuration: "PRN",
    indication: "Pruritus, sunburn, chickenpox irritation, insect bites",
    category: "Dermatology",
    info: "Mild antipruritic agent with zinc oxide. Provides physical cooling and mild astringent action.",
    sideEffects: "Dry skin residue, transient irritation.",
    contraindications: "Open oozing wounds, before receiving x-ray exposure."
  },
  {
    name: "Minoxidil 5% Topical Spray (Regaine)",
    defaultDose: "60ml Spray Bottle",
    defaultFreq: "Apply 1ml (6 sprays) twice daily to affected scalp areas",
    defaultDuration: "Chronic",
    indication: "Androgenetic alopecia (male/female pattern hair loss)",
    category: "Dermatology",
    info: "Topical vasodilator. Stimulates hair follicle epithelial cell growth. Regular continuous application required.",
    sideEffects: "Local irritation, hypertrichosis (unwanted hair growth elsewhere), contact dermatitis.",
    contraindications: "Sudden unexplained hair loss, scalability or scalp infection."
  },
  {
    name: "Calcipotriol 50 mcg/g Ointment (Dovonex)",
    defaultDose: "30g Tube",
    defaultFreq: "Apply thin layer to affected lesions twice daily",
    defaultDuration: "8 weeks",
    indication: "Plaque psoriasis",
    category: "Dermatology",
    info: "Vitamin D3 Analogue. Inhibits epidermal keratinocyte proliferation and enhances cellular differentiation.",
    sideEffects: "Local skin irritation, facial dermatitis, risk of hypercalcemia if exceeding 100g weekly.",
    contraindications: "Calcium metabolism disorders, severe hepatic/renal impairment."
  },
  {
    name: "Isotretinoin 0.05% Gel (Isotrexin)",
    defaultDose: "30g Tube",
    defaultFreq: "Apply thin layer once or twice daily to clean skin",
    defaultDuration: "12 weeks",
    indication: "Acne vulgaris",
    category: "Dermatology",
    info: "Cis-retinoic acid derivative. Modulates follicular keratinisation to clear comedones.",
    sideEffects: "Dry skin, photosensitivity, localized irritation, skin peeling.",
    contraindications: "Pregnancy, planning pregnancy, severe eczema."
  },
  {
    name: "Zinc Oxide Ointment (Sudocrem)",
    defaultDose: "125g Tub",
    defaultFreq: "Apply thinly as needed at each diaper change or prn",
    defaultDuration: "PRN",
    indication: "Diaper dermatitis, minor skin burns, eczema barrier",
    category: "Dermatology",
    info: "Soothing barrier cream. Provides antiseptic, astringent, and emollient actions protecting from moisture.",
    sideEffects: "Rare transient irritation.",
    contraindications: "Wounds infected with systemic pathogens, hypersensitivity."
  },
  {
    name: "Coal Tar 5% Topical Solution (Psoriderm Cream/Gel)",
    defaultDose: "100g Tube",
    defaultFreq: "Apply to affected areas 1-2 times daily",
    defaultDuration: "4 weeks",
    indication: "Psoriasis, seborrheic dermatitis, chronic eczema",
    category: "Dermatology",
    info: "Anti-inflammatory and keratoplastic topical agent. Normalizes desquamation rate. Stains clothes, has strong odor.",
    sideEffects: "Photosensitivity, folliculitis, skin warming, stains skin.",
    contraindications: "Exudative or pustular psoriasis, broken skin, genital regions."
  },
  {
    name: "Ciclopirox Olamine 1% Cream (Loprox)",
    defaultDose: "30g Tube",
    defaultFreq: "Apply to affected skin twice daily",
    defaultDuration: "14 days",
    indication: "Tinea pedis, tinea versicolor, cutaneous candidiasis",
    category: "Dermatology",
    info: "Broad-spectrum hydroxypyridone antifungal. Chelates polyvalent ions causing cell membrane leakage.",
    sideEffects: "Burning sensation, skin redness, pruritus.",
    contraindications: "Known hypersensitivity."
  },
  {
    name: "Econazole Nitrate 1% Cream (Pevaryl)",
    defaultDose: "30g Tube",
    defaultFreq: "Apply twice daily to affected area",
    defaultDuration: "14 days",
    indication: "Dermatomycoses, vulvovaginal candidiasis dermal manifestation",
    category: "Dermatology",
    info: "Highly active broad-spectrum topical imidazole antimycotic against dermatophytes and yeasts.",
    sideEffects: "Mild burning sensation, erythema, localized scaling.",
    contraindications: "First trimester pregnancy, systemic deep organ mycoses."
  },
  {
    name: "Salicylic Acid 10% in Vaseline Ointment",
    defaultDose: "50g Jar",
    defaultFreq: "Apply to hyperkeratotic skin areas once or twice daily",
    defaultDuration: "14 days",
    indication: "Plaque psoriasis scales, hyperkeratotic hand eczema, warts",
    category: "Dermatology",
    info: "Topical Keratolytic agent. Dissolves intercellular cement binding corneal scales to help peel thick lesions.",
    sideEffects: "Dry skin, salicylate toxicity if applied to massive surface area.",
    contraindications: "Infants, active skin infection, facial or genital applications."
  },
  {
    name: "Dermovate Scalp Application (Clobetasol Propionate 0.05%)",
    defaultDose: "100ml Squeeze Bottle",
    defaultFreq: "Apply sparingly to the scalp twice daily",
    defaultDuration: "10 days",
    indication: "Severe inflammatory conditions of the scalp or psoriasis",
    category: "Dermatology",
    info: "Extremely potent corticosteroid hair-friendly lotion. Minimizes greasy residue in hair.",
    sideEffects: "Local hair thinning, telangiectasia, skin sensitivity.",
    contraindications: "Scalp infections (tinea capitis, herpes zoster, pyoderma)."
  },
  {
    name: "Elica Cream (Mometasone Furoate 0.1%)",
    defaultDose: "30g Tube",
    defaultFreq: "Apply thin layer to affected skin once daily",
    defaultDuration: "14 days",
    indication: "Atopic dermatitis, psoriasis, corticosteroid-responsive dermatoses",
    category: "Dermatology",
    info: "Medium-to-potent synthetic topical corticosteroid. Features high local efficacy with once daily application.",
    sideEffects: "Stinging, acneiform eruptions, burning.",
    contraindications: "Facial rosacea, acne vulgaris, skin infections."
  },
  {
    name: "Elocom Ointment (Mometasone Furoate 0.1%)",
    defaultDose: "30g Tube",
    defaultFreq: "Apply thin layer to affected skin once daily",
    defaultDuration: "14 days",
    indication: "Dry, scaly corticosteroid-responsive skin lesions",
    category: "Dermatology",
    info: "Medium-potency corticosteroid in dry occlusive ointment vehicle, maximizing hydration of rough plaques.",
    sideEffects: "Pruritus, skin atrophy, localized folliculitis.",
    contraindications: "Skin viral lesions, perioral dermatitis."
  },
  {
    name: "Fusibact Cream (Fusidic Acid 2%)",
    defaultDose: "15g Tube",
    defaultFreq: "Apply to affected skin 3 times daily",
    defaultDuration: "7 days",
    indication: "Primary and secondary bacterial skin infections",
    category: "Dermatology",
    info: "Potent topical antibacterial agent. High penetrability across skin layers.",
    sideEffects: "Application site irritation, hypersensitivity reactions.",
    contraindications: "Known hypersensitivity to fusidate sodium."
  },
  {
    name: "Nystatin 100,000 U/g Cream (Mycostatin)",
    defaultDose: "30g Tube",
    defaultFreq: "Apply to cutaneous lesions 2-3 times daily",
    defaultDuration: "14 days",
    indication: "Dermal candidal infections",
    category: "Dermatology",
    info: "Polyene antifungal antibiotic. Specifically effective against dermal Candida albicans species.",
    sideEffects: "Erythema, burning sensation, contact dermatitis.",
    contraindications: "Known hypersensitivity."
  },
  {
    name: "Diprogenta Cream (Betamethasone Valerate + Gentamicin)",
    defaultDose: "30g Tube",
    defaultFreq: "Apply thin layer to affected skin twice daily",
    defaultDuration: "10 days",
    indication: "Inflammatory dermatoses infected with susceptible bacteria",
    category: "Dermatology",
    info: "Combined potent anti-inflammatory corticosteroid and broad-spectrum aminoglycoside antibiotic.",
    sideEffects: "Numbness, skin thinning, hypopigmentation.",
    contraindications: "Perianal and genital pruritus, vaccinia or varicella, tuberculosis."
  },
  {
    name: "Diprosalic Ointment (Betamethasone Dipropionate + Salicylic Acid)",
    defaultDose: "30g Tube",
    defaultFreq: "Apply thin layer to affected skin 1-2 times daily",
    defaultDuration: "14 days",
    indication: "Psoriasis, chronic lichen simplex, hyperkeratotic eczema",
    category: "Dermatology",
    info: "Topical corticosteroid combined with salicylic acid. Promotes peeling while delivering anti-inflammatory steroid.",
    sideEffects: "Skin exfoliation, localized pain, secondary bacterial infection.",
    contraindications: "Rosacea, inflammatory conditions of the face."
  },
  {
    name: "Daivobet Ointment (Calcipotriol + Betamethasone Dipropionate)",
    defaultDose: "30g Tube",
    defaultFreq: "Apply to plaque psoriasis lesions once daily",
    defaultDuration: "4 weeks",
    indication: "Topical treatment of stable plaque psoriasis",
    category: "Dermatology",
    info: "Synergistic dual action agent combining Calcipotriol and potent Betamethasone steroid. Targets dual pathway.",
    sideEffects: "Pruritus, skin exfoliation, psoriasis flare-ups.",
    contraindications: "Severe liver/renal dysfunction, hypercalcemia."
  },
  {
    name: "Differin 0.1% Cream (Adapalene)",
    defaultDose: "30g Tube",
    defaultFreq: "Apply thin layer to acne lesions once daily at bedtime",
    defaultDuration: "12 weeks",
    indication: "Acne vulgaris with dominant comedones",
    category: "Dermatology",
    info: "Topical synthetic retinoid gel/cream. Clears cellular hyperkeratosis in the follicle pore.",
    sideEffects: "Dry skin, burning feeling, skin peeling.",
    contraindications: "Eczematous skin, pregnancy."
  },
  {
    name: "Moisturizing Cream (Cetaphil / CeraVe / Physiogel)",
    defaultDose: "150g Tube",
    defaultFreq: "Apply liberally twice daily or as often as needed for dry skin",
    defaultDuration: "Ongoing",
    indication: "Atopic eczema skin barrier recovery, compromised skin barrier",
    category: "Dermatology",
    info: "Hypoallergenic skin recovery barrier helper cream containing ceramides, lipids and physiological barriers.",
    sideEffects: "Transient mild sting.",
    contraindications: "None known as a general cosmetic moisturizer."
  },
  {
    name: "Avène Cicalfate+ Restorative Protective Cream",
    defaultDose: "40ml Tube",
    defaultFreq: "Apply twice daily to clean, dry, non-oozing skin",
    defaultDuration: "14 days",
    indication: "Skin irritation, post-procedure healing, superficial skin abrasions",
    category: "Dermatology",
    info: "Copper-zinc sulfate formula combined with thermal spring water to soothe and restore fragile skin.",
    sideEffects: "None reported.",
    contraindications: "Oozing acute dermatological wounds."
  },
  {
    name: "La Roche-Posay Cicaplast Baume B5+",
    defaultDose: "40ml Tube",
    defaultFreq: "Apply twice daily to clean dry skin on body or face",
    defaultDuration: "Ongoing",
    indication: "Skin irritation, barrier repair, post-dermatological procedures",
    category: "Dermatology",
    info: "Soothing repairing balm with 5% Panthenol and Madecassoside to support epidermal cell reconstruction.",
    sideEffects: "Extremely low allergen profile.",
    contraindications: "None known."
  },
  {
    name: "Biafine Emulsion (Trolamine 0.67%)",
    defaultDose: "93g Tube",
    defaultFreq: "Apply in thick layers 2-4 times daily and massage gently",
    defaultDuration: "7 days",
    indication: "First and second-degree burns, superficial wounds, erythema",
    category: "Dermatology",
    info: "Wound-healing promoter and skin protectant. Retains cellular hydration and tissue microenvironment.",
    sideEffects: "Transient stinging.",
    contraindications: "Bleeding wounds, infected wounds."
  },
  {
    name: "Silon Cream (Barrier Cream)",
    defaultDose: "40g Tube",
    defaultFreq: "Apply to skin of affected area on each diaper change or PRN",
    defaultDuration: "PRN",
    indication: "Prevention or treatment of urinary or fecal diaper rash",
    category: "Dermatology",
    info: "Moisture-repellent silicone based medical barrier cream designed for diaper or macerated skin protection.",
    sideEffects: "Contact allergy (very rare).",
    contraindications: "None."
  },
  {
    name: "Sebocur Shampoo (Anti-Seborrheic)",
    defaultDose: "150ml Bottle",
    defaultFreq: "Use 2-3 times weekly, leave on scalp for 3-5 mins before washing",
    defaultDuration: "4 weeks",
    indication: "Oily hair scaling, seborrheic dermatitis",
    category: "Dermatology",
    info: "Specially formulated medical hair shampoo containing anti-dandruff and seboregulating active complexes.",
    sideEffects: "Scalp irritation, dry hair ends.",
    contraindications: "Known allergy to active ingredients."
  },
  // ==========================================
  // OPHTHALMOLOGY & ENT MEDICATIONS
  // ==========================================
  {
    name: "Latanoprost Eye Drops 0.005%",
    defaultDose: "5ml Bottle (1 drop in affected eye)",
    defaultFreq: "Once daily in the evening (OD in evening)",
    defaultDuration: "Ongoing",
    indication: "Open-angle glaucoma, ocular hypertension",
    category: "Ophthalmology",
    info: "Prostaglandin analogue. Increases uveoscleral outflow of aqueous humor. Wash hands before use and remove contact lenses.",
    sideEffects: "Iris hyperpigmentation, eyelash changes, conjunctival hyperemia.",
    contraindications: "Hypersensitivity to latanoprost, active intraocular inflammation."
  },
  {
    name: "Timolol Eye Drops 0.5%",
    defaultDose: "5ml Bottle (1 drop in affected eye)",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "Ongoing",
    indication: "Chronic open-angle glaucoma, ocular hypertension",
    category: "Ophthalmology",
    info: "Beta-adrenoceptor blocker. Decreases aqueous humor production. Apply nasolacrimal occlusion for 1-2 minutes to decrease systemic absorption.",
    sideEffects: "Bradycardia, bronchospasm, dry eyes, local irritation.",
    contraindications: "Bradycardia, heart block, asthma, severe COPD."
  },
  {
    name: "Tobramycin Eye Drops 0.3%",
    defaultDose: "5ml Bottle (1-2 drops in affected eye)",
    defaultFreq: "QDS (Four times daily / every 4 hours)",
    defaultDuration: "7 days",
    indication: "Bacterial conjunctivitis, superficial external ocular infections",
    category: "Ophthalmology",
    info: "Aminoglycoside bactericidal antibiotic. High efficacy against Gram-negative pathogens.",
    sideEffects: "Localized ocular toxicity, lid itching, swelling, conjunctival erythema.",
    contraindications: "Hypersensitivity to aminoglycoside antibiotics."
  },
  {
    name: "Prednisolone Acetate Eye Drops 1%",
    defaultDose: "5ml Susp (1 drop in affected eye)",
    defaultFreq: "QDS (Four times daily / every 4 hours)",
    defaultDuration: "10 days (with gradual taper)",
    indication: "Non-infectious ocular inflammation, post-operative ocular inflammation",
    category: "Ophthalmology",
    info: "Potent topical ophthalmic corticosteroid. Shake well before use. Monitor IOP closely if used for more than 2 weeks.",
    sideEffects: "Increased intraocular pressure (IOP), glaucoma, posterior subcapsular cataract.",
    contraindications: "Viral, fungal, or tuberculous eye infections, untreated purulent bacterial infections."
  },
  {
    name: "Sodium Hyaluronate 0.15% Eye Drops (Lubricant)",
    defaultDose: "10ml Bottle (1 drop in both eyes)",
    defaultFreq: "PRN (As needed, 3-5 times daily)",
    defaultDuration: "Ongoing",
    indication: "Moderate to severe dry eye syndrome, corneal hydration, post-operative eye lubrication",
    category: "Ophthalmology",
    info: "Preservative-free viscoelastic tear substitute. Provides persistent and soothing lubrication without causing transient blurred vision.",
    sideEffects: "None reported, transient mild stinging or burning may occur very rarely.",
    contraindications: "None known."
  },
  {
    name: "Olopatadine Eye Drops 0.1%",
    defaultDose: "5ml Bottle (1 drop in both eyes)",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "14 days",
    indication: "Allergic conjunctivitis, seasonal ocular itching, hyperreactivity",
    category: "Ophthalmology",
    info: "Dual-action antihistamine and mast cell stabilizer. High affinity receptor blocker providing rapid relief.",
    sideEffects: "Ocular burning, dry eyes, headache, dysgeusia.",
    contraindications: "Hypersensitivity to olopatadine."
  },
  {
    name: "Chloramphenicol 1% Eye Ointment",
    defaultDose: "4g Tube (Apply 1 cm ribbon inside lower eyelid)",
    defaultFreq: "Once daily at bedtime (OD before sleep)",
    defaultDuration: "7 days",
    indication: "Acute bacterial conjunctivitis, blepharitis, superficial corneal abrasions",
    category: "Ophthalmology",
    info: "Broad-spectrum bacteriostatic antibiotic ointment. Ideal for nighttime coverage or supportive healing.",
    sideEffects: "Temporary blurred vision, transient burning/stinging.",
    contraindications: "Hypersensitivity to chloramphenicol, history of bone marrow suppression."
  },
  {
    name: "Tobramycin 0.3% + Dexamethasone 0.1% Eye Ointment",
    defaultDose: "3.5g Tube (Apply 1 cm ribbon inside lower eyelid)",
    defaultFreq: "TDS (Three times daily)",
    defaultDuration: "7 days",
    indication: "Steroid-responsive inflammatory ocular conditions with bacterial infection risk",
    category: "Ophthalmology",
    info: "Combination glucocorticoid and aminoglycoside. Indicated for severe blepharitis or post-operative tissue healing.",
    sideEffects: "IOP elevation, delayed wound healing, secondary infections.",
    contraindications: "Epithelial herpes simplex, vaccinia, varicella, fungal infections of the eye."
  },
  {
    name: "Tetracycline 1% Eye Ointment",
    defaultDose: "5g Tube (Apply 1 cm ribbon inside lower eyelid)",
    defaultFreq: "QDS (Four times daily / every 4 hours)",
    defaultDuration: "10 days",
    indication: "Trachoma, marginal blepharitis, bacterial superficial ophthalmia",
    category: "Ophthalmology",
    info: "Bacteriostatic tetracycline antibiotic. Highly valued standard treatment for localized superficial ocular tissue infections.",
    sideEffects: "Transient stinging, mild local irritation.",
    contraindications: "Hypersensitivity to tetracyclines."
  },
  {
    name: "Xylometazoline 0.1% Nasal Spray",
    defaultDose: "10ml Spray (1-2 sprays per nostril)",
    defaultFreq: "TDS (Three times daily)",
    defaultDuration: "5 days (Strictly max)",
    indication: "Acute nasal congestion, rhinitis, sinus ventilation support",
    category: "ENT Specialists",
    info: "Direct-acting vasoconstrictor. WARNING: Strictly do not exceed 5 consecutive days to prevent rebound congestion (rhinitis medicamentosa).",
    sideEffects: "Local irritation, dry nasal mucosa, rebound congestion, palpitations.",
    contraindications: "Narrow-angle glaucoma, transsphenoidal hypophysectomy history, dry rhinitis."
  },
  {
    name: "Fluticasone Propionate Nasal Spray",
    defaultDose: "120 actuations (2 sprays per nostril)",
    defaultFreq: "Once daily in the morning (OD morning)",
    defaultDuration: "30 days",
    indication: "Allergic rhinitis, nasal polyposis, non-allergic chronic rhinitis",
    category: "ENT Specialists",
    info: "Potent anti-inflammatory topical nasal corticosteroid. Spray outer nasal walls to maximize therapeutic coverage and avoid septal soreness.",
    sideEffects: "Epistaxis, nasal septal perforation (rare), nasal dryness, headache.",
    contraindications: "Untreated localized nasal fungal or bacterial infections."
  },
  {
    name: "Mometasone Furoate Nasal Spray",
    defaultDose: "120 actuations (2 sprays per nostril)",
    defaultFreq: "Once daily in the morning (OD morning)",
    defaultDuration: "30 days",
    indication: "Seasonal/perennial allergic rhinitis, rhinosinusitis congestion",
    category: "ENT Specialists",
    info: "Glucocorticoid with low systemic bioavailability. Direct outer-pointing nasal spray pattern highly recommended.",
    sideEffects: "Epistaxis, nasal burning, pharyngitis, headache.",
    contraindications: "Hypersensitivity, recent nasal surgery or trauma prior to mucosal healing."
  },
  {
    name: "Ciprofloxacin 0.3% + Dexamethasone 0.1% Ear Drops",
    defaultDose: "7.5ml Bottle (4 drops inside affected ear canal)",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "7 days",
    indication: "Acute otitis externa, otitis media with tympanostomy tubes",
    category: "ENT Specialists",
    info: "Combination fluoroquinolone antimicrobial and anti-inflammatory. Warm bottle in hands before use to prevent caloric vestibular vertigo.",
    sideEffects: "Ear discomfort, ear pruritus, local residue accumulation.",
    contraindications: "Viral infections of the external ear canal, hypersensitivity to ingredients."
  },
  {
    name: "Sodium Bicarbonate 5% Ear Drops (Wax Softener)",
    defaultDose: "10ml Bottle (3-4 drops in affected ear)",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "5 days",
    indication: "Impacted ear wax (cerumen) occlusion, facilitating ear syringing",
    category: "ENT Specialists",
    info: "Bicarbonate ear drop. Chemically softens dense dehydrated cerumen to enable automatic ear clearance or safe clinical syringing.",
    sideEffects: "Transient hearing fullness/muffliness as wax swells while softening.",
    contraindications: "Perforated tympanic membrane, active ear discharge."
  },
  {
    name: "Betamethasone 0.1% + Neomycin 0.5% Ear/Eye Drops",
    defaultDose: "10ml Bottle (2-3 drops in affected ear / eye)",
    defaultFreq: "TDS (Three times daily)",
    defaultDuration: "7 days",
    indication: "Infected eczema of external auditory canal, inflammatory bacterial conjunctivitis",
    category: "ENT Specialists",
    info: "Dual-purpose anti-inflammatory corticosteroid and broad-range aminoglycoside antibiotic drops.",
    sideEffects: "Local burning, dry skin, secondary fungal overgrowth.",
    contraindications: "Perforated eardrum (ototoxicity risk limit), viral corneal ulcerations."
  },
  // ==========================================
  // CHAPTER 12: ENDOCRINE & DIABETES
  // ==========================================
  {
    name: "Insulin Glargine (Lantus)",
    defaultDose: "10-20 Units (Titrated)",
    defaultFreq: "OD (Once daily, typically at night)",
    defaultDuration: "Chronic",
    indication: "Type 1 & Type 2 Diabetes Mellitus",
    category: "Endocrine",
    info: "Long-acting basal insulin analog. Provides a constant, peakless basal insulin supply.",
    sideEffects: "Hypoglycemia, weight gain, injection site lipohypertrophy.",
    contraindications: "Episodes of severe hypoglycemia."
  },
  {
    name: "Empagliflozin (Jardiance)",
    defaultDose: "10 mg",
    defaultFreq: "OD (Once daily in the morning)",
    defaultDuration: "Chronic",
    indication: "Type 2 Diabetes Mellitus, Heart Failure with reduced ejection fraction",
    category: "Endocrine",
    info: "SGLT2 inhibitor. Promotes urinary glucose excretion. Proven cardiovascular mortality benefit.",
    sideEffects: "Genital mycotic infections (thrush), UTIs, increased urination, euglycemic DKA.",
    contraindications: "Severe renal impairment (eGFR < 30), Type 1 DM (DKA risk)."
  },
  {
    name: "Levothyroxine Sodium (Eltroxin)",
    defaultDose: "50-100 mcg",
    defaultFreq: "OD (Once daily on empty stomach)",
    defaultDuration: "Chronic",
    indication: "Hypothyroidism (Hashimoto's, post-thyroidectomy)",
    category: "Endocrine",
    info: "Synthetic T4 replacement. Must be taken 30-60 minutes before breakfast.",
    sideEffects: "Palpitations, weight loss, tremor, heat intolerance (if over-replaced).",
    contraindications: "Untreated thyrotoxicosis, uncorrected adrenal insufficiency."
  },
  {
    name: "Carbimazole",
    defaultDose: "15-20 mg",
    defaultFreq: "OD to TDS (Depending on severity)",
    defaultDuration: "12-18 months",
    indication: "Hyperthyroidism (Graves' disease)",
    category: "Endocrine",
    info: "Thioamide anti-thyroid drug. Inhibits thyroid hormone synthesis.",
    sideEffects: "Rash, arthralgia, agranulocytosis (requires urgent CBC if sore throat/fever occurs).",
    contraindications: "Severe hepatic impairment, history of severe adverse reaction."
  },
  {
    name: "Dexamethasone",
    defaultDose: "4-8 mg (Varies)",
    defaultFreq: "OD (Morning)",
    defaultDuration: "Short-term / Tapered",
    indication: "Severe allergic reactions, severe inflammation, cerebral edema",
    category: "Endocrine",
    info: "Potent, long-acting synthetic glucocorticoid with negligible mineralocorticoid activity.",
    sideEffects: "Insomnia, hyperglycemia, hypertension, adrenal suppression (if long-term).",
    contraindications: "Systemic fungal infections, live virus vaccines."
  },
  // ==========================================
  // CHAPTER 13: OBGYN & UROLOGY
  // ==========================================
  {
    name: "Dydrogesterone (Duphaston)",
    defaultDose: "10 mg",
    defaultFreq: "BD to TDS",
    defaultDuration: "Cyclical or Continuous",
    indication: "Threatened miscarriage, PMS, Dysmenorrhea, HRT adjunct",
    category: "Genitourinary",
    info: "Orally active progestogen. Similar to endogenous progesterone without androgenic effects.",
    sideEffects: "Breast tenderness, headache, breakthrough bleeding.",
    contraindications: "Undiagnosed vaginal bleeding, severe liver dysfunction."
  },
  {
    name: "Ethinylestradiol + Drospirenone (Yasmin/Yaz)",
    defaultDose: "1 Tablet",
    defaultFreq: "OD (Daily at the same time)",
    defaultDuration: "21 days on, 7 days off",
    indication: "Oral contraception, PCOS symptom management, acne",
    category: "Genitourinary",
    info: "Combined Oral Contraceptive (COC). Drospirenone has anti-androgenic properties.",
    sideEffects: "Nausea, mood swings, increased risk of VTE (thrombosis).",
    contraindications: "History of DVT/PE, migraine with aura, uncontrolled hypertension, smokers > 35 years."
  },
  {
    name: "Finasteride",
    defaultDose: "5 mg (BPH) or 1 mg (Alopecia)",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "Chronic",
    indication: "Benign Prostatic Hyperplasia (BPH), Androgenetic Alopecia",
    category: "Genitourinary",
    info: "5-alpha-reductase inhibitor. Reduces prostate size by blocking DHT conversion.",
    sideEffects: "Decreased libido, erectile dysfunction, gynecomastia.",
    contraindications: "Women of childbearing potential (teratogenic to male fetus)."
  },
  {
    name: "Solifenacin Succinate (Vesicare)",
    defaultDose: "5 mg",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "Chronic",
    indication: "Overactive Bladder (OAB) syndrome",
    category: "Genitourinary",
    info: "Antimuscarinic agent. Reduces detrusor muscle contractility.",
    sideEffects: "Dry mouth, constipation, blurred vision, urinary retention.",
    contraindications: "Urinary retention, severe GI strictures, narrow-angle glaucoma."
  },
  // ==========================================
  // CHAPTER 14: PSYCHIATRY & CNS
  // ==========================================
  {
    name: "Escitalopram (Lexapro)",
    defaultDose: "10 mg",
    defaultFreq: "OD (Morning)",
    defaultDuration: "6-12 months",
    indication: "Major Depressive Disorder, Generalized Anxiety Disorder",
    category: "CNS & Psychiatry",
    info: "Highly selective SSRI. May take 2-4 weeks for full therapeutic effect.",
    sideEffects: "Nausea, sexual dysfunction, insomnia, minor QTc prolongation.",
    contraindications: "Concomitant use of MAOIs, known prolonged QT interval."
  },
  {
    name: "Quetiapine (Seroquel)",
    defaultDose: "25-50 mg (Sleep) / 300-800 mg (Psychosis)",
    defaultFreq: "OD (Night)",
    defaultDuration: "Chronic or PRN",
    indication: "Schizophrenia, Bipolar Disorder, severe Insomnia (off-label)",
    category: "CNS & Psychiatry",
    info: "Atypical antipsychotic. Highly sedating at low doses due to antihistamine affinity.",
    sideEffects: "Somnolence, weight gain, metabolic syndrome, postural hypotension.",
    contraindications: "Severe CNS depression, uncorrected hypokalemia."
  },
  {
    name: "Clonazepam (Rivotril)",
    defaultDose: "0.5-1 mg",
    defaultFreq: "BD to PRN",
    defaultDuration: "Short-term (2-4 weeks)",
    indication: "Panic disorder, acute severe anxiety, epilepsy adjunct",
    category: "CNS & Psychiatry",
    info: "Long-acting benzodiazepine. High risk of dependence and tolerance if used long-term.",
    sideEffects: "Drowsiness, ataxia, cognitive impairment, paradoxial agitation (rare).",
    contraindications: "Myasthenia gravis, severe sleep apnea, acute narrow-angle glaucoma."
  },
  {
    name: "Sodium Valproate (Depakine)",
    defaultDose: "500 mg",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "Chronic",
    indication: "Epilepsy (all types), Bipolar mania, Migraine prophylaxis",
    category: "CNS & Psychiatry",
    info: "Broad-spectrum antiepileptic drug.",
    sideEffects: "Weight gain, hair loss, tremor, hepatotoxicity.",
    contraindications: "Pregnancy (highly teratogenic), pre-existing severe hepatic dysfunction."
  },
  // ==========================================
  // CHAPTER 15: HEMATOLOGY, VITAMINS & SUPPLEMENTS
  // ==========================================
  {
    name: "Ferrous Sulfate (Iron)",
    defaultDose: "200 mg (Elemental Iron 65mg)",
    defaultFreq: "OD to BD",
    defaultDuration: "3-6 months",
    indication: "Iron Deficiency Anemia",
    category: "Hematology & Nutrition",
    info: "Oral iron supplement. Best absorbed on an empty stomach with Vitamin C.",
    sideEffects: "Constipation, dark/black stools, nausea, abdominal pain.",
    contraindications: "Hemochromatosis, hemolytic anemias."
  },
  {
    name: "Cholecalciferol (Vitamin D3)",
    defaultDose: "50,000 IU",
    defaultFreq: "Weekly",
    defaultDuration: "8 weeks (then daily maintenance)",
    indication: "Vitamin D deficiency, osteoporosis adjunct",
    category: "Endocrine & Nutrition",
    info: "Fat-soluble vitamin crucial for calcium homeostasis and bone health.",
    sideEffects: "Hypercalcemia (rare, usually requires massive overdose).",
    contraindications: "Hypercalcemia, hypervitaminosis D."
  },
  {
    name: "Rivaroxaban (Xarelto)",
    defaultDose: "20 mg",
    defaultFreq: "OD (With food)",
    defaultDuration: "Chronic",
    indication: "DVT/PE treatment and prophylaxis, Atrial Fibrillation stroke prevention",
    category: "Hematology & Coagulation",
    info: "Direct Oral Anticoagulant (DOAC) - Factor Xa inhibitor. No routine INR monitoring required.",
    sideEffects: "Bleeding, bruising, epistaxis, GI hemorrhage.",
    contraindications: "Active bleeding, severe hepatic disease with coagulopathy, mechanical heart valves."
  },
  // ==========================================
  // CHAPTER 16: EXTENSIVE DERMATOLOGY (SINGLE & COMBINED)
  // ==========================================
  
  // --- CORTICOSTEROIDS (SINGLE) ---
  {
    name: "Hydrocortisone 1% Cream / Ointment",
    defaultDose: "Apply a thin layer",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "7-14 days",
    indication: "Mild eczema, contact dermatitis, insect bites",
    category: "Dermatology",
    info: "Mild topical corticosteroid. Safe for face and intertriginous areas for short durations.",
    sideEffects: "Skin atrophy (rare with 1%), striae.",
    contraindications: "Untreated bacterial/fungal skin infections, rosacea."
  },
  {
    name: "Mometasone Furoate 0.1% Cream / Ointment (Elocom)",
    defaultDose: "Apply a thin layer",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "7-14 days",
    indication: "Moderate to severe eczema, psoriasis",
    category: "Dermatology",
    info: "Potent topical corticosteroid. Once daily application improves compliance.",
    sideEffects: "Skin thinning, striae, telangiectasia with prolonged use.",
    contraindications: "Acne vulgaris, perioral dermatitis, widespread plaque psoriasis."
  },
  {
    name: "Clobetasol Propionate 0.05% Ointment (Dermovate)",
    defaultDose: "Apply a thin layer sparingly",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "Max 2-4 weeks",
    indication: "Severe resistant eczema, discoid lupus, lichen planus",
    category: "Dermatology",
    info: "Ultra-potent topical corticosteroid. Not for use on face or flexures.",
    sideEffects: "Significant skin atrophy, adrenal suppression if absorbed systemically.",
    contraindications: "Rosacea, children under 1 year, perioral dermatitis."
  },

  // --- COMBINED CORTICOSTEROIDS (MIXED / المخلوطة) ---
  {
    name: "Fusidic acid 2% + Betamethasone 0.1% (Fucibet)",
    defaultDose: "Apply a thin layer",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "Up to 2 weeks",
    indication: "Infected eczema, infected dermatitis",
    category: "Dermatology",
    info: "Combination of a potent topical steroid and an antibiotic. Avoid prolonged use to prevent resistance.",
    sideEffects: "Skin thinning, secondary fungal infections.",
    contraindications: "Primary viral skin infections (herpes), rosacea."
  },
  {
    name: "Miconazole 2% + Hydrocortisone 1% (Daktacort)",
    defaultDose: "Apply to affected area",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "7 days",
    indication: "Inflamed fungal infections (e.g. severe athlete's foot, infected intertrigo)",
    category: "Dermatology",
    info: "Combination of a mild steroid and antifungal. Excellent for sweat-rash with fungal overgrowth.",
    sideEffects: "Local burning sensation.",
    contraindications: "Tuberculous skin lesions, viral infections."
  },
  {
    name: "Betamethasone + Clotrimazole (Lotriderm)",
    defaultDose: "Apply to affected area",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "Max 2 weeks",
    indication: "Severe inflammatory tinea infections",
    category: "Dermatology",
    info: "Potent steroid combined with broad-spectrum antifungal.",
    sideEffects: "Striae, skin atrophy if used beyond 2 weeks.",
    contraindications: "Children under 12 years, facial application."
  },
  {
    name: "Triamcinolone + Neomycin + Nystatin + Gramicidin (Kenacomb / Panderm)",
    defaultDose: "Apply a thin layer",
    defaultFreq: "BD to TDS",
    defaultDuration: "7-14 days",
    indication: "Complicated dermatoses with suspected mixed bacterial and candidal infections",
    category: "Dermatology",
    info: "Quadruple combination cream/ointment. Highly effective for non-specific infected inflammatory rashes.",
    sideEffects: "Ototoxicity (if eardrum perforated), skin atrophy.",
    contraindications: "Viral lesions, perforated tympanic membrane."
  },
  {
    name: "Calcipotriol + Betamethasone (Daivobet / Xamiol)",
    defaultDose: "Apply to plaques",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "Up to 4 weeks",
    indication: "Plaque Psoriasis, Scalp Psoriasis",
    category: "Dermatology",
    info: "Vitamin D analogue combined with potent steroid. Highly effective for psoriasis.",
    sideEffects: "Local irritation, hypercalcemia (rarely).",
    contraindications: "Pustular psoriasis, disorders of calcium metabolism."
  },
  {
    name: "Hydroquinone 4% + Tretinoin 0.05% + Fluocinolone 0.01% (Pigmanorm / Tri-Luma)",
    defaultDose: "Apply a thin layer to hyperpigmented spots ONLY",
    defaultFreq: "OD (At night)",
    defaultDuration: "8-12 weeks max",
    indication: "Moderate to severe Melasma / Hyperpigmentation",
    category: "Dermatology",
    info: "Kligman's formula (Triple combination). Must use high SPF sunscreen during the day.",
    sideEffects: "Erythema, peeling, exogenous ochronosis (if used long term).",
    contraindications: "Pregnancy, acute eczema, sunburn."
  },

  // --- ACNE & ROSACEA (SINGLE & COMBINED) ---
  {
    name: "Adapalene 0.1% + Benzoyl Peroxide 2.5% (Epiduo)",
    defaultDose: "Apply a pea-sized amount to the entire face",
    defaultFreq: "OD (At night)",
    defaultDuration: "Chronic (months)",
    indication: "Mild to moderate acne vulgaris (comedonal and inflammatory)",
    category: "Dermatology",
    info: "Retinoid + antimicrobial. Can bleach hair/fabrics. Causes initial purging/dryness.",
    sideEffects: "Erythema, scaling, dryness, burning.",
    contraindications: "Pregnancy, very sensitive/eczematous skin."
  },
  {
    name: "Clindamycin 1% + Benzoyl Peroxide 5% (Duac)",
    defaultDose: "Apply to affected areas",
    defaultFreq: "OD (At night)",
    defaultDuration: "Up to 12 weeks",
    indication: "Inflammatory acne vulgaris",
    category: "Dermatology",
    info: "Antibiotic + antimicrobial peeling agent. Store in refrigerator before dispensing.",
    sideEffects: "Dryness, peeling, redness.",
    contraindications: "History of regional enteritis, ulcerative colitis."
  },
  {
    name: "Isotretinoin Oral (Roaccutane / Curacne)",
    defaultDose: "0.5 - 1.0 mg/kg/day",
    defaultFreq: "OD to BD (With fatty meals)",
    defaultDuration: "4-6 months (Cumulative dose 120-150 mg/kg)",
    indication: "Severe nodulocystic acne, treatment-resistant acne",
    category: "Dermatology",
    info: "Systemic retinoid. Requires strict pregnancy prevention and lipid/liver monitoring.",
    sideEffects: "Severe dry skin/lips/eyes, teratogenicity, hypertriglyceridemia, myalgia.",
    contraindications: "Pregnancy (Absolute), severe hepatic impairment, hyperlipidemia."
  },
  {
    name: "Ivermectin 1% Cream (Soolantra)",
    defaultDose: "Apply pea-sized amounts to face",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "Up to 4 months",
    indication: "Papulopustular Rosacea",
    category: "Dermatology",
    info: "Anti-inflammatory and anti-parasitic (Demodex mites).",
    sideEffects: "Skin burning sensation, irritation.",
    contraindications: "Pregnancy (caution)."
  },

  // --- ANTIFUNGALS (TOPICAL & SYSTEMIC) ---
  {
    name: "Terbinafine 1% Cream (Lamisil)",
    defaultDose: "Apply to affected area",
    defaultFreq: "OD to BD",
    defaultDuration: "1-2 weeks",
    indication: "Tinea pedis, Tinea cruris, Tinea corporis",
    category: "Dermatology",
    info: "Allylamine antifungal. Fungicidal against dermatophytes.",
    sideEffects: "Local irritation, erythema.",
    contraindications: "Known hypersensitivity."
  },
  {
    name: "Itraconazole 100mg Capsules (Sporanox)",
    defaultDose: "100-200 mg",
    defaultFreq: "OD to BD (Immediately after a full meal)",
    defaultDuration: "1 week to 3 months (depends on indication)",
    indication: "Onychomycosis, severe pityriasis versicolor, systemic fungal infections",
    category: "Dermatology",
    info: "Broad-spectrum triazole antifungal. Strong CYP3A4 inhibitor.",
    sideEffects: "Hepatotoxicity, heart failure exacerbation, GI upset.",
    contraindications: "Ventricular dysfunction, concurrent use of statins/colchicine."
  },

  // --- IMMUNOMODULATORS & OTHERS ---
  {
    name: "Tacrolimus 0.1% Ointment (Protopic)",
    defaultDose: "Apply a thin layer",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "Chronic intermittent",
    indication: "Moderate to severe atopic dermatitis (especially on face/neck), Vitiligo (off-label)",
    category: "Dermatology",
    info: "Topical calcineurin inhibitor. Does NOT cause skin atrophy like steroids.",
    sideEffects: "Intense burning/stinging upon initial application, flushing with alcohol.",
    contraindications: "Infected skin lesions, Netherton's syndrome."
  },
  {
    name: "Permethrin 5% Cream (Lyclear)",
    defaultDose: "Apply to entire body from neck down",
    defaultFreq: "Single application (Leave for 8-14 hours, wash off. Repeat in 1 week)",
    defaultDuration: "1-2 applications",
    indication: "Scabies",
    category: "Dermatology",
    info: "First-line scabicide. Treat all household contacts simultaneously.",
    sideEffects: "Pruritus (may worsen temporarily), erythema.",
    contraindications: "Hypersensitivity to chrysanthemums."
  },
  {
    name: "Minoxidil 5% Topical Solution/Foam (Regaine)",
    defaultDose: "1 mL or half-capful foam applied to dry scalp",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "Continuous (Lifelong to maintain effect)",
    indication: "Androgenetic Alopecia (Male pattern baldness)",
    category: "Dermatology",
    info: "Potent vasodilator. Initial shedding is common in the first 2-6 weeks.",
    sideEffects: "Scalp irritation, unwanted facial hair growth (in females), contact dermatitis.",
    contraindications: "Sudden/patchy hair loss, age < 18."
  },
  // ==========================================
  // CHAPTER 17: DERMATOLOGY PART 2 (ANTIMICROBIALS, ACNE, PSORIASIS, BIOLOGICS)
  // ==========================================
  
  // --- TOPICAL ACNE & ROSACEA ---
  {
    name: "Tretinoin 0.025% / 0.05% Cream (Retin-A)",
    defaultDose: "Apply a pea-sized amount",
    defaultFreq: "OD (At night)",
    defaultDuration: "Chronic",
    indication: "Comedonal Acne, Photoaging",
    category: "Dermatology",
    info: "Topical retinoid. Highly effective for unblocking pores and increasing cell turnover.",
    sideEffects: "Skin peeling, erythema, photosensitivity.",
    contraindications: "Pregnancy, severe eczema."
  },
  {
    name: "Azelaic Acid 20% Cream (Skinoren)",
    defaultDose: "Apply to affected area",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "Chronic",
    indication: "Acne Vulgaris, Rosacea, Post-inflammatory hyperpigmentation",
    category: "Dermatology",
    info: "Antibacterial, comedolytic, and mild depigmenting agent. Safe in pregnancy.",
    sideEffects: "Transient stinging/burning, pruritus.",
    contraindications: "None major."
  },
  {
    name: "Benzoyl Peroxide 5% Wash/Gel (PanOxyl / Benzac)",
    defaultDose: "Apply to affected area",
    defaultFreq: "OD to BD",
    defaultDuration: "Chronic",
    indication: "Mild to moderate Acne Vulgaris",
    category: "Dermatology",
    info: "Antimicrobial peeling agent. Does not cause bacterial resistance.",
    sideEffects: "Bleaches hair and fabrics, skin dryness.",
    contraindications: "Very sensitive skin."
  },
  {
    name: "Clindamycin 1% Topical Solution/Gel (Dalacin T)",
    defaultDose: "Apply a thin film",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "Max 12 weeks (to prevent resistance)",
    indication: "Inflammatory Acne Vulgaris",
    category: "Dermatology",
    info: "Topical lincosamide antibiotic. Best used in combination with Benzoyl Peroxide.",
    sideEffects: "Skin dryness, rare risk of pseudomembranous colitis.",
    contraindications: "History of inflammatory bowel disease."
  },
  {
    name: "Erythromycin + Zinc Acetate (Zineryt)",
    defaultDose: "Apply using applicator",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "10-12 weeks",
    indication: "Acne Vulgaris",
    category: "Dermatology",
    info: "Macrolide antibiotic combined with zinc for enhanced penetration and wound healing.",
    sideEffects: "Transient stinging, dry skin.",
    contraindications: "Macrolide hypersensitivity."
  },

  // --- TOPICAL ANTIBIOTICS & ANTIFUNGALS ---
  {
    name: "Fusidic Acid 2% Cream/Ointment (Fucidin)",
    defaultDose: "Apply to affected area",
    defaultFreq: "TDS (Three times daily)",
    defaultDuration: "7-10 days",
    indication: "Impetigo, infected cuts, staphylococcal infections",
    category: "Dermatology",
    info: "Narrow-spectrum antibiotic highly effective against Staph aureus. Ointment preferred for dry lesions.",
    sideEffects: "Mild irritation.",
    contraindications: "Pseudomonas infections."
  },
  {
    name: "Mupirocin 2% Ointment (Bactroban)",
    defaultDose: "Apply to affected area",
    defaultFreq: "TDS (Three times daily)",
    defaultDuration: "5-10 days",
    indication: "Impetigo, MRSA nasal decolonization",
    category: "Dermatology",
    info: "Excellent broad-spectrum topical antibiotic, including MRSA coverage.",
    sideEffects: "Burning, stinging, pruritus.",
    contraindications: "Extensive burns (PEG vehicle toxicity risk)."
  },
  {
    name: "Clotrimazole 1% Cream (Canesten)",
    defaultDose: "Apply to affected area",
    defaultFreq: "BD to TDS",
    defaultDuration: "2-4 weeks",
    indication: "Candidiasis, Tinea infections",
    category: "Dermatology",
    info: "Broad-spectrum imidazole antifungal. Safe for all ages.",
    sideEffects: "Local mild irritation.",
    contraindications: "None."
  },
  {
    name: "Ketoconazole 2% Shampoo/Cream (Nizoral)",
    defaultDose: "Wash and leave for 3-5 mins before rinsing",
    defaultFreq: "Twice weekly",
    defaultDuration: "2-4 weeks",
    indication: "Seborrheic Dermatitis, Pityriasis Versicolor, Dandruff",
    category: "Dermatology",
    info: "Antifungal shampoo targeting Malassezia yeast.",
    sideEffects: "Hair discoloration (rare), skin irritation.",
    contraindications: "None."
  },
  {
    name: "Amorolfine 5% Nail Lacquer (Loceryl)",
    defaultDose: "Paint affected nails",
    defaultFreq: "Once or twice weekly",
    defaultDuration: "6 months (Fingernails) - 12 months (Toenails)",
    indication: "Mild distal onychomycosis (without matrix involvement)",
    category: "Dermatology",
    info: "Topical antifungal polish. Requires filing the nail before application.",
    sideEffects: "Transient burning around the nail.",
    contraindications: "Severe onychomycosis requiring systemic therapy."
  },

  // --- WARTS, PSORIASIS & KERATOLYTICS ---
  {
    name: "Salicylic Acid 16.7% / Lactic Acid 16.7% (Duofilm)",
    defaultDose: "Apply exactly to the wart/corn",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "Until resolution (up to 12 weeks)",
    indication: "Common Warts (Verruca vulgaris), Plantar Warts, Corns",
    category: "Dermatology",
    info: "Strong keratolytic. Protect surrounding healthy skin with petroleum jelly.",
    sideEffects: "Severe irritation of healthy skin, ulceration if misused.",
    contraindications: "Facial warts, anogenital warts, diabetic neuropathy."
  },
  {
    name: "Betamethasone 0.05% + Salicylic Acid 3% (Diprosalic)",
    defaultDose: "Apply a thin layer",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "2-3 weeks",
    indication: "Hyperkeratotic eczema, Scalp Psoriasis, Lichen simplex",
    category: "Dermatology",
    info: "Potent steroid combined with a keratolytic to penetrate thickened plaques.",
    sideEffects: "Skin atrophy, burning sensation.",
    contraindications: "Viral infections, widespread plaque psoriasis (risk of systemic absorption)."
  },
  {
    name: "Urea 10% / 20% Cream (Nutraplus / Eucerin)",
    defaultDose: "Apply generously",
    defaultFreq: "BD to TDS",
    defaultDuration: "Chronic",
    indication: "Ichthyosis, severe Xerosis, hyperkeratosis of heels",
    category: "Dermatology",
    info: "Potent humectant and keratolytic. Retains moisture in the stratum corneum.",
    sideEffects: "Stinging on broken skin.",
    contraindications: "Acute oozing eczema."
  },
  {
    name: "Calamine Lotion",
    defaultDose: "Apply to affected areas",
    defaultFreq: "PRN (As needed)",
    defaultDuration: "Short-term",
    indication: "Pruritus, Chickenpox, insect bites, sunburn",
    category: "Dermatology",
    info: "Soothing, cooling, mild astringent lotion.",
    sideEffects: "Skin dryness if used excessively.",
    contraindications: "None."
  },

  // --- ADVANCED DERMATOLOGY & BIOLOGICS ---
  {
    name: "Pimecrolimus 1% Cream (Elidel)",
    defaultDose: "Apply a thin layer",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "Intermittent chronic",
    indication: "Mild to moderate Atopic Dermatitis (especially face/neck)",
    category: "Dermatology",
    info: "Topical calcineurin inhibitor. Less potent than Tacrolimus, does not cause skin thinning.",
    sideEffects: "Mild burning sensation initially.",
    contraindications: "Immunocompromised patients, infected skin lesions."
  },
  {
    name: "Imiquimod 5% Cream (Aldara)",
    defaultDose: "Apply to lesions before sleep, wash off after 8 hours",
    defaultFreq: "3 times per week",
    defaultDuration: "Up to 16 weeks",
    indication: "Anogenital warts, superficial Basal Cell Carcinoma, Actinic Keratosis",
    category: "Dermatology",
    info: "Immune response modifier (induces cytokines).",
    sideEffects: "Severe local inflammatory reactions, erythema, ulceration.",
    contraindications: "None major, but avoid in pregnancy unless strictly necessary."
  },
  {
    name: "5-Fluorouracil 5% Cream (Efudix)",
    defaultDose: "Apply thin layer",
    defaultFreq: "OD to BD",
    defaultDuration: "3-4 weeks",
    indication: "Actinic Keratosis, superficial Basal Cell Carcinoma",
    category: "Dermatology",
    info: "Topical cytotoxic agent. Causes expected, intense inflammatory phase before healing.",
    sideEffects: "Severe erythema, crusting, ulceration, pain.",
    contraindications: "Pregnancy, DPD enzyme deficiency."
  },
  {
    name: "Dupilumab (Dupixent)",
    defaultDose: "600 mg initial, then 300 mg Subcutaneous",
    defaultFreq: "Every 2 weeks",
    defaultDuration: "Chronic",
    indication: "Severe Atopic Dermatitis, severe Asthma",
    category: "Dermatology",
    info: "Monoclonal antibody inhibiting IL-4 and IL-13 signaling.",
    sideEffects: "Injection site reactions, conjunctivitis, oral herpes.",
    contraindications: "Severe helminth infections."
  },
  {
    name: "Methotrexate Oral",
    defaultDose: "7.5 - 15 mg",
    defaultFreq: "ONCE WEEKLY",
    defaultDuration: "Chronic",
    indication: "Severe Psoriasis, Rheumatoid Arthritis",
    category: "Dermatology",
    info: "Folic acid antagonist. ALWAYS prescribe Folic acid on non-MTX days.",
    sideEffects: "Hepatotoxicity, bone marrow suppression, pneumonitis, severe nausea.",
    contraindications: "Pregnancy (highly teratogenic), severe liver/kidney disease, active infections."
  },
  // ==========================================
  // CHAPTER 18: DERMATOLOGY PART 3 (SYSTEMICS, RETINOIDS, BIOLOGICS, & SPECIALTIES)
  // ==========================================
  
  // --- SYSTEMIC ACNE & ROSACEA ANTIBIOTICS ---
  {
    name: "Doxycycline 100mg Capsules (Vibramycin)",
    defaultDose: "100 mg",
    defaultFreq: "OD to BD (With a full glass of water, remain upright for 30 mins)",
    defaultDuration: "2-3 months",
    indication: "Moderate to severe Inflammatory Acne Vulgaris, Rosacea",
    category: "Dermatology",
    info: "Tetracycline antibiotic with anti-inflammatory properties.",
    sideEffects: "Photosensitivity, GI upset, esophagitis, vaginal candidiasis.",
    contraindications: "Pregnancy/breastfeeding, children under 12 years (stains developing teeth)."
  },
  {
    name: "Lymecycline 408mg Capsules (Tetralysal)",
    defaultDose: "408 mg",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "8-12 weeks",
    indication: "Moderate Inflammatory Acne Vulgaris",
    category: "Dermatology",
    info: "Tetracycline derivative. Better GI tolerance and can be taken with food (unlike other tetracyclines).",
    sideEffects: "Nausea, headache, photosensitivity.",
    contraindications: "Pregnancy, severe renal impairment."
  },

  // --- TOPICAL & SYSTEMIC RETINOIDS ---
  {
    name: "Adapalene 0.1% Gel / Cream (Differin)",
    defaultDose: "Apply a pea-sized amount",
    defaultFreq: "OD (At night)",
    defaultDuration: "Chronic",
    indication: "Mild to moderate Comedonal Acne",
    category: "Dermatology",
    info: "Third-generation topical retinoid. Less irritating and more photostable than Tretinoin.",
    sideEffects: "Initial erythema, dryness, scaling (subsides after 2-4 weeks).",
    contraindications: "Pregnancy, severe eczema."
  },
  {
    name: "Tazarotene 0.05% / 0.1% Gel (Tazorac)",
    defaultDose: "Apply a thin film",
    defaultFreq: "OD (At night)",
    defaultDuration: "Up to 12 weeks for psoriasis, chronic for acne",
    indication: "Plaque Psoriasis, Acne Vulgaris",
    category: "Dermatology",
    info: "Potent topical retinoid. Highly effective but highly irritating.",
    sideEffects: "Severe erythema, peeling, burning.",
    contraindications: "Pregnancy (Category X)."
  },
  {
    name: "Acitretin 10mg / 25mg Capsules (Neotigason)",
    defaultDose: "25-50 mg",
    defaultFreq: "OD (With main meal)",
    defaultDuration: "Chronic",
    indication: "Severe extensive Psoriasis, Ichthyosis",
    category: "Dermatology",
    info: "Systemic retinoid specific for hyperkeratotic disorders.",
    sideEffects: "Mucocutaneous dryness, hyperlipidemia, hepatotoxicity.",
    contraindications: "Pregnancy (Strictly avoided for 3 YEARS after stopping the drug), severe liver/kidney disease."
  },
  {
    name: "Alitretinoin 10mg / 30mg Capsules (Toctino)",
    defaultDose: "30 mg",
    defaultFreq: "OD (With a meal)",
    defaultDuration: "12-24 weeks",
    indication: "Severe chronic hand eczema unresponsive to potent topical steroids",
    category: "Dermatology",
    info: "Systemic retinoid.",
    sideEffects: "Headache, hypertriglyceridemia, dry lips.",
    contraindications: "Pregnancy (Strictly avoided for 1 month after stopping), uncontrolled hyperlipidemia."
  },

  // --- SYSTEMIC ANTIFUNGALS & ANTI-PRURITICS ---
  {
    name: "Fluconazole 150mg Capsules (Diflucan)",
    defaultDose: "150 mg",
    defaultFreq: "Single dose (or weekly for chronic conditions)",
    defaultDuration: "Varies (Stat for vaginal candidiasis)",
    indication: "Vaginal Candidiasis, Tinea Versicolor, severe dermal candidiasis",
    category: "Dermatology",
    info: "Triazole antifungal. Very effective single-dose treatment for candidal infections.",
    sideEffects: "Headache, GI upset.",
    contraindications: "Concomitant use of drugs that prolong QT interval."
  },
  {
    name: "Griseofulvin 125mg / 500mg Tablets",
    defaultDose: "500 mg - 1000 mg",
    defaultFreq: "OD (With a fatty meal to enhance absorption)",
    defaultDuration: "6-8 weeks (Tinea Capitis)",
    indication: "Tinea Capitis (Scalp Ringworm in children), severe Tinea pedis/corporis",
    category: "Dermatology",
    info: "Fungistatic. Drug of choice for Microsporum scalp infections in children.",
    sideEffects: "Headache, nausea, photosensitivity.",
    contraindications: "Severe liver disease, pregnancy, SLE."
  },
  {
    name: "Hydroxyzine 10mg / 25mg Tablets (Atarax)",
    defaultDose: "25 mg",
    defaultFreq: "ON (At night)",
    defaultDuration: "Short-term / PRN",
    indication: "Severe Pruritus, Urticaria, Atopic dermatitis causing sleep loss",
    category: "Dermatology",
    info: "First-generation antihistamine with strong sedative and anti-anxiety properties.",
    sideEffects: "Drowsiness, dry mouth, blurred vision.",
    contraindications: "Early pregnancy, narrow-angle glaucoma."
  },

  // --- ANTI-ANDROGENS & HAIR GROWTH ---
  {
    name: "Spironolactone 25mg / 50mg Tablets (Aldactone)",
    defaultDose: "50-100 mg",
    defaultFreq: "OD to BD",
    defaultDuration: "Chronic",
    indication: "Female Pattern Hair Loss, Hormonal Acne (Off-label)",
    category: "Dermatology",
    info: "Potassium-sparing diuretic with potent anti-androgenic effects at higher doses.",
    sideEffects: "Hyperkalemia, menstrual irregularities, breast tenderness.",
    contraindications: "Pregnancy, hyperkalemia, acute renal failure."
  },
  {
    name: "Eflornithine 11.5% Cream (Vaniqa)",
    defaultDose: "Apply a thin layer",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "Continuous (Effect lost 8 weeks after stopping)",
    indication: "Facial Hirsutism in women",
    category: "Dermatology",
    info: "Irreversible inhibitor of ornithine decarboxylase. Slows hair growth.",
    sideEffects: "Acne, stinging, erythema.",
    contraindications: "None major."
  },
  {
    name: "Bimatoprost 0.03% Ophthalmic Solution (Latisse)",
    defaultDose: "Apply 1 drop to the base of upper eyelashes",
    defaultFreq: "OD (At night)",
    defaultDuration: "Continuous",
    indication: "Eyelash Hypotrichosis",
    category: "Dermatology",
    info: "Prostaglandin analog. Promotes eyelash growth, length, and darkness.",
    sideEffects: "Eye irritation, irreversible darkening of iris (if dropped in eye).",
    contraindications: "Active intraocular inflammation."
  },

  // --- PSORIASIS BIOLOGICS & ADVANCED THERAPIES ---
  {
    name: "Apremilast 30mg Tablets (Otezla)",
    defaultDose: "30 mg",
    defaultFreq: "BD (After initial titration pack)",
    defaultDuration: "Chronic",
    indication: "Moderate to Severe Plaque Psoriasis, Psoriatic Arthritis",
    category: "Dermatology",
    info: "Oral PDE4 inhibitor. Good safety profile, no baseline lab monitoring required.",
    sideEffects: "Diarrhea, nausea, weight loss, tension headache.",
    contraindications: "Severe depression/suicidal ideation."
  },
  {
    name: "Secukinumab (Cosentyx)",
    defaultDose: "300 mg Subcutaneous",
    defaultFreq: "Weeks 0, 1, 2, 3, 4, then monthly",
    defaultDuration: "Chronic",
    indication: "Severe Plaque Psoriasis, Ankylosing Spondylitis",
    category: "Dermatology",
    info: "Human monoclonal antibody targeting IL-17A. Highly efficacious for skin clearance.",
    sideEffects: "Nasopharyngitis, candidal infections.",
    contraindications: "Active severe infections, caution in IBD (can exacerbate Crohn's)."
  },
  {
    name: "Coal Tar 1% - 5% Preparations (Polytar / T-Gel)",
    defaultDose: "Massage into scalp / Apply to plaques",
    defaultFreq: "OD to twice weekly",
    defaultDuration: "Chronic",
    indication: "Scalp Psoriasis, Seborrheic Dermatitis, Chronic Eczema",
    category: "Dermatology",
    info: "Keratolytic, anti-inflammatory, and anti-pruritic.",
    sideEffects: "Strong odor, stains clothes/skin, photosensitivity.",
    contraindications: "Acute inflamed or infected skin."
  },

  // --- SPECIALTY CREAMS & EMOLLIENTS ---
  {
    name: "Podophyllotoxin 0.5% Solution (Condyline)",
    defaultDose: "Apply precisely to warts",
    defaultFreq: "BD for 3 days, followed by 4 days off",
    defaultDuration: "Repeat cycle up to 4 weeks",
    indication: "External Anogenital Warts",
    category: "Dermatology",
    info: "Antimitotic agent causing necrosis of the wart.",
    sideEffects: "Severe local pain, ulceration, balanoposthitis.",
    contraindications: "Pregnancy, large area of warts."
  },
  {
    name: "Crotamiton 10% Cream (Eurax)",
    defaultDose: "Apply to itchy areas",
    defaultFreq: "BD to TDS",
    defaultDuration: "PRN (As needed)",
    indication: "Pruritus, Scabies adjunct",
    category: "Dermatology",
    info: "Mild anti-pruritic and weak scabicide. Useful for post-scabietic itch.",
    sideEffects: "Mild irritation.",
    contraindications: "Acute exudative dermatoses."
  },
  {
    name: "Zinc Oxide Ointment (Sudocrem)",
    defaultDose: "Apply a protective layer",
    defaultFreq: "PRN (With each diaper change)",
    defaultDuration: "Chronic / PRN",
    indication: "Diaper Dermatitis, Minor burns, Irritant contact dermatitis",
    category: "Dermatology",
    info: "Excellent soothing and protective barrier cream.",
    sideEffects: "None.",
    contraindications: "None."
  },
  // ==========================================
  // CHAPTER 19: GENERAL PRACTICE (GP) ESSENTIALS
  // ==========================================

  // --- ANALGESICS, NSAIDs & MUSCLE RELAXANTS ---
  {
    name: "Paracetamol 500mg Tablets (Panadol)",
    defaultDose: "1000 mg (2 tablets)",
    defaultFreq: "QDS (Every 6 hours PRN)",
    defaultDuration: "PRN (As needed)",
    indication: "Mild to moderate pain, Fever",
    category: "Nervous System & Pain",
    info: "First-line antipyretic and analgesic. Safe in pregnancy.",
    sideEffects: "Hepatotoxicity in overdose.",
    contraindications: "Severe hepatic impairment."
  },
  {
    name: "Perfalgan 10mg/ml IV Infusion (Paracetamol 1g/100ml)",
    defaultDose: "1000 mg (1 vial)",
    defaultFreq: "QDS (Every 6 hours)",
    defaultDuration: "PRN / Short-term",
    indication: "Moderate pain, Fever, Post-operative pain",
    category: "Nervous System & Pain",
    info: "Intravenous paracetamol. Administer as 15-minute IV infusion.",
    sideEffects: "Hypotension, hepatotoxicity in overdose.",
    contraindications: "Severe hepatic impairment."
  },
  {
    name: "Ibuprofen 400mg Tablets (Brufen)",
    defaultDose: "400 mg",
    defaultFreq: "TDS (With food)",
    defaultDuration: "Short-term / PRN",
    indication: "Mild to moderate pain, Inflammation, Fever",
    category: "Nervous System & Pain",
    info: "NSAID. Must be taken after meals to reduce GI irritation.",
    sideEffects: "Dyspepsia, GI ulceration, bronchospasm in susceptible asthmatics.",
    contraindications: "Active peptic ulcer, severe heart failure, third trimester of pregnancy."
  },
  {
    name: "Diclofenac Sodium 50mg / 75mg / 100mg (Voltaren)",
    defaultDose: "50 mg",
    defaultFreq: "BD to TDS (With food)",
    defaultDuration: "Short-term",
    indication: "Acute musculoskeletal pain, Gout flares, Renal colic (IM)",
    category: "Nervous System & Pain",
    info: "Potent NSAID. Available in oral, IM, suppositories, and topical forms.",
    sideEffects: "GI bleeding, increased cardiovascular risk with long term use.",
    contraindications: "Ischemic heart disease, active peptic ulcer."
  },
  {
    name: "Celecoxib 200mg Capsules (Celebrex)",
    defaultDose: "200 mg",
    defaultFreq: "OD to BD",
    defaultDuration: "Chronic or Short-term",
    indication: "Osteoarthritis, Rheumatoid Arthritis",
    category: "Nervous System & Pain",
    info: "COX-2 selective NSAID. Lower risk of GI bleeding compared to traditional NSAIDs.",
    sideEffects: "Hypertension, edema, cardiovascular events.",
    contraindications: "Sulfa allergy, severe cardiovascular disease."
  },
  {
    name: "Tramadol 50mg Capsules",
    defaultDose: "50-100 mg",
    defaultFreq: "TDS to QDS",
    defaultDuration: "Short-term",
    indication: "Moderate to severe pain",
    category: "Nervous System & Pain",
    info: "Weak opioid and SNRI. High risk of dependence and tolerance.",
    sideEffects: "Nausea, dizziness, constipation, seizure risk at high doses.",
    contraindications: "Uncontrolled epilepsy, concurrent use of MAOIs."
  },
  {
    name: "Eperisone 50mg Tablets (Myonal)",
    defaultDose: "50 mg",
    defaultFreq: "TDS (Three times daily)",
    defaultDuration: "1-2 weeks",
    indication: "Muscle spasms, tension headache, back pain",
    category: "Nervous System & Pain",
    info: "Centrally acting muscle relaxant.",
    sideEffects: "Drowsiness, weakness, dizziness.",
    contraindications: "Severe hepatic impairment."
  },

  // --- COMMON GP ANTIBIOTICS ---
  {
    name: "Amoxicillin + Clavulanate 1g Tablets (Augmentin)",
    defaultDose: "1 Gram (875mg/125mg)",
    defaultFreq: "BD (Every 12 hours)",
    defaultDuration: "5-7 days",
    indication: "RTI, UTI, Skin/Soft tissue infections, Bite wounds",
    category: "Infections",
    info: "Broad-spectrum beta-lactam with beta-lactamase inhibitor.",
    sideEffects: "Diarrhea (very common), nausea, candidiasis.",
    contraindications: "Penicillin allergy, previous Augmentin-associated jaundice."
  },
  {
    name: "Azithromycin 500mg Tablets (Zithromax)",
    defaultDose: "500 mg",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "3 days (or 5 days depending on indication)",
    indication: "Atypical pneumonia, Chlamydia, ENT infections (if penicillin-allergic)",
    category: "Infections",
    info: "Macrolide antibiotic. Has a long half-life.",
    sideEffects: "GI upset, QT prolongation.",
    contraindications: "Macrolide allergy, severe hepatic impairment."
  },
  {
    name: "Ciprofloxacin 500mg Tablets (Ciprox)",
    defaultDose: "500 mg",
    defaultFreq: "BD (Every 12 hours)",
    defaultDuration: "3-7 days",
    indication: "Complicated UTI, Typhoid, severe gastroenteritis",
    category: "Infections",
    info: "Fluoroquinolone. Excellent gram-negative coverage.",
    sideEffects: "Tendon rupture (especially Achilles), QT prolongation, neuropathy.",
    contraindications: "Pregnancy, children (cartilage damage risk), history of tendon disorders."
  },
  {
    name: "Cefuroxime Axetil 500mg Tablets (Zinnat)",
    defaultDose: "500 mg",
    defaultFreq: "BD (Every 12 hours)",
    defaultDuration: "5-7 days",
    indication: "Lyme disease, RTI, UTI",
    category: "Infections",
    info: "Second-generation cephalosporin.",
    sideEffects: "GI upset, hypersensitivity.",
    contraindications: "Severe cephalosporin allergy."
  },
  {
    name: "Metronidazole 400mg / 500mg Tablets (Flagyl)",
    defaultDose: "400-500 mg",
    defaultFreq: "TDS (Three times daily)",
    defaultDuration: "5-7 days",
    indication: "Anaerobic infections, bacterial vaginosis, Giardiasis, Trichomoniasis",
    category: "Infections",
    info: "Nitroimidazole antibiotic.",
    sideEffects: "Metallic taste, nausea, disulfiram-like reaction with alcohol.",
    contraindications: "Alcohol consumption during and 48 hours after treatment."
  },

  // --- CARDIOLOGY & HYPERTENSION ---
  {
    name: "Amlodipine 5mg / 10mg Tablets",
    defaultDose: "5-10 mg",
    defaultFreq: "OD",
    defaultDuration: "Chronic",
    indication: "Hypertension, Angina",
    category: "Cardiovascular",
    info: "Calcium channel blocker (dihydropyridine).",
    sideEffects: "Peripheral edema (ankle swelling), flushing, headache.",
    contraindications: "Severe aortic stenosis, cardiogenic shock."
  },
  {
    name: "Valsartan 80mg / 160mg Tablets (Diovan)",
    defaultDose: "80-160 mg",
    defaultFreq: "OD",
    defaultDuration: "Chronic",
    indication: "Hypertension, Heart Failure, Post-MI",
    category: "Cardiovascular",
    info: "Angiotensin II Receptor Blocker (ARB).",
    sideEffects: "Dizziness, hyperkalemia, renal impairment.",
    contraindications: "Pregnancy (Teratogenic), severe hepatic impairment."
  },
  {
    name: "Bisoprolol 2.5mg / 5mg / 10mg Tablets (Concor)",
    defaultDose: "5 mg",
    defaultFreq: "OD",
    defaultDuration: "Chronic",
    indication: "Hypertension, Angina, Heart Failure",
    category: "Cardiovascular",
    info: "Cardioselective Beta-1 blocker.",
    sideEffects: "Bradycardia, fatigue, cold extremities, bronchospasm.",
    contraindications: "Severe asthma, 2nd/3rd degree heart block, symptomatic bradycardia."
  },
  {
    name: "Rosuvastatin 10mg / 20mg Tablets (Crestor)",
    defaultDose: "10-20 mg",
    defaultFreq: "OD (Any time of day)",
    defaultDuration: "Chronic",
    indication: "Hypercholesterolemia, Cardiovascular risk reduction",
    category: "Cardiovascular",
    info: "High-intensity statin. Longer half-life than Atorvastatin.",
    sideEffects: "Myalgia, elevated liver enzymes, increased risk of new-onset diabetes.",
    contraindications: "Active liver disease, pregnancy."
  },

  // --- DIABETES (ORAL) ---
  {
    name: "Metformin 500mg / 850mg / 1000mg Tablets (Glucophage)",
    defaultDose: "500 mg initially",
    defaultFreq: "BD to TDS (With meals)",
    defaultDuration: "Chronic",
    indication: "Type 2 Diabetes Mellitus, PCOS",
    category: "Endocrine",
    info: "Biguanide. First-line oral hypoglycemic. Does NOT cause hypoglycemia on its own.",
    sideEffects: "GI upset (diarrhea, nausea), lactic acidosis (rare), B12 deficiency over time.",
    contraindications: "eGFR < 30, acute metabolic acidosis, severe hepatic impairment."
  },
  {
    name: "Sitagliptin 100mg Tablets (Januvia)",
    defaultDose: "100 mg",
    defaultFreq: "OD",
    defaultDuration: "Chronic",
    indication: "Type 2 Diabetes Mellitus",
    category: "Endocrine",
    info: "DPP-4 inhibitor. Weight neutral.",
    sideEffects: "Nasopharyngitis, headache, rare risk of pancreatitis.",
    contraindications: "History of pancreatitis."
  },

  // --- GASTROINTESTINAL ---
  {
    name: "Pantoprazole 40mg Tablets (Controloc)",
    defaultDose: "40 mg",
    defaultFreq: "OD (30 mins before breakfast)",
    defaultDuration: "2-8 weeks",
    indication: "GERD, Peptic Ulcer Disease, H. Pylori eradication",
    category: "Gastro-intestinal",
    info: "Proton Pump Inhibitor (PPI).",
    sideEffects: "Headache, GI upset, increased risk of C. diff and bone fractures (long-term).",
    contraindications: "Concomitant use with specific antivirals (e.g., atazanavir)."
  },
  {
    name: "Hyoscine Butylbromide 10mg Tablets (Buscopan)",
    defaultDose: "10-20 mg",
    defaultFreq: "TDS to QDS",
    defaultDuration: "Short-term / PRN",
    indication: "GI/Biliary spasms, Irritable Bowel Syndrome (IBS)",
    category: "Gastro-intestinal",
    info: "Antispasmodic / Anticholinergic.",
    sideEffects: "Dry mouth, tachycardia, blurred vision, urinary retention.",
    contraindications: "Myasthenia gravis, megacolon, narrow-angle glaucoma."
  },
  {
    name: "Mebeverine 135mg / 200mg SR Tablets (Duspatalin)",
    defaultDose: "135mg TDS or 200mg BD",
    defaultFreq: "20 mins before meals",
    defaultDuration: "Chronic / PRN",
    indication: "Irritable Bowel Syndrome (IBS)",
    category: "Gastro-intestinal",
    info: "Musculotropic antispasmodic. Acts directly on gut smooth muscle.",
    sideEffects: "Rare allergic reactions.",
    contraindications: "Paralytic ileus."
  },
  {
    name: "Domperidone 10mg Tablets (Motilium)",
    defaultDose: "10 mg",
    defaultFreq: "TDS (Before meals)",
    defaultDuration: "Max 7 days",
    indication: "Nausea, Vomiting, Gastroparesis",
    category: "Gastro-intestinal",
    info: "Prokinetic and antiemetic. Does not cross BBB significantly.",
    sideEffects: "QT prolongation, elevated prolactin (galactorrhea).",
    contraindications: "Cardiac conduction disorders, prolactinoma, GI hemorrhage."
  },

  // --- RESPIRATORY & ALLERGIES ---
  {
    name: "Salbutamol 100mcg Inhaler (Ventolin)",
    defaultDose: "1-2 Puffs",
    defaultFreq: "PRN (As needed for wheeze/breathlessness)",
    defaultDuration: "Chronic PRN",
    indication: "Asthma rescue, COPD exacerbation",
    category: "Respiratory",
    info: "SABA (Short-acting beta agonist).",
    sideEffects: "Tremor, tachycardia, hypokalemia at high doses.",
    contraindications: "None major for acute rescue."
  },
  {
    name: "Budesonide + Formoterol Inhaler (Symbicort)",
    defaultDose: "1-2 Puffs",
    defaultFreq: "BD (Maintenance) or PRN (SMART therapy)",
    defaultDuration: "Chronic",
    indication: "Asthma maintenance, COPD",
    category: "Respiratory",
    info: "ICS + LABA combination. Must rinse mouth after use.",
    sideEffects: "Oral thrush (candidiasis), hoarseness, palpitations.",
    contraindications: "Primary treatment of status asthmaticus."
  },
  {
    name: "Montelukast 10mg Tablets (Singulair)",
    defaultDose: "10 mg",
    defaultFreq: "OD (At night)",
    defaultDuration: "Chronic",
    indication: "Asthma prophylaxis, Allergic Rhinitis",
    category: "Respiratory",
    info: "Leukotriene receptor antagonist.",
    sideEffects: "Neuropsychiatric events (nightmares, agitation, depression).",
    contraindications: "None major."
  },
  {
    name: "Desloratadine 5mg Tablets (Aerius)",
    defaultDose: "5 mg",
    defaultFreq: "OD",
    defaultDuration: "PRN to Chronic",
    indication: "Allergic Rhinitis, Urticaria",
    category: "Respiratory",
    info: "Non-sedating antihistamine. Metabolite of loratadine.",
    sideEffects: "Fatigue, dry mouth (minimal).",
    contraindications: "Severe renal impairment (requires dose adjustment)."
  },

  // --- VERTIGO, GOUT, VITAMINS ---
  {
    name: "Betahistine 16mg / 24mg Tablets (Serc)",
    defaultDose: "16 mg TDS or 24 mg BD",
    defaultFreq: "With meals",
    defaultDuration: "Chronic / PRN",
    indication: "Meniere's Disease, Vertigo, Tinnitus",
    category: "Nervous System & Pain",
    info: "Histamine analogue. Improves microcirculation of the inner ear.",
    sideEffects: "GI upset, headache.",
    contraindications: "Pheochromocytoma, active peptic ulcer."
  },
  {
    name: "Allopurinol 100mg / 300mg Tablets (Zyloric)",
    defaultDose: "100-300 mg",
    defaultFreq: "OD (After meals)",
    defaultDuration: "Chronic",
    indication: "Gout prophylaxis (Hyperuricemia)",
    category: "Genitourinary",
    info: "Xanthine oxidase inhibitor. Never start DURING an acute gout flare.",
    sideEffects: "Maculopapular rash, GI upset, severe hypersensitivity (DRESS).",
    contraindications: "Acute gout attack."
  },
  {
    name: "Vitamin B-Complex Tablets (Neurobion)",
    defaultDose: "1 Tablet",
    defaultFreq: "OD to TDS",
    defaultDuration: "1-3 months",
    indication: "Neuropathy, Vitamin B deficiency",
    category: "Endocrine & Nutrition",
    info: "Contains B1 (Thiamine), B6 (Pyridoxine), B12 (Cyanocobalamin).",
    sideEffects: "Yellow discoloration of urine.",
    contraindications: "Levodopa therapy (B6 reduces its efficacy unless with carbidopa)."
  },
  // ==========================================
  // CHAPTER 20: EMERGENCY MEDICINE & RESUSCITATION (INJECTIONS)
  // ==========================================

  // --- CARDIAC ARREST & ARRHYTHMIAS ---
  {
    name: "Adrenaline (Epinephrine) 1:10,000 IV Injection",
    defaultDose: "1 mg (10 mL of 1:10,000)",
    defaultFreq: "Every 3-5 minutes during CPR",
    defaultDuration: "Stat / During Resuscitation",
    indication: "Cardiac Arrest (VF, pVT, Asystole, PEA)",
    category: "Emergency & Resuscitation",
    info: "Primary vasopressor in ALS. Increases coronary and cerebral perfusion pressure.",
    sideEffects: "Severe tachycardia, hypertension, myocardial ischemia (post-resuscitation).",
    contraindications: "None in cardiac arrest."
  },
  {
    name: "Amiodarone 300mg IV Injection",
    defaultDose: "300 mg bolus (in 20ml D5W)",
    defaultFreq: "Stat (Followed by 150mg if needed)",
    defaultDuration: "Stat",
    indication: "Shock-refractory VF / pVT, stable sustained VT",
    category: "Emergency & Resuscitation",
    info: "Class III Antiarrhythmic.",
    sideEffects: "Hypotension, bradycardia.",
    contraindications: "Severe sinus node dysfunction, 2nd/3rd degree heart block."
  },
  {
    name: "Atropine 0.5mg - 1mg IV Injection",
    defaultDose: "0.5 - 1 mg",
    defaultFreq: "Every 3-5 minutes (Max 3mg)",
    defaultDuration: "Stat",
    indication: "Symptomatic Bradycardia, Organophosphate poisoning",
    category: "Emergency & Resuscitation",
    info: "Anticholinergic. Reverses vagal tone.",
    sideEffects: "Tachycardia, dry mouth, dilated pupils, urinary retention.",
    contraindications: "Glaucoma, pyloric stenosis (relative in emergency)."
  },
  {
    name: "Adenosine 6mg IV Rapid Push",
    defaultDose: "6 mg rapid push (Followed by 12mg if no response)",
    defaultFreq: "Stat",
    defaultDuration: "Stat",
    indication: "Supraventricular Tachycardia (SVT)",
    category: "Emergency & Resuscitation",
    info: "Causes transient AV block to reset the rhythm. Must be flushed rapidly with saline.",
    sideEffects: "Sense of impending doom, flushing, chest tightness, transient asystole.",
    contraindications: "Asthma (can cause bronchospasm), 2nd/3rd degree heart block."
  },

  // --- ANAPHYLAXIS & SEVERE ALLERGY ---
  {
    name: "Adrenaline (Epinephrine) 1:1000 IM Injection",
    defaultDose: "0.5 mg (0.5 mL of 1:1000)",
    defaultFreq: "Stat (Repeat after 5 mins if no improvement)",
    defaultDuration: "Stat",
    indication: "Anaphylaxis, severe life-threatening asthma",
    category: "Emergency & Resuscitation",
    info: "Must be given INTRAMUSCULARLY in the anterolateral thigh for anaphylaxis.",
    sideEffects: "Palpitations, tremor, anxiety.",
    contraindications: "None in true anaphylaxis."
  },
  {
    name: "Hydrocortisone 100mg - 200mg IV Injection",
    defaultDose: "200 mg",
    defaultFreq: "Stat (Then QDS)",
    defaultDuration: "Short-term",
    indication: "Anaphylaxis (post-adrenaline), Acute Severe Asthma, Adrenal Crisis",
    category: "Emergency & Resuscitation",
    info: "Fast-acting IV corticosteroid. Prevents late-phase allergic responses.",
    sideEffects: "Hyperglycemia, fluid retention.",
    contraindications: "Systemic fungal infections."
  },
  {
    name: "Chlorphenamine 10mg IV Injection",
    defaultDose: "10 mg",
    defaultFreq: "Stat",
    defaultDuration: "Stat",
    indication: "Anaphylaxis (adjunct), Severe allergic reactions",
    category: "Emergency & Resuscitation",
    info: "First-generation antihistamine given slowly IV.",
    sideEffects: "Drowsiness, transient hypotension if given too fast.",
    contraindications: "None in emergency."
  },

  // --- NEUROLOGICAL EMERGENCIES (SEIZURES) ---
  {
    name: "Diazepam 10mg IV / Rectal",
    defaultDose: "10 mg (IV given slowly 2mg/min)",
    defaultFreq: "Stat (Repeat once if needed)",
    defaultDuration: "Stat",
    indication: "Status Epilepticus, Severe muscle spasm, Alcohol withdrawal",
    category: "Emergency & Resuscitation",
    info: "Long-acting benzodiazepine. High risk of respiratory depression.",
    sideEffects: "Respiratory depression, hypotension, prolonged sedation.",
    contraindications: "Respiratory failure, myasthenia gravis."
  },
  {
    name: "Midazolam 5mg - 10mg IM / IV",
    defaultDose: "10 mg IM (or 2-5 mg IV slowly)",
    defaultFreq: "Stat",
    defaultDuration: "Stat",
    indication: "Status Epilepticus (IM preferred if no IV access), Procedural Sedation",
    category: "Emergency & Resuscitation",
    info: "Short-acting benzodiazepine. Faster onset than diazepam IM.",
    sideEffects: "Respiratory depression, apnea, hypotension.",
    contraindications: "Shock, severe respiratory depression."
  },

  // --- ER ANALGESIA & SEDATION ---
  {
    name: "Morphine Sulfate 2mg - 10mg IV Injection",
    defaultDose: "2-5 mg titrated to effect",
    defaultFreq: "PRN",
    defaultDuration: "Stat / Short-term",
    indication: "Severe acute pain (Trauma, MI, Renal Colic)",
    category: "Emergency & Resuscitation",
    info: "Strong opioid analgesic. Monitor respiratory rate and BP.",
    sideEffects: "Respiratory depression, hypotension, nausea, vomiting, pinpoint pupils.",
    contraindications: "Hypotension, respiratory depression, raised intracranial pressure."
  },
  {
    name: "Fentanyl 50mcg - 100mcg IV Injection",
    defaultDose: "50-100 mcg",
    defaultFreq: "Stat",
    defaultDuration: "Stat",
    indication: "Severe acute pain, rapid sequence intubation (RSI) adjunct",
    category: "Emergency & Resuscitation",
    info: "Synthetic opioid. 100x more potent than morphine, faster onset, less hypotension.",
    sideEffects: "Chest wall rigidity (if pushed too fast), respiratory depression.",
    contraindications: "Severe respiratory depression."
  },
  {
    name: "Ketamine 1-2 mg/kg IV (or 4-5 mg/kg IM)",
    defaultDose: "1-2 mg/kg IV",
    defaultFreq: "Stat",
    defaultDuration: "Stat",
    indication: "Procedural Sedation, Severe pain in trauma, RSI induction",
    category: "Emergency & Resuscitation",
    info: "Dissociative anesthetic. Preserves respiratory drive and increases BP.",
    sideEffects: "Emergence delirium, hallucinations, tachycardia, hypertension.",
    contraindications: "Conditions where significantly elevated BP is hazardous (e.g. aortic dissection)."
  },

  // --- ANTIDOTES & TOXICOLOGY ---
  {
    name: "Naloxone 400mcg IV / IM",
    defaultDose: "400 mcg (Titrate up to 2mg)",
    defaultFreq: "Stat (May need infusion)",
    defaultDuration: "Stat",
    indication: "Opioid Overdose (Respiratory depression)",
    category: "Emergency & Resuscitation",
    info: "Opioid receptor antagonist. Shorter half-life than many opioids; observe for re-sedation.",
    sideEffects: "Acute opioid withdrawal symptoms, agitation, tachycardia.",
    contraindications: "None in life-threatening opioid overdose."
  },
  {
    name: "Flumazenil 200mcg IV",
    defaultDose: "200 mcg over 15 seconds",
    defaultFreq: "Stat (Repeat up to 1mg)",
    defaultDuration: "Stat",
    indication: "Benzodiazepine Overdose (Iatrogenic or intentional)",
    category: "Emergency & Resuscitation",
    info: "Benzodiazepine antagonist. Caution in chronic benzo users (can trigger seizures).",
    sideEffects: "Seizures, agitation, nausea.",
    contraindications: "Co-ingestion of TCAs, known seizure disorder."
  },

  // --- METABOLIC & FLUID EMERGENCIES ---
  {
    name: "Dextrose 50% IV Injection",
    defaultDose: "25-50 mL (12.5 - 25g)",
    defaultFreq: "Stat",
    defaultDuration: "Stat",
    indication: "Severe Hypoglycemia (unconscious patient)",
    category: "Emergency & Resuscitation",
    info: "Hypertonic glucose. Must ensure good IV patency to avoid tissue necrosis.",
    sideEffects: "Phlebitis, tissue necrosis if extravasated.",
    contraindications: "Hyperglycemia, intracranial hemorrhage (relative)."
  },
  {
    name: "Glucagon 1mg IM Injection",
    defaultDose: "1 mg",
    defaultFreq: "Stat",
    defaultDuration: "Stat",
    indication: "Severe Hypoglycemia (no IV access)",
    category: "Emergency & Resuscitation",
    info: "Mobilizes hepatic glycogen stores. Will not work in starved/alcoholic patients.",
    sideEffects: "Nausea, vomiting.",
    contraindications: "Pheochromocytoma."
  },
  {
    name: "Normal Saline 0.9% IV Fluid",
    defaultDose: "500 mL - 1000 mL Bolus",
    defaultFreq: "Stat",
    defaultDuration: "Stat",
    indication: "Hypovolemic shock, Dehydration, Sepsis",
    category: "Emergency & Resuscitation",
    info: "Isotonic crystalloid. First-line resuscitation fluid.",
    sideEffects: "Hyperchloremic metabolic acidosis (with massive volumes), fluid overload.",
    contraindications: "Pulmonary edema, severe heart failure."
  },

  // --- MISCELLANEOUS ER DRUGS ---
  {
    name: "Ondansetron 4mg - 8mg IV Injection (Zofran)",
    defaultDose: "4 mg",
    defaultFreq: "Stat / TDS",
    defaultDuration: "Short-term",
    indication: "Severe Nausea and Vomiting",
    category: "Emergency & Resuscitation",
    info: "5-HT3 receptor antagonist. Highly effective antiemetic.",
    sideEffects: "Headache, constipation, QT prolongation.",
    contraindications: "Concomitant use of apomorphine, known long QT syndrome."
  },
  {
    name: "Tranexamic Acid 1g IV (TXA)",
    defaultDose: "1 Gram (Over 10 mins)",
    defaultFreq: "Stat",
    defaultDuration: "Stat",
    indication: "Major Trauma with hemorrhage, severe epistaxis, postpartum hemorrhage",
    category: "Emergency & Resuscitation",
    info: "Antifibrinolytic. Reduces mortality if given within 3 hours of trauma.",
    sideEffects: "Hypotension if pushed too fast, thromboembolic events (rare).",
    contraindications: "Active intravascular clotting (DIC), isolated subarachnoid hemorrhage."
  },
  {
    name: "Furosemide 40mg IV Injection (Lasix)",
    defaultDose: "40 mg (Slow IV push)",
    defaultFreq: "Stat",
    defaultDuration: "Stat",
    indication: "Acute Pulmonary Edema, severe fluid overload",
    category: "Emergency & Resuscitation",
    info: "Potent loop diuretic. Causes rapid venodilation followed by diuresis.",
    sideEffects: "Hypokalemia, hypotension, ototoxicity (if pushed too fast).",
    contraindications: "Anuria, severe hypovolemia/dehydration, severe hypokalemia."
  },
  {
    name: "Magnesium Sulfate 2g IV",
    defaultDose: "2 Grams (over 20 mins)",
    defaultFreq: "Stat",
    defaultDuration: "Stat",
    indication: "Severe Acute Asthma, Torsades de Pointes, Eclampsia",
    category: "Emergency & Resuscitation",
    info: "Smooth muscle relaxant and membrane stabilizer.",
    sideEffects: "Flushing, hypotension, loss of deep tendon reflexes (toxicity).",
    contraindications: "Myasthenia gravis, severe renal impairment."
  },
  // ==========================================
  // CHAPTER 21: RESPIRATORY INHALERS & NEBULIZER SOLUTIONS
  // ==========================================

  // --- SHORT-ACTING BRONCHODILATORS (SABA & SAMA) ---
  {
    name: "Salbutamol 2.5mg / 5mg Nebules (Ventolin Nebules)",
    defaultDose: "2.5 mg - 5 mg via Nebulizer",
    defaultFreq: "QDS or PRN (Can be continuous in severe attacks)",
    defaultDuration: "Short-term / Acute",
    indication: "Acute Asthma attack, COPD exacerbation",
    category: "Respiratory",
    info: "Short-acting Beta-2 Agonist (SABA) for nebulization.",
    sideEffects: "Tachycardia, tremor, hypokalemia.",
    contraindications: "None in acute severe bronchospasm."
  },
  {
    name: "Ipratropium Bromide 20mcg Inhaler / 500mcg Nebules (Atrovent)",
    defaultDose: "2 Puffs or 500mcg via Nebulizer",
    defaultFreq: "QDS",
    defaultDuration: "Short-term / Maintenance",
    indication: "COPD maintenance, Acute Asthma (adjunct)",
    category: "Respiratory",
    info: "Short-acting Muscarinic Antagonist (SAMA). Dries up secretions and causes bronchodilation.",
    sideEffects: "Dry mouth, paradoxical bronchospasm, urinary retention (rare).",
    contraindications: "Narrow-angle glaucoma (protect eyes during nebulization)."
  },
  {
    name: "Salbutamol 2.5mg + Ipratropium 500mcg Nebules (Combivent / Duolin)",
    defaultDose: "1 Nebule via Nebulizer",
    defaultFreq: "QDS or PRN",
    defaultDuration: "Short-term / Acute",
    indication: "Severe COPD exacerbation, Severe Asthma",
    category: "Respiratory",
    info: "Synergistic combination of SABA and SAMA for maximum acute bronchodilation.",
    sideEffects: "Tachycardia, tremor, dry mouth.",
    contraindications: "Glaucoma, symptomatic tachycardia."
  },

  // --- INHALED CORTICOSTEROIDS (ICS) ---
  {
    name: "Budesonide 0.5mg / 1mg Nebules (Pulmicort Respules)",
    defaultDose: "1-2 mg via Nebulizer",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "Acute / Maintenance",
    indication: "Croup in children, Asthma maintenance, COPD exacerbation",
    category: "Respiratory",
    info: "Inhaled corticosteroid (ICS) for nebulization. Reduces airway inflammation.",
    sideEffects: "Oral thrush (rinse mouth after use), hoarseness.",
    contraindications: "Primary treatment of status asthmaticus."
  },
  {
    name: "Fluticasone Propionate 50mcg / 125mcg / 250mcg Inhaler (Flixotide)",
    defaultDose: "2 Puffs",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "Chronic",
    indication: "Asthma prophylaxis",
    category: "Respiratory",
    info: "Potent Inhaled Corticosteroid (ICS). Needs to be used regularly, not for acute rescue.",
    sideEffects: "Oral candidiasis, dysphonia.",
    contraindications: "None major, but avoid as sole therapy in COPD."
  },
  {
    name: "Beclometasone 100mcg / 200mcg Inhaler (Clenil Modulite)",
    defaultDose: "2 Puffs",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "Chronic",
    indication: "Mild to moderate Asthma prophylaxis",
    category: "Respiratory",
    info: "Standard ICS. Usually prescribed with a spacer device.",
    sideEffects: "Oral thrush.",
    contraindications: "None major."
  },

  // --- LONG-ACTING BRONCHODILATORS (LABA & LAMA) ---
  {
    name: "Salmeterol 25mcg Inhaler (Serevent)",
    defaultDose: "2 Puffs",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "Chronic",
    indication: "Asthma (Must be combined with ICS), COPD",
    category: "Respiratory",
    info: "Long-acting Beta-2 Agonist (LABA). Never use without an ICS in asthma.",
    sideEffects: "Tremor, palpitations, headache.",
    contraindications: "Monotherapy in asthma (increases asthma-related death risk)."
  },
  {
    name: "Tiotropium 18mcg HandiHaler / 2.5mcg Respimat (Spiriva)",
    defaultDose: "1 Inhalation (HandiHaler) or 2 Puffs (Respimat)",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "Chronic",
    indication: "COPD maintenance, Severe Asthma (adjunct)",
    category: "Respiratory",
    info: "Long-acting Muscarinic Antagonist (LAMA). Gold standard for COPD.",
    sideEffects: "Dry mouth, constipation, urinary retention.",
    contraindications: "Caution in severe renal impairment and narrow-angle glaucoma."
  },

  // --- COMBINATION INHALERS (ICS + LABA) ---
  {
    name: "Salmeterol + Fluticasone Inhaler (Seretide Evohaler/Accuhaler)",
    defaultDose: "2 Puffs (or 1 Blister)",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "Chronic",
    indication: "Asthma maintenance, Severe COPD",
    category: "Respiratory",
    info: "ICS + LABA combination. One of the most widely used maintenance inhalers.",
    sideEffects: "Oral thrush, hoarseness, increased risk of pneumonia in COPD patients.",
    contraindications: "Acute asthma rescue."
  },
  {
    name: "Formoterol + Budesonide Inhaler (Symbicort Turbuhaler)",
    defaultDose: "1-2 Inhalations",
    defaultFreq: "BD (Maintenance) or PRN (MART/SMART therapy)",
    defaultDuration: "Chronic",
    indication: "Asthma (Maintenance and Reliever Therapy), COPD",
    category: "Respiratory",
    info: "ICS + LABA. Formoterol has a rapid onset, allowing this inhaler to be used as both preventer and reliever.",
    sideEffects: "Tremor, palpitations, thrush.",
    contraindications: "None major."
  },
  {
    name: "Vilanterol + Fluticasone Furoate (Relvar Ellipta)",
    defaultDose: "1 Inhalation (92/22mcg or 184/22mcg)",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "Chronic",
    indication: "Asthma, COPD",
    category: "Respiratory",
    info: "Once-daily ICS + LABA. Improves patient compliance.",
    sideEffects: "Nasopharyngitis, oral candidiasis, pneumonia in COPD.",
    contraindications: "Acute bronchospasm."
  },

  // --- DUAL & TRIPLE THERAPY INHALERS (COPD) ---
  {
    name: "Umeclidinium + Vilanterol (Anoro Ellipta)",
    defaultDose: "1 Inhalation",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "Chronic",
    indication: "COPD maintenance",
    category: "Respiratory",
    info: "LAMA + LABA combination. Maximizes bronchodilation without steroids.",
    sideEffects: "Dry mouth, nasopharyngitis, cough.",
    contraindications: "Asthma (not indicated), acute bronchospasm."
  },
  {
    name: "Fluticasone + Umeclidinium + Vilanterol (Trelegy Ellipta)",
    defaultDose: "1 Inhalation",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "Chronic",
    indication: "Severe COPD, Severe Asthma",
    category: "Respiratory",
    info: "Triple therapy (ICS + LAMA + LABA) in a single device.",
    sideEffects: "Pneumonia, oral thrush, dysphonia.",
    contraindications: "Acute bronchospasm."
  },

  // --- OTHER NEBULIZER SOLUTIONS ---
  {
    name: "Hypertonic Saline 3% / 7% Nebules",
    defaultDose: "4 mL via Nebulizer",
    defaultFreq: "BD to QDS",
    defaultDuration: "Short-term / Chronic in CF",
    indication: "Bronchiolitis (infants), Cystic Fibrosis, Bronchiectasis",
    category: "Respiratory",
    info: "Osmotic agent that draws water into airways to thin mucus and induce sputum.",
    sideEffects: "Bronchospasm (can pre-treat with salbutamol), coughing.",
    contraindications: "Severe uncontrolled asthma."
  },
  {
    name: "Normal Saline 0.9% Nebules",
    defaultDose: "2.5 - 5 mL via Nebulizer",
    defaultFreq: "PRN",
    defaultDuration: "Short-term",
    indication: "Mild congestion, airway humidification",
    category: "Respiratory",
    info: "Isotonic solution. Soothes irritated airways and helps loosen mild secretions.",
    sideEffects: "None.",
    contraindications: "None."
  },
  // ==========================================
  // CHAPTER 22: ALLERGY, NASAL, & OPHTHALMIC MEDICATIONS
  // ==========================================

  // --- NASAL SPRAYS (ALLERGIC RHINITIS & DECONGESTANTS) ---
  {
    name: "Mometasone Furoate 50mcg/spray Nasal Spray (Nasonex)",
    defaultDose: "2 Sprays in each nostril",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "Chronic / Seasonal",
    indication: "Allergic Rhinitis (Seasonal & Perennial), Nasal Polyps",
    category: "ENT & Allergy",
    info: "Intranasal corticosteroid. Needs to be used regularly for full effect (onset in 1-2 days).",
    sideEffects: "Epistaxis (nosebleeds), nasal irritation, headache.",
    contraindications: "Untreated localized nasal infection (e.g. Herpes Simplex)."
  },
  {
    name: "Fluticasone Propionate 50mcg/spray Nasal Spray (Flixonase)",
    defaultDose: "2 Sprays in each nostril",
    defaultFreq: "OD (Once daily in the morning)",
    defaultDuration: "Seasonal / Chronic",
    indication: "Allergic Rhinitis",
    category: "ENT & Allergy",
    info: "Intranasal corticosteroid. Very effective for nasal congestion and sneezing.",
    sideEffects: "Epistaxis, dry nose, unpleasant taste.",
    contraindications: "Recent nasal surgery or trauma (until healed)."
  },
  {
    name: "Budesonide 64mcg/spray Nasal Spray (Rhinocort)",
    defaultDose: "2 Sprays in each nostril",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "Seasonal / Chronic",
    indication: "Allergic Rhinitis, Vasomotor Rhinitis",
    category: "ENT & Allergy",
    info: "Intranasal corticosteroid. Safe and effective option.",
    sideEffects: "Nasal bleeding, irritation.",
    contraindications: "Hypersensitivity."
  },
  {
    name: "Azelastine 0.1% Nasal Spray (Allergodil)",
    defaultDose: "1 Spray in each nostril",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "PRN to Seasonal",
    indication: "Allergic Rhinitis (rapid relief)",
    category: "ENT & Allergy",
    info: "Intranasal antihistamine. Provides rapid onset relief (within 15 mins).",
    sideEffects: "Bitter taste, somnolence, nasal burning.",
    contraindications: "None major."
  },
  {
    name: "Xylometazoline 0.1% Nasal Spray (Otrivin)",
    defaultDose: "1 Spray in each nostril",
    defaultFreq: "TDS (Three times daily)",
    defaultDuration: "MAX 5-7 days",
    indication: "Nasal Congestion (Colds, Sinusitis)",
    category: "ENT & Allergy",
    info: "Topical decongestant. STRICT WARNING: Do not use for more than 7 days to avoid Rhinitis Medicamentosa (rebound congestion).",
    sideEffects: "Rebound congestion, dry nasal mucosa.",
    contraindications: "Glaucoma, trans-sphenoidal hypophysectomy."
  },

  // --- EYE DROPS (ALLERGIC CONJUNCTIVITIS) ---
  {
    name: "Olopatadine 0.1% / 0.2% Eye Drops (Patanol / Pataday)",
    defaultDose: "1 Drop in affected eye(s)",
    defaultFreq: "BD (0.1%) or OD (0.2%)",
    defaultDuration: "Seasonal / PRN",
    indication: "Allergic Conjunctivitis (Itchy, red, watery eyes)",
    category: "Ophthalmology",
    info: "Dual-action: Antihistamine and mast-cell stabilizer.",
    sideEffects: "Mild eye burning on instillation, dry eyes, altered taste.",
    contraindications: "Do not use while wearing contact lenses."
  },
  {
    name: "Ketotifen 0.025% Eye Drops (Zaditen)",
    defaultDose: "1 Drop in affected eye(s)",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "Seasonal",
    indication: "Allergic Conjunctivitis",
    category: "Ophthalmology",
    info: "Antihistamine and mast-cell stabilizer. Good for long-term seasonal prevention.",
    sideEffects: "Transient stinging, dry eyes.",
    contraindications: "None major."
  },
  {
    name: "Sodium Cromoglicate 2% Eye Drops (Opticrom)",
    defaultDose: "1 Drop in affected eye(s)",
    defaultFreq: "QDS (Four times daily)",
    defaultDuration: "Chronic (Start before allergy season)",
    indication: "Vernal Keratoconjunctivitis, Allergic Conjunctivitis",
    category: "Ophthalmology",
    info: "Mast-cell stabilizer. Requires frequent dosing (QDS) for efficacy.",
    sideEffects: "Transient stinging.",
    contraindications: "None major."
  },
  {
    name: "Fluorometholone 0.1% Eye Drops (FML)",
    defaultDose: "1 Drop in affected eye(s)",
    defaultFreq: "BD to QDS",
    defaultDuration: "Short-term (Max 1-2 weeks)",
    indication: "Severe Allergic Conjunctivitis, Ocular inflammation",
    category: "Ophthalmology",
    info: "Mild topical corticosteroid. Must be prescribed cautiously.",
    sideEffects: "Increased intraocular pressure (IOP), risk of cataracts, secondary infections.",
    contraindications: "Viral eye infections (Herpes Simplex), fungal eye infections."
  },

  // --- ORAL ANTIHISTAMINES ---
  {
    name: "Cetirizine 10mg Tablets (Zyrtec)",
    defaultDose: "10 mg",
    defaultFreq: "OD (Once daily, usually evening)",
    defaultDuration: "PRN to Chronic",
    indication: "Allergic Rhinitis, Urticaria, Pruritus",
    category: "Allergy",
    info: "Second-generation antihistamine. More sedating than loratadine/fexofenadine.",
    sideEffects: "Somnolence, dry mouth, fatigue.",
    contraindications: "Severe renal impairment."
  },
  {
    name: "Levocetirizine 5mg Tablets (Xyzal)",
    defaultDose: "5 mg",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "PRN to Chronic",
    indication: "Allergic Rhinitis, Chronic Idiopathic Urticaria",
    category: "Allergy",
    info: "Active enantiomer of cetirizine. Potent with slightly less sedation.",
    sideEffects: "Somnolence, dry mouth.",
    contraindications: "Severe renal impairment (CrCl < 10 mL/min)."
  },
  {
    name: "Fexofenadine 120mg / 180mg Tablets (Telfast)",
    defaultDose: "120 mg (Rhinitis) or 180 mg (Urticaria)",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "PRN to Chronic",
    indication: "Allergic Rhinitis, Urticaria",
    category: "Allergy",
    info: "Third-generation antihistamine. Truly non-sedating. Do not take with fruit juices (reduces absorption).",
    sideEffects: "Headache, nausea.",
    contraindications: "None major."
  },
  {
    name: "Loratadine 10mg Tablets (Claritin)",
    defaultDose: "10 mg",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "PRN to Chronic",
    indication: "Allergic Rhinitis, Urticaria",
    category: "Allergy",
    info: "Second-generation, non-sedating antihistamine.",
    sideEffects: "Headache, dry mouth.",
    contraindications: "Severe hepatic impairment (requires lower dose)."
  },
  {
    name: "Chlorphenamine 4mg Tablets (Piriton)",
    defaultDose: "4 mg",
    defaultFreq: "TDS to QDS",
    defaultDuration: "Short-term / PRN",
    indication: "Acute Allergic reactions, severe itch",
    category: "Allergy",
    info: "First-generation antihistamine. Highly sedating.",
    sideEffects: "Drowsiness, dry mouth, blurred vision, urinary retention.",
    contraindications: "Narrow-angle glaucoma, symptomatic BPH."
  },

  // --- SYSTEMIC STEROIDS (ALLERGY FLARES & ASTHMA) ---
  {
    name: "Prednisolone 5mg / 20mg Tablets",
    defaultDose: "40 mg (Typically 8 x 5mg tablets) in the morning",
    defaultFreq: "OD (Once daily after breakfast)",
    defaultDuration: "5-7 days (No taper needed if < 2 weeks)",
    indication: "Acute Asthma exacerbation, Severe Allergic reactions, Contact Dermatitis flare",
    category: "Systemic Steroids",
    info: "Standard oral corticosteroid. Take in the morning to prevent insomnia.",
    sideEffects: "Insomnia, mood changes, increased appetite, hyperglycemia, dyspepsia.",
    contraindications: "Systemic fungal infections, live vaccines."
  },
  {
    name: "Dexamethasone 0.5mg Tablets / 8mg IM Injection",
    defaultDose: "0.5-8 mg (Depending on route/indication)",
    defaultFreq: "Stat or OD",
    defaultDuration: "Short-term",
    indication: "Croup (in children), Severe allergy, Cerebral edema",
    category: "Systemic Steroids",
    info: "Long-acting, very potent corticosteroid without mineralocorticoid activity.",
    sideEffects: "Hyperglycemia, insomnia, mood swings, GI bleeding.",
    contraindications: "Systemic fungal infections."
  },
  // ==========================================
  // CHAPTER 23: EYE, EAR, & NASAL DROPS/OINTMENTS
  // ==========================================

  // --- OPHTHALMIC ANTIBIOTICS ---
  {
    name: "Chloramphenicol 0.5% Eye Drops / 1% Ointment",
    defaultDose: "1 Drop or 1cm Ointment in affected eye(s)",
    defaultFreq: "QDS (Drops) or At Night (Ointment)",
    defaultDuration: "5-7 days",
    indication: "Bacterial Conjunctivitis",
    category: "Ophthalmology",
    info: "Broad-spectrum bacteriostatic. First-line for simple bacterial conjunctivitis.",
    sideEffects: "Transient stinging, rare risk of aplastic anemia (systemic absorption).",
    contraindications: "Personal or family history of blood dyscrasias."
  },
  {
    name: "Tobramycin 0.3% Eye Drops / Ointment (Tobrex)",
    defaultDose: "1-2 Drops in affected eye(s)",
    defaultFreq: "QDS",
    defaultDuration: "5-7 days",
    indication: "Bacterial eye infections",
    category: "Ophthalmology",
    info: "Aminoglycoside antibiotic. Good gram-negative coverage.",
    sideEffects: "Eye irritation, tearing.",
    contraindications: "None major."
  },
  {
    name: "Ciprofloxacin 0.3% Eye Drops (Ciloxan)",
    defaultDose: "1-2 Drops in affected eye(s)",
    defaultFreq: "Every 2 hours for 2 days, then QDS",
    defaultDuration: "7 days",
    indication: "Corneal Ulcers, Severe Bacterial Conjunctivitis",
    category: "Ophthalmology",
    info: "Fluoroquinolone antibiotic. Used for serious infections or pseudomonas coverage.",
    sideEffects: "White crystalline precipitate in the cornea (harmless, resolves), stinging.",
    contraindications: "None major."
  },
  {
    name: "Fusidic Acid 1% Viscous Eye Drops (Fucithalmic)",
    defaultDose: "1 Drop in affected eye(s)",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "7 days",
    indication: "Bacterial Conjunctivitis, Staphylococcal infections",
    category: "Ophthalmology",
    info: "Highly effective against Staph. Convenient twice-daily dosing due to viscous formulation.",
    sideEffects: "Blurred vision immediately after use.",
    contraindications: "None major."
  },

  // --- EYE COMBINATIONS (ANTIBIOTIC + STEROID) ---
  {
    name: "Tobramycin + Dexamethasone Eye Drops / Ointment (TobraDex)",
    defaultDose: "1-2 Drops in affected eye(s)",
    defaultFreq: "QDS to Every 2 hours",
    defaultDuration: "Max 7-14 days",
    indication: "Steroid-responsive ocular inflammation with risk of bacterial infection",
    category: "Ophthalmology",
    info: "Potent anti-inflammatory + antibiotic. MUST exclude Herpes Simplex before prescribing.",
    sideEffects: "Elevated intraocular pressure (IOP), delayed healing, secondary fungal infection.",
    contraindications: "Viral or fungal eye infections."
  },
  {
    name: "Neomycin + Polymyxin + Dexamethasone (Maxitrol)",
    defaultDose: "1-2 Drops",
    defaultFreq: "QDS",
    defaultDuration: "Max 7 days",
    indication: "Blepharoconjunctivitis, Iritis",
    category: "Ophthalmology",
    info: "Triple combination. Same precautions as TobraDex.",
    sideEffects: "Elevated IOP, local irritation.",
    contraindications: "Viral/fungal infections, perforated eardrum (if used in ear)."
  },

  // --- DRY EYES / LUBRICANTS ---
  {
    name: "Hyaluronic Acid 0.1% / 0.2% Eye Drops (Hylo-Comod / Hylo-Gel)",
    defaultDose: "1 Drop in affected eye(s)",
    defaultFreq: "TDS or PRN",
    defaultDuration: "Chronic",
    indication: "Dry Eye Syndrome",
    category: "Ophthalmology",
    info: "Preservative-free premium artificial tears. Excellent for long-term use.",
    sideEffects: "None.",
    contraindications: "None."
  },
  {
    name: "Polyethylene Glycol + Propylene Glycol Eye Drops (Systane Ultra)",
    defaultDose: "1-2 Drops",
    defaultFreq: "PRN (As needed)",
    defaultDuration: "Chronic",
    indication: "Dry Eye Syndrome, Ocular irritation",
    category: "Ophthalmology",
    info: "Provides a gel-like protective matrix over the cornea.",
    sideEffects: "Mild blurring immediately after instillation.",
    contraindications: "None."
  },
  {
    name: "Carbomer 0.2% Eye Gel (Viscotears)",
    defaultDose: "1 Drop",
    defaultFreq: "BD to QDS",
    defaultDuration: "Chronic",
    indication: "Severe Dry Eyes",
    category: "Ophthalmology",
    info: "Liquid gel, longer retention time than regular drops. Better used at night.",
    sideEffects: "Blurred vision for a few minutes after application.",
    contraindications: "None."
  },

  // --- GLAUCOMA DROPS ---
  {
    name: "Latanoprost 0.005% Eye Drops (Xalatan)",
    defaultDose: "1 Drop in affected eye(s)",
    defaultFreq: "OD (ON - At night)",
    defaultDuration: "Chronic",
    indication: "Open-angle Glaucoma, Ocular Hypertension",
    category: "Ophthalmology",
    info: "Prostaglandin analogue. First-line for glaucoma.",
    sideEffects: "Iris color change (browning), eyelash growth, conjunctival hyperemia.",
    contraindications: "Active uveitis."
  },
  {
    name: "Timolol 0.5% Eye Drops (Timoptol)",
    defaultDose: "1 Drop in affected eye(s)",
    defaultFreq: "BD",
    defaultDuration: "Chronic",
    indication: "Open-angle Glaucoma",
    category: "Ophthalmology",
    info: "Non-selective Beta-blocker. Reduces aqueous humor production.",
    sideEffects: "Systemic beta-blocker effects (bradycardia, bronchospasm).",
    contraindications: "Asthma, COPD, severe bradycardia or heart block."
  },

  // --- EAR DROPS (INFECTIONS & WAX) ---
  {
    name: "Ciprofloxacin + Dexamethasone Ear Drops (Ciprodex)",
    defaultDose: "4 Drops in affected ear(s)",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "7 days",
    indication: "Acute Otitis Externa, Acute Otitis Media with tympanostomy tubes",
    category: "ENT",
    info: "Antibacterial and anti-inflammatory. Safe in perforated tympanic membrane.",
    sideEffects: "Ear discomfort.",
    contraindications: "Viral infections of the ear canal."
  },
  {
    name: "Framycetin + Gramicidin + Dexamethasone Ear Drops (Sofradex)",
    defaultDose: "2-3 Drops in affected ear(s)",
    defaultFreq: "TDS or QDS",
    defaultDuration: "7 days",
    indication: "Otitis Externa",
    category: "ENT",
    info: "Aminoglycoside + Steroid. DO NOT use if eardrum is perforated.",
    sideEffects: "Ototoxicity if eardrum is perforated, local irritation.",
    contraindications: "Perforated tympanic membrane (Risk of deafness)."
  },
  {
    name: "Clotrimazole 1% Ear Drops (Canesten Ear)",
    defaultDose: "2-3 Drops in affected ear",
    defaultFreq: "TDS (Three times daily)",
    defaultDuration: "14 days (Continue for 2 weeks after symptoms resolve)",
    indication: "Fungal Otitis Externa (Otomycosis)",
    category: "ENT",
    info: "Antifungal specific for ear canal infections.",
    sideEffects: "Mild stinging.",
    contraindications: "None major."
  },
  {
    name: "Olive Oil Ear Drops / Sodium Bicarbonate Ear Drops",
    defaultDose: "2-3 Drops in affected ear",
    defaultFreq: "BD",
    defaultDuration: "3-5 days before syringing",
    indication: "Impacted Ear Wax (Cerumen)",
    category: "ENT",
    info: "Softens ear wax prior to removal by syringing.",
    sideEffects: "Temporary hearing reduction as wax swells.",
    contraindications: "Perforated eardrum."
  },

  // --- NASAL DROPS (INFANTS/CHILDREN) ---
  {
    name: "Normal Saline 0.9% Nasal Drops",
    defaultDose: "1-2 Drops per nostril",
    defaultFreq: "PRN (Especially before feeds)",
    defaultDuration: "Short-term / PRN",
    indication: "Nasal congestion in infants and children",
    category: "ENT",
    info: "Safe and effective for loosening mucus in babies.",
    sideEffects: "None.",
    contraindications: "None."
  }
  , {
    name: "Tetracycline",
    defaultDose: "250 mg",
    defaultFreq: "QID (Four times daily)",
    defaultDuration: "7 days",
    indication: "Bacterial infections, acne",
    category: "Infections",
    info: "Broad-spectrum antibiotic. Avoid antacids and milk.",
    sideEffects: "GI upset, photosensitivity, teeth staining in children.",
    contraindications: "Pregnancy, children < 12 years."
  },
  {
    name: "Tetracycline Topical Ointment",
    defaultDose: "Apply thinly",
    defaultFreq: "BID (Twice daily)",
    defaultDuration: "7 days",
    indication: "Skin infections, acne",
    category: "Skin",
    info: "Topical antibiotic ointment.",
    sideEffects: "Local skin irritation.",
    contraindications: "Hypersensitivity."
  },
  {
    name: "Neomycin Topical Ointment",
    defaultDose: "Apply thinly",
    defaultFreq: "BID (Twice daily)",
    defaultDuration: "7 days",
    indication: "Skin infections",
    category: "Skin",
    info: "Topical aminoglycoside antibiotic.",
    sideEffects: "Contact dermatitis, local irritation.",
    contraindications: "Hypersensitivity."
  }
  , {
    name: "Hydrocortisone 1% Cream",
    defaultDose: "Apply thinly",
    defaultFreq: "BID (Twice daily)",
    defaultDuration: "7 days",
    indication: "Mild eczema, dermatitis",
    category: "Skin",
    info: "Mild topical corticosteroid.",
    sideEffects: "Skin thinning with prolonged use.",
    contraindications: "Untreated skin infections."
  },
  {
    name: "Betamethasone Valerate 0.1% Cream",
    defaultDose: "Apply thinly",
    defaultFreq: "BID (Twice daily)",
    defaultDuration: "7 days",
    indication: "Severe eczema, psoriasis",
    category: "Skin",
    info: "Potent topical corticosteroid.",
    sideEffects: "Skin atrophy, striae.",
    contraindications: "Rosacea, acne vulgaris, infections."
  },
  {
    name: "Clobetasol Propionate 0.05% Ointment",
    defaultDose: "Apply thinly",
    defaultFreq: "OD or BID",
    defaultDuration: "Up to 4 weeks",
    indication: "Very severe inflammatory skin conditions",
    category: "Skin",
    info: "Very potent topical corticosteroid.",
    sideEffects: "Significant skin atrophy, systemic absorption.",
    contraindications: "Under 1 year of age, untreated infections."
  },
  {
    name: "Fusidic Acid 2% Cream",
    defaultDose: "Apply thinly",
    defaultFreq: "TID (Three times daily)",
    defaultDuration: "7-14 days",
    indication: "Impetigo, staphylococcal skin infections",
    category: "Skin",
    info: "Topical antibiotic.",
    sideEffects: "Mild irritation.",
    contraindications: "Hypersensitivity."
  },
  {
    name: "Fusidic Acid 2% + Hydrocortisone 1% Cream",
    defaultDose: "Apply thinly",
    defaultFreq: "BID (Twice daily)",
    defaultDuration: "7-14 days",
    indication: "Infected eczema/dermatitis",
    category: "Skin",
    info: "Antibiotic + mild steroid.",
    sideEffects: "Mild irritation, skin thinning.",
    contraindications: "Viral/fungal infections."
  },
  {
    name: "Mupirocin 2% Ointment",
    defaultDose: "Apply thinly",
    defaultFreq: "TID (Three times daily)",
    defaultDuration: "Up to 10 days",
    indication: "MRSA colonization, impetigo",
    category: "Skin",
    info: "Topical antibiotic.",
    sideEffects: "Local burning sensation.",
    contraindications: "Hypersensitivity."
  },
  {
    name: "Clotrimazole 1% Cream",
    defaultDose: "Apply thinly",
    defaultFreq: "BID or TID",
    defaultDuration: "2-4 weeks",
    indication: "Fungal skin infections (Tinea, Candida)",
    category: "Skin",
    info: "Broad-spectrum topical antifungal.",
    sideEffects: "Local irritation.",
    contraindications: "Hypersensitivity."
  },
  {
    name: "Ketoconazole 2% Shampoo",
    defaultDose: "Wash and leave for 3-5 mins",
    defaultFreq: "Twice weekly",
    defaultDuration: "2-4 weeks",
    indication: "Seborrheic dermatitis, Dandruff",
    category: "Skin",
    info: "Topical antifungal shampoo.",
    sideEffects: "Skin irritation, changes in hair texture.",
    contraindications: "Hypersensitivity."
  },
  {
    name: "Terbinafine 1% Cream",
    defaultDose: "Apply thinly",
    defaultFreq: "OD or BID",
    defaultDuration: "1-2 weeks",
    indication: "Tinea pedis, cruris, corporis",
    category: "Skin",
    info: "Allylamine topical antifungal.",
    sideEffects: "Redness, itching.",
    contraindications: "Hypersensitivity."
  },
  {
    name: "Permethrin 5% Cream",
    defaultDose: "Apply to whole body, wash off after 8-12h",
    defaultFreq: "Once, repeat in 1 week",
    defaultDuration: "1 day",
    indication: "Scabies",
    category: "Skin",
    info: "Topical scabicide.",
    sideEffects: "Burning, itching.",
    contraindications: "Hypersensitivity to chrysanthemums."
  },
  {
    name: "Benzoyl Peroxide 5% Gel",
    defaultDose: "Apply thinly to affected areas",
    defaultFreq: "OD or BID",
    defaultDuration: "Continuous",
    indication: "Mild to moderate acne vulgaris",
    category: "Skin",
    info: "Keratolytic and antibacterial. May bleach fabrics.",
    sideEffects: "Skin dryness, peeling, erythema.",
    contraindications: "Hypersensitivity."
  },
  {
    name: "Adapalene 0.1% Gel",
    defaultDose: "Apply thinly to affected areas at night",
    defaultFreq: "OD (Once daily at night)",
    defaultDuration: "Continuous",
    indication: "Acne vulgaris",
    category: "Skin",
    info: "Topical retinoid-like compound.",
    sideEffects: "Skin irritation, dryness, sun sensitivity.",
    contraindications: "Pregnancy, severe eczema."
  },
  {
    name: "Mometasone Furoate 0.1% Cream/Ointment",
    defaultDose: "Apply thinly",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "Up to 2 weeks",
    indication: "Inflammatory skin conditions",
    category: "Skin",
    info: "Potent topical corticosteroid.",
    sideEffects: "Skin atrophy, burning.",
    contraindications: "Untreated infections."
  },
  {
    name: "Isotretinoin 20mg Capsule",
    defaultDose: "20 mg",
    defaultFreq: "OD with food",
    defaultDuration: "4-6 months",
    indication: "Severe nodulocystic acne",
    category: "Skin",
    info: "Oral retinoid. Highly teratogenic.",
    sideEffects: "Dry lips/skin, elevated liver enzymes/lipids, depression.",
    contraindications: "Pregnancy (absolute), hepatic impairment."
  },
  {
    name: "Doxycycline 100mg Capsule",
    defaultDose: "100 mg",
    defaultFreq: "OD or BID",
    defaultDuration: "1-3 months",
    indication: "Moderate to severe acne, Rosacea",
    category: "Skin / Antibiotics",
    info: "Oral tetracycline antibiotic. Take with water, avoid laying down immediately.",
    sideEffects: "Photosensitivity, GI upset, esophagitis.",
    contraindications: "Pregnancy, children < 12 years."
  },
  {
    name: "Minoxidil 5% Topical Solution/Spray",
    defaultDose: "Apply 1 mL to dry scalp",
    defaultFreq: "BID (Twice daily)",
    defaultDuration: "Continuous",
    indication: "Androgenetic alopecia",
    category: "Skin / Hair",
    info: "Vasodilator for hair growth.",
    sideEffects: "Scalp irritation, unwanted facial hair.",
    contraindications: "Pheochromocytoma, inflamed scalp."
  }
  , {
    name: "Sunscreen SPF 50+ Cream/Fluid",
    defaultDose: "Apply generously",
    defaultFreq: "QAM (Every morning) and reapply every 2h",
    defaultDuration: "Continuous",
    indication: "Sun protection, anti-aging, melasma prevention",
    category: "Skin / Cosmetics",
    info: "Broad-spectrum UVA/UVB protection.",
    sideEffects: "Rarely local irritation.",
    contraindications: "Hypersensitivity to UV filters."
  },
  {
    name: "Daily Moisturizing Cream / Lotion",
    defaultDose: "Apply generously",
    defaultFreq: "BID (Twice daily)",
    defaultDuration: "Continuous",
    indication: "Dry skin, eczema maintenance, skin barrier repair",
    category: "Skin / Cosmetics",
    info: "Hydrates and restores skin barrier.",
    sideEffects: "None.",
    contraindications: "None."
  },
  {
    name: "Vitamin C 10-20% Serum",
    defaultDose: "Apply 3-4 drops",
    defaultFreq: "QAM (Every morning) before sunscreen",
    defaultDuration: "Continuous",
    indication: "Hyperpigmentation, antioxidant, anti-aging",
    category: "Skin / Cosmetics",
    info: "Antioxidant serum. Can increase sun sensitivity.",
    sideEffects: "Tingling, mild erythema.",
    contraindications: "Active severe acne or broken skin."
  },
  {
    name: "Hyaluronic Acid Serum",
    defaultDose: "Apply 3-4 drops to damp skin",
    defaultFreq: "BID (Twice daily)",
    defaultDuration: "Continuous",
    indication: "Skin dehydration, fine lines",
    category: "Skin / Cosmetics",
    info: "Humectant, plumps skin.",
    sideEffects: "None.",
    contraindications: "None."
  },
  {
    name: "Niacinamide 10% Serum",
    defaultDose: "Apply 3-4 drops",
    defaultFreq: "OD or BID",
    defaultDuration: "Continuous",
    indication: "Sebum control, enlarged pores, redness",
    category: "Skin / Cosmetics",
    info: "Vitamin B3 derivative.",
    sideEffects: "Mild tingling.",
    contraindications: "None."
  },
  {
    name: "Dexpanthenol 5% Cream",
    defaultDose: "Apply to affected area",
    defaultFreq: "BID to QID",
    defaultDuration: "Until healed",
    indication: "Minor burns, superficial wounds, dryness",
    category: "Skin / Cosmetics",
    info: "Promotes wound healing and hydration.",
    sideEffects: "None.",
    contraindications: "None."
  },
  {
    name: "Salicylic Acid 2% Cleanser",
    defaultDose: "Wash face gently",
    defaultFreq: "OD or BID",
    defaultDuration: "Continuous",
    indication: "Oily skin, acne-prone skin",
    category: "Skin / Cosmetics",
    info: "BHA chemical exfoliant wash.",
    sideEffects: "Dryness, mild peeling.",
    contraindications: "Very dry or compromised skin barrier."
  },
  {
    name: "Glycolic Acid 7% Toning Solution",
    defaultDose: "Apply with cotton pad",
    defaultFreq: "OD (at night, 2-3 times weekly)",
    defaultDuration: "Continuous",
    indication: "Dullness, uneven skin tone",
    category: "Skin / Cosmetics",
    info: "AHA chemical exfoliant. Use sunscreen during the day.",
    sideEffects: "Tingling, sun sensitivity.",
    contraindications: "Broken skin, use with strong retinoids."
  }
  , {
    name: "Imiquimod 5% Cream",
    defaultDose: "Apply thinly at bedtime",
    defaultFreq: "3 times weekly",
    defaultDuration: "Up to 16 weeks",
    indication: "Genital/perianal warts (HPV)",
    category: "Skin / Genitourinary",
    info: "Immune response modifier. Wash off after 6-10 hours.",
    sideEffects: "Local erythema, irritation, burning.",
    contraindications: "Hypersensitivity."
  },
  {
    name: "Podophyllotoxin 0.5% Solution/Cream",
    defaultDose: "Apply exactly to warts",
    defaultFreq: "BID (Twice daily) for 3 days, then 4 days off",
    defaultDuration: "Repeat up to 4 cycles",
    indication: "External genital warts",
    category: "Skin / Genitourinary",
    info: "Antimitotic. Highly toxic if swallowed or applied excessively.",
    sideEffects: "Severe local irritation, pain.",
    contraindications: "Pregnancy, open wounds."
  },
  {
    name: "Clotrimazole 2% Vaginal Cream / 500mg Pessary",
    defaultDose: "Insert 1 applicator/pessary",
    defaultFreq: "Once daily at bedtime",
    defaultDuration: "1 to 3 days",
    indication: "Vulvovaginal candidiasis (Thrush)",
    category: "Genitourinary",
    info: "Topical antifungal. Can damage latex condoms.",
    sideEffects: "Mild vaginal burning.",
    contraindications: "Hypersensitivity."
  },
  {
    name: "Miconazole 2% Vaginal Cream",
    defaultDose: "Insert 1 applicatorful",
    defaultFreq: "Once daily at bedtime",
    defaultDuration: "7 days",
    indication: "Vulvovaginal candidiasis",
    category: "Genitourinary",
    info: "Topical antifungal.",
    sideEffects: "Vaginal irritation.",
    contraindications: "Hypersensitivity."
  },
  {
    name: "Metronidazole 0.75% Vaginal Gel",
    defaultDose: "Insert 1 applicatorful",
    defaultFreq: "Once daily at bedtime",
    defaultDuration: "5 days",
    indication: "Bacterial vaginosis (BV)",
    category: "Genitourinary",
    info: "Topical antibiotic/antiprotozoal. Avoid alcohol.",
    sideEffects: "Candidiasis, mild irritation.",
    contraindications: "First trimester of pregnancy, alcohol use."
  },
  {
    name: "Clindamycin 2% Vaginal Cream",
    defaultDose: "Insert 1 applicatorful",
    defaultFreq: "Once daily at bedtime",
    defaultDuration: "3 to 7 days",
    indication: "Bacterial vaginosis (BV)",
    category: "Genitourinary",
    info: "Topical antibiotic. Can weaken latex condoms.",
    sideEffects: "Vaginitis, cervicitis.",
    contraindications: "History of pseudomembranous colitis."
  },
  {
    name: "Conjugated Estrogens Vaginal Cream",
    defaultDose: "Insert 0.5-2 g",
    defaultFreq: "Daily or twice weekly",
    defaultDuration: "Continuous (Cyclic)",
    indication: "Atrophic vaginitis, menopausal symptoms",
    category: "Genitourinary",
    info: "Topical estrogen replacement.",
    sideEffects: "Breast tenderness, vaginal bleeding.",
    contraindications: "Undiagnosed vaginal bleeding, estrogen-dependent tumors."
  }
  , {
    name: "Hyoscine Butylbromide 10mg Tablet",
    defaultDose: "10-20 mg",
    defaultFreq: "TID or QID (3-4 times daily)",
    defaultDuration: "As needed",
    indication: "GI spasm, IBS, renal colic",
    category: "Gastro-intestinal",
    info: "Antispasmodic.",
    sideEffects: "Dry mouth, blurred vision, tachycardia.",
    contraindications: "Glaucoma, myasthenia gravis."
  },
  {
    name: "Mebeverine 135mg Tablet",
    defaultDose: "135 mg",
    defaultFreq: "TID 20 mins before meals",
    defaultDuration: "As needed",
    indication: "Irritable Bowel Syndrome (IBS)",
    category: "Gastro-intestinal",
    info: "Antispasmodic specifically for GI tract.",
    sideEffects: "Rarely allergic reactions.",
    contraindications: "Paralytic ileus."
  },
  {
    name: "Ondansetron 4mg/8mg Tablet",
    defaultDose: "4-8 mg",
    defaultFreq: "BID or TID",
    defaultDuration: "As needed for nausea",
    indication: "Nausea and vomiting",
    category: "Gastro-intestinal",
    info: "5-HT3 receptor antagonist antiemetic.",
    sideEffects: "Constipation, headache, QT prolongation.",
    contraindications: "Concurrent apomorphine use."
  },
  {
    name: "Metoclopramide 10mg Tablet",
    defaultDose: "10 mg",
    defaultFreq: "TID",
    defaultDuration: "Up to 5 days",
    indication: "Nausea and vomiting, gastroparesis",
    category: "Gastro-intestinal",
    info: "Prokinetic and antiemetic.",
    sideEffects: "Extrapyramidal symptoms, drowsiness.",
    contraindications: "GI obstruction/perforation, history of dyskinesia."
  },
  {
    name: "Domperidone 10mg Tablet",
    defaultDose: "10 mg",
    defaultFreq: "TID before meals",
    defaultDuration: "Up to 1 week",
    indication: "Nausea and vomiting",
    category: "Gastro-intestinal",
    info: "Peripheral dopamine antagonist.",
    sideEffects: "Hyperprolactinemia, QT prolongation.",
    contraindications: "Cardiac conduction disorders."
  },
  {
    name: "Esomeprazole 20mg/40mg Capsule",
    defaultDose: "20-40 mg",
    defaultFreq: "OD before breakfast",
    defaultDuration: "4-8 weeks",
    indication: "GERD, Peptic Ulcers",
    category: "Gastro-intestinal",
    info: "Proton Pump Inhibitor (PPI).",
    sideEffects: "Headache, diarrhea, nausea.",
    contraindications: "Hypersensitivity."
  },
  {
    name: "Pantoprazole 20mg/40mg Tablet",
    defaultDose: "20-40 mg",
    defaultFreq: "OD before breakfast",
    defaultDuration: "4-8 weeks",
    indication: "GERD, Peptic Ulcers",
    category: "Gastro-intestinal",
    info: "Proton Pump Inhibitor (PPI).",
    sideEffects: "Headache, GI upset.",
    contraindications: "Hypersensitivity."
  },
  {
    name: "Lactulose Syrup (3.3g/5ml)",
    defaultDose: "15 ml",
    defaultFreq: "BID",
    defaultDuration: "Until regular bowel movements",
    indication: "Constipation, Hepatic encephalopathy",
    category: "Gastro-intestinal",
    info: "Osmotic laxative.",
    sideEffects: "Bloating, flatulence, cramps.",
    contraindications: "Galactosemia, GI obstruction."
  },
  {
    name: "Loperamide 2mg Capsule",
    defaultDose: "4 mg initially, then 2 mg after each loose stool",
    defaultFreq: "PRN (Max 16mg/day)",
    defaultDuration: "Short term (up to 2 days)",
    indication: "Acute diarrhea",
    category: "Gastro-intestinal",
    info: "Antimotility drug.",
    sideEffects: "Constipation, dizziness.",
    contraindications: "Dysentery, inflammatory bowel disease flares."
  },
  {
    name: "Ivy Leaf Extract Syrup",
    defaultDose: "5-7.5 ml",
    defaultFreq: "TID (Three times daily)",
    defaultDuration: "7-10 days",
    indication: "Productive cough, bronchitis",
    category: "Respiratory",
    info: "Herbal expectorant.",
    sideEffects: "Mild GI upset.",
    contraindications: "Fructose intolerance."
  },
  {
    name: "Desloratadine 5mg Tablet",
    defaultDose: "5 mg",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "As needed",
    indication: "Allergic rhinitis, urticaria",
    category: "Respiratory / Allergy",
    info: "Non-sedating antihistamine.",
    sideEffects: "Dry mouth, fatigue.",
    contraindications: "Hypersensitivity."
  },
  {
    name: "Levocetirizine 5mg Tablet",
    defaultDose: "5 mg",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "As needed",
    indication: "Allergic rhinitis, urticaria",
    category: "Respiratory / Allergy",
    info: "Non-sedating antihistamine.",
    sideEffects: "Somnolence, dry mouth.",
    contraindications: "Severe renal impairment."
  },
  {
    name: "Fexofenadine 120mg Tablet",
    defaultDose: "120-180 mg",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "As needed",
    indication: "Seasonal allergic rhinitis",
    category: "Respiratory / Allergy",
    info: "Non-sedating antihistamine.",
    sideEffects: "Headache, dizziness.",
    contraindications: "Hypersensitivity."
  },
  {
    name: "Budesonide/Formoterol Turbuhaler",
    defaultDose: "1-2 inhalations",
    defaultFreq: "BID (Twice daily)",
    defaultDuration: "Continuous",
    indication: "Asthma, COPD",
    category: "Respiratory",
    info: "ICS / LABA combination. Rinse mouth after use.",
    sideEffects: "Oral thrush, tremors, palpitations.",
    contraindications: "Acute bronchospasm (as primary rescue)."
  },
  {
    name: "Fluticasone/Salmeterol Inhaler",
    defaultDose: "1-2 inhalations",
    defaultFreq: "BID (Twice daily)",
    defaultDuration: "Continuous",
    indication: "Asthma, COPD",
    category: "Respiratory",
    info: "ICS / LABA combination. Rinse mouth after use.",
    sideEffects: "Oral thrush, hoarseness.",
    contraindications: "Status asthmaticus."
  },
  {
    name: "Thiocolchicoside 4mg Capsule",
    defaultDose: "4 mg",
    defaultFreq: "BID",
    defaultDuration: "5-7 days",
    indication: "Muscle spasms",
    category: "Musculoskeletal",
    info: "Muscle relaxant.",
    sideEffects: "Diarrhea, gastralgia.",
    contraindications: "Pregnancy, women of childbearing potential without contraception."
  },
  {
    name: "Orphenadrine + Paracetamol Tablet",
    defaultDose: "2 tablets",
    defaultFreq: "TID",
    defaultDuration: "As needed",
    indication: "Muscle spasms with pain",
    category: "Musculoskeletal",
    info: "Analgesic + Muscle relaxant.",
    sideEffects: "Dry mouth, dizziness, urinary retention.",
    contraindications: "Glaucoma, prostatic hypertrophy."
  },
  {
    name: "Tizanidine 2mg Tablet",
    defaultDose: "2-4 mg",
    defaultFreq: "TID",
    defaultDuration: "As needed",
    indication: "Spasticity, severe muscle spasms",
    category: "Musculoskeletal",
    info: "Central alpha-2 agonist muscle relaxant.",
    sideEffects: "Drowsiness, hypotension, dry mouth.",
    contraindications: "Severe hepatic impairment."
  },
  {
    name: "Diclofenac Sodium 50mg Tablet",
    defaultDose: "50 mg",
    defaultFreq: "BID or TID after meals",
    defaultDuration: "Short term",
    indication: "Pain, inflammation, osteoarthritis",
    category: "Musculoskeletal / Analgesics",
    info: "NSAID.",
    sideEffects: "GI ulcers, elevated cardiovascular risk.",
    contraindications: "Active peptic ulcer, heart failure, asthma."
  },
  {
    name: "Meloxicam 15mg Tablet",
    defaultDose: "7.5 - 15 mg",
    defaultFreq: "OD with food",
    defaultDuration: "Short to medium term",
    indication: "Osteoarthritis, Rheumatoid arthritis",
    category: "Musculoskeletal / Analgesics",
    info: "COX-2 preferential NSAID.",
    sideEffects: "Dyspepsia, GI bleeding, edema.",
    contraindications: "Active GI bleeding, severe renal/hepatic failure."
  },
  {
    name: "Celecoxib 200mg Capsule",
    defaultDose: "100-200 mg",
    defaultFreq: "OD or BID",
    defaultDuration: "Short term",
    indication: "Osteoarthritis, Rheumatoid arthritis, acute pain",
    category: "Musculoskeletal / Analgesics",
    info: "COX-2 specific NSAID. Lower GI risk.",
    sideEffects: "Hypertension, cardiovascular events.",
    contraindications: "Sulfonamide allergy, established ischemic heart disease."
  },
  {
    name: "Pregabalin 75mg Capsule",
    defaultDose: "75 mg",
    defaultFreq: "BID (Twice daily)",
    defaultDuration: "Continuous (Review regularly)",
    indication: "Neuropathic pain, GAD",
    category: "Neurology",
    info: "Gabapentinoid. Avoid abrupt withdrawal.",
    sideEffects: "Dizziness, somnolence, weight gain.",
    contraindications: "Hypersensitivity."
  },
  {
    name: "Betahistine 16mg Tablet",
    defaultDose: "16 mg",
    defaultFreq: "TID with food",
    defaultDuration: "As needed",
    indication: "Meniere's disease, Vertigo",
    category: "Neurology",
    info: "Histamine analogue.",
    sideEffects: "Mild GI upset, headache.",
    contraindications: "Pheochromocytoma."
  },
  {
    name: "Vitamin B Complex (B1, B6, B12)",
    defaultDose: "1 tablet/ampoule",
    defaultFreq: "OD (Tablet) or 1 Ampoule Weekly",
    defaultDuration: "1 month",
    indication: "Neuropathy, vitamin B deficiency",
    category: "Vitamins / Supplements",
    info: "Neurotropic vitamins.",
    sideEffects: "Urine discoloration.",
    contraindications: "None."
  },
  {
    name: "Vitamin D3 50,000 IU Capsule",
    defaultDose: "1 capsule (50,000 IU)",
    defaultFreq: "Weekly",
    defaultDuration: "8 weeks (for deficiency)",
    indication: "Vitamin D deficiency",
    category: "Vitamins / Supplements",
    info: "Cholecalciferol.",
    sideEffects: "Hypercalcemia (rare at normal doses).",
    contraindications: "Hypercalcemia, hypervitaminosis D."
  },
  {
    name: "Iron Polymaltose Complex",
    defaultDose: "100 mg",
    defaultFreq: "OD or BID with food",
    defaultDuration: "3-6 months",
    indication: "Iron deficiency anemia",
    category: "Vitamins / Supplements",
    info: "Oral iron supplement.",
    sideEffects: "Dark stools, constipation, nausea.",
    contraindications: "Iron overload disorders."
  },
  // --- GI & CONSTIPATION MEDICATIONS ---
  {
    name: "Lactulose Syrup (Duphalac / Ezilax)",
    defaultDose: "15-30 ml",
    defaultFreq: "OD or BD",
    defaultDuration: "PRN (Until bowel movement)",
    indication: "Constipation, Hepatic Encephalopathy",
    category: "GI",
    sideEffects: "Bloating, Cramps, Diarrhea",
    contraindications: "Galactosemia, Bowel obstruction"
  },
  {
    name: "Bisacodyl 5mg Tablets (Dulcolax)",
    defaultDose: "5-10 mg (1-2 tablets)",
    defaultFreq: "ON (At night)",
    defaultDuration: "PRN (Short term only)",
    indication: "Constipation",
    category: "GI",
    sideEffects: "Abdominal cramps, Nausea",
    contraindications: "Ileus, Intestinal obstruction, Acute abdominal conditions"
  },
  {
    name: "Senna Tablets (Senokot / Pursennid)",
    defaultDose: "2 Tablets",
    defaultFreq: "ON (At night)",
    defaultDuration: "PRN",
    indication: "Constipation",
    category: "GI",
    sideEffects: "Abdominal cramps, Melanosis coli (long term)",
    contraindications: "Intestinal obstruction, Undiagnosed abdominal pain"
  },
  {
    name: "Macrogol Powders (Movicol)",
    defaultDose: "1 Sachet dissolved in water",
    defaultFreq: "1-3 times daily",
    defaultDuration: "PRN",
    indication: "Chronic Constipation, Fecal impaction",
    category: "GI",
    sideEffects: "Abdominal pain, Bloating, Nausea",
    contraindications: "Intestinal perforation, Toxic megacolon"
  },
  {
    name: "Ispaghula Husk (Fybogel / Mucofalk)",
    defaultDose: "1 Sachet in full glass of water",
    defaultFreq: "BD (After meals)",
    defaultDuration: "PRN",
    indication: "Constipation, IBS",
    category: "GI",
    sideEffects: "Bloating, Flatulence",
    contraindications: "Bowel obstruction, Difficulty swallowing"
  },
  {
    name: "Sodium Picosulfate Drops (Laxoberal / Skilax)",
    defaultDose: "10-20 drops",
    defaultFreq: "ON (At night)",
    defaultDuration: "PRN",
    indication: "Constipation",
    category: "GI",
    sideEffects: "Cramps, Diarrhea",
    contraindications: "Ileus, Dehydration"
  },
  {
    name: "Glycerin Suppositories",
    defaultDose: "1 Suppository",
    defaultFreq: "PR (Per rectum) PRN",
    defaultDuration: "PRN",
    indication: "Acute Constipation",
    category: "GI",
    sideEffects: "Rectal irritation",
    contraindications: "Undiagnosed rectal bleeding"
  },

  // --- HEMORRHOIDS & VENOUS INSUFFICIENCY ---
  {
    name: "Diosmin 450mg + Hesperidin 50mg (Daflon 500mg)",
    defaultDose: "2 Tablets",
    defaultFreq: "BD (For venous insufficiency) / TDS (For acute hemorrhoids)",
    defaultDuration: "1-2 weeks",
    indication: "Hemorrhoids, Chronic Venous Insufficiency",
    category: "GI",
    sideEffects: "Mild GI upset, Headache",
    contraindications: "Hypersensitivity"
  },
  {
    name: "Lidocaine + Tribenoside Ointment/Supp (Procto-Glyvenol)",
    defaultDose: "Apply/Insert 1",
    defaultFreq: "BD",
    defaultDuration: "Until symptoms improve",
    indication: "Hemorrhoids (Internal and External)",
    category: "GI",
    sideEffects: "Local irritation",
    contraindications: "Severe hepatic impairment"
  },
  {
    name: "Cinchocaine + Hydrocortisone (Proctosedyl / Scheriproct)",
    defaultDose: "Apply/Insert 1",
    defaultFreq: "BD or TDS",
    defaultDuration: "Max 7 days",
    indication: "Inflamed Hemorrhoids, Anal fissures",
    category: "GI",
    sideEffects: "Skin atrophy (prolonged use)",
    contraindications: "Local viral/fungal infections"
  },
  {
    name: "Herbal/Natural Hemorrhoid Ointment (Neo-Healar)",
    defaultDose: "Apply",
    defaultFreq: "TDS",
    defaultDuration: "2-3 weeks",
    indication: "Hemorrhoids, Anal fissures",
    category: "GI",
    sideEffects: "Rare local irritation",
    contraindications: "Hypersensitivity to ingredients"
  },
  {
    name: "Bismuth Subgallate + Zinc Oxide (Anusol)",
    defaultDose: "Apply/Insert 1",
    defaultFreq: "BD",
    defaultDuration: "PRN",
    indication: "Mild Hemorrhoids",
    category: "GI",
    sideEffects: "Rare local irritation",
    contraindications: "Hypersensitivity"
  },
  // --- MEDICAL SHAMPOOS ---
  {
    name: "Ketoconazole 2% Shampoo (Nizoral)",
    defaultDose: "Apply to scalp/skin",
    defaultFreq: "Twice weekly",
    defaultDuration: "2-4 weeks",
    indication: "Dandruff, Seborrheic Dermatitis, Pityriasis Versicolor",
    category: "Dermatology",
    sideEffects: "Local irritation",
    contraindications: "Hypersensitivity"
  },
  {
    name: "Selenium Sulfide 2.5% Shampoo (Selsun)",
    defaultDose: "Apply to scalp",
    defaultFreq: "Twice weekly",
    defaultDuration: "2 weeks",
    indication: "Dandruff, Tinea Capitis",
    category: "Dermatology",
    sideEffects: "Hair discoloration, Irritation",
    contraindications: "Broken skin, Acute inflammation"
  },
  {
    name: "Coal Tar Shampoo (Polytar / T/Gel)",
    defaultDose: "Apply to scalp",
    defaultFreq: "1-2 times weekly",
    defaultDuration: "PRN",
    indication: "Psoriasis, Scalp Eczema",
    category: "Dermatology",
    sideEffects: "Photosensitivity, Staining of hair/clothes",
    contraindications: "Infected or open skin lesions"
  },
  {
    name: "Ciclopirox Olamine 1.5% Shampoo (Stieprox)",
    defaultDose: "Apply to scalp",
    defaultFreq: "Twice weekly",
    defaultDuration: "4 weeks",
    indication: "Seborrheic Dermatitis",
    category: "Dermatology",
    sideEffects: "Mild redness",
    contraindications: "Hypersensitivity"
  },

  // --- SOAP SUBSTITUTES & MEDICAL CLEANSERS ---
  {
    name: "Soap-Free Emollient Wash (QV / Cetaphil / CeraVe)",
    defaultDose: "Use as a soap substitute",
    defaultFreq: "Daily during shower",
    defaultDuration: "Ongoing",
    indication: "Dry Skin, Eczema, Atopic Dermatitis",
    category: "Dermatology",
    sideEffects: "None",
    contraindications: "Hypersensitivity to ingredients"
  },
  {
    name: "Aqueous Cream BP (Soap Substitute)",
    defaultDose: "Apply to skin instead of soap",
    defaultFreq: "Daily",
    defaultDuration: "Ongoing",
    indication: "Dry skin conditions",
    category: "Dermatology",
    sideEffects: "Skin irritation (if left on)",
    contraindications: "None"
  },
  {
    name: "Benzoyl Peroxide 5% Wash (PanOxyl / Benzac)",
    defaultDose: "Apply to wet skin, leave for 1-2 mins, rinse",
    defaultFreq: "OD or BD",
    defaultDuration: "Until acne clears",
    indication: "Acne Vulgaris",
    category: "Dermatology",
    sideEffects: "Dryness, Peeling, Erythema, Bleaches fabrics",
    contraindications: "Hypersensitivity"
  },
  {
    name: "Salicylic Acid Cleanser (CeraVe SA / Neutrogena)",
    defaultDose: "Wash affected area",
    defaultFreq: "OD or BD",
    defaultDuration: "Ongoing",
    indication: "Acne, Keratosis Pilaris",
    category: "Dermatology",
    sideEffects: "Mild dryness",
    contraindications: "Broken skin"
  },
  {
    name: "Chlorhexidine 4% Surgical Wash (Hibiscrub)",
    defaultDose: "Use as directed",
    defaultFreq: "Pre/Post-operative or as directed",
    defaultDuration: "Short term",
    indication: "Skin disinfection, Recurrent skin infections",
    category: "Dermatology",
    sideEffects: "Irritation, Dryness",
    contraindications: "Do not use in ears or eyes"
  },
  // --- DERMATOLOGY SPRAYS ---
  {
    name: "Minoxidil 5% / 2% Topical Spray (Regaine / Hairgrow)",
    defaultDose: "6 sprays (1 ml) to affected scalp area",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "Continuous (Results take 3-4 months)",
    indication: "Androgenetic Alopecia (Hair Loss)",
    category: "Dermatology",
    sideEffects: "Scalp irritation, Unwanted facial hair",
    contraindications: "Broken skin, Cardiovascular disease (caution)"
  },
  {
    name: "Terbinafine 1% Spray (Lamisil Spray)",
    defaultDose: "Spray on affected skin and surrounding area",
    defaultFreq: "OD or BD",
    defaultDuration: "1-2 weeks",
    indication: "Tinea Corporis, Tinea Cruris, Tinea Pedis",
    category: "Dermatology",
    sideEffects: "Redness, Itching, Stinging",
    contraindications: "Hypersensitivity"
  },
  {
    name: "Clotrimazole 1% Spray (Canesten Spray)",
    defaultDose: "Spray evenly on affected area",
    defaultFreq: "BD or TDS",
    defaultDuration: "2-4 weeks",
    indication: "Fungal Skin Infections",
    category: "Dermatology",
    sideEffects: "Mild irritation",
    contraindications: "Hypersensitivity"
  },
  {
    name: "Panthenol Spray",
    defaultDose: "Spray onto affected area",
    defaultFreq: "Multiple times daily PRN",
    defaultDuration: "Until healed",
    indication: "Minor Burns, Sunburn, Skin Abrasions",
    category: "Dermatology",
    sideEffects: "None",
    contraindications: "Severe/Deep bleeding wounds"
  },
  {
    name: "Clobetasol Propionate 0.05% Spray (Clobex)",
    defaultDose: "Spray onto affected areas and rub gently",
    defaultFreq: "BD",
    defaultDuration: "Max 4 weeks",
    indication: "Plaque Psoriasis",
    category: "Dermatology",
    sideEffects: "Skin atrophy, Striae, Burning",
    contraindications: "Rosacea, Acne, Untreated skin infections"
  },
  {
    name: "Oxytetracycline + Hydrocortisone Spray (Terra-Cortril / Oxycort)",
    defaultDose: "Spray from 15-20cm for 1-2 seconds",
    defaultFreq: "TDS",
    defaultDuration: "7-14 days",
    indication: "Infected Eczema, Dermatitis with bacterial infection",
    category: "Dermatology",
    sideEffects: "Local irritation, Skin thinning (long term)",
    contraindications: "Viral/Fungal infections"
  },
  {
    name: "Povidone-Iodine Dry Powder Spray (Betadine)",
    defaultDose: "Spray light dust over wound",
    defaultFreq: "OD or BD",
    defaultDuration: "Until wound dries",
    indication: "Minor cuts, Grazes, Antiseptic wound care",
    category: "Dermatology",
    sideEffects: "Local irritation",
    contraindications: "Thyroid disorders, Large burns"
  },
  {
    name: "Lidocaine 10% Topical Spray (Xylocaine)",
    defaultDose: "1-3 sprays to mucosal/skin area",
    defaultFreq: "PRN",
    defaultDuration: "Short term",
    indication: "Topical Anesthesia, Minor painful procedures",
    category: "Dermatology",
    sideEffects: "Numbness, Tingling",
    contraindications: "Hypersensitivity to amide anesthetics"
  },
  // --- DERMATOLOGY: STEROIDS & IMMUNOMODULATORS ---
  {
    name: "Betamethasone Valerate 0.1% (Betnovate)",
    defaultDose: "Apply thinly to affected area",
    defaultFreq: "OD or BD",
    defaultDuration: "1-2 weeks",
    indication: "Eczema, Dermatitis",
    category: "Dermatology",
    sideEffects: "Skin atrophy, Striae (with prolonged use)",
    contraindications: "Untreated skin infections, Rosacea"
  },
  {
    name: "Clobetasol Propionate 0.05% (Dermovate)",
    defaultDose: "Apply thinly",
    defaultFreq: "OD or BD",
    defaultDuration: "Max 4 weeks",
    indication: "Severe Eczema, Psoriasis",
    category: "Dermatology",
    sideEffects: "Skin thinning, Adrenal suppression (large areas)",
    contraindications: "Acne, Perioral dermatitis, Children under 1 yr"
  },
  {
    name: "Fusidic Acid 2% + Betamethasone 0.1% (Fucicort)",
    defaultDose: "Apply thinly",
    defaultFreq: "BD",
    defaultDuration: "Max 2 weeks",
    indication: "Infected Eczema, Inflammatory dermatoses with bacterial infection",
    category: "Dermatology",
    sideEffects: "Mild burning, Skin thinning",
    contraindications: "Viral, fungal, or primary bacterial skin infections"
  },
  {
    name: "Triamcinolone + Neomycin + Nystatin + Gramicidin (Kenacomb)",
    defaultDose: "Apply thinly",
    defaultFreq: "BD or TDS",
    defaultDuration: "Max 7-14 days",
    indication: "Infected Dermatitis, Intertrigo",
    category: "Dermatology",
    sideEffects: "Local irritation",
    contraindications: "Tuberculosis of the skin, Viral infections"
  },
  {
    name: "Tacrolimus 0.1% / 0.03% Ointment (Protopic)",
    defaultDose: "Apply thinly",
    defaultFreq: "BD",
    defaultDuration: "Until clearance, then reduce",
    indication: "Atopic Dermatitis (Moderate to Severe)",
    category: "Dermatology",
    sideEffects: "Burning sensation initially",
    contraindications: "Immunocompromised patients, Infected lesions"
  },
  {
    name: "Pimecrolimus 1% Cream (Elidel)",
    defaultDose: "Apply thinly",
    defaultFreq: "BD",
    defaultDuration: "Until clearance",
    indication: "Atopic Dermatitis (Mild to Moderate)",
    category: "Dermatology",
    sideEffects: "Mild burning",
    contraindications: "Immunocompromised patients"
  },

  // --- DERMATOLOGY: ACNE TREATMENTS ---
  {
    name: "Adapalene 0.1% Gel/Cream (Differin)",
    defaultDose: "Apply a pea-sized amount to affected areas",
    defaultFreq: "ON (At night)",
    defaultDuration: "3-4 months",
    indication: "Acne Vulgaris",
    category: "Dermatology",
    sideEffects: "Dryness, Redness, Peeling",
    contraindications: "Pregnancy, Severe sunburn"
  },
  {
    name: "Adapalene 0.1% + Benzoyl Peroxide 2.5% (Epiduo)",
    defaultDose: "Apply a thin layer",
    defaultFreq: "ON (At night)",
    defaultDuration: "Until acne clears",
    indication: "Moderate to Severe Acne Vulgaris",
    category: "Dermatology",
    sideEffects: "Erythema, Scaling, Burning",
    contraindications: "Pregnancy, Broken skin"
  },
  {
    name: "Tretinoin 0.025% / 0.05% Cream (Acretin / Retin-A)",
    defaultDose: "Apply a pea-sized amount",
    defaultFreq: "ON (At night)",
    defaultDuration: "3-6 months",
    indication: "Acne Vulgaris, Photoaging",
    category: "Dermatology",
    sideEffects: "Skin irritation, Photosensitivity",
    contraindications: "Pregnancy, Rosacea"
  },
  {
    name: "Erythromycin + Zinc Acetate Lotion (Zineryt)",
    defaultDose: "Apply over the entire affected area",
    defaultFreq: "BD",
    defaultDuration: "10-12 weeks",
    indication: "Acne Vulgaris",
    category: "Dermatology",
    sideEffects: "Stinging, Dryness",
    contraindications: "Macrolide hypersensitivity"
  },

  // --- DERMATOLOGY: TOPICAL ANTIBIOTICS & ANTIFUNGALS ---
  {
    name: "Fusidic Acid 2% Cream/Ointment (Fucidin)",
    defaultDose: "Apply to affected area",
    defaultFreq: "TDS",
    defaultDuration: "7-14 days",
    indication: "Impetigo, Folliculitis, Paronychia",
    category: "Dermatology",
    sideEffects: "Mild irritation",
    contraindications: "Hypersensitivity"
  },
  {
    name: "Mupirocin 2% Ointment/Cream (Bactroban)",
    defaultDose: "Apply to affected area",
    defaultFreq: "TDS",
    defaultDuration: "5-10 days",
    indication: "Impetigo, MRSA eradication (nasal)",
    category: "Dermatology",
    sideEffects: "Burning sensation",
    contraindications: "Hypersensitivity"
  },
  {
    name: "Miconazole 2% Cream (Daktarin)",
    defaultDose: "Apply to affected area and rub in well",
    defaultFreq: "BD",
    defaultDuration: "Continue for 10 days after lesions clear",
    indication: "Fungal skin infections",
    category: "Dermatology",
    sideEffects: "Local irritation",
    contraindications: "Hypersensitivity"
  },

  // --- DERMATOLOGY: SCABIES & LICE ---
  {
    name: "Permethrin 5% Cream (Lyclear / Scabene)",
    defaultDose: "Apply to whole body (from neck down), wash off after 8-12 hours",
    defaultFreq: "Once, repeat in 7 days if necessary",
    defaultDuration: "Single application (Repeat once if needed)",
    indication: "Scabies",
    category: "Dermatology",
    sideEffects: "Pruritus, Mild burning",
    contraindications: "Hypersensitivity to pyrethroids"
  },

  // --- DERMATOLOGY: WARTS & EMOLLIENTS ---
  {
    name: "Salicylic Acid + Lactic Acid Paint (Duofilm / Collomack)",
    defaultDose: "Apply 1-2 drops directly to the wart",
    defaultFreq: "OD (Daily)",
    defaultDuration: "Until wart resolves (Max 12 weeks)",
    indication: "Warts, Corns, Calluses",
    category: "Dermatology",
    sideEffects: "Local irritation, Skin peeling",
    contraindications: "Diabetics, Facial/Genital warts"
  },
  {
    name: "Dexpanthenol Cream / Ointment (Bepanthen)",
    defaultDose: "Apply as needed",
    defaultFreq: "Multiple times daily PRN",
    defaultDuration: "Ongoing",
    indication: "Minor burns, Diaper rash, Dry skin, Fissures",
    category: "Dermatology",
    sideEffects: "None",
    contraindications: "None"
  },
  // --- PSORIASIS (FOAM/OINTMENT) ---
  {
    name: "Calcipotriol + Betamethasone Foam (Enstilar)",
    defaultDose: "Apply to affected areas",
    defaultFreq: "OD (Daily)",
    defaultDuration: "Max 4 weeks",
    indication: "Psoriasis Vulgaris",
    category: "Dermatology",
    sideEffects: "Application site reactions, Folliculitis",
    contraindications: "Erythrodermic, exfoliative and pustular psoriasis"
  }
  , {
    name: "Amoxicillin 250mg/5ml Suspension",
    defaultDose: "5 ml",
    defaultFreq: "TID (Every 8 hours)",
    defaultDuration: "5-7 days",
    indication: "Otitis media, Respiratory tract infections",
    category: "المضادات الحيوية (أطفال)",
    info: "Penicillin antibiotic.",
    sideEffects: "Diarrhea, skin rash.",
    contraindications: "Penicillin allergy."
  },
  {
    name: "Amoxicillin + Clavulanic Acid 228mg/5ml Suspension",
    defaultDose: "5 ml",
    defaultFreq: "BID (Every 12 hours)",
    defaultDuration: "5-7 days",
    indication: "Otitis media, Sinusitis, Respiratory tract infections",
    category: "المضادات الحيوية (أطفال)",
    info: "Broad-spectrum penicillin antibiotic.",
    sideEffects: "Diarrhea, nausea.",
    contraindications: "Penicillin allergy, history of amoxicillin-associated jaundice."
  },
  {
    name: "Amoxicillin + Clavulanic Acid 457mg/5ml Suspension",
    defaultDose: "5 ml",
    defaultFreq: "BID (Every 12 hours)",
    defaultDuration: "5-7 days",
    indication: "Severe respiratory tract infections",
    category: "المضادات الحيوية (أطفال)",
    info: "Broad-spectrum penicillin antibiotic (Forte).",
    sideEffects: "Diarrhea, nausea.",
    contraindications: "Penicillin allergy."
  },
  {
    name: "Azithromycin 200mg/5ml Suspension",
    defaultDose: "5 ml (10 mg/kg)",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "3-5 days",
    indication: "Atypical pneumonia, pharyngitis",
    category: "المضادات الحيوية (أطفال)",
    info: "Macrolide antibiotic.",
    sideEffects: "GI upset, QT prolongation.",
    contraindications: "Macrolide allergy."
  },
  {
    name: "Cefixime 100mg/5ml Suspension",
    defaultDose: "5 ml (8 mg/kg)",
    defaultFreq: "OD or BID",
    defaultDuration: "7 days",
    indication: "UTI, Otitis media",
    category: "المضادات الحيوية (أطفال)",
    info: "Third-generation cephalosporin.",
    sideEffects: "Diarrhea, abdominal pain.",
    contraindications: "Cephalosporin allergy."
  },
  {
    name: "Cefdinir 125mg/5ml Suspension",
    defaultDose: "5 ml",
    defaultFreq: "BID or OD",
    defaultDuration: "5-10 days",
    indication: "Otitis media, Pharyngitis",
    category: "المضادات الحيوية (أطفال)",
    info: "Third-generation cephalosporin.",
    sideEffects: "Reddish stools, diarrhea.",
    contraindications: "Cephalosporin allergy."
  },
  {
    name: "Cephalexin 250mg/5ml Suspension",
    defaultDose: "5 ml",
    defaultFreq: "QID or BID",
    defaultDuration: "7-10 days",
    indication: "Skin infections, Pharyngitis",
    category: "المضادات الحيوية (أطفال)",
    info: "First-generation cephalosporin.",
    sideEffects: "GI upset, rash.",
    contraindications: "Cephalosporin allergy."
  },
  {
    name: "Trimethoprim/Sulfamethoxazole 240mg/5ml Suspension",
    defaultDose: "5 ml",
    defaultFreq: "BID (Every 12 hours)",
    defaultDuration: "5-10 days",
    indication: "UTI, Otitis media",
    category: "المضادات الحيوية (أطفال)",
    info: "Sulfa drug.",
    sideEffects: "Rash, GI upset.",
    contraindications: "Sulfa allergy, infants <2 months."
  },
  {
    name: "Metronidazole 125mg/5ml Suspension",
    defaultDose: "5 ml",
    defaultFreq: "TID (Every 8 hours)",
    defaultDuration: "5-7 days",
    indication: "Amebiasis, Giardiasis, Anaerobic infections",
    category: "المضادات الحيوية (أطفال)",
    info: "Antiprotozoal and antibacterial.",
    sideEffects: "Metallic taste, nausea.",
    contraindications: "First trimester of pregnancy (not applicable here)."
  },
  {
    name: "Salbutamol 100mcg Inhaler",
    defaultDose: "1-2 puffs",
    defaultFreq: "PRN (As needed for wheezing)",
    defaultDuration: "Ongoing",
    indication: "Asthma, Bronchospasm",
    category: "بخاخات وجلسات تنفس (أطفال)",
    info: "SABA bronchodilator.",
    sideEffects: "Tachycardia, tremors.",
    contraindications: "Severe tachyarrhythmia."
  },
  {
    name: "Salbutamol Nebulizer Solution (Respirator Solution)",
    defaultDose: "0.5 - 1 ml diluted in 2.5ml Normal Saline",
    defaultFreq: "PRN (Every 4-6 hours)",
    defaultDuration: "During acute exacerbation",
    indication: "Acute asthma exacerbation",
    category: "بخاخات وجلسات تنفس (أطفال)",
    info: "Used in nebulizer.",
    sideEffects: "Tachycardia, tremors.",
    contraindications: "Severe tachyarrhythmia."
  },
  {
    name: "Fluticasone 50mcg Inhaler",
    defaultDose: "1-2 puffs",
    defaultFreq: "BID (Twice daily)",
    defaultDuration: "Maintenance",
    indication: "Asthma maintenance",
    category: "بخاخات وجلسات تنفس (أطفال)",
    info: "Inhaled corticosteroid (ICS). Use with spacer. Rinse mouth after use.",
    sideEffects: "Oral thrush, hoarseness.",
    contraindications: "Acute bronchospasm (not for rescue)."
  },
  {
    name: "Budesonide 0.25mg/2ml Nebulizer Suspension",
    defaultDose: "1 respule (2ml)",
    defaultFreq: "BID (Twice daily)",
    defaultDuration: "Maintenance or acute croup",
    indication: "Asthma maintenance, Croup",
    category: "بخاخات وجلسات تنفس (أطفال)",
    info: "Nebulized corticosteroid.",
    sideEffects: "Oral thrush, mild cough.",
    contraindications: "Primary treatment of status asthmaticus."
  },
  {
    name: "Ipratropium Bromide Nebulizer Solution",
    defaultDose: "1 ml",
    defaultFreq: "QID (Every 6 hours) or PRN",
    defaultDuration: "During acute exacerbation",
    indication: "Severe bronchospasm",
    category: "بخاخات وجلسات تنفس (أطفال)",
    info: "Anticholinergic bronchodilator.",
    sideEffects: "Dry mouth, tachycardia.",
    contraindications: "Hypersensitivity to atropine."
  },
  {
    name: "Normal Saline 0.9% Nasal Drops",
    defaultDose: "2-3 drops in each nostril",
    defaultFreq: "PRN (Before feeds)",
    defaultDuration: "As needed",
    indication: "Nasal congestion",
    category: "بخاخات وجلسات تنفس (أطفال)",
    info: "Safe for newborns.",
    sideEffects: "None significant.",
    contraindications: "None."
  },
  {
    name: "Xylometazoline 0.05% Nasal Drops",
    defaultDose: "1-2 drops in each nostril",
    defaultFreq: "BID or TID",
    defaultDuration: "Max 3-5 days",
    indication: "Severe nasal congestion",
    category: "بخاخات وجلسات تنفس (أطفال)",
    info: "Pediatric decongestant. Do not use for >5 days to avoid rebound.",
    sideEffects: "Nasal irritation, rebound congestion.",
    contraindications: "Infants under 2 years, MAOIs."
  },
  {
    name: "Mometasone 50mcg Nasal Spray",
    defaultDose: "1 spray in each nostril",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "Maintenance",
    indication: "Allergic rhinitis, Adenoid hypertrophy",
    category: "بخاخات وجلسات تنفس (أطفال)",
    info: "Intranasal corticosteroid.",
    sideEffects: "Epistaxis (nosebleeds), local irritation.",
    contraindications: "Recent nasal surgery or trauma."
  },
  // ==========================================
  // CHAPTER: MEDICAL SUPPLIES & DRESSINGS (مستلزمات طبية وضمادات)
  // ==========================================
  { 
    name: "Elastic Bandage (Crepe Bandage) / رباط ضاغط مرن", 
    defaultDose: "1 Roll", 
    defaultFreq: "Apply as needed", 
    defaultDuration: "PRN", 
    indication: "Sprains, strains, varicose veins, joint support", 
    category: "Medical Supplies (مستلزمات طبية)",
    info: "Used to provide localized pressure and support for soft tissue injuries.",
    sideEffects: "Impaired circulation if applied too tightly.",
    contraindications: "Severe peripheral arterial disease."
  },
  { 
    name: "Gauze Bandage Roll / رباط شاش طبي", 
    defaultDose: "1 Roll", 
    defaultFreq: "Change daily or when wet", 
    defaultDuration: "PRN", 
    indication: "Securing wound dressings", 
    category: "Medical Supplies (مستلزمات طبية)",
    info: "Non-elastic, highly absorbent open-weave cotton bandage.",
    sideEffects: "None.",
    contraindications: "None."
  },
  { 
    name: "Adhesive Wound Plasters (Band-Aid) / بلاستر جروح لاصق", 
    defaultDose: "1 Piece", 
    defaultFreq: "Change daily", 
    defaultDuration: "PRN", 
    indication: "Minor cuts, abrasions, puncture wounds", 
    category: "Medical Supplies (مستلزمات طبية)",
    info: "Assorted sizes. Keeps minor wounds clean and protected from bacteria.",
    sideEffects: "Skin irritation from adhesive.",
    contraindications: "Adhesive allergy."
  },
  { 
    name: "Zinc Oxide Adhesive Tape / بلاستر قماشي قوي (زنك أوكسايد)", 
    defaultDose: "1 Roll", 
    defaultFreq: "Apply as needed", 
    defaultDuration: "PRN", 
    indication: "Securing heavy dressings, strapping joints (sports taping)", 
    category: "Medical Supplies (مستلزمات طبية)",
    info: "Strong, rigid tape with high adhesive strength. Not suitable for fragile skin.",
    sideEffects: "Skin irritation upon removal.",
    contraindications: "Fragile skin, adhesive allergy."
  },
  { 
    name: "Micropore Surgical Paper Tape / بلاستر ورقي طبي (مايكروبور)", 
    defaultDose: "1 Roll", 
    defaultFreq: "Apply as needed", 
    defaultDuration: "PRN", 
    indication: "Securing lightweight dressings, IV lines", 
    category: "Medical Supplies (مستلزمات طبية)",
    info: "Hypoallergenic, breathable, gentle on fragile skin.",
    sideEffects: "Rare skin sensitivity.",
    contraindications: "None."
  },
  { 
    name: "Sterile Gauze Swabs (Pads) / شاش معقم لتنظيف الجروح", 
    defaultDose: "1 Packet (5 pads)", 
    defaultFreq: "Use for wound cleaning", 
    defaultDuration: "PRN", 
    indication: "Wound cleaning, exudate absorption", 
    category: "Medical Supplies (مستلزمات طبية)",
    info: "Sterile 100% cotton gauze. Essential for aseptic wound care.",
    sideEffects: "None.",
    contraindications: "None."
  },
  { 
    name: "Alcohol Swabs (Prep Pads) / مسحات طبية كحولية", 
    defaultDose: "1 Swab", 
    defaultFreq: "Before injections/pricks", 
    defaultDuration: "PRN", 
    indication: "Skin disinfection prior to injection", 
    category: "Medical Supplies (مستلزمات طبية)",
    info: "70% Isopropyl Alcohol. Fast-acting skin antiseptic.",
    sideEffects: "Dry skin with frequent use.",
    contraindications: "Do not use on open wounds (causes pain and tissue damage)."
  },
  { 
    name: "Povidone-Iodine Solution (Betadine) / محلول معقم يود (بيتادين)", 
    defaultDose: "1 Bottle (100ml)", 
    defaultFreq: "Apply to wound", 
    defaultDuration: "PRN", 
    indication: "Wound antisepsis, pre-operative skin prep", 
    category: "Medical Supplies (مستلزمات طبية)",
    info: "Broad-spectrum microbicide.",
    sideEffects: "Local skin irritation, iodine toxicity if applied to large burns.",
    contraindications: "Thyroid disorders, iodine allergy, pregnancy/lactation."
  },
  { 
    name: "Chlorhexidine Gluconate Solution / محلول معقم كلورهيكسيدين", 
    defaultDose: "1 Bottle", 
    defaultFreq: "Apply to intact skin", 
    defaultDuration: "PRN", 
    indication: "Pre-operative skin disinfection, general antisepsis", 
    category: "Medical Supplies (مستلزمات طبية)",
    info: "Long-lasting residual effect. Clear or tinted.",
    sideEffects: "Skin irritation.",
    contraindications: "Do not use in eyes or ears."
  },
  { 
    name: "Hydrogen Peroxide Solution / محلول ماء الأكسجين", 
    defaultDose: "1 Bottle", 
    defaultFreq: "Use for wound irrigation", 
    defaultDuration: "PRN", 
    indication: "Cleaning dirty/necrotic wounds, ear wax removal", 
    category: "Medical Supplies (مستلزمات طبية)",
    info: "Effervescent cleaning action. Do not use for closed spaces.",
    sideEffects: "Can delay healing if used repeatedly on healthy granulating tissue.",
    contraindications: "Deep puncture wounds."
  },
  { 
    name: "Waterproof Transparent Dressing (Tegaderm) / لاصق جروح شفاف ومضاد للماء", 
    defaultDose: "1 Piece", 
    defaultFreq: "Change every 3-5 days", 
    defaultDuration: "PRN", 
    indication: "IV site covering, minor burns, superficial wounds", 
    category: "Medical Supplies (مستلزمات طبية)",
    info: "Breathable but protects against water and bacteria.",
    sideEffects: "Maceration if wound is heavily exudating.",
    contraindications: "Infected wounds."
  },
  { 
    name: "Tubular Bandage (Tubigrip) / رباط ضاغط أنبوبي", 
    defaultDose: "1 Roll (Specify Size)", 
    defaultFreq: "Wear as needed", 
    defaultDuration: "PRN", 
    indication: "Joint effusion, edema control, post-cast support", 
    category: "Medical Supplies (مستلزمات طبية)",
    info: "Provides continuous, even tissue support.",
    sideEffects: "Constriction if the wrong size is applied.",
    contraindications: "Arterial insufficiency."
  },
  { 
    name: "Cotton Wool Roll / قطن طبي لفة", 
    defaultDose: "1 Roll", 
    defaultFreq: "Use as padding", 
    defaultDuration: "PRN", 
    indication: "Padding under casts, general cleaning", 
    category: "Medical Supplies (مستلزمات طبية)",
    info: "Highly absorbent but fibers can stick to open wounds. Use over gauze.",
    sideEffects: "Foreign body reaction if left in wound.",
    contraindications: "Applying directly to open wounds."
  },
  { 
    name: "Knee Support (Hinged/Simple) / ساند ومثبت للركبة", 
    defaultDose: "1 Piece (Specify Size)", 
    defaultFreq: "Wear during activity", 
    defaultDuration: "PRN", 
    indication: "Osteoarthritis, ligament injuries, post-op support", 
    category: "Medical Supplies (مستلزمات طبية)",
    info: "Provides stability and warmth to the knee joint.",
    sideEffects: "Skin irritation from prolonged use.",
    contraindications: "Severe vascular compromise."
  },
  { 
    name: "Lumbar Corset (Back Support Brace) / حزام ساند ومثبت للظهر", 
    defaultDose: "1 Piece (Specify Size)", 
    defaultFreq: "Wear during lifting/activity", 
    defaultDuration: "PRN", 
    indication: "Lumbago, disc prolapse, muscle spasms", 
    category: "Medical Supplies (مستلزمات طبية)",
    info: "Reduces strain on the lower back. Should not be worn 24/7 to prevent muscle atrophy.",
    sideEffects: "Core muscle weakness with chronic over-reliance.",
    contraindications: "None specific."
  },
  { 
    name: "Ankle Binder (Support) / رباط وساند للكاحل", 
    defaultDose: "1 Piece (Specify Size)", 
    defaultFreq: "Wear during walking/activity", 
    defaultDuration: "PRN", 
    indication: "Ankle sprains, chronic ankle instability", 
    category: "Medical Supplies (مستلزمات طبية)",
    info: "Provides compression and limits inversion/eversion.",
    sideEffects: "Constriction if improperly sized.",
    contraindications: "Severe peripheral neuropathy."
  },
  { 
    name: "Wrist Splint / Support / ساند ومثبت للمعصم", 
    defaultDose: "1 Piece (Left/Right)", 
    defaultFreq: "Wear constantly or at night", 
    defaultDuration: "PRN", 
    indication: "Carpal tunnel syndrome, wrist sprains, tendinitis", 
    category: "Medical Supplies (مستلزمات طبية)",
    info: "Keeps wrist in a neutral position to relieve nerve pressure.",
    sideEffects: "Stiffness.",
    contraindications: "None."
  },
  { 
    name: "Cervical Collar (Neck Brace) / دعامة وطوق للرقبة", 
    defaultDose: "1 Piece (Soft or Hard)", 
    defaultFreq: "Wear as prescribed", 
    defaultDuration: "PRN", 
    indication: "Cervical spondylosis, whiplash injury, neck muscle spasm", 
    category: "Medical Supplies (مستلزمات طبية)",
    info: "Supports the head and limits neck movement.",
    sideEffects: "Skin maceration, pressure sores (hard collar).",
    contraindications: "Unstable cervical fractures (for soft collars)."
  },
  { 
    name: "Arm Sling / حمالة ذراع طبية", 
    defaultDose: "1 Piece", 
    defaultFreq: "Wear constantly", 
    defaultDuration: "PRN", 
    indication: "Fractures of arm/shoulder, post-cast support", 
    category: "Medical Supplies (مستلزمات طبية)",
    info: "Elevates and immobilizes the upper extremity.",
    sideEffects: "Neck strain from the strap.",
    contraindications: "None."
  },
  // ==========================================
  // CHAPTER: GENITOURINARY & STDs
  // ==========================================
  { 
    name: "Ceftriaxone 250mg IM Injection", 
    defaultDose: "250 mg", 
    defaultFreq: "STAT (Single dose)", 
    defaultDuration: "1 day", 
    indication: "Uncomplicated Gonococcal Infection", 
    category: "Genitourinary & STDs",
    info: "Third-generation cephalosporin. Usually given with Azithromycin.",
    sideEffects: "Pain at injection site, rash.",
    contraindications: "Severe penicillin allergy, hyperbilirubinemic neonates."
  },
  { 
    name: "Ceftriaxone 500mg IM Injection", 
    defaultDose: "500 mg", 
    defaultFreq: "STAT (Single dose)", 
    defaultDuration: "1 day", 
    indication: "Gonococcal Infection", 
    category: "Genitourinary & STDs",
    info: "Third-generation cephalosporin.",
    sideEffects: "Pain at injection site, rash.",
    contraindications: "Severe penicillin allergy."
  },
  { 
    name: "Benzathine Penicillin G 2.4 Million Units IM Injection", 
    defaultDose: "2.4 Million Units", 
    defaultFreq: "STAT (Single dose)", 
    defaultDuration: "1 day", 
    indication: "Primary, Secondary, or Early Latent Syphilis", 
    category: "Genitourinary & STDs",
    info: "Long-acting penicillin. Administer deep IM.",
    sideEffects: "Pain at injection site, Jarisch-Herxheimer reaction.",
    contraindications: "Penicillin hypersensitivity."
  },
  { 
    name: "Azithromycin 1g Tablet", 
    defaultDose: "1 g", 
    defaultFreq: "STAT (Single dose)", 
    defaultDuration: "1 day", 
    indication: "Chlamydia trachomatis, Gonorrhea (adjunct)", 
    category: "Genitourinary & STDs",
    info: "Macrolide antibiotic. Often co-administered with Ceftriaxone.",
    sideEffects: "Nausea, vomiting, diarrhea, QT prolongation.",
    contraindications: "Macrolide allergy, history of cholestatic jaundice with macrolides."
  },
  { 
    name: "Doxycycline 100mg Capsule", 
    defaultDose: "100 mg", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "7 days", 
    indication: "Chlamydia trachomatis, PID, Syphilis (if penicillin allergic)", 
    category: "Genitourinary & STDs",
    info: "Tetracycline antibiotic. Take with plenty of water, avoid dairy.",
    sideEffects: "Photosensitivity, esophagitis, GI upset.",
    contraindications: "Pregnancy, children under 8 years."
  },
  { 
    name: "Metronidazole 2g Tablet", 
    defaultDose: "2 g", 
    defaultFreq: "STAT (Single dose)", 
    defaultDuration: "1 day", 
    indication: "Trichomoniasis, Bacterial Vaginosis", 
    category: "Genitourinary & STDs",
    info: "Nitroimidazole antimicrobial. Avoid alcohol during and 48h after treatment.",
    sideEffects: "Metallic taste, nausea, disulfiram-like reaction with alcohol.",
    contraindications: "First trimester of pregnancy (relative)."
  },
  { 
    name: "Metronidazole 500mg IV Infusion", 
    defaultDose: "500 mg", 
    defaultFreq: "TDS (Three times / day)", 
    defaultDuration: "7 days", 
    indication: "Severe Pelvic Inflammatory Disease (PID)", 
    category: "Genitourinary & STDs",
    info: "Given slowly IV for severe anaerobic infections.",
    sideEffects: "Metallic taste, nausea, phlebitis.",
    contraindications: "Alcohol consumption."
  },
  { 
    name: "Cefixime 400mg Capsule", 
    defaultDose: "400 mg", 
    defaultFreq: "STAT (Single dose)", 
    defaultDuration: "1 day", 
    indication: "Uncomplicated Gonococcal Infection", 
    category: "Genitourinary & STDs",
    info: "Oral alternative if Ceftriaxone is unavailable.",
    sideEffects: "Diarrhea, abdominal pain.",
    contraindications: "Cephalosporin allergy."
  },
  { 
    name: "Fluconazole 150mg Capsule", 
    defaultDose: "150 mg", 
    defaultFreq: "STAT (Single dose)", 
    defaultDuration: "1 day", 
    indication: "Vulvovaginal Candidiasis, Balanitis", 
    category: "Genitourinary & STDs",
    info: "Oral triazole antifungal.",
    sideEffects: "Headache, nausea.",
    contraindications: "Pregnancy, co-administration with terfenadine/cisapride."
  },
  { 
    name: "Clotrimazole 500mg Vaginal Pessary", 
    defaultDose: "500 mg", 
    defaultFreq: "STAT (Single dose at night)", 
    defaultDuration: "1 day", 
    indication: "Vulvovaginal Candidiasis", 
    category: "Genitourinary & STDs",
    info: "Insert high into vagina at bedtime.",
    sideEffects: "Local irritation.",
    contraindications: "Hypersensitivity."
  },
  { 
    name: "Valacyclovir 500mg Tablet", 
    defaultDose: "500 mg", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "3 days", 
    indication: "Genital Herpes (Episodic Treatment)", 
    category: "Genitourinary & STDs",
    info: "Prodrug of acyclovir with better oral bioavailability.",
    sideEffects: "Headache, nausea.",
    contraindications: "Hypersensitivity."
  },
  { 
    name: "Acyclovir 400mg Tablet", 
    defaultDose: "400 mg", 
    defaultFreq: "TDS (Three times / day)", 
    defaultDuration: "5-10 days", 
    indication: "Genital Herpes", 
    category: "Genitourinary & STDs",
    info: "Antiviral for HSV.",
    sideEffects: "Nausea, diarrhea, headache.",
    contraindications: "Hypersensitivity."
  },
  { 
    name: "Podophyllotoxin 0.5% Solution", 
    defaultDose: "Apply to lesions", 
    defaultFreq: "BD (Twice daily for 3 days)", 
    defaultDuration: "1 week cycle", 
    indication: "External Genital Warts (Condylomata acuminata)", 
    category: "Genitourinary & STDs",
    info: "Patient-applied antimitotic. Wash off after designated time if required.",
    sideEffects: "Severe local inflammation, erosion.",
    contraindications: "Pregnancy."
  },
  { 
    name: "Imiquimod 5% Cream", 
    defaultDose: "Apply to lesions", 
    defaultFreq: "3 times / week at night", 
    defaultDuration: "Up to 16 weeks", 
    indication: "External Genital Warts", 
    category: "Genitourinary & STDs",
    info: "Immune response modifier. Wash off after 6-10 hours.",
    sideEffects: "Erythema, irritation, ulceration at site.",
    contraindications: "None significant."
  },
  // ==========================================
  // CHAPTER: PSYCHIATRY & MENTAL HEALTH
  // ==========================================
  { 
    name: "Fluoxetine 20mg Capsule", 
    defaultDose: "20 mg", 
    defaultFreq: "OD (Once daily in morning)", 
    defaultDuration: "Chronic", 
    indication: "Major Depressive Disorder, OCD, Bulimia", 
    category: "Psychiatry & Mental Health",
    info: "SSRI antidepressant. Taking in the morning prevents insomnia.",
    sideEffects: "Insomnia, nausea, sexual dysfunction, weight changes.",
    contraindications: "Concurrent MAOI use."
  },
  { 
    name: "Escitalopram 10mg Tablet", 
    defaultDose: "10 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Depression, Generalized Anxiety Disorder", 
    category: "Psychiatry & Mental Health",
    info: "Highly selective SSRI. Well tolerated.",
    sideEffects: "Nausea, somnolence, sexual dysfunction, QT prolongation.",
    contraindications: "Concurrent MAOI use, pimozide."
  },
  { 
    name: "Sertraline 50mg Tablet", 
    defaultDose: "50 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Depression, Panic Disorder, PTSD", 
    category: "Psychiatry & Mental Health",
    info: "SSRI antidepressant. Take with food to minimize GI upset.",
    sideEffects: "Diarrhea, nausea, insomnia, sexual dysfunction.",
    contraindications: "Concurrent MAOI use."
  },
  { 
    name: "Mirtazapine 15mg Tablet", 
    defaultDose: "15 mg", 
    defaultFreq: "ON (At night)", 
    defaultDuration: "Chronic", 
    indication: "Major Depressive Disorder (especially with insomnia/weight loss)", 
    category: "Psychiatry & Mental Health",
    info: "Atypical antidepressant. Highly sedating at lower doses.",
    sideEffects: "Somnolence, increased appetite, weight gain.",
    contraindications: "Concurrent MAOI use."
  },
  { 
    name: "Venlafaxine 75mg ER Capsule", 
    defaultDose: "75 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Major Depressive Disorder, Generalized Anxiety Disorder", 
    category: "Psychiatry & Mental Health",
    info: "SNRI antidepressant. Monitor blood pressure.",
    sideEffects: "Nausea, dizziness, sweating, hypertension.",
    contraindications: "Concurrent MAOI use."
  },
  { 
    name: "Amitriptyline 25mg Tablet", 
    defaultDose: "25 mg", 
    defaultFreq: "ON (At night)", 
    defaultDuration: "Chronic", 
    indication: "Depression, Neuropathic pain, Migraine prophylaxis", 
    category: "Psychiatry & Mental Health",
    info: "Tricyclic antidepressant (TCA). Strongly sedating.",
    sideEffects: "Dry mouth, constipation, weight gain, orthostatic hypotension.",
    contraindications: "Recent myocardial infarction, arrhythmias."
  },
  { 
    name: "Alprazolam 0.5mg Tablet", 
    defaultDose: "0.5 mg", 
    defaultFreq: "PRN (When required) or BD", 
    defaultDuration: "Short-term (Max 2-4 weeks)", 
    indication: "Panic Disorder, Severe Anxiety", 
    category: "Psychiatry & Mental Health",
    info: "Short-acting benzodiazepine. High risk of dependence.",
    sideEffects: "Drowsiness, dizziness, memory impairment.",
    contraindications: "Myasthenia gravis, severe respiratory depression, acute narrow-angle glaucoma."
  },
  { 
    name: "Clonazepam 2mg Tablet", 
    defaultDose: "0.5 - 2 mg", 
    defaultFreq: "BD (Twice daily) or ON", 
    defaultDuration: "Short-term (Max 2-4 weeks)", 
    indication: "Panic Disorder, Seizure Disorders", 
    category: "Psychiatry & Mental Health",
    info: "Long-acting benzodiazepine.",
    sideEffects: "Somnolence, ataxia, cognitive impairment.",
    contraindications: "Severe liver disease, acute narrow-angle glaucoma."
  },
  { 
    name: "Olanzapine 5mg Tablet", 
    defaultDose: "5 mg", 
    defaultFreq: "ON (At night)", 
    defaultDuration: "Chronic", 
    indication: "Schizophrenia, Bipolar Mania", 
    category: "Psychiatry & Mental Health",
    info: "Atypical antipsychotic. Significant metabolic side effects.",
    sideEffects: "Weight gain, sedation, increased appetite, hyperlipidemia.",
    contraindications: "Known hypersensitivity."
  },
  { 
    name: "Quetiapine 25mg Tablet", 
    defaultDose: "25 mg", 
    defaultFreq: "ON (At night)", 
    defaultDuration: "Chronic", 
    indication: "Schizophrenia, Bipolar Disorder, Insomnia (off-label)", 
    category: "Psychiatry & Mental Health",
    info: "Atypical antipsychotic. Highly sedating.",
    sideEffects: "Somnolence, dizziness, dry mouth, weight gain.",
    contraindications: "Known hypersensitivity."
  },
  { 
    name: "Risperidone 2mg Tablet", 
    defaultDose: "2 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Schizophrenia, Bipolar Mania, Irritability in Autism", 
    category: "Psychiatry & Mental Health",
    info: "Atypical antipsychotic. Higher risk of EPS at higher doses.",
    sideEffects: "Extrapyramidal symptoms (EPS), hyperprolactinemia, weight gain.",
    contraindications: "Known hypersensitivity."
  },
  { 
    name: "Haloperidol 5mg Tablet", 
    defaultDose: "5 mg", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "Chronic", 
    indication: "Schizophrenia, Acute Psychosis, Severe Agitation", 
    category: "Psychiatry & Mental Health",
    info: "Typical antipsychotic.",
    sideEffects: "Extrapyramidal symptoms (EPS), tardive dyskinesia, QT prolongation.",
    contraindications: "Parkinson's disease, severe CNS depression."
  },
  { 
    name: "Sodium Valproate 500mg Tablet", 
    defaultDose: "500 mg", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "Chronic", 
    indication: "Bipolar Disorder (Mania), Epilepsy", 
    category: "Psychiatry & Mental Health",
    info: "Mood stabilizer and anticonvulsant.",
    sideEffects: "Nausea, tremor, weight gain, hair loss.",
    contraindications: "Hepatic disease, mitochondrial disorders, pregnancy (high teratogenicity)."
  },
  { 
    name: "Lithium Carbonate 400mg Tablet", 
    defaultDose: "400 mg", 
    defaultFreq: "BD (Twice daily) or ON", 
    defaultDuration: "Chronic", 
    indication: "Bipolar Disorder (Maintenance)", 
    category: "Psychiatry & Mental Health",
    info: "Classic mood stabilizer. Narrow therapeutic index; requires blood monitoring.",
    sideEffects: "Tremor, polyuria, hypothyroidism, weight gain.",
    contraindications: "Severe renal or cardiovascular disease."
  },
  // ==========================================
  // CHAPTER: ADVANCED WOUND CARE DRESSINGS (الضمادات الحديثة والمتطورة)
  // ==========================================
  { 
    name: "Hydrocolloid Dressing (e.g., DuoDERM) / لاصق هيدروكولويد", 
    defaultDose: "1 Piece", 
    defaultFreq: "Change every 3-7 days", 
    defaultDuration: "PRN", 
    indication: "Light to moderate exudate wounds, pressure ulcers (Stage I-II)", 
    category: "Advanced Wound Care",
    info: "Creates a moist environment to promote autolytic debridement.",
    sideEffects: "May produce a characteristic odor upon removal (often confused with infection).",
    contraindications: "Infected wounds, heavy exudate, deep cavities."
  },
  { 
    name: "Alginate Dressing (e.g., Kaltostat) / ضمادة الجينات للامتصاص", 
    defaultDose: "1 Piece", 
    defaultFreq: "Change every 1-3 days depending on exudate", 
    defaultDuration: "PRN", 
    indication: "Highly exudating wounds, bleeding wounds, pressure ulcers (Stage III-IV)", 
    category: "Advanced Wound Care",
    info: "Derived from seaweed. Highly absorbent and forms a gel on contact with exudate. Hemostatic properties.",
    sideEffects: "Can dry out and stick to the wound if there is insufficient exudate.",
    contraindications: "Dry wounds, hard eschar."
  },
  { 
    name: "Polyurethane Foam Dressing (e.g., Allevyn) / ضمادة فوم اسفنجية", 
    defaultDose: "1 Piece", 
    defaultFreq: "Change every 3-7 days", 
    defaultDuration: "PRN", 
    indication: "Moderate to heavy exudate, venous leg ulcers, pressure prevention", 
    category: "Advanced Wound Care",
    info: "Provides cushioning, thermal insulation, and manages fluid well.",
    sideEffects: "Maceration of surrounding skin if saturated.",
    contraindications: "Dry wounds (can desiccate further)."
  },
  { 
    name: "Hydrogel Dressing (e.g., IntraSite Gel) / جل هيدروجيل للترطيب", 
    defaultDose: "1 Tube / Piece", 
    defaultFreq: "Change daily or every other day", 
    defaultDuration: "PRN", 
    indication: "Dry, sloughy, or necrotic wounds, minor burns", 
    category: "Advanced Wound Care",
    info: "Donates moisture to the wound bed to facilitate autolytic debridement.",
    sideEffects: "Maceration of peri-wound skin.",
    contraindications: "Heavily exudating wounds."
  },
  { 
    name: "Silver Antimicrobial Dressing (e.g., Aquacel Ag) / ضمادة الفضة المعقمة", 
    defaultDose: "1 Piece", 
    defaultFreq: "Change every 3-7 days", 
    defaultDuration: "PRN", 
    indication: "Infected wounds, critically colonized wounds, burns", 
    category: "Advanced Wound Care",
    info: "Releases silver ions which have broad-spectrum antimicrobial activity.",
    sideEffects: "Transient skin staining (argyria).",
    contraindications: "Silver allergy, routine use on clean wounds (may delay healing)."
  },
  { 
    name: "Soft Silicone Dressing (e.g., Mepitel) / شبكة سيليكون لينة", 
    defaultDose: "1 Piece", 
    defaultFreq: "Change every 7-14 days", 
    defaultDuration: "PRN", 
    indication: "Skin tears, fragile skin, superficial burns, skin grafts", 
    category: "Advanced Wound Care",
    info: "Atraumatic removal. Does not adhere to the moist wound bed.",
    sideEffects: "Requires a secondary absorbent dressing.",
    contraindications: "None significant."
  },
  { 
    name: "Medical Honey Dressing (e.g., Medihoney) / ضمادة العسل الطبي", 
    defaultDose: "1 Piece / Tube", 
    defaultFreq: "Change every 1-3 days", 
    defaultDuration: "PRN", 
    indication: "Infected or malodorous wounds, necrotic tissue", 
    category: "Advanced Wound Care",
    info: "Osmotic effect draws fluid and provides autolytic debridement and antimicrobial action.",
    sideEffects: "Transient stinging or drawing pain on application.",
    contraindications: "Bee venom allergy."
  },
  { 
    name: "Non-Adherent Absorbent Dressing (e.g., Melolin, Telfa) / ضمادة غير لاصقة", 
    defaultDose: "1 Piece", 
    defaultFreq: "Change daily or as needed", 
    defaultDuration: "PRN", 
    indication: "Clean sutured wounds, minor cuts and abrasions", 
    category: "Advanced Wound Care",
    info: "Low-adherent perforated film prevents sticking to granulating tissue.",
    sideEffects: "None.",
    contraindications: "Heavily exudating wounds (insufficient absorption)."
  },
  { 
    name: "Collagen Matrix Dressing / ضمادة الكولاجين لتحفيز الالتئام", 
    defaultDose: "1 Piece", 
    defaultFreq: "Change every 2-7 days", 
    defaultDuration: "PRN", 
    indication: "Stalled or chronic wounds, diabetic foot ulcers", 
    category: "Advanced Wound Care",
    info: "Provides a scaffold for cell migration and binds MMPs to kickstart healing.",
    sideEffects: "None.",
    contraindications: "Bovine/Porcine/Avian allergy (depending on source), active infection."
  },
  { 
    name: "Negative Pressure Wound Therapy (NPWT) Foam Kit / طقم جهاز شفط الجروح", 
    defaultDose: "1 Kit", 
    defaultFreq: "Change every 48-72 hours", 
    defaultDuration: "PRN", 
    indication: "Deep cavity wounds, dehisced surgical wounds, large traumatic wounds", 
    category: "Advanced Wound Care",
    info: "Applies sub-atmospheric pressure to reduce edema and promote granulation.",
    sideEffects: "Pain during dressing changes, bleeding.",
    contraindications: "Untreated osteomyelitis, malignancy in wound, exposed vessels/organs."
  },
  // ==========================================
  // CHAPTER: ANTIBIOTICS (TABLETS & SYRUPS)
  // ==========================================
  { 
    name: "Amoxicillin 500mg Capsule", 
    defaultDose: "500 mg", 
    defaultFreq: "TDS (Three times / day)", 
    defaultDuration: "5-7 days", 
    indication: "Respiratory tract infections, otitis media, UTI", 
    category: "Antibiotics",
    info: "Broad-spectrum penicillin. Take after food.",
    sideEffects: "Diarrhea, nausea, skin rash.",
    contraindications: "Penicillin allergy."
  },
  { 
    name: "Amoxicillin 250mg/5ml Syrup", 
    defaultDose: "5 ml", 
    defaultFreq: "TDS (Three times / day)", 
    defaultDuration: "5-7 days", 
    indication: "Pediatric respiratory tract infections, otitis media", 
    category: "Antibiotics",
    info: "Broad-spectrum penicillin syrup. Shake well.",
    sideEffects: "Diarrhea, nausea, skin rash.",
    contraindications: "Penicillin allergy."
  },
  { 
    name: "Amoxicillin + Clavulanic Acid 1g Tablet (Augmentin)", 
    defaultDose: "1 g", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "5-7 days", 
    indication: "Severe respiratory tract infections, bite wounds, dental infections", 
    category: "Antibiotics",
    info: "Beta-lactamase inhibitor combination. High risk of GI upset.",
    sideEffects: "Severe diarrhea, nausea, vomiting, candidiasis.",
    contraindications: "Penicillin allergy, history of amoxicillin/clavulanate-associated jaundice."
  },
  { 
    name: "Amoxicillin + Clavulanic Acid 228mg/5ml Syrup", 
    defaultDose: "5 ml", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "5-7 days", 
    indication: "Pediatric severe infections, otitis media", 
    category: "Antibiotics",
    info: "Pediatric beta-lactamase inhibitor combination. Keep refrigerated.",
    sideEffects: "Severe diarrhea, nausea, diaper rash.",
    contraindications: "Penicillin allergy."
  },
  { 
    name: "Amoxicillin + Clavulanic Acid 457mg/5ml Syrup", 
    defaultDose: "5 ml", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "5-7 days", 
    indication: "Pediatric severe infections (older children)", 
    category: "Antibiotics",
    info: "Pediatric beta-lactamase inhibitor combination (Forte). Keep refrigerated.",
    sideEffects: "Severe diarrhea, nausea.",
    contraindications: "Penicillin allergy."
  },
  { 
    name: "Cefuroxime 500mg Tablet (Zinnat)", 
    defaultDose: "500 mg", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "5-7 days", 
    indication: "Lyme disease, respiratory tract infections, UTI", 
    category: "Antibiotics",
    info: "Second-generation cephalosporin. Take with food for better absorption.",
    sideEffects: "Diarrhea, nausea, eosinophilia.",
    contraindications: "Cephalosporin allergy."
  },
  { 
    name: "Cefuroxime 125mg/5ml Suspension", 
    defaultDose: "5 ml", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "5-7 days", 
    indication: "Pediatric respiratory tract infections, otitis media", 
    category: "Antibiotics",
    info: "Second-generation cephalosporin syrup.",
    sideEffects: "Diarrhea, nausea.",
    contraindications: "Cephalosporin allergy."
  },
  { 
    name: "Cefixime 400mg Capsule (Suprax)", 
    defaultDose: "400 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "5-7 days", 
    indication: "Gonorrhea, UTI, otitis media", 
    category: "Antibiotics",
    info: "Third-generation cephalosporin.",
    sideEffects: "Diarrhea, abdominal pain.",
    contraindications: "Cephalosporin allergy."
  },
  { 
    name: "Cefixime 100mg/5ml Suspension", 
    defaultDose: "5 ml", 
    defaultFreq: "OD or BD", 
    defaultDuration: "5-7 days", 
    indication: "Pediatric UTI, otitis media", 
    category: "Antibiotics",
    info: "Third-generation cephalosporin syrup.",
    sideEffects: "Diarrhea, abdominal pain.",
    contraindications: "Cephalosporin allergy."
  },
  { 
    name: "Cefdinir 300mg Capsule (Omnicef)", 
    defaultDose: "300 mg", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "5-10 days", 
    indication: "Community-acquired pneumonia, skin infections", 
    category: "Antibiotics",
    info: "Third-generation cephalosporin. May cause reddish stools if taken with iron.",
    sideEffects: "Diarrhea, vaginal candidiasis, red stools.",
    contraindications: "Cephalosporin allergy."
  },
  { 
    name: "Cefdinir 125mg/5ml Suspension", 
    defaultDose: "5 ml", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "5-10 days", 
    indication: "Pediatric pneumonia, skin infections", 
    category: "Antibiotics",
    info: "Third-generation cephalosporin syrup.",
    sideEffects: "Diarrhea, red stools.",
    contraindications: "Cephalosporin allergy."
  },
  { 
    name: "Cephalexin 500mg Capsule (Keflex)", 
    defaultDose: "500 mg", 
    defaultFreq: "QDS or BD", 
    defaultDuration: "5-7 days", 
    indication: "Skin and soft tissue infections, uncomplicated UTI", 
    category: "Antibiotics",
    info: "First-generation cephalosporin.",
    sideEffects: "Diarrhea, dyspepsia.",
    contraindications: "Cephalosporin allergy."
  },
  { 
    name: "Cephalexin 250mg/5ml Suspension", 
    defaultDose: "5 ml", 
    defaultFreq: "QDS or BD", 
    defaultDuration: "5-7 days", 
    indication: "Pediatric skin infections", 
    category: "Antibiotics",
    info: "First-generation cephalosporin syrup.",
    sideEffects: "Diarrhea.",
    contraindications: "Cephalosporin allergy."
  },
  { 
    name: "Azithromycin 500mg Tablet (Zithromax)", 
    defaultDose: "500 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "3 days", 
    indication: "Atypical pneumonia, chlamydia, traveler's diarrhea", 
    category: "Antibiotics",
    info: "Macrolide antibiotic. Long half-life.",
    sideEffects: "Nausea, vomiting, QT prolongation.",
    contraindications: "Macrolide allergy, history of QT prolongation."
  },
  { 
    name: "Azithromycin 200mg/5ml Suspension", 
    defaultDose: "5 ml", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "3 days", 
    indication: "Pediatric atypical pneumonia", 
    category: "Antibiotics",
    info: "Macrolide antibiotic syrup.",
    sideEffects: "Nausea, vomiting.",
    contraindications: "Macrolide allergy."
  },
  { 
    name: "Clarithromycin 500mg Tablet (Klacid)", 
    defaultDose: "500 mg", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "7-14 days", 
    indication: "H. pylori eradication, exacerbation of COPD, pneumonia", 
    category: "Antibiotics",
    info: "Macrolide antibiotic. Strong CYP3A4 inhibitor (many drug interactions).",
    sideEffects: "Metallic taste, nausea, QT prolongation.",
    contraindications: "Macrolide allergy, co-administration with statins (simvastatin/lovastatin)."
  },
  { 
    name: "Clarithromycin 125mg/5ml Suspension", 
    defaultDose: "5 ml", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "7 days", 
    indication: "Pediatric respiratory infections", 
    category: "Antibiotics",
    info: "Macrolide antibiotic syrup.",
    sideEffects: "Metallic taste, nausea.",
    contraindications: "Macrolide allergy."
  },
  { 
    name: "Levofloxacin 500mg Tablet (Tavanic)", 
    defaultDose: "500 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "5-7 days", 
    indication: "Community-acquired pneumonia, complicated UTI, prostatitis", 
    category: "Antibiotics",
    info: "Respiratory fluoroquinolone.",
    sideEffects: "Tendon rupture, CNS effects, QT prolongation, peripheral neuropathy.",
    contraindications: "Pregnancy, children, history of tendon disorders."
  },
  { 
    name: "Ciprofloxacin 500mg Tablet (Cipro)", 
    defaultDose: "500 mg", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "5-7 days", 
    indication: "Complicated UTI, infectious diarrhea, typhoid fever", 
    category: "Antibiotics",
    info: "Fluoroquinolone. Excellent against Gram-negative bacteria.",
    sideEffects: "Tendon rupture, CNS effects, QT prolongation.",
    contraindications: "Pregnancy, children, history of tendon disorders."
  },
  { 
    name: "Trimethoprim/Sulfamethoxazole 480mg Tablet (Bactrim / Septrin)", 
    defaultDose: "2 Tablets", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "3-5 days", 
    indication: "Uncomplicated UTI, PCP prophylaxis, MRSA skin infections", 
    category: "Antibiotics",
    info: "Sulfonamide combination (Co-trimoxazole).",
    sideEffects: "Skin rashes (Stevens-Johnson syndrome risk), hyperkalemia, crystalluria.",
    contraindications: "Sulfa allergy, severe renal/hepatic impairment, pregnancy (first/third trimester)."
  },
  { 
    name: "Trimethoprim/Sulfamethoxazole 240mg/5ml Suspension", 
    defaultDose: "5 ml", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "5 days", 
    indication: "Pediatric UTI, otitis media", 
    category: "Antibiotics",
    info: "Sulfonamide combination syrup.",
    sideEffects: "Skin rashes.",
    contraindications: "Sulfa allergy, infants < 2 months."
  },
  { 
    name: "Linezolid 600mg Tablet (Zyvox)", 
    defaultDose: "600 mg", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "10-14 days", 
    indication: "VRE infections, complicated MRSA skin infections, nosocomial pneumonia", 
    category: "Antibiotics",
    info: "Oxazolidinone. Acts as a weak MAOI (avoid tyramine-rich foods).",
    sideEffects: "Thrombocytopenia (if used >14 days), peripheral neuropathy, serotonin syndrome.",
    contraindications: "Concurrent MAOI use, uncontrolled hypertension."
  },
  { 
    name: "Clindamycin 300mg Capsule (Dalacin C)", 
    defaultDose: "300 mg", 
    defaultFreq: "QDS (Four times / day)", 
    defaultDuration: "7-10 days", 
    indication: "Anaerobic infections, MRSA skin infections, dental infections", 
    category: "Antibiotics",
    info: "Lincosamide antibiotic. High risk of C. difficile colitis.",
    sideEffects: "Diarrhea, pseudomembranous colitis, metallic taste.",
    contraindications: "History of regional enteritis or ulcerative colitis."
  },
  { 
    name: "Nitrofurantoin 100mg Capsule (Macrodantin)", 
    defaultDose: "100 mg", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "5-7 days", 
    indication: "Uncomplicated cystitis (UTI)", 
    category: "Antibiotics",
    info: "Urinary tract antiseptic. Take with food.",
    sideEffects: "Nausea, brown urine, pulmonary toxicity (with long-term use).",
    contraindications: "Renal impairment (eGFR < 30), pregnancy at term."
  },
  { 
    name: "Fosfomycin 3g Sachet (Monuril)", 
    defaultDose: "3 g", 
    defaultFreq: "STAT (Single dose)", 
    defaultDuration: "1 day", 
    indication: "Uncomplicated acute cystitis (UTI) in women", 
    category: "Antibiotics",
    info: "Dissolve in cold water and take on an empty stomach before bedtime.",
    sideEffects: "Diarrhea, vaginitis, nausea.",
    contraindications: "Severe renal impairment."
  },
  { 
    name: "Metronidazole 500mg Tablet (Flagyl)", 
    defaultDose: "500 mg", 
    defaultFreq: "TDS (Three times / day)", 
    defaultDuration: "5-7 days", 
    indication: "Anaerobic infections, C. difficile colitis, amoebiasis", 
    category: "Antibiotics",
    info: "Nitroimidazole. Avoid alcohol during and 48h after.",
    sideEffects: "Metallic taste, nausea, disulfiram-like reaction.",
    contraindications: "First trimester of pregnancy."
  },
  { 
    name: "Metronidazole 125mg/5ml Suspension", 
    defaultDose: "5 ml", 
    defaultFreq: "TDS (Three times / day)", 
    defaultDuration: "5-7 days", 
    indication: "Pediatric amoebiasis, giardiasis", 
    category: "Antibiotics",
    info: "Nitroimidazole syrup.",
    sideEffects: "Metallic taste, nausea.",
    contraindications: "First trimester of pregnancy."
  },
  // ==========================================
  // CHAPTER: COMBINATION MEDICINES (أدوية مخلوطة/مركبة - حبوب وشراب)
  // ==========================================
  { 
    name: "Paracetamol 500mg + Ibuprofen 400mg Tablet (Megafen/Cetafen)", 
    defaultDose: "1 Tablet", 
    defaultFreq: "TDS (Three times / day)", 
    defaultDuration: "3-5 days", 
    indication: "Moderate to severe pain, migraine, dental pain", 
    category: "Analgesics & Anti-inflammatory (Combination)",
    info: "Combination analgesic and NSAID. Take with or after food.",
    sideEffects: "Dyspepsia, GI ulceration, nausea.",
    contraindications: "Active GI ulcer, severe renal failure, third trimester of pregnancy."
  },
  { 
    name: "Paracetamol 500mg + Orphenadrine 35mg Tablet (Myogesic/Muscadol)", 
    defaultDose: "1-2 Tablets", 
    defaultFreq: "TDS (Three times / day)", 
    defaultDuration: "5 days", 
    indication: "Muscle spasms, tension headache, musculoskeletal pain", 
    category: "Muscle Relaxants (Combination)",
    info: "Combination of analgesic and skeletal muscle relaxant.",
    sideEffects: "Drowsiness, dry mouth, blurred vision, dizziness.",
    contraindications: "Glaucoma, prostatic hypertrophy, myasthenia gravis."
  },
  { 
    name: "Paracetamol + Chlorpheniramine + Pseudoephedrine Tablet (Flutab / Panadol Cold & Flu)", 
    defaultDose: "1 Tablet", 
    defaultFreq: "TDS (Three times / day)", 
    defaultDuration: "3-5 days", 
    indication: "Common cold, allergic rhinitis, sinusitis", 
    category: "Cough & Cold (Combination)",
    info: "Combination of analgesic, antihistamine, and decongestant.",
    sideEffects: "Drowsiness, dry mouth, palpitations, insomnia.",
    contraindications: "Severe hypertension, severe CAD, concurrent MAOI use."
  },
  { 
    name: "Ibuprofen 200mg + Pseudoephedrine 30mg Tablet (Advil Cold & Sinus)", 
    defaultDose: "1-2 Tablets", 
    defaultFreq: "TDS (Three times / day)", 
    defaultDuration: "3-5 days", 
    indication: "Sinus congestion with pain, common cold", 
    category: "Cough & Cold (Combination)",
    info: "NSAID plus decongestant. Take with food.",
    sideEffects: "Dyspepsia, insomnia, tachycardia.",
    contraindications: "Active GI bleeding, severe hypertension."
  },
  { 
    name: "Paracetamol + Metoclopramide Tablet (Paramax / Migramax)", 
    defaultDose: "1-2 Tablets", 
    defaultFreq: "STAT (at onset of attack)", 
    defaultDuration: "PRN (Max 3 days)", 
    indication: "Acute migraine with nausea/vomiting", 
    category: "Analgesics & Anti-emetic (Combination)",
    info: "Analgesic plus prokinetic anti-emetic.",
    sideEffects: "Drowsiness, extrapyramidal symptoms (EPS), diarrhea.",
    contraindications: "GI obstruction, pheochromocytoma, epilepsy."
  },
  { 
    name: "Tramadol 37.5mg + Paracetamol 325mg Tablet (Zaldiar)", 
    defaultDose: "1-2 Tablets", 
    defaultFreq: "QDS (Four times / day)", 
    defaultDuration: "Short-term (PRN)", 
    indication: "Moderate to severe acute pain", 
    category: "Analgesics (Combination)",
    info: "Weak opioid plus non-opioid analgesic.",
    sideEffects: "Nausea, dizziness, somnolence, constipation.",
    contraindications: "Severe respiratory depression, acute intoxication with alcohol/hypnotics."
  },
  { 
    name: "Dextromethorphan + Guaifenesin Syrup (Cough Suppressant & Expectorant)", 
    defaultDose: "10 ml", 
    defaultFreq: "QDS (Four times / day)", 
    defaultDuration: "5-7 days", 
    indication: "Chesty cough with tickly throat", 
    category: "Cough & Cold (Combination)",
    info: "Combination antitussive and expectorant syrup.",
    sideEffects: "Dizziness, GI disturbance.",
    contraindications: "Chronic persistent cough (e.g., asthma), concurrent MAOI use."
  },
  { 
    name: "Salbutamol + Guaifenesin Syrup (Bronchodilator & Expectorant)", 
    defaultDose: "5-10 ml", 
    defaultFreq: "TDS (Three times / day)", 
    defaultDuration: "5-7 days", 
    indication: "Bronchospasm with productive cough (Asthma, Bronchitis)", 
    category: "Respiratory (Combination)",
    info: "Opens airways and loosens mucus.",
    sideEffects: "Fine tremor, tachycardia, palpitations.",
    contraindications: "Severe cardiovascular disease."
  },
  { 
    name: "Diphenhydramine + Ammonium Chloride Syrup (Benylin / Expectorant)", 
    defaultDose: "10 ml", 
    defaultFreq: "QDS (Four times / day)", 
    defaultDuration: "5 days", 
    indication: "Productive cough associated with allergies/cold", 
    category: "Cough & Cold (Combination)",
    info: "Sedating antihistamine plus expectorant.",
    sideEffects: "Drowsiness, dry mouth, blurred vision.",
    contraindications: "Glaucoma, urinary retention."
  },
  { 
    name: "Amlodipine 5mg + Valsartan 80mg Tablet (Exforge)", 
    defaultDose: "1 Tablet", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Essential Hypertension (not controlled on monotherapy)", 
    category: "Cardiovascular (Combination)",
    info: "CCB plus ARB combination.",
    sideEffects: "Peripheral edema, dizziness, headache.",
    contraindications: "Pregnancy, severe hepatic impairment, severe hypotension."
  },
  { 
    name: "Valsartan 80mg + Hydrochlorothiazide 12.5mg Tablet (Co-Diovan)", 
    defaultDose: "1 Tablet", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Essential Hypertension", 
    category: "Cardiovascular (Combination)",
    info: "ARB plus Thiazide diuretic.",
    sideEffects: "Dizziness, hypokalemia, hyperuricemia.",
    contraindications: "Pregnancy, anuria, severe hepatic/renal impairment."
  },
  { 
    name: "Bisoprolol 5mg + Hydrochlorothiazide 6.25mg Tablet (Ziac / Concor Plus)", 
    defaultDose: "1 Tablet", 
    defaultFreq: "OD (Once daily in the morning)", 
    defaultDuration: "Chronic", 
    indication: "Essential Hypertension", 
    category: "Cardiovascular (Combination)",
    info: "Beta-blocker plus Thiazide diuretic.",
    sideEffects: "Fatigue, bradycardia, cold extremities.",
    contraindications: "Asthma, severe bradycardia, cardiogenic shock."
  },
  { 
    name: "Sitagliptin 50mg + Metformin 1000mg Tablet (Janumet)", 
    defaultDose: "1 Tablet", 
    defaultFreq: "BD (Twice daily with meals)", 
    defaultDuration: "Chronic", 
    indication: "Type 2 Diabetes Mellitus", 
    category: "Endocrinology (Combination)",
    info: "DPP-4 inhibitor plus Biguanide. Take with meals to reduce GI upset.",
    sideEffects: "Nausea, diarrhea, hypoglycemia (rare on its own).",
    contraindications: "Severe renal impairment (eGFR < 30), metabolic acidosis."
  },
  { 
    name: "Ezetimibe 10mg + Simvastatin 20mg Tablet (Vytorin)", 
    defaultDose: "1 Tablet", 
    defaultFreq: "ON (At night)", 
    defaultDuration: "Chronic", 
    indication: "Primary Hypercholesterolemia", 
    category: "Cardiovascular (Combination)",
    info: "Cholesterol absorption inhibitor plus Statin.",
    sideEffects: "Myalgia, elevated hepatic enzymes, headache.",
    contraindications: "Active liver disease, pregnancy, concurrent use of strong CYP3A4 inhibitors."
  },
  { 
    name: "Levodopa + Carbidopa 250mg/25mg Tablet (Sinemet)", 
    defaultDose: "1 Tablet", 
    defaultFreq: "TDS (Three times / day)", 
    defaultDuration: "Chronic", 
    indication: "Parkinson's Disease", 
    category: "Neurology (Combination)",
    info: "Dopamine precursor plus decarboxylase inhibitor. Dose titrated slowly.",
    sideEffects: "Nausea, dyskinesia, orthostatic hypotension, hallucinations.",
    contraindications: "Narrow-angle glaucoma, concurrent non-selective MAOI use."
  },
  // ==========================================
  // CHAPTER: HYPERTENSION & DIABETES (أدوية الضغط والسكر - حبوب وإبر)
  // ==========================================
  { 
    name: "Metformin 500mg Tablet (Glucophage)", 
    defaultDose: "500 mg", 
    defaultFreq: "BD (Twice daily with meals)", 
    defaultDuration: "Chronic", 
    indication: "Type 2 Diabetes Mellitus, PCOS", 
    category: "Endocrinology (Diabetes)",
    info: "First-line oral antidiabetic. Take with food to reduce GI upset.",
    sideEffects: "Nausea, diarrhea, metallic taste, B12 deficiency.",
    contraindications: "Severe renal impairment (eGFR < 30), metabolic acidosis."
  },
  { 
    name: "Glimepiride 2mg Tablet (Amaryl)", 
    defaultDose: "2 mg", 
    defaultFreq: "OD (Once daily before breakfast)", 
    defaultDuration: "Chronic", 
    indication: "Type 2 Diabetes Mellitus", 
    category: "Endocrinology (Diabetes)",
    info: "Sulfonylurea. Stimulates insulin release.",
    sideEffects: "Hypoglycemia, weight gain.",
    contraindications: "Type 1 Diabetes, DKA, severe hepatic/renal impairment."
  },
  { 
    name: "Gliclazide 60mg MR Tablet (Diamicron MR)", 
    defaultDose: "60 mg", 
    defaultFreq: "OD (Once daily before breakfast)", 
    defaultDuration: "Chronic", 
    indication: "Type 2 Diabetes Mellitus", 
    category: "Endocrinology (Diabetes)",
    info: "Modified release sulfonylurea.",
    sideEffects: "Hypoglycemia, weight gain.",
    contraindications: "Type 1 Diabetes, DKA, severe renal/hepatic impairment."
  },
  { 
    name: "Sitagliptin 100mg Tablet (Januvia)", 
    defaultDose: "100 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Type 2 Diabetes Mellitus", 
    category: "Endocrinology (Diabetes)",
    info: "DPP-4 inhibitor. Weight-neutral.",
    sideEffects: "Headache, nasopharyngitis.",
    contraindications: "Type 1 Diabetes, DKA."
  },
  { 
    name: "Empagliflozin 10mg Tablet (Jardiance)", 
    defaultDose: "10 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Type 2 Diabetes Mellitus, Heart Failure", 
    category: "Endocrinology (Diabetes)",
    info: "SGLT2 inhibitor. Offers cardiovascular and renal protection.",
    sideEffects: "Genital mycotic infections, UTIs, polyuria.",
    contraindications: "Severe renal impairment (eGFR < 20)."
  },
  { 
    name: "Semaglutide 1mg SC Injection (Ozempic)", 
    defaultDose: "1 mg", 
    defaultFreq: "Once weekly", 
    defaultDuration: "Chronic", 
    indication: "Type 2 Diabetes Mellitus, Weight management", 
    category: "Endocrinology (Diabetes Injections)",
    info: "GLP-1 receptor agonist. Pre-filled pen. Administer Subcutaneously.",
    sideEffects: "Nausea, vomiting, diarrhea, weight loss.",
    contraindications: "Personal/family history of medullary thyroid carcinoma."
  },
  { 
    name: "Insulin Glargine 100 U/ml SC Injection (Lantus)", 
    defaultDose: "Individualized", 
    defaultFreq: "ON (At night)", 
    defaultDuration: "Chronic", 
    indication: "Type 1 & Type 2 Diabetes Mellitus", 
    category: "Endocrinology (Diabetes Injections)",
    info: "Long-acting basal insulin. Does not have a pronounced peak.",
    sideEffects: "Hypoglycemia, weight gain, lipohypertrophy.",
    contraindications: "Episodes of hypoglycemia."
  },
  { 
    name: "Insulin Aspart 100 U/ml SC Injection (NovoRapid)", 
    defaultDose: "Individualized", 
    defaultFreq: "TDS (Before meals)", 
    defaultDuration: "Chronic", 
    indication: "Type 1 & Type 2 Diabetes Mellitus", 
    category: "Endocrinology (Diabetes Injections)",
    info: "Rapid-acting prandial insulin. Inject 10-15 mins before meals.",
    sideEffects: "Hypoglycemia, weight gain, lipohypertrophy.",
    contraindications: "Episodes of hypoglycemia."
  },
  { 
    name: "Biphasic Insulin Aspart 30/70 SC Injection (NovoMix 30)", 
    defaultDose: "Individualized", 
    defaultFreq: "BD (Twice daily before meals)", 
    defaultDuration: "Chronic", 
    indication: "Type 1 & Type 2 Diabetes Mellitus", 
    category: "Endocrinology (Diabetes Injections)",
    info: "Premixed insulin (30% rapid, 70% intermediate).",
    sideEffects: "Hypoglycemia, weight gain.",
    contraindications: "Episodes of hypoglycemia."
  },
  { 
    name: "Amlodipine 5mg Tablet (Norvasc)", 
    defaultDose: "5 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Hypertension, Angina", 
    category: "Cardiovascular (Hypertension)",
    info: "Calcium channel blocker (CCB).",
    sideEffects: "Peripheral edema, dizziness, flushing, palpitations.",
    contraindications: "Severe hypotension, shock."
  },
  { 
    name: "Lisinopril 10mg Tablet (Zestril)", 
    defaultDose: "10 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Hypertension, Heart Failure, Diabetic Nephropathy", 
    category: "Cardiovascular (Hypertension)",
    info: "ACE inhibitor. Renoprotective.",
    sideEffects: "Dry cough, hyperkalemia, dizziness.",
    contraindications: "Pregnancy, history of angioedema."
  },
  { 
    name: "Valsartan 80mg Tablet (Diovan)", 
    defaultDose: "80 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Hypertension, Heart Failure", 
    category: "Cardiovascular (Hypertension)",
    info: "Angiotensin II Receptor Blocker (ARB). Good alternative if ACEi causes cough.",
    sideEffects: "Dizziness, hyperkalemia.",
    contraindications: "Pregnancy, severe hepatic impairment."
  },
  { 
    name: "Bisoprolol 5mg Tablet (Concor)", 
    defaultDose: "5 mg", 
    defaultFreq: "OD (Once daily in the morning)", 
    defaultDuration: "Chronic", 
    indication: "Hypertension, Angina, Heart Failure", 
    category: "Cardiovascular (Hypertension)",
    info: "Cardioselective beta-blocker.",
    sideEffects: "Fatigue, bradycardia, cold extremities.",
    contraindications: "Asthma, severe bradycardia, cardiogenic shock."
  },
  { 
    name: "Furosemide 40mg Tablet (Lasix)", 
    defaultDose: "40 mg", 
    defaultFreq: "OD (Once daily in the morning)", 
    defaultDuration: "Chronic", 
    indication: "Edema, Heart Failure, Resistant Hypertension", 
    category: "Cardiovascular (Hypertension)",
    info: "Loop diuretic. Take in the morning to avoid nocturia.",
    sideEffects: "Hypokalemia, dehydration, hypotension.",
    contraindications: "Anuria, severe hypokalemia/hyponatremia."
  },
  { 
    name: "Furosemide 20mg/2ml IM/IV Injection (Lasix)", 
    defaultDose: "20-40 mg", 
    defaultFreq: "STAT (or as prescribed)", 
    defaultDuration: "PRN", 
    indication: "Acute pulmonary edema, severe fluid overload", 
    category: "Cardiovascular (Hypertension Injections)",
    info: "Loop diuretic injection. Push slowly IV.",
    sideEffects: "Hypotension, electrolyte imbalance.",
    contraindications: "Anuria, severe volume depletion."
  },
  { 
    name: "Spironolactone 25mg Tablet (Aldactone)", 
    defaultDose: "25 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Heart Failure, Ascites, Resistant Hypertension", 
    category: "Cardiovascular (Hypertension)",
    info: "Potassium-sparing diuretic / Aldosterone antagonist.",
    sideEffects: "Hyperkalemia, gynecomastia in males.",
    contraindications: "Hyperkalemia, Addison's disease, severe renal impairment."
  },
  { 
    name: "Methyldopa 250mg Tablet (Aldomet)", 
    defaultDose: "250 mg", 
    defaultFreq: "BD or TDS", 
    defaultDuration: "Chronic (during pregnancy)", 
    indication: "Pregnancy-induced Hypertension", 
    category: "Cardiovascular (Hypertension)",
    info: "Centrally acting alpha-2 agonist. Safe in pregnancy.",
    sideEffects: "Drowsiness, dry mouth, positive Coombs test.",
    contraindications: "Active liver disease, depression."
  },
  { 
    name: "Hydralazine 20mg/ml Injection", 
    defaultDose: "5-10 mg", 
    defaultFreq: "STAT (Slow IV)", 
    defaultDuration: "PRN", 
    indication: "Hypertensive Emergencies (esp. Eclampsia)", 
    category: "Cardiovascular (Hypertension Injections)",
    info: "Direct vasodilator. Given by slow IV injection.",
    sideEffects: "Tachycardia, flushing, headache.",
    contraindications: "SLE (Systemic Lupus Erythematosus), severe tachycardia."
  },
  // ==========================================
  // CHAPTER: HYPERTENSION (ADDITIONAL MEDICATIONS) - أدوية إضافية للضغط
  // ==========================================
  { 
    name: "Losartan 50mg Tablet (Cozaar)", 
    defaultDose: "50 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Hypertension, Diabetic Nephropathy", 
    category: "Cardiovascular (Hypertension)",
    info: "Angiotensin II Receptor Blocker (ARB).",
    sideEffects: "Dizziness, hyperkalemia.",
    contraindications: "Pregnancy, severe hepatic impairment."
  },
  { 
    name: "Candesartan 8mg Tablet (Atacand)", 
    defaultDose: "8 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Hypertension, Heart Failure", 
    category: "Cardiovascular (Hypertension)",
    info: "Angiotensin II Receptor Blocker (ARB).",
    sideEffects: "Dizziness, hyperkalemia.",
    contraindications: "Pregnancy, severe hepatic impairment."
  },
  { 
    name: "Telmisartan 40mg Tablet (Micardis)", 
    defaultDose: "40 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Hypertension, Cardiovascular risk reduction", 
    category: "Cardiovascular (Hypertension)",
    info: "Angiotensin II Receptor Blocker (ARB) with long half-life.",
    sideEffects: "Dizziness, hyperkalemia.",
    contraindications: "Pregnancy, severe hepatic impairment, biliary obstructive disorders."
  },
  { 
    name: "Enalapril 5mg Tablet (Renitec)", 
    defaultDose: "5 mg", 
    defaultFreq: "OD or BD", 
    defaultDuration: "Chronic", 
    indication: "Hypertension, Heart Failure", 
    category: "Cardiovascular (Hypertension)",
    info: "ACE inhibitor.",
    sideEffects: "Dry cough, hyperkalemia, angioedema.",
    contraindications: "Pregnancy, history of angioedema."
  },
  { 
    name: "Ramipril 5mg Tablet (Tritace)", 
    defaultDose: "5 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Hypertension, Post-MI, Nephropathy", 
    category: "Cardiovascular (Hypertension)",
    info: "ACE inhibitor.",
    sideEffects: "Dry cough, hyperkalemia, dizziness.",
    contraindications: "Pregnancy, history of angioedema."
  },
  { 
    name: "Captopril 25mg Tablet (Capoten)", 
    defaultDose: "25 mg", 
    defaultFreq: "BD or TDS", 
    defaultDuration: "Chronic", 
    indication: "Hypertension, Heart Failure", 
    category: "Cardiovascular (Hypertension)",
    info: "Short-acting ACE inhibitor. Can be used sublingually in emergencies.",
    sideEffects: "Dry cough, hyperkalemia, taste disturbance.",
    contraindications: "Pregnancy, history of angioedema."
  },
  { 
    name: "Nifedipine 30mg MR Tablet (Adalat LA)", 
    defaultDose: "30 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Hypertension, Angina, Raynaud's phenomenon", 
    category: "Cardiovascular (Hypertension)",
    info: "Calcium Channel Blocker (Dihydropyridine). Modified release.",
    sideEffects: "Peripheral edema, flushing, headache, gingival hyperplasia.",
    contraindications: "Cardiogenic shock, unstable angina."
  },
  { 
    name: "Diltiazem 90mg MR Tablet (Cardizem)", 
    defaultDose: "90 mg", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "Chronic", 
    indication: "Hypertension, Angina", 
    category: "Cardiovascular (Hypertension)",
    info: "Calcium Channel Blocker (Non-dihydropyridine). Slows heart rate.",
    sideEffects: "Bradycardia, constipation, peripheral edema.",
    contraindications: "Heart block, sick sinus syndrome, severe heart failure."
  },
  { 
    name: "Verapamil 80mg Tablet (Isoptin)", 
    defaultDose: "80 mg", 
    defaultFreq: "TDS (Three times / day)", 
    defaultDuration: "Chronic", 
    indication: "Hypertension, Angina, Supraventricular Tachyarrhythmias", 
    category: "Cardiovascular (Hypertension)",
    info: "Calcium Channel Blocker (Non-dihydropyridine). Strong negative inotrope.",
    sideEffects: "Constipation, bradycardia, hypotension.",
    contraindications: "Heart block, heart failure, concurrent use with beta-blockers."
  },
  { 
    name: "Atenolol 50mg Tablet (Tenormin)", 
    defaultDose: "50 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Hypertension, Angina", 
    category: "Cardiovascular (Hypertension)",
    info: "Cardioselective beta-blocker.",
    sideEffects: "Fatigue, cold extremities, bradycardia.",
    contraindications: "Asthma, severe bradycardia, heart block."
  },
  { 
    name: "Metoprolol 50mg Tablet (Betaloc / Lopressor)", 
    defaultDose: "50 mg", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "Chronic", 
    indication: "Hypertension, Angina, Post-MI, Arrhythmias", 
    category: "Cardiovascular (Hypertension)",
    info: "Cardioselective beta-blocker.",
    sideEffects: "Fatigue, cold extremities, bradycardia.",
    contraindications: "Asthma, severe bradycardia, heart block."
  },
  { 
    name: "Carvedilol 6.25mg Tablet (Dilatrend)", 
    defaultDose: "6.25 mg", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "Chronic", 
    indication: "Heart Failure, Hypertension", 
    category: "Cardiovascular (Hypertension)",
    info: "Non-selective beta-blocker with alpha-1 blocking activity.",
    sideEffects: "Dizziness, fatigue, hypotension, weight gain.",
    contraindications: "Asthma, severe bradycardia, heart block, severe hepatic impairment."
  },
  { 
    name: "Indapamide 1.5mg SR Tablet (Natrilix SR)", 
    defaultDose: "1.5 mg", 
    defaultFreq: "OD (Once daily in the morning)", 
    defaultDuration: "Chronic", 
    indication: "Essential Hypertension", 
    category: "Cardiovascular (Hypertension)",
    info: "Thiazide-like diuretic.",
    sideEffects: "Hypokalemia, hyponatremia, hyperuricemia.",
    contraindications: "Severe hepatic impairment, severe renal failure, hypokalemia."
  },
  { 
    name: "Doxazosin 2mg Tablet (Cardura)", 
    defaultDose: "2 mg", 
    defaultFreq: "ON (At night)", 
    defaultDuration: "Chronic", 
    indication: "Hypertension, Benign Prostatic Hyperplasia (BPH)", 
    category: "Cardiovascular (Hypertension)",
    info: "Alpha-1 blocker. Take first dose at bedtime to avoid syncope.",
    sideEffects: "Postural hypotension, dizziness, drowsiness.",
    contraindications: "History of postural hypotension."
  },
  { 
    name: "Clonidine 0.15mg Tablet (Catapres)", 
    defaultDose: "0.15 mg", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "Chronic", 
    indication: "Hypertension (usually resistant), Menopausal flushing", 
    category: "Cardiovascular (Hypertension)",
    info: "Centrally acting alpha-2 agonist. Do not stop abruptly (rebound hypertension).",
    sideEffects: "Dry mouth, sedation, constipation.",
    contraindications: "Severe bradyarrhythmia."
  },
  // ==========================================
  // CHAPTER: PERINDOPRIL & COMBINATIONS (عائلة كوفيرسيل - Coversyl Group)
  // ==========================================
  { 
    name: "Perindopril 5mg Tablet (Coversyl)", 
    defaultDose: "5 mg", 
    defaultFreq: "OD (Once daily in the morning)", 
    defaultDuration: "Chronic", 
    indication: "Hypertension, Heart Failure, Stable Coronary Artery Disease", 
    category: "Cardiovascular (Hypertension)",
    info: "Long-acting ACE inhibitor.",
    sideEffects: "Dry cough, dizziness, hyperkalemia.",
    contraindications: "Pregnancy, history of angioedema."
  },
  { 
    name: "Perindopril 10mg Tablet (Coversyl)", 
    defaultDose: "10 mg", 
    defaultFreq: "OD (Once daily in the morning)", 
    defaultDuration: "Chronic", 
    indication: "Hypertension, Stable Coronary Artery Disease", 
    category: "Cardiovascular (Hypertension)",
    info: "Long-acting ACE inhibitor (higher dose).",
    sideEffects: "Dry cough, dizziness, hyperkalemia.",
    contraindications: "Pregnancy, history of angioedema."
  },
  { 
    name: "Perindopril 5mg + Indapamide 1.25mg Tablet (Coversyl Plus / Preterax)", 
    defaultDose: "1 Tablet", 
    defaultFreq: "OD (Once daily in the morning)", 
    defaultDuration: "Chronic", 
    indication: "Essential Hypertension", 
    category: "Cardiovascular (Hypertension)",
    info: "ACE inhibitor + Thiazide-like diuretic combination.",
    sideEffects: "Dry cough, hypokalemia, hypotension.",
    contraindications: "Pregnancy, severe renal impairment, severe hepatic impairment."
  },
  { 
    name: "Perindopril 10mg + Indapamide 2.5mg Tablet (Coversyl Plus / Preterax)", 
    defaultDose: "1 Tablet", 
    defaultFreq: "OD (Once daily in the morning)", 
    defaultDuration: "Chronic", 
    indication: "Essential Hypertension", 
    category: "Cardiovascular (Hypertension)",
    info: "High dose ACE inhibitor + Diuretic combination.",
    sideEffects: "Dry cough, hypokalemia, hypotension.",
    contraindications: "Pregnancy, severe renal impairment, severe hepatic impairment."
  },
  { 
    name: "Perindopril 5mg + Amlodipine 5mg Tablet (Coveram 5/5)", 
    defaultDose: "1 Tablet", 
    defaultFreq: "OD (Once daily in the morning)", 
    defaultDuration: "Chronic", 
    indication: "Hypertension, Stable Coronary Artery Disease", 
    category: "Cardiovascular (Hypertension)",
    info: "ACE inhibitor + Calcium Channel Blocker combination.",
    sideEffects: "Peripheral edema, dry cough, dizziness.",
    contraindications: "Pregnancy, severe hypotension, history of angioedema."
  },
  { 
    name: "Perindopril 10mg + Amlodipine 10mg Tablet (Coveram 10/10)", 
    defaultDose: "1 Tablet", 
    defaultFreq: "OD (Once daily in the morning)", 
    defaultDuration: "Chronic", 
    indication: "Hypertension, Stable Coronary Artery Disease", 
    category: "Cardiovascular (Hypertension)",
    info: "High dose ACE inhibitor + Calcium Channel Blocker combination.",
    sideEffects: "Peripheral edema, dry cough, dizziness.",
    contraindications: "Pregnancy, severe hypotension, history of angioedema."
  },
  { 
    name: "Perindopril 5mg + Indapamide 1.25mg + Amlodipine 5mg Tablet (Triplixam)", 
    defaultDose: "1 Tablet", 
    defaultFreq: "OD (Once daily in the morning)", 
    defaultDuration: "Chronic", 
    indication: "Hypertension (Replacement therapy)", 
    category: "Cardiovascular (Hypertension)",
    info: "Triple combination: ACEi + Diuretic + CCB.",
    sideEffects: "Hypotension, dry cough, peripheral edema, hypokalemia.",
    contraindications: "Pregnancy, severe renal/hepatic impairment, severe hypotension."
  },
  // ==========================================
  // CHAPTER: ORAL & DENTAL CARE (أدوية وتقرحات وغسول الفم - للكبار والأطفال)
  // ==========================================
  { 
    name: "Miconazole 2% Oral Gel (Daktarin Oral Gel)", 
    defaultDose: "1/4 to 1/2 measuring spoon", 
    defaultFreq: "QDS (Four times / day)", 
    defaultDuration: "7-14 days", 
    indication: "Oral candidiasis (Thrush) in infants, children, and adults", 
    category: "Oral & Dental (Antifungal)",
    info: "Keep gel in mouth as long as possible before swallowing. Avoid feeding immediately after.",
    sideEffects: "Nausea, vomiting, dry mouth.",
    contraindications: "Infants less than 4 months of age (choking risk), liver dysfunction."
  },
  { 
    name: "Nystatin 100,000 IU/ml Oral Suspension (Mycostatin)", 
    defaultDose: "1 ml (Infants) to 4-6 ml (Adults)", 
    defaultFreq: "QDS (Four times / day)", 
    defaultDuration: "7-14 days", 
    indication: "Oral candidiasis (Thrush)", 
    category: "Oral & Dental (Antifungal)",
    info: "Swish and swallow (or paint inside the mouth for infants).",
    sideEffects: "GI distress, nausea.",
    contraindications: "Hypersensitivity."
  },
  { 
    name: "Choline Salicylate + Cetalkonium Chloride Gel (Bonjela / Mundisal)", 
    defaultDose: "Small pea-sized amount", 
    defaultFreq: "TDS to QDS (Max 6 times/day)", 
    defaultDuration: "PRN", 
    indication: "Mouth ulcers, denture sores", 
    category: "Oral & Dental (Analgesic)",
    info: "Rub gently onto the sore area. (Note: standard Bonjela contains salicylate; infant versions differ).",
    sideEffects: "Transient stinging.",
    contraindications: "Children under 16 years (for salicylate-containing formulations due to Reye's syndrome risk)."
  },
  { 
    name: "Lidocaine 2% + Cetylpyridinium Chloride Gel/Spray (Xylocaine / Kamistad)", 
    defaultDose: "Apply small amount to affected area", 
    defaultFreq: "TDS (Three times / day)", 
    defaultDuration: "PRN", 
    indication: "Painful mouth ulcers, teething, sore gums", 
    category: "Oral & Dental (Local Anesthetic)",
    info: "Topical anesthetic. Do not use excessively to avoid numbness of throat and choking.",
    sideEffects: "Numbness, mild stinging.",
    contraindications: "Hypersensitivity to local anesthetics."
  },
  { 
    name: "Triamcinolone Acetonide 0.1% Dental Paste (Kenalog in Orabase)", 
    defaultDose: "Apply thin layer (do not rub in)", 
    defaultFreq: "BD to TDS (preferably after meals & at bedtime)", 
    defaultDuration: "3-5 days", 
    indication: "Severe aphthous ulcers (canker sores), stomatitis", 
    category: "Oral & Dental (Corticosteroid)",
    info: "Press a small dab to the lesion until a thin film develops. Do not rub.",
    sideEffects: "Local irritation, opportunistic fungal infection.",
    contraindications: "Viral, fungal, or bacterial infections of the mouth."
  },
  { 
    name: "Hyaluronic Acid 0.2% Gel/Spray/Mouthwash (Gengigel)", 
    defaultDose: "Apply to gums/ulcers or rinse", 
    defaultFreq: "TDS to QDS (Three to four times / day)", 
    defaultDuration: "Until healed", 
    indication: "Gingivitis, mouth ulcers, receding gums", 
    category: "Oral & Dental (Healing Agent)",
    info: "Promotes tissue healing and reduces inflammation. Safe for all ages including infants.",
    sideEffects: "Rarely any side effects.",
    contraindications: "None known."
  },
  { 
    name: "Chlorhexidine Gluconate 0.2% Mouthwash (Corsodyl / Kin)", 
    defaultDose: "10 ml", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "Up to 2-4 weeks", 
    indication: "Gingivitis, post-dental surgery, severe oral ulcers", 
    category: "Oral & Dental (Antiseptic Mouthwash)",
    info: "Rinse mouth for 1 minute and spit. Do not swallow. Wait 30 mins after brushing teeth before use.",
    sideEffects: "Brown staining of teeth/tongue, altered taste.",
    contraindications: "Hypersensitivity."
  },
  { 
    name: "Benzydamine 0.15% Mouthwash or Oral Spray (Difflam / Tantum Verde)", 
    defaultDose: "15 ml (rinse) or 4-8 sprays", 
    defaultFreq: "TDS to QDS (Every 1.5 to 3 hours PRN)", 
    defaultDuration: "Up to 7 days", 
    indication: "Pain and inflammation in mouth/throat, pharyngitis, ulcers", 
    category: "Oral & Dental (NSAID/Analgesic)",
    info: "Anti-inflammatory and locally acting analgesic.",
    sideEffects: "Numbness or stinging in mouth/throat.",
    contraindications: "Hypersensitivity to NSAIDs."
  },
  { 
    name: "Hexetidine 0.1% Mouthwash (Oraldene)", 
    defaultDose: "15 ml", 
    defaultFreq: "BD to TDS", 
    defaultDuration: "Up to 7 days", 
    indication: "Minor oral infections, gingivitis, aphthous ulcers", 
    category: "Oral & Dental (Antiseptic Mouthwash)",
    info: "Rinse or gargle for 30 seconds and spit out.",
    sideEffects: "Taste alteration, local irritation.",
    contraindications: "Children under 6 years."
  },
  { 
    name: "Povidone-Iodine 1% Mouthwash/Gargle (Betadine Gargle)", 
    defaultDose: "10 ml (diluted or undiluted)", 
    defaultFreq: "QDS (Four times / day)", 
    defaultDuration: "Up to 14 days", 
    indication: "Oral and pharyngeal infections, routine oral hygiene", 
    category: "Oral & Dental (Antiseptic Mouthwash)",
    info: "Gargle/rinse for 30 seconds. Do not swallow.",
    sideEffects: "Local irritation, iodine absorption if prolonged use.",
    contraindications: "Thyroid disorders, children under 6 years, pregnancy/lactation."
  },
  // ==========================================
  // CHAPTER: H. PYLORI ERADICATION KITS (أدوية جرثومة المعدة الثلاثية والرباعية)
  // ==========================================
  { 
    name: "Omeprazole + Clarithromycin + Amoxicillin Kit (Triple Therapy - e.g., Pepticare / Heligo)", 
    defaultDose: "1 Blister Strip (PPI + 2 Antibiotics)", 
    defaultFreq: "BD (Twice daily, morning and evening)", 
    defaultDuration: "14 days", 
    indication: "Helicobacter Pylori Eradication", 
    category: "Gastroenterology (H. Pylori Kit)",
    info: "Standard triple therapy kit containing a PPI and two antibiotics. Take the antibiotics after food.",
    sideEffects: "Diarrhea, metallic taste, nausea, abdominal pain.",
    contraindications: "Penicillin allergy, severe hepatic impairment, concurrent use with certain statins (due to Clarithromycin)."
  },
  { 
    name: "Lansoprazole + Clarithromycin + Amoxicillin Kit (Prevpac / Klacid HP7)", 
    defaultDose: "1 Blister Strip (PPI + 2 Antibiotics)", 
    defaultFreq: "BD (Twice daily, morning and evening)", 
    defaultDuration: "14 days", 
    indication: "Helicobacter Pylori Eradication", 
    category: "Gastroenterology (H. Pylori Kit)",
    info: "Alternative triple therapy kit. Lansoprazole acts as the PPI.",
    sideEffects: "Diarrhea, metallic taste, nausea, abdominal pain.",
    contraindications: "Penicillin allergy, severe hepatic impairment."
  },
  { 
    name: "Esomeprazole + Clarithromycin + Amoxicillin Kit (Nexium HP7)", 
    defaultDose: "1 Blister Strip (PPI + 2 Antibiotics)", 
    defaultFreq: "BD (Twice daily, morning and evening)", 
    defaultDuration: "14 days", 
    indication: "Helicobacter Pylori Eradication", 
    category: "Gastroenterology (H. Pylori Kit)",
    info: "Triple therapy kit using Esomeprazole for stronger acid suppression.",
    sideEffects: "Diarrhea, metallic taste, nausea.",
    contraindications: "Penicillin allergy, severe hepatic impairment."
  },
  { 
    name: "Bismuth subcitrate + Metronidazole + Tetracycline Capsule (Pylera - Quadruple Therapy)", 
    defaultDose: "3 Capsules", 
    defaultFreq: "QDS (Four times / day after meals and at bedtime)", 
    defaultDuration: "10-14 days", 
    indication: "Helicobacter Pylori Eradication (often used if triple therapy fails)", 
    category: "Gastroenterology (H. Pylori Kit)",
    info: "Quadruple therapy. Must be taken with a separate PPI (e.g., Omeprazole BD). Do not consume dairy with it.",
    sideEffects: "Black stools, dark tongue, nausea, diarrhea, metallic taste.",
    contraindications: "Pregnancy, children under 12, severe renal/hepatic impairment."
  },
  { 
    name: "Pantoprazole + Metronidazole + Clarithromycin Kit", 
    defaultDose: "1 Blister Strip (PPI + 2 Antibiotics)", 
    defaultFreq: "BD (Twice daily, morning and evening)", 
    defaultDuration: "14 days", 
    indication: "Helicobacter Pylori Eradication (in patients with Penicillin allergy)", 
    category: "Gastroenterology (H. Pylori Kit)",
    info: "Common alternative for penicillin-allergic patients (replaces Amoxicillin with Metronidazole).",
    sideEffects: "Metallic taste, nausea, diarrhea, abdominal cramps.",
    contraindications: "Alcohol consumption (due to Metronidazole), severe hepatic impairment."
  },
  { 
    name: "Omeprazole + Amoxicillin + Rifabutin Capsule (Talicia)", 
    defaultDose: "4 Capsules", 
    defaultFreq: "TDS (Three times / day with food)", 
    defaultDuration: "14 days", 
    indication: "Helicobacter Pylori Eradication (Rescue/Resistant therapy)", 
    category: "Gastroenterology (H. Pylori Kit)",
    info: "New combination therapy (Rifabutin-based) for resistant H. Pylori strains.",
    sideEffects: "Chromaturia (red/orange urine), diarrhea, headache, nausea.",
    contraindications: "Penicillin allergy, concurrent use with certain antivirals (e.g. delavirdine)."
  },
  { 
    name: "Rifabutin 150mg Capsule (Mycobutin)", 
    defaultDose: "150 mg", 
    defaultFreq: "BD (Twice daily)", 
    defaultDuration: "14 days", 
    indication: "Refractory Helicobacter Pylori Eradication (used with PPI + Amoxicillin)", 
    category: "Gastroenterology (H. Pylori)",
    info: "Used off-label in triple therapy for resistant H. Pylori. Also used for MAC prophylaxis.",
    sideEffects: "Red-orange discoloration of urine/tears, uveitis, neutropenia.",
    contraindications: "Hypersensitivity to rifamycins."
  },
  // ==========================================
  // CHAPTER: VITAMINS & MINERALS (الفيتامينات والمعادن)
  // ==========================================
  { 
    name: "Vitamin D3 400 IU/Drop Oral Drops (Vidrop)", 
    defaultDose: "1-4 Drops", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic (or as prescribed)", 
    indication: "Vitamin D Deficiency (Prophylaxis/Treatment in infants and children)", 
    category: "Vitamins & Minerals",
    info: "Essential for calcium absorption and bone health. Can be mixed with milk or juice.",
    sideEffects: "Hypercalcemia (rarely if overused).",
    contraindications: "Hypercalcemia, hypercalciuria."
  },
  { 
    name: "Vitamin D3 1000 IU Tablet/Capsule", 
    defaultDose: "1 Tablet/Capsule", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Vitamin D Deficiency Prophylaxis", 
    category: "Vitamins & Minerals",
    info: "Daily maintenance dose for adults. Take with a fat-containing meal for better absorption.",
    sideEffects: "Rarely any at this dose.",
    contraindications: "Hypercalcemia."
  },
  { 
    name: "Vitamin D3 5000 IU Tablet/Capsule", 
    defaultDose: "1 Tablet/Capsule", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "8-12 weeks", 
    indication: "Mild Vitamin D Deficiency", 
    category: "Vitamins & Minerals",
    info: "Take with a fat-containing meal.",
    sideEffects: "Rarely any.",
    contraindications: "Hypercalcemia."
  },
  { 
    name: "Vitamin D3 10,000 IU Tablet/Capsule", 
    defaultDose: "1 Tablet/Capsule", 
    defaultFreq: "OD (Once daily) or Twice Weekly", 
    defaultDuration: "8-12 weeks", 
    indication: "Moderate Vitamin D Deficiency", 
    category: "Vitamins & Minerals",
    info: "Take with a fat-containing meal.",
    sideEffects: "Rarely any.",
    contraindications: "Hypercalcemia."
  },
  { 
    name: "Vitamin D3 50,000 IU Capsule", 
    defaultDose: "1 Capsule", 
    defaultFreq: "Once weekly", 
    defaultDuration: "8 weeks", 
    indication: "Severe Vitamin D Deficiency", 
    category: "Vitamins & Minerals",
    info: "High-dose loading therapy. Follow up with maintenance dose after 8 weeks.",
    sideEffects: "Toxicity risk if taken daily by mistake (Hypercalcemia).",
    contraindications: "Hypercalcemia, hypervitaminosis D."
  },
  { 
    name: "Vitamin D3 200,000 IU / 300,000 IU IM Injection", 
    defaultDose: "1 Ampoule", 
    defaultFreq: "STAT", 
    defaultDuration: "Once (may repeat after 3-6 months)", 
    indication: "Severe Vitamin D Deficiency / Malabsorption", 
    category: "Vitamins & Minerals (Injections)",
    info: "Deep Intramuscular injection.",
    sideEffects: "Injection site pain, risk of hypercalcemia.",
    contraindications: "Hypercalcemia."
  },
  { 
    name: "Vitamin B Complex Tablet (Neurobion / Neurovit)", 
    defaultDose: "1 Tablet", 
    defaultFreq: "OD to TDS", 
    defaultDuration: "1-3 months", 
    indication: "Neuropathy, B-Vitamin Deficiency, General fatigue", 
    category: "Vitamins & Minerals",
    info: "Contains B1 (Thiamine), B6 (Pyridoxine), B12 (Cyanocobalamin).",
    sideEffects: "Bright yellow urine, rarely GI upset.",
    contraindications: "Hypersensitivity."
  },
  { 
    name: "Vitamin B Complex IM Injection (Neurobion Ampoule)", 
    defaultDose: "1 Ampoule", 
    defaultFreq: "Once weekly to Once daily", 
    defaultDuration: "PRN", 
    indication: "Severe Neuropathy, Acute nerve pain", 
    category: "Vitamins & Minerals (Injections)",
    info: "Deep IM injection. Can cause pain at injection site.",
    sideEffects: "Injection site pain.",
    contraindications: "Hypersensitivity."
  },
  { 
    name: "Vitamin B12 500mcg Sublingual Tablet (Mecobalamin)", 
    defaultDose: "1 Tablet", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Vitamin B12 Deficiency, Peripheral Neuropathy", 
    category: "Vitamins & Minerals",
    info: "Place under the tongue until dissolved for better absorption.",
    sideEffects: "Rare.",
    contraindications: "None significant."
  },
  { 
    name: "Vitamin B12 1000mcg IM Injection (Depovit / Methycobal)", 
    defaultDose: "1 Ampoule", 
    defaultFreq: "Once weekly", 
    defaultDuration: "4-8 weeks", 
    indication: "Pernicious Anemia, Severe B12 Deficiency", 
    category: "Vitamins & Minerals (Injections)",
    info: "For pernicious anemia, may need lifelong monthly injections after loading phase.",
    sideEffects: "Rarely hypokalemia, mild diarrhea.",
    contraindications: "Cobalt allergy."
  },
  { 
    name: "Vitamin C 1000mg Effervescent Tablet (Redoxon / C-Retard)", 
    defaultDose: "1 Tablet", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "10-14 days", 
    indication: "Immune support, Scurvy, Cold/Flu adjunct", 
    category: "Vitamins & Minerals",
    info: "Dissolve in a glass of water.",
    sideEffects: "High doses can cause diarrhea and increase risk of kidney stones.",
    contraindications: "History of oxalate kidney stones."
  },
  { 
    name: "Folic Acid 1mg / 5mg Tablet", 
    defaultDose: "1-5 mg", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic (during pregnancy or for anemia)", 
    indication: "Pregnancy (neural tube defect prophylaxis), Megaloblastic Anemia", 
    category: "Vitamins & Minerals",
    info: "1mg usually sufficient for standard prophylaxis; 5mg for high risk or treatment.",
    sideEffects: "Rare.",
    contraindications: "Undiagnosed megaloblastic anemia (can mask B12 deficiency)."
  },
  { 
    name: "Calcium + Vitamin D3 Tablet (Osteocare / Calcivid)", 
    defaultDose: "1-2 Tablets", 
    defaultFreq: "OD or BD", 
    defaultDuration: "Chronic", 
    indication: "Osteoporosis, Calcium deficiency", 
    category: "Vitamins & Minerals",
    info: "Take with food to increase absorption and reduce GI upset.",
    sideEffects: "Constipation, bloating, risk of kidney stones.",
    contraindications: "Hypercalcemia, severe renal failure."
  },
  { 
    name: "Ferrous Fumarate / Sulfate Tablet (Iron Supplement)", 
    defaultDose: "1 Tablet", 
    defaultFreq: "OD to BD", 
    defaultDuration: "3-6 months", 
    indication: "Iron Deficiency Anemia", 
    category: "Vitamins & Minerals",
    info: "Take on an empty stomach with Vitamin C for best absorption. Avoid taking with tea/coffee or dairy.",
    sideEffects: "Black stools, constipation, nausea, abdominal pain.",
    contraindications: "Iron overload (Hemochromatosis)."
  },
  { 
    name: "Iron III Hydroxide Polymaltose Syrup (Ferose / Globifer)", 
    defaultDose: "5-10 ml", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "3-6 months", 
    indication: "Iron Deficiency Anemia (Pediatric or unable to swallow pills)", 
    category: "Vitamins & Minerals",
    info: "Better GI tolerance compared to sulfate salts. May stain teeth (rinse mouth after use).",
    sideEffects: "Black stools, mild constipation.",
    contraindications: "Iron overload."
  },
  { 
    name: "Iron IV Infusion (Ferinject / Venofer)", 
    defaultDose: "Calculated based on Hb deficit", 
    defaultFreq: "STAT (as infusion)", 
    defaultDuration: "Once or divided doses", 
    indication: "Severe Iron Deficiency Anemia, Intolerance to oral iron", 
    category: "Vitamins & Minerals (Injections)",
    info: "Administer via slow IV infusion in a clinical setting.",
    sideEffects: "Hypotension, flushing, rare anaphylaxis.",
    contraindications: "Iron overload, non-iron deficiency anemia."
  },
  { 
    name: "Magnesium Effervescent / Tablet", 
    defaultDose: "1 Tablet", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "PRN", 
    indication: "Muscle cramps, Magnesium deficiency", 
    category: "Vitamins & Minerals",
    info: "Can help with sleep and muscle relaxation.",
    sideEffects: "Diarrhea (acts as an osmotic laxative at high doses).",
    contraindications: "Severe renal impairment."
  },
  { 
    name: "Zinc Sulfate / Gluconate Tablet or Syrup", 
    defaultDose: "1 Tablet or 5ml", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "14-30 days", 
    indication: "Zinc deficiency, adjunct in acute diarrhea, immune support", 
    category: "Vitamins & Minerals",
    info: "Take with food if it causes nausea.",
    sideEffects: "Nausea, metallic taste.",
    contraindications: "Copper deficiency (high zinc blocks absorption)."
  },
  { 
    name: "Multivitamin Tablet (Centrum / Pharmaton)", 
    defaultDose: "1 Tablet", 
    defaultFreq: "OD (Once daily)", 
    defaultDuration: "Chronic", 
    indication: "Dietary supplement, general fatigue", 
    category: "Vitamins & Minerals",
    info: "Best taken in the morning with food.",
    sideEffects: "Rarely GI upset, bright yellow urine (due to B vitamins).",
    contraindications: "Hypervitaminosis."
  },

  // ==========================================
  // CHILDREN MEDICATIONS (PAINKILLERS, SUPPOSITORIES, SYRUPS, DROPS)
  // ==========================================
  {
    name: "Paracetamol Syrup (Adol, Panadol) / شراب باراسيتامول",
    defaultDose: "10-15 mg/kg",
    defaultFreq: "QDS (4 times daily) PRN",
    defaultDuration: "3-5 days",
    indication: "Mild to moderate pain, fever in children",
    category: "Analgesics/Antipyretics",
    info: "Safe for children from 2 months. Do not exceed 4 doses in 24 hours.",
    sideEffects: "Rare at normal doses. Hepatotoxicity in overdose.",
    contraindications: "Severe liver impairment."
  },
  {
    name: "Paracetamol Suppository (125mg, 250mg) / تحاميل باراسيتامول",
    defaultDose: "1 Suppository",
    defaultFreq: "BD or TDS PRN",
    defaultDuration: "3 days",
    indication: "Fever, pain in children unable to tolerate oral meds",
    category: "Analgesics/Antipyretics",
    info: "Administer rectally. Lubricate before use.",
    sideEffects: "Local irritation.",
    contraindications: "Severe liver impairment, recent rectal surgery."
  },
  {
    name: "Ibuprofen Syrup (Profen, Nurofen) / شراب ايبوبروفين",
    defaultDose: "5-10 mg/kg",
    defaultFreq: "TDS (3 times daily) PRN",
    defaultDuration: "3-5 days",
    indication: "Fever, inflammatory pain in children",
    category: "NSAIDs",
    info: "Take with or after food. Not suitable for children under 3 months or under 5 kg.",
    sideEffects: "GI upset, nausea, rarely gastric ulceration.",
    contraindications: "Active GI bleeding, severe asthma, renal impairment."
  },
  {
    name: "Diclofenac Suppository (Voltaren 12.5mg, 25mg) / تحاميل فولتارين",
    defaultDose: "1 Suppository",
    defaultFreq: "BD (Twice daily) PRN",
    defaultDuration: "2-3 days",
    indication: "Moderate to severe pain, high fever",
    category: "NSAIDs",
    info: "Administer rectally. Not recommended for children under 1 year.",
    sideEffects: "Local irritation, GI upset if absorbed.",
    contraindications: "Active peptic ulcer, NSAID-induced asthma, proctitis."
  },
  {
    name: "Mefenamic Acid Suspension (Ponstan) / شراب بونستان",
    defaultDose: "5 ml",
    defaultFreq: "TDS (3 times daily) PRN",
    defaultDuration: "3-5 days",
    indication: "Mild to moderate pain, fever",
    category: "NSAIDs",
    info: "Suitable for children > 6 months. Take with food.",
    sideEffects: "Diarrhea, GI upset, rash.",
    contraindications: "Inflammatory bowel disease, peptic ulcer."
  },
  {
    name: "Amoxicillin Suspension (Amoxil) / شراب اموكسيل",
    defaultDose: "125-250 mg",
    defaultFreq: "TDS (3 times daily)",
    defaultDuration: "5-7 days",
    indication: "Bacterial infections (otitis media, respiratory)",
    category: "Antibiotics",
    info: "Penicillin antibiotic. Shake well before use. Keep refrigerated.",
    sideEffects: "Diarrhea, nausea, skin rash.",
    contraindications: "Penicillin allergy."
  },
  {
    name: "Azithromycin Suspension (Zithromax) / شراب زيثروماكس",
    defaultDose: "10 mg/kg",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "3-5 days",
    indication: "Respiratory tract infections, atypical pneumonia",
    category: "Antibiotics",
    info: "Macrolide antibiotic. Shake well. Give 1 hour before or 2 hours after food.",
    sideEffects: "GI upset, diarrhea, nausea.",
    contraindications: "Macrolide allergy, severe liver disease."
  },
  {
    name: "Cefixime Suspension (Suprax) / شراب سوبراكس",
    defaultDose: "8 mg/kg",
    defaultFreq: "OD or BD",
    defaultDuration: "7 days",
    indication: "UTI, Otitis media, respiratory infections",
    category: "Antibiotics",
    info: "Cephalosporin (3rd Gen). Reconstitute with water, shake well.",
    sideEffects: "Diarrhea, GI disturbance.",
    contraindications: "Cephalosporin allergy."
  },
  {
    name: "Metronidazole Suspension (Flagyl) / شراب فلاجيل",
    defaultDose: "7.5 mg/kg",
    defaultFreq: "TDS (3 times daily)",
    defaultDuration: "5-7 days",
    indication: "Amoebiasis, Giardiasis, anaerobic infections",
    category: "Antibiotics/Antiprotozoal",
    info: "Take with food. May cause metallic taste.",
    sideEffects: "Nausea, metallic taste, dark urine.",
    contraindications: "First trimester of pregnancy (if applicable), severe liver disease."
  },
  {
    name: "Domperidone Suspension (Motilium) / شراب موتيلوم",
    defaultDose: "0.25 mg/kg",
    defaultFreq: "TDS (3 times daily) before meals",
    defaultDuration: "3-5 days",
    indication: "Nausea and vomiting in children",
    category: "Antiemetics",
    info: "Use lowest effective dose for shortest duration.",
    sideEffects: "Dry mouth, rarely extrapyramidal effects.",
    contraindications: "GI hemorrhage, prolactinoma, cardiac arrhythmias."
  },
  {
    name: "Domperidone Suppository (10mg) / تحاميل موتيلوم",
    defaultDose: "1 Suppository",
    defaultFreq: "BD or TDS",
    defaultDuration: "3 days",
    indication: "Severe nausea and vomiting",
    category: "Antiemetics",
    info: "Rectal administration. Not for children < 15 kg unless specifically prescribed.",
    sideEffects: "Local irritation.",
    contraindications: "Same as oral domperidone."
  },
  {
    name: "Diphenhydramine Syrup (Allermine, Benylin) / شراب للحساسية والسعال",
    defaultDose: "2.5 - 5 ml",
    defaultFreq: "TDS or QDS",
    defaultDuration: "3-5 days",
    indication: "Allergic rhinitis, cough, cold symptoms",
    category: "Antihistamines/Cough Preparations",
    info: "First generation antihistamine. May cause drowsiness.",
    sideEffects: "Drowsiness, dry mouth, thickened respiratory secretions.",
    contraindications: "Neonates, acute asthma attack."
  },
  {
    name: "Loratadine Syrup (Claritin) / شراب كلاريتين",
    defaultDose: "5 ml",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "7-14 days",
    indication: "Allergic rhinitis, urticaria",
    category: "Antihistamines",
    info: "Non-sedating antihistamine. For children > 2 years.",
    sideEffects: "Headache, mild fatigue.",
    contraindications: "Hypersensitivity."
  },
  {
    name: "Glycerin Suppository (Infant/Child) / تحاميل جلسرين للاطفال",
    defaultDose: "1 Suppository",
    defaultFreq: "PRN",
    defaultDuration: "As needed",
    indication: "Constipation",
    category: "Laxatives",
    info: "Insert into rectum. Produces bowel movement within 15-60 mins.",
    sideEffects: "Rectal irritation.",
    contraindications: "Intestinal obstruction, undiagnosed abdominal pain."
  },
  {
    name: "Multivitamin Syrup (Sanatogen, etc) / شراب فيتامينات للاطفال",
    defaultDose: "5 ml",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "1 month",
    indication: "Vitamin supplementation, poor appetite",
    category: "Vitamins & Supplements",
    info: "Take with or after meals.",
    sideEffects: "Rarely GI upset.",
    contraindications: "Hypervitaminosis."
  },
  {
    name: "Iron Drops/Syrup (Fer-in-Sol, Ferose) / قطرات أو شراب حديد للاطفال",
    defaultDose: "Determined by weight",
    defaultFreq: "OD or BD",
    defaultDuration: "1-3 months",
    indication: "Iron deficiency anemia prophylaxis or treatment",
    category: "Vitamins & Supplements",
    info: "May stain teeth (use dropper/straw). May cause dark stools. Best absorbed on empty stomach.",
    sideEffects: "Constipation, diarrhea, dark stools, nausea.",
    contraindications: "Iron overload disorders (hemochromatosis)."
  },
  {
    name: "Vitamin D3 Drops (Vidrop) / قطرات فيتامين د3 للاطفال",
    defaultDose: "400-800 IU (4-8 drops)",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "Daily maintenance",
    indication: "Prevention and treatment of Vitamin D deficiency, rickets",
    category: "Vitamins & Supplements",
    info: "Essential for bone health in infants and children.",
    sideEffects: "None at recommended doses.",
    contraindications: "Hypercalcemia."
  },
  {
    name: "Simethicone Drops/Syrup (Infacol, Dentinox) / قطرات مغص للاطفال",
    defaultDose: "0.5 - 1 ml",
    defaultFreq: "Before feeds PRN",
    defaultDuration: "As needed",
    indication: "Infant colic, trapped wind",
    category: "Gastro-intestinal",
    info: "Safe from birth. Helps release trapped gas.",
    sideEffects: "Extremely rare.",
    contraindications: "Intestinal obstruction."
  },
  {
    name: "Prospan Syrup (Ivy Leaf Extract) / شراب بروسبان للسعال",
    defaultDose: "2.5 - 5 ml",
    defaultFreq: "TDS (3 times daily)",
    defaultDuration: "5-7 days",
    indication: "Chesty cough, bronchitis",
    category: "Cough Preparations (Herbal)",
    info: "Natural mucolytic and spasmolytic.",
    sideEffects: "Rarely laxative effect due to sorbitol.",
    contraindications: "Fructose intolerance."
  }  ,
  {
    name: "Duloxetine",
    defaultDose: "60 mg",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "Chronic",
    indication: "Major depressive disorder, neuropathic pain, generalized anxiety",
    category: "Central Nervous System",
    info: "SNRI antidepressant.",
    sideEffects: "Nausea, dry mouth, somnolence, fatigue.",
    contraindications: "Concomitant MAOI use."
  },
  {
    name: "Vildagliptin",
    defaultDose: "50 mg",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "Chronic",
    indication: "Type 2 Diabetes Mellitus",
    category: "Endocrine",
    info: "DPP-4 inhibitor.",
    sideEffects: "Hypoglycemia (if combined with sulfonylurea), headache.",
    contraindications: "Severe hepatic impairment."
  },
  {
    name: "Linagliptin",
    defaultDose: "5 mg",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "Chronic",
    indication: "Type 2 Diabetes Mellitus",
    category: "Endocrine",
    info: "DPP-4 inhibitor. No dose adjustment needed in renal impairment.",
    sideEffects: "Nasopharyngitis, hypoglycemia.",
    contraindications: "Hypersensitivity."
  },
  {
    name: "Liraglutide",
    defaultDose: "1.2 mg",
    defaultFreq: "OD (Once daily via SC injection)",
    defaultDuration: "Chronic",
    indication: "Type 2 Diabetes Mellitus, Obesity",
    category: "Endocrine",
    info: "GLP-1 receptor agonist.",
    sideEffects: "Nausea, diarrhea, vomiting, pancreatitis risk.",
    contraindications: "Personal or family history of medullary thyroid carcinoma."
  },
  {
    name: "Insulin Detemir",
    defaultDose: "10 Units",
    defaultFreq: "OD (Once daily at bedtime)",
    defaultDuration: "Chronic",
    indication: "Type 1 & Type 2 Diabetes Mellitus",
    category: "Endocrine",
    info: "Long-acting basal insulin.",
    sideEffects: "Hypoglycemia, weight gain, injection site reactions.",
    contraindications: "Hypoglycemia."
  },
  {
    name: "Insulin Degludec",
    defaultDose: "10 Units",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "Chronic",
    indication: "Type 1 & Type 2 Diabetes Mellitus",
    category: "Endocrine",
    info: "Ultra-long-acting basal insulin.",
    sideEffects: "Hypoglycemia, weight gain.",
    contraindications: "Hypoglycemia."
  },
  {
    name: "Ticagrelor",
    defaultDose: "90 mg",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "12 months post-ACS",
    indication: "Acute Coronary Syndrome (ACS)",
    category: "Cardiovascular",
    info: "P2Y12 platelet inhibitor.",
    sideEffects: "Bleeding, dyspnea, bradycardia.",
    contraindications: "Active pathological bleeding, history of intracranial hemorrhage."
  },
  {
    name: "Prasugrel",
    defaultDose: "10 mg",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "12 months post-ACS",
    indication: "Acute Coronary Syndrome with PCI",
    category: "Cardiovascular",
    info: "Thienopyridine class P2Y12 inhibitor.",
    sideEffects: "Bleeding risk.",
    contraindications: "History of TIA or stroke, active pathological bleeding."
  },
  {
    name: "Sacubitril / Valsartan (Entresto)",
    defaultDose: "49/51 mg",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "Chronic",
    indication: "Heart failure with reduced ejection fraction (HFrEF)",
    category: "Cardiovascular",
    info: "Angiotensin receptor neprilysin inhibitor (ARNI).",
    sideEffects: "Hypotension, hyperkalemia, renal impairment.",
    contraindications: "Concomitant use of ACE inhibitors, history of angioedema."
  },
  {
    name: "Fenofibrate",
    defaultDose: "160 mg",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "Chronic",
    indication: "Hypertriglyceridemia, mixed dyslipidemia",
    category: "Cardiovascular",
    info: "Fibric acid derivative.",
    sideEffects: "Abnormal LFTs, myopathy.",
    contraindications: "Severe renal/hepatic impairment, gallbladder disease."
  },
  {
    name: "Dutasteride",
    defaultDose: "0.5 mg",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "Chronic",
    indication: "Benign Prostatic Hyperplasia (BPH)",
    category: "Genito-Urinary",
    info: "5-alpha-reductase inhibitor.",
    sideEffects: "Impotence, decreased libido, ejaculation disorders.",
    contraindications: "Women, children, pregnancy."
  },
  {
    name: "Atorvastatin 20mg Tablet",
    defaultDose: "20 mg",
    defaultFreq: "ON (At night)",
    defaultDuration: "Chronic",
    indication: "Hyperlipidemia, primary/secondary cardiovascular prevention",
    category: "Cardiovascular",
    info: "HMG-CoA Reductase Inhibitor. Highly efficacious statin.",
    sideEffects: "Myalgia/myopathy, elevated LFTs, headache.",
    contraindications: "Active liver disease, pregnancy."
  },
  {
    name: "Atorvastatin 40mg Tablet",
    defaultDose: "40 mg",
    defaultFreq: "ON (At night)",
    defaultDuration: "Chronic",
    indication: "Hyperlipidemia, primary/secondary cardiovascular prevention",
    category: "Cardiovascular",
    info: "HMG-CoA Reductase Inhibitor. High intensity statin.",
    sideEffects: "Myalgia/myopathy, elevated LFTs, headache.",
    contraindications: "Active liver disease, pregnancy."
  },
  {
    name: "Atorvastatin 80mg Tablet",
    defaultDose: "80 mg",
    defaultFreq: "ON (At night)",
    defaultDuration: "Chronic",
    indication: "Hyperlipidemia, primary/secondary cardiovascular prevention",
    category: "Cardiovascular",
    info: "HMG-CoA Reductase Inhibitor. High intensity statin.",
    sideEffects: "Myalgia/myopathy, elevated LFTs, headache.",
    contraindications: "Active liver disease, pregnancy."
  },
  {
    name: "Levothyroxine 50mcg Tablet",
    defaultDose: "50 mcg",
    defaultFreq: "OD (Once daily, empty stomach)",
    defaultDuration: "Chronic",
    indication: "Hypothyroidism",
    category: "Endocrine",
    info: "Synthetic T4 hormone.",
    sideEffects: "Palpitations, weight loss, heat intolerance (if over-replaced).",
    contraindications: "Uncorrected adrenal insufficiency."
  },
  {
    name: "Levothyroxine 100mcg Tablet",
    defaultDose: "100 mcg",
    defaultFreq: "OD (Once daily, empty stomach)",
    defaultDuration: "Chronic",
    indication: "Hypothyroidism",
    category: "Endocrine",
    info: "Synthetic T4 hormone.",
    sideEffects: "Palpitations, weight loss, heat intolerance (if over-replaced).",
    contraindications: "Uncorrected adrenal insufficiency."
  },
  // ==========================================
  // NEW ADDITIONS: JAK INHIBITORS, BIOLOGICS, & WEIGHT MANAGEMENT
  // ==========================================
  {
    name: "Tofacitinib 5mg / 10mg Tablets (Xeljanz)",
    defaultDose: "5 mg",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "Chronic",
    indication: "Rheumatoid Arthritis, Ulcerative Colitis, Alopecia Areata",
    category: "Immunosuppressant (JAK Inhibitor)",
    info: "JAK inhibitor. Monitor CBC, LFTs, and lipids. Test for latent TB before starting.",
    sideEffects: "Infections, herpes zoster, increased risk of thrombosis.",
    contraindications: "Severe hepatic impairment, active serious infection, pregnancy."
  },
  {
    name: "Baricitinib 2mg / 4mg Tablets (Olumiant)",
    defaultDose: "4 mg",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "Chronic",
    indication: "Rheumatoid Arthritis, Alopecia Areata",
    category: "Immunosuppressant (JAK Inhibitor)",
    info: "JAK inhibitor. Monitor renal function and CBC.",
    sideEffects: "Upper respiratory tract infections, hypercholesterolemia, herpes zoster.",
    contraindications: "Severe renal or hepatic impairment, pregnancy."
  },
  {
    name: "Upadacitinib 15mg / 30mg Extended-Release Tablets (Rinvoq)",
    defaultDose: "15 mg",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "Chronic",
    indication: "Atopic Dermatitis, Rheumatoid Arthritis",
    category: "Immunosuppressant (JAK Inhibitor)",
    info: "JAK inhibitor. Must not be crushed or chewed.",
    sideEffects: "Acne, URI, nausea, herpes zoster.",
    contraindications: "Active tuberculosis, severe hepatic impairment, pregnancy."
  },
  {
    name: "Abrocitinib 50mg / 100mg / 200mg Tablets (Cibinqo)",
    defaultDose: "100 mg",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "Chronic",
    indication: "Moderate to severe Atopic Dermatitis",
    category: "Immunosuppressant (JAK Inhibitor)",
    info: "JAK1 selective inhibitor. Monitor platelet count and lipids.",
    sideEffects: "Nausea, headache, herpes simplex, acne.",
    contraindications: "Severe renal impairment, pregnancy, lactation."
  },
  {
    name: "Ruxolitinib 1.5% Cream (Opzelura)",
    defaultDose: "Apply thin layer",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "Chronic",
    indication: "Vitiligo, Atopic Dermatitis",
    category: "Dermatological (Topical JAK Inhibitor)",
    info: "Avoid mucous membranes and eyes. Maximum 60g per week.",
    sideEffects: "Application site reactions, acne, nasopharyngitis.",
    contraindications: "Hypersensitivity to ruxolitinib."
  },
  {
    name: "Dupilumab 200mg / 300mg Pre-filled Syringe (Dupixent)",
    defaultDose: "300 mg",
    defaultFreq: "Every 2 weeks (after loading dose)",
    defaultDuration: "Chronic",
    indication: "Atopic Dermatitis, Asthma, CRSwNP",
    category: "Biological (IL-4/IL-13 inhibitor)",
    info: "Subcutaneous injection. Initial loading dose is usually 600mg.",
    sideEffects: "Injection site reactions, conjunctivitis, oral herpes.",
    contraindications: "Hypersensitivity."
  },
  {
    name: "Secukinumab 150mg / 300mg Pre-filled Pen (Cosentyx)",
    defaultDose: "300 mg",
    defaultFreq: "Monthly (after initial weekly loading)",
    defaultDuration: "Chronic",
    indication: "Psoriasis, Ankylosing Spondylitis",
    category: "Biological (IL-17A inhibitor)",
    info: "Screen for TB before starting.",
    sideEffects: "Nasopharyngitis, upper respiratory infections, mucocutaneous candida.",
    contraindications: "Clinically important active infection (e.g., active TB)."
  },
  {
    name: "Ixekizumab 80mg/ml Pre-filled Pen (Taltz)",
    defaultDose: "80 mg",
    defaultFreq: "Every 4 weeks (after loading doses)",
    defaultDuration: "Chronic",
    indication: "Plaque Psoriasis, Psoriatic Arthritis",
    category: "Biological (IL-17A inhibitor)",
    info: "Subcutaneous injection. Initial loading dose is usually 160mg.",
    sideEffects: "Injection site reactions, upper respiratory infections, nausea.",
    contraindications: "Active TB or severe infections, hypersensitivity."
  },
  {
    name: "Ustekinumab 45mg / 90mg Pre-filled Syringe (Stelara)",
    defaultDose: "45 mg",
    defaultFreq: "Every 12 weeks (after week 0 and 4)",
    defaultDuration: "Chronic",
    indication: "Psoriasis, Crohn's Disease, Ulcerative Colitis",
    category: "Biological (IL-12/IL-23 inhibitor)",
    info: "Dose based on body weight (90mg if >100kg).",
    sideEffects: "Nasopharyngitis, headache, fatigue.",
    contraindications: "Clinically important active infection."
  },
  {
    name: "Guselkumab 100mg/ml Pre-filled Syringe (Tremfya)",
    defaultDose: "100 mg",
    defaultFreq: "Every 8 weeks (after week 0 and 4)",
    defaultDuration: "Chronic",
    indication: "Plaque Psoriasis, Psoriatic Arthritis",
    category: "Biological (IL-23 inhibitor)",
    info: "Subcutaneous injection.",
    sideEffects: "Upper respiratory infections, headache, injection site reactions.",
    contraindications: "Active severe infection."
  },
  {
    name: "Risankizumab 150mg/ml Pre-filled Pen (Skyrizi)",
    defaultDose: "150 mg",
    defaultFreq: "Every 12 weeks (after week 0 and 4)",
    defaultDuration: "Chronic",
    indication: "Plaque Psoriasis",
    category: "Biological (IL-23 inhibitor)",
    info: "Subcutaneous injection.",
    sideEffects: "Upper respiratory infections, fatigue, fungal skin infections.",
    contraindications: "Active severe infection."
  },
  {
    name: "Adalimumab 40mg Pre-filled Pen (Humira)",
    defaultDose: "40 mg",
    defaultFreq: "Every 2 weeks",
    defaultDuration: "Chronic",
    indication: "Psoriasis, Rheumatoid Arthritis, HS, Crohn's",
    category: "Biological (TNF-alpha inhibitor)",
    info: "Screen for latent TB, Hepatitis B & C before starting.",
    sideEffects: "Injection site reactions, upper respiratory infections, sinusitis.",
    contraindications: "Active TB, severe infections, moderate-to-severe heart failure."
  },
  {
    name: "Omalizumab 150mg Pre-filled Syringe (Xolair)",
    defaultDose: "150-300 mg",
    defaultFreq: "Every 4 weeks",
    defaultDuration: "Chronic",
    indication: "Chronic Spontaneous Urticaria, Severe Asthma",
    category: "Biological (Anti-IgE)",
    info: "Dosing for asthma depends on IgE levels and body weight.",
    sideEffects: "Injection site reactions, viral infections, headache.",
    contraindications: "Hypersensitivity."
  },
  {
    name: "Tralokinumab 150mg/ml Pre-filled Syringe (Adbry / Adtralza)",
    defaultDose: "300 mg",
    defaultFreq: "Every 2 weeks (after 600mg loading)",
    defaultDuration: "Chronic",
    indication: "Moderate to severe Atopic Dermatitis",
    category: "Biological (IL-13 inhibitor)",
    info: "Requires two 150mg injections per dose.",
    sideEffects: "Upper respiratory tract infections, conjunctivitis, injection site reactions.",
    contraindications: "Hypersensitivity."
  },
  {
    name: "Crisaborole 2% Ointment (Eucrisa)",
    defaultDose: "Apply thin layer",
    defaultFreq: "BD (Twice daily)",
    defaultDuration: "Until clearance",
    indication: "Mild to moderate Atopic Dermatitis",
    category: "Dermatological (PDE-4 inhibitor)",
    info: "For topical use only.",
    sideEffects: "Application site pain (burning or stinging).",
    contraindications: "Hypersensitivity."
  },
  {
    name: "Tapinarof 1% Cream (Vtama)",
    defaultDose: "Apply thin layer",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "Until clearance",
    indication: "Plaque Psoriasis",
    category: "Dermatological (Aryl hydrocarbon receptor agonist)",
    info: "Non-steroidal topical treatment.",
    sideEffects: "Folliculitis, contact dermatitis, headache.",
    contraindications: "Hypersensitivity."
  },
  {
    name: "Roflumilast 0.3% Cream (Zoryve)",
    defaultDose: "Apply thin layer",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "Until clearance",
    indication: "Plaque Psoriasis",
    category: "Dermatological (PDE-4 inhibitor)",
    info: "Can be used on face and intertriginous areas.",
    sideEffects: "Diarrhea, headache, insomnia, nausea.",
    contraindications: "Moderate to severe liver impairment."
  },
  {
    name: "Tirzepatide 2.5mg / 5mg / 7.5mg / 10mg / 12.5mg / 15mg (Mounjaro)",
    defaultDose: "2.5 mg",
    defaultFreq: "Once weekly",
    defaultDuration: "Chronic",
    indication: "Type 2 Diabetes Mellitus, Weight management",
    category: "Endocrine (GIP and GLP-1 receptor agonist)",
    info: "Subcutaneous injection. Dose titrated up by 2.5mg every 4 weeks.",
    sideEffects: "Nausea, diarrhea, decreased appetite, vomiting.",
    contraindications: "Personal or family history of medullary thyroid carcinoma, MEN 2."
  },
  {
    name: "Tirzepatide (Zepbound)",
    defaultDose: "2.5 mg",
    defaultFreq: "Once weekly",
    defaultDuration: "Chronic",
    indication: "Chronic weight management",
    category: "Metabolic (GIP and GLP-1 receptor agonist)",
    info: "Same active ingredient as Mounjaro, branded for obesity.",
    sideEffects: "Nausea, diarrhea, constipation, vomiting.",
    contraindications: "Personal or family history of MTC, MEN 2."
  },
  {
    name: "Semaglutide 0.25mg / 0.5mg / 1mg / 1.7mg / 2.4mg (Wegovy)",
    defaultDose: "0.25 mg",
    defaultFreq: "Once weekly",
    defaultDuration: "Chronic",
    indication: "Chronic weight management",
    category: "Metabolic (GLP-1 receptor agonist)",
    info: "Titrate dose every 4 weeks to maintenance of 2.4mg.",
    sideEffects: "Nausea, diarrhea, vomiting, constipation, abdominal pain.",
    contraindications: "Personal or family history of MTC, MEN 2."
  },
  {
    name: "Liraglutide 3mg/ml (Saxenda)",
    defaultDose: "0.6 mg",
    defaultFreq: "OD (Once daily)",
    defaultDuration: "Chronic",
    indication: "Chronic weight management",
    category: "Metabolic (GLP-1 receptor agonist)",
    info: "Daily subcutaneous injection. Titrate up by 0.6mg weekly to 3mg.",
    sideEffects: "Nausea, hypoglycemia, diarrhea, constipation.",
    contraindications: "Personal or family history of MTC, MEN 2, pregnancy."
  }
];
export const labCatalog = [
  "Routine Tests",
  "Screening Tests",
  // --- Doctor's Requested General Tests ---
  "CBC (Complete Blood Count)",
  "CMP (Comprehensive Metabolic Panel)",
  "Lipid Profile",
  "LFT (Liver Function Test)",
  "KFT / RFT (Renal Function Test)",
  "GUE (General Urine Examination)",
  "GSE (General Stool Examination)",
  "Thyroid Profile (TSH, T3, T4)",
  // ----------------------------------------
  
  // Hematology
  "Complete Blood Count (CBC) w/ diff",
  "Hemoglobin & Hematocrit (H&H)",
  "Erythrocyte Sedimentation Rate (ESR)",
  "C-Reactive Protein (CRP), High Sensitivity",
  "Prothrombin Time (PT) / INR",
  "Activated Partial Thromboplastin Time (aPTT)",
  "D-Dimer",
  "Ferritin",
  "Iron Panel (TIBC, Iron, Transferrin)",
  "Vitamin B12 & Folate",
  "Blood Grouping & Rh Typing",
  "Direct Antiglobulin Test (DAT/Coombs)",
  "Reticulocyte Count",
  "Peripheral Blood Smear",

  // Biochemistry 
  "Basic Metabolic Panel (BMP; U&E)",
  "Comprehensive Metabolic Panel (CMP)",
  "Electrolytes Panel (Na, K, Cl, HCO3)",
  "Liver Function Tests (LFTs - ALT, AST, ALP, Bilirubin, Albumin)",
  "Renal Function Panel (BUN, Creatinine, eGFR)",
  "Lipid Panel (Total Chol, LDL, HDL, Triglycerides)",
  "Fasting Blood Glucose",
  "HbA1c (Glycosylated Hemoglobin)",
  "Calcium, Corrected",
  "Magnesium",
  "Phosphate",
  "Uric Acid / Urate",
  "Troponin I / T (High sensitivity)",
  "BNP / NT-proBNP",
  "Amylase / Lipase",
  "Lactate Dehydrogenase (LDH)",
  "Creatine Kinase (CK)",
  "Arterial Blood Gas (ABG)",
  
  // Endocrinology
  "Thyroid Function Profile (TSH, Free T4, Free T3)",
  "Thyroid Peroxidase Antibodies (TPO)",
  "25-OH Vitamin D",
  "Parathyroid Hormone (PTH)",
  "Cortisol (8 AM)",
  "Testosterone (Total / Free)",
  "Estradiol (E2)",
  "Prolactin",
  "LH & FSH",
  "Progesterone",
  "Insulin (Fasting)",
  "C-Peptide",
  
  // Immunology & Serology
  "Rheumatoid Factor (RF)",

  // Clinical Pathology / Routine Analysis
  "General Urine Examination (GUE) / Urine Routine",
  "Urine Culture and Sensitivity",
  "24-Hour Urine Protein",
  "Microalbumin/Creatinine Ratio (Urine)",
  "General Stool Examination (GSE) / Stool Routine",
  "Stool Occult Blood (FOBT)",
  "Stool Culture",
  "Stool for H. pylori Antigen",
  "Stool Calprotectin",
  "Seminal Fluid Analysis (SFA)",
  "CSF Analysis (Routine & Microscopy)",
  "Anti-CCP Antibodies",
  "Antinuclear Antibodies (ANA) Screen",
  "Celiac Disease Panel (Anti-tTG IgA, Total IgA)",
  "Syphilis Screen (VDRL / RPR)",
  "HIV 1/2 Ag/Ab Combo",
  "Hepatitis B Surface Antigen (HBsAg)",
  "Hepatitis C Antibody (Anti-HCV)",
  "Covid-19 PCR",
  "IgE (Total / Specific Allergen)",
  
  // Microbiology & Fluids
  "Urinalysis (Dipstick & Microscopy)",
  "Urine Culture and Sensitivity",
  "Stool Culture & C. diff Toxin",
  "Stool Fecal Immunochemical Test (FIT)",
  "Fecal Calprotectin",
  "Blood Cultures (Aerobic/Anaerobic)",
  "Sputum Culture & AFB Smear",
  "Wound Swab - Microscopy, Culture & Sensitivity",
  "Chlamydia & Gonorrhea NAAT (Urine/Swab)",
  "CSF Analysis (Cells, Protein, Glucose, Culture)",
  "Pleural Fluid Analysis",
  "Joint Fluid Aspiration (Crystals, WBC, Culture)",

  // Extended Rheumatology & Autoimmune
  "Anti-dsDNA",
  "Anti-Smith (Sm) Antibodies",
  "Anti-Ro/SSA & Anti-La/SSB",
  "Anti-Centromere Antibodies",
  "Scl-70 (Anti-topoisomerase I)",
  "Anti-Jo-1",
  "ANCA Panel (p-ANCA, c-ANCA)",
  "HLA-B27 Typing",
  "Complement C3 & C4",
  "Lupus Anticoagulant",
  "Anticardiolipin Antibodies",

  // Extended Dermatology & Allergy
  "Skin Biopsy (H&E, DIF)",
  "KOH Preparation (Fungal scraping)",
  "Fungal Culture (Skin/Nail/Hair)",
  "Tzanck Smear",
  "Patch Testing (Contact Allergy)",
  "Total IgE",
  "Specific IgE (RAST Panel)",
  "Desmoglein 1 & 3 Antibodies (Pemphigus)",
  "BP180 & BP230 Antibodies (Pemphigoid)",

  // Extended Cardiology
  "Creatine Kinase-MB (CK-MB)",
  "Myoglobin",
  "Homocysteine",
  "Lipoprotein (a) [Lp(a)]",
  "Apolipoprotein A1 & B",

  // Extended Gastroenterology
  "Fecal Elastase (Pancreatic Exocrine Insufficiency)",
  "Anti-Saccharomyces cerevisiae antibodies (ASCA)",
  "Deamidated Gliadin Peptide (DGP) Antibodies",
  "Serum Gastrin",
  "Urea Breath Test (H. pylori)",
  "Blood Ammonia (NH3)",

  // Extended Endocrinology & Glands
  "ACTH (Adrenocorticotropic Hormone)",
  "Aldosterone & Plasma Renin Activity",
  "IGF-1 (Insulin-like Growth Factor 1)",
  "Growth Hormone (GH)",
  "Calcitonin",
  "Thyroglobulin & Anti-Thyroglobulin Antibodies",
  "TSH Receptor Antibodies (TRAb / TSI)",
  "DHEA-S",
  "17-OH Progesterone",
  "Metanephrines (Plasma/Urine)",
  "SHBG (Sex Hormone Binding Globulin)",

  // Extended Immune System & Autoimmune
  "Immunoglobulins Profile (IgA, IgG, IgM)",
  "IgG Subclasses (1, 2, 3, 4)",
  "CD4 / CD8 Lymphocyte Count",
  "CH50 (Total Complement Activity)",
  "Anti-Smooth Muscle Antibody (ASMA)",
  "Anti-Mitochondrial Antibody (AMA)",
  "Liver-Kidney Microsomal (LKM-1) Antibodies",

  // Extended Infectious Diseases
  "TORCH Panel (Toxo, Rubella, CMV, HSV)",
  "Widal Test (Typhoid Fever)",
  "Brucella Antibodies (Rose Bengal / STAT)",
  "Monospot Test / EBV Serology",
  "QuantiFERON-TB Gold (Latent TB)",
  "Viral Load PCR (HBV, HCV, HIV)",
  "Malaria Parasite Smear & Rapid Antigen",
  "Leishmania Serology",

  // Extended Infertility & Repro-Genetics
  "Anti-Mullerian Hormone (AMH)",
  "Inhibin B",
  "Antisperm Antibodies (ASA)",
  "Sperm DNA Fragmentation Index (DFI)",
  "Karyotyping / Chromosomal Analysis",
  "Y-Chromosome Microdeletion Analysis",
  "Thrombophilia Screen (Recurrent Miscarriage)",

  // Extended Hematology & Blood Disorders
  "Hemoglobin Electrophoresis",
  "Bone Marrow Aspiration & Biopsy",
  "G6PD Assay (Quantitative)",
  "Osmotic Fragility Test",
  "Von Willebrand Factor (vWF) Ag & Activity",
  "Factor VIII & Factor IX Assays",
  "Erythropoietin (EPO) Level",
  "JAK2 V617F Mutation",
  "BCR-ABL1 Fusion Gene PCR",

  // Extended Genetics & Molecular Pathology
  "Whole Exome Sequencing (WES)",
  "Chromosomal Microarray Analysis (CMA)",
  "Fragile X Syndrome DNA testing",
  "Cystic Fibrosis (CFTR) Gene Mutation",
  "BRCA1 & BRCA2 Gene Mutations",
  "SMA (SMN1/SMN2) Gene Testing",
  "DMD (Duchenne) Genetic Test",
  "HLA-DQ2/DQ8 (Celiac Genetics)"  ,
  // --- Additional Tests (Dermatology, Aesthetics, Hair Loss) ---
  "Serum Zinc",
  "Serum Copper",
  "Dihydrotestosterone (DHT)",
  "Free Androgen Index (FAI)",
  "Androstenedione",
  
  // --- Additional Infections & STD ---
  "HSV 1/2 IgM & IgG (Herpes Simplex)",
  "VZV IgM & IgG (Varicella-Zoster)",
  "HPV DNA Genotyping (Swab)",
  "Urethral Swab (Culture & Sensitivity)",
  "Vaginal Swab (Culture & Sensitivity)",
  "H. pylori IgG/IgM (Blood)",

  // --- Tumor Markers & General Check-up ---
  "PSA Total (Prostate Specific Antigen)",
  "PSA Free",
  "CEA (Carcinoembryonic Antigen)",
  "CA-125 (Ovarian Tumor Marker)",
  "CA 15-3 (Breast Tumor Marker)",
  "CA 19-9 (GI/Pancreatic Tumor Marker)",
  "AFP (Alpha-Fetoprotein)",
  
  // --- Additional Vitamins & Minerals ---
  "Vitamin B1 (Thiamine)",
  "Vitamin B6 (Pyridoxine)",
  "Serum Folate (Folic Acid)",

  // --- Advanced Functional & Metabolic ---
  "Insulin Resistance Index (HOMA-IR)",
  "Omega-3 Index",
  "Leptin",
  "Adiponectin",
  "Organic Acids Test (OAT)",
  "Heavy Metals Panel (Blood/Urine)",

  // --- Advanced Oncology / Liquid Biopsy ---
  "Circulating Tumor DNA (ctDNA)",
  "Circulating Tumor Cells (CTC)",
  "B-RAF V600E Mutation",
  "EGFR Mutation Analysis",
  "Septin 9 DNA (Colorectal Cancer Screening)",

  // --- Genetics & Pharmacogenomics ---
  "MTHFR Gene Mutation",
  "CYP450 Pharmacogenomic Panel",
  "Gut Microbiome Sequencing",

  // --- Advanced Autoimmune & Neurological ---
  "Acetylcholine Receptor Antibodies (AChR)",
  "Anti-MUSK Antibodies",
  "Anti-Aquaporin-4 (AQP4) Antibodies",
  "Anti-MOG Antibodies",
  "Beta-2 Glycoprotein 1 Antibodies",
  "Anti-NMDAR Antibodies",

  // --- Advanced Nutrition & Allergy ---
  "Food Intolerance Panel (IgG)",
  "Coenzyme Q10 (CoQ10)",
  "RBC Magnesium",
  "Vitamin A",
  "Vitamin E",
  "Iodine",
  "Selenium",

  // --- Advanced Molecular Infections (Multiplex PCR) ---
  "Multiplex PCR Respiratory Panel",
  "Multiplex PCR Gastrointestinal Panel",
  "Lyme Disease (Borrelia burgdorferi) Antibodies",
  "CMV PCR",
  "EBV PCR",
  "Monkeypox (Mpox) PCR"

];

export const xrayCatalog = [
  // Plain X-ray Radiography
  "X-Ray Chest PA/LAT",
  "X-Ray Abdomen (KUB)",
  "X-Ray Pelvis AP",
  "X-Ray Cervical Spine AP/LAT",
  "X-Ray Lumbar Spine AP/LAT",
  "X-Ray Shoulder (Right / Left)",
  "X-Ray Knee Weight Bearing (Right / Left)",
  "X-Ray Hand / Wrist (Right / Left)",
  "X-Ray Foot / Ankle (Right / Left)",

  // Ultrasound (US)
  "US Abdomen Complete",
  "US Pelvis (Transabdominal / Transvaginal)",
  "US Renal / KUB Trakt",
  "US Thyroid / Neck",
  "US Doppler Lower Extremity DVT Screen (Right / Left)",
  "US Scrotum / Testicular",
  "US Breast",

  // CT Scans
  "CT Brain Non-Contrast (Stroke protocol)",
  "CT Brain / Head W/WO Contrast",
  "CT Chest Low Dose (Lung Cancer screening)",
  "CT Chest / Abdomen / Pelvis W/ Contrast",
  "CT KUB (Unenhanced for stones - CT Urogram)",
  "CT Angiography Pulmonary (CTPA for PE)",
  "CT Angiography Head & Neck",
  "CT Facial Bones & Sinuses",

  // MRI Scans
  "MRI Brain W/WO Contrast",
  "MRI Cervical Spine",
  "MRI Lumbar Spine",
  "MRI Knee (Right / Left)",
  "MRI Shoulder (Right / Left)",
  "MRI Pelvis (Gynecological / Rectal staging)",
  "MRI MRCP (Biliary Tree)",

  // Other Imaging/Nuclear
  "DEXA Scan (Bone Mineral Density)",
  "Mammography (Screening / Diagnostic)",
  "Fluoroscopy / Barium Swallow",
  "Echocardiogram (TTE)",
  "ECG - 12 Lead (Electrocardiogram)",
  "Holter Monitor (24h / 48h / 7 Day)"  ,
  // --- Specialized Procedures & Physical Examinations ---
  
  // Dermatology & Allergy
  "Wood's Lamp Examination",
  "Dermoscopy Examination",
  "Skin Prick Test (Allergy Panel)",
  "Patch Testing (Contact Allergy)",
  "Skin Biopsy Procedure (Punch / Excisional)",
  "Cryotherapy Session",
  
  // Gastroenterology Endoscopy
  "Upper GI Endoscopy (OGD)",
  "Colonoscopy / Sigmoidoscopy",
  "FibroScan (Liver Elastography)",
  
  // Pulmonology
  "Spirometry (Pulmonary Function Test - PFT)",
  "Bronchoscopy",
  
  // Neurology
  "EEG (Electroencephalogram)",
  "EMG (Electromyography)",
  "NCS (Nerve Conduction Study)",
  
  // Urology
  "Uroflowmetry",
  "Cystoscopy",
  
  // Advanced MRI
  "MRI Brain with Pituitary Protocol",
  "MRI Breast",
  "MRI Prostate (Multiparametric)"

];

export interface DetailedInvestigation {
  name: string;
  category: string;
  dept: "LAB" | "X_RAY";
  indication: string;
  specimen: string;
  clinicalUtility: string;
  referenceRange?: string;
  criticalValue?: string;
  clinicalSignificance?: string;
}

export const fullInvestigationCatalog: DetailedInvestigation[] = [
  {
    name: "Vitamin D (25-OH)",
    category: "Routine Biochemistry",
    dept: "LAB",
    indication: "Osteoporosis, osteomalacia, rickets, fatigue, bone pain, malabsorption syndromes, hypocalcemia",
    specimen: "SST/Gold Top Tube",
    clinicalUtility: "Measures serum 25-hydroxyvitamin D levels to assess vitamin D stores."
  },
  {
    name: "Prostate Specific Antigen (PSA)",
    category: "Tumor Markers",
    dept: "LAB",
    indication: "Prostate cancer screening, BPH, prostatitis, frequent urination in males",
    specimen: "SST/Gold Top Tube",
    clinicalUtility: "Screening and monitoring test for prostate abnormalities."
  },
  {
    name: "Beta-hCG (Quantitative)",
    category: "Hormones",
    dept: "LAB",
    indication: "Pregnancy confirmation, ectopic pregnancy, trophoblastic disease, missed period",
    specimen: "SST/Gold Top Tube",
    clinicalUtility: "Measures the exact amount of human chorionic gonadotropin in blood."
  },
  {
    name: "D-Dimer",
    category: "Hematology & Coagulation",
    dept: "LAB",
    indication: "Deep vein thrombosis (DVT), pulmonary embolism (PE), DIC, leg swelling",
    specimen: "Sodium Citrate Light Blue Top Tube",
    clinicalUtility: "Fibrin degradation product indicating active clotting."
  },
  {
    name: "Fecal Occult Blood Test (FOBT/FIT)",
    category: "Gastroenterology",
    dept: "LAB",
    indication: "Colorectal cancer screening, anemia, GI bleeding, dark stools",
    specimen: "Stool Sample",
    clinicalUtility: "Detects hidden blood in the stool."
  },
  {
    name: "Pap Smear & HPV DNA Testing",
    category: "Cytology",
    dept: "LAB",
    indication: "Cervical cancer screening, abnormal bleeding, pelvic pain, HPV infection",
    specimen: "Cervical Swab",
    clinicalUtility: "Cytology and viral DNA detection for cervical screening."
  },
  {
    name: "Urine Microalbumin/Creatinine Ratio (ACR)",
    category: "Renal",
    dept: "LAB",
    indication: "Diabetes mellitus, hypertension, chronic kidney disease, proteinuria",
    specimen: "Random Urine Sample",
    clinicalUtility: "Detects early signs of kidney damage."
  },
  {
    name: "VDRL / Syphilis Screen",
    category: "Infectious Disease",
    dept: "LAB",
    indication: "Syphilis, STD screening, painless genital ulcer, rash on palms and soles",
    specimen: "SST/Gold Top Tube",
    clinicalUtility: "Non-treponemal serologic screening for Syphilis."
  },
  // --- HEMATOLOGY ---
  {
    name: "Complete Blood Count (CBC) w/ Differential",
    category: "Hematology & Coagulation",
    dept: "LAB",
    indication: "Fever of unknown origin, signs of anemia, bleeding tendencies, routine checkup",
    specimen: "EDTA Purple Top Tube (Whole Blood)",
    clinicalUtility: "Evaluates red blood cells, hemoglobin, white blood cells, and platelets. Vital for identifying infection, anemia, and myeloproliferative disorders.",
    referenceRange: "WBC: 4.5 - 11.0 x10^9/L | RBC: 4.50 - 5.90 x10^12/L | Hb: 13.5 - 17.5 g/dL (M), 12.0 - 15.5 g/dL (F) | Plt: 150 - 400 x10^9/L",
    criticalValue: "Hemoglobin: < 7.0 g/dL | Platelets: < 50,000 /uL or > 1,000,000 /uL",
    clinicalSignificance: "Elevated WBC indicates active infection/inflammation. Decreased Hemoglobin indicates anemia. Low Platelets increase hemorrhage risk."
  },
  {
    name: "Coagulation Profile (PT, INR, aPTT)",
    category: "Hematology & Coagulation",
    dept: "LAB",
    indication: "Heparin or Warfarin therapy monitoring, pre-operative screening, active bleeding",
    specimen: "Sodium Citrate Blue Top Tube (Plasma)",
    clinicalUtility: "Measures extrinsic and intrinsic coagulation cascade performance. Critical for patients under anticoagulant therapy or with liver damage.",
    referenceRange: "PT: 11.0 - 13.5 sec | INR: 0.8 - 1.2 (Therapeutic: 2.0 - 3.0) | aPTT: 25 - 35 sec",
    criticalValue: "INR: > 5.0 | aPTT: > 70 sec (unless on clinical heparin protocol)",
    clinicalSignificance: "Prolonged PT/INR indicates Warfarin therapeutic effect, Vitamin K deficiency, or severe liver disease. Prolonged aPTT suggests Factor deficiencies or Heparin dosage."
  },
  {
    name: "Erythrocyte Sedimentation Rate (ESR)",
    category: "Hematology & Coagulation",
    dept: "LAB",
    indication: "Unexplained bone pain, joint inflammation, suspicion of temporal arteritis",
    specimen: "EDTA Purple Top or Black Top Tube",
    clinicalUtility: "Non-specific acute phase reactant representing erythrocyte aggregation; monitors chronic rheumatological changes.",
    referenceRange: "Male: 0 - 15 mm/hr | Female: 0 - 20 mm/hr",
    criticalValue: "ESR: > 100 mm/hr (Highly associated with giant cell arteritis, osteomyelitis, or malignancy)",
    clinicalSignificance: "Indicates active inflammation. Highly elevated in temporal arteritis, rheumatoid arthritis, polymyalgia rheumatica, and acute infections."
  },
  {
    name: "C-Reactive Protein (CRP)",
    category: "Hematology & Coagulation",
    dept: "LAB",
    indication: "Acute infections, rheumatoid arthritis monitoring, postoperative monitoring",
    specimen: "Serum Yellow Top Tube",
    clinicalUtility: "Highly responsive liver-synthesized inflammatory biomarker reflecting active tissue damage or acute infection phases.",
    referenceRange: "< 3.0 mg/L",
    criticalValue: "CRP: > 50.0 mg/L (Indicates severe bacterial infection, tissue infarction, or severe autoimmune flare)",
    clinicalSignificance: "Rises rapidly within hours of inflammation or bacterial tissue damage. Helpful for tracking response to antibiotics and DMARD therapies."
  },
  {
    name: "Iron Studies Panel (Ferritin, Iron, TIBC)",
    category: "Hematology & Coagulation",
    dept: "LAB",
    indication: "Microcytic anemia workup, restless leg syndrome, suspected hemochromatosis",
    specimen: "Serum Yellow Top Tube",
    clinicalUtility: "Assesses total iron body reserves (ferritin), circulating iron levels, and iron binding capabilities.",
    referenceRange: "Ferritin: 30 - 400 ng/mL (M), 15 - 150 ng/mL (F) | Iron: 60 - 170 mcg/dL | TIBC: 240 - 450 mcg/dL",
    criticalValue: "Ferritin: < 10.0 ng/mL (Diagnostic of severe depleted iron store)",
    clinicalSignificance: "Ferritin is the most sensitive marker for iron deficiency. High TIBC with low Ferritin confirms microcytic iron deficiency anemia."
  },
  {
    name: "Vitamin B12 & Serum Folate Assays",
    category: "Hematology & Coagulation",
    dept: "LAB",
    indication: "Macrocytic anemia, progressive unexplained neuropathy, vegan dietary profile",
    specimen: "Serum Yellow Top Tube",
    clinicalUtility: "Required for DNA synthesis evaluation. Megaloblastic anemia helper.",
    referenceRange: "Vitamin B12: 200 - 900 pg/mL | Serum Folate: > 4.0 ng/mL",
    criticalValue: "Vitamin B12: < 150 pg/mL (High risk of subacute combined degeneration of the spinal cord)",
    clinicalSignificance: "Low levels cause megaloblastic anemia. B12 deficiencies lead to progressive peripheral neuropathy and cognitive impairment."
  },

  // --- BIOCHEMISTRY ---
  {
    name: "Urea & Electrolytes (U&Es / BMP)",
    category: "Biochemistry & Organ Panels",
    dept: "LAB",
    indication: "Dehydration, diuretic treatment, suspected renal insufficiency, hypertension",
    specimen: "Serum Yellow Top Tube",
    clinicalUtility: "Quantifies Sodium, Potassium, Chloride, Bicarbonate, Urea, and Creatinine. Crucial for acid-base and fluid regulation monitoring.",
    referenceRange: "Na: 135 - 145 mmol/L | K: 3.5 - 5.0 mmol/L | Urea: 2.5 - 7.1 mmol/L | Creatinine: 60 - 110 umol/L",
    criticalValue: "Sodium: < 120 or > 160 mmol/L | Potassium: < 2.5 or > 6.0 mmol/L | Creatinine: > 300 umol/L (Acute Kidney Injury)",
    clinicalSignificance: "Hyperkalemia (> 5.0) causes cardiac dysrhythmia risk. Rising creatinine is diagnostic of acute or chronic renal impairment."
  },
  {
    name: "Comprehensive Metabolic Panel (CMP)",
    category: "Biochemistry & Organ Panels",
    dept: "LAB",
    indication: "Annual physical exam, severe hypertension, multi-organ symptom presentations",
    specimen: "Serum Yellow Top Tube",
    clinicalUtility: "Broad metabolic baseline covering kidney function, fluid/electrolyte status, liver function, and systemic glucose.",
    referenceRange: "Glucose: 70 - 100 mg/dL | Calcium: 8.5 - 10.2 mg/dL | Total Protein: 6.0 - 8.3 g/dL | Albumin: 3.5 - 5.0 g/dL",
    criticalValue: "Glucose: < 40 or > 500 mg/dL | Calcium: < 6.5 or > 13.0 mg/dL",
    clinicalSignificance: "Provides global picture of nutrition, hydration, and organic status. Hypoglycemia (< 70) or hypocalcemia are emergent states."
  },
  {
    name: "Liver Function Tests (LFTs Profile)",
    category: "Biochemistry & Organ Panels",
    dept: "LAB",
    indication: "Scleral icterus, right upper quadrant pain, chronic alcohol utilization, hepatotoxic drug safety monitoring",
    specimen: "Serum Yellow Top Tube",
    clinicalUtility: "Analyzes Total/Direct Bilirubin, ALT, AST, Alkaline Phosphatase, Total Protein, and Albumin for hepatic cell integrity.",
    referenceRange: "ALT: 7 - 56 U/L | AST: 10 - 40 U/L | ALP: 44 - 147 U/L | Bilirubin: 0.2 - 1.2 mg/dL | Albumin: 3.5 - 5.0 g/dL",
    criticalValue: "ALT/AST: > 1000 U/L (Acute toxic, ischemic, or viral hepatitis)",
    clinicalSignificance: "Elevated ALT/AST reflects hepatocyte necroinflammatory activity. High ALP and Bilirubin indicate cholestatic / biliary obstruction."
  },
  {
    name: "Renal Panel (BUN, Creatinine & eGFR)",
    category: "Biochemistry & Organ Panels",
    dept: "LAB",
    indication: "Known CKD oversight, starting ACE-inhibitors, diabetic metabolic maintenance",
    specimen: "Serum Yellow Top Tube",
    clinicalUtility: "Provides precise calculation of glomerular filtration rate (eGFR) and toxic waste metabolites.",
    referenceRange: "BUN: 7 - 20 mg/dL | Creatinine: 0.6 - 1.2 mg/dL | eGFR: > 90 mL/min/1.73m² (Normal)",
    criticalValue: "eGFR: < 15 mL/min/1.73m² (Kidney Failure / Stage 5 CKD)",
    clinicalSignificance: "Monitoring eGFR is critical prior to initiating potentially nephrotoxic therapies or dosing medications in elderly patients."
  },
  {
    name: "Cardiometabolic Lipid Profile",
    category: "Biochemistry & Organ Panels",
    dept: "LAB",
    indication: "Cardiovascular risk categorization, ASCVD scoring, statin therapy follow-up",
    specimen: "Serum Yellow Top Tube (Fasting preferred)",
    clinicalUtility: "Total Cholesterol, LDL-C (Bad), HDL-C (Good), and Triglycerides. Key for atherosclerosis and metabolic syndromic risk screening.",
    referenceRange: "Total Chol: < 200 mg/dL | LDL-C: < 100 mg/dL | HDL-C: > 40 mg/dL (M), > 50 mg/dL (F) | Triglycerides: < 150 mg/dL",
    criticalValue: "Triglycerides: > 500 mg/dL (Associated with high risk of acute pancreatitis)",
    clinicalSignificance: "High LDL cholesterol scales vascular atherosclerotic risk. Extremely high triglycerides require statin or fibrate mitigation."
  },
  {
    name: "Glycated Hemoglobin (HbA1c)",
    category: "Biochemistry & Organ Panels",
    dept: "LAB",
    indication: "Diabetes Mellitus screening, existing diabetic glycemic control reviews",
    specimen: "EDTA Purple Top Tube (Whole Blood)",
    clinicalUtility: "Measures 3-month average plasma glucose concentration. Gold standard for diabetic therapy response oversight.",
    referenceRange: "Normal: < 5.7% | Prediabetes: 5.7% - 6.4% | Diabetes: >= 6.5%",
    criticalValue: "HbA1c: > 10.0% (Represents extremely poor long-term glycemic regulation)",
    clinicalSignificance: "A standard clinical index for adjusting oral hypoglycemic medications and insulin schedules."
  },
  {
    name: "Cardiac Troponin I / T (High-Sensitivity)",
    category: "Biochemistry & Organ Panels",
    dept: "LAB",
    indication: "Acute onset retrosternal chest pain, dyspnea pointing to acute coronary syndrome (ACS)",
    specimen: "Serum or Plasma Green Top Tube",
    clinicalUtility: "Ultra-sensitive myocardial injury biomarker. Key diagnostic indicator for Non-STEMI and Myocardial Infarction.",
    referenceRange: "< 0.04 ng/mL",
    criticalValue: "Troponin I: > 0.40 ng/mL (Authoritative of acute myocardial infarction)",
    clinicalSignificance: "Serially measured Troponins are essential in emergency departments to diagnose Myocardial Infarction and triage chest pain."
  },
  {
    name: "Brain Natriuretic Peptide (NT-proBNP)",
    category: "Biochemistry & Organ Panels",
    dept: "LAB",
    indication: "Differentiating cardiac versus pulmonary dyspnea, suspected Congestive Heart Failure",
    specimen: "Serum Yellow Top Tube",
    clinicalUtility: "Released by ventricles during hemodynamic stretching. Outstanding negative predictive marker for heart failure.",
    referenceRange: "Age < 75 yr: < 125 pg/mL | Age >= 75 yr: < 450 pg/mL",
    criticalValue: "NT-proBNP: > 900 pg/mL (Indicates decompensated congestive heart failure)",
    clinicalSignificance: "Used clinically to differentiate myocardial stretching (congestive heart failure) from primary pulmonary dyspnea."
  },
  {
    name: "Serum Amylase & Lipase",
    category: "Biochemistry & Organ Panels",
    dept: "LAB",
    indication: "Severe epigastric pain radiating to the back, nausea, suspected acute pancreatitis",
    specimen: "Serum Yellow Top Tube",
    clinicalUtility: "Pancreatic digestive enzymes. Elevations >3x upper limits are highly diagnostic for Acute Pancreatitis.",
    referenceRange: "Amylase: 30 - 110 U/L | Lipase: 10 - 140 U/L",
    criticalValue: "Lipase: > 420 U/L (Diagnostic threshold for Acute Pancreatitis)",
    clinicalSignificance: "Lipase is more specific and sensitive than amylase for pancreatic tissue inflammation."
  },
  {
    name: "Uric Acid / Serum Urates",
    category: "Biochemistry & Organ Panels",
    dept: "LAB",
    indication: "Acute monoarthritis (suspected Gout), nephrolithiasis history",
    specimen: "Serum Yellow Top Tube",
    clinicalUtility: "Measures blood purine waste. High values imply gouty crystallization risk or tumor lysis syndrome.",
    referenceRange: "Male: 3.5 - 7.2 mg/dL | Female: 2.6 - 6.0 mg/dL",
    criticalValue: "Uric Acid: > 12.0 mg/dL",
    clinicalSignificance: "Hyperuricemia can lead to deposition of monosodium urate crystals in joints (gouty flares) or kidneys (nephrolithiasis)."
  },

  // --- ENDOCRINOLOGY ---
  {
    name: "Thyroid Function Tests (TSH, Free T4, Free T3)",
    category: "Endocrinology & Hormones",
    dept: "LAB",
    indication: "Unplanned weight changes, heat/cold intolerance, alopecia, fatigue, tremors",
    specimen: "Serum Yellow Top Tube",
    clinicalUtility: "Evaluates hypothalamic-pituitary-thyroid axis function. Detects primary/secondary Hypothyroidism & Hyperthyroidism.",
    referenceRange: "TSH: 0.40 - 4.00 mIU/L | Free T4: 0.9 - 1.7 ng/dL | Free T3: 2.3 - 4.2 pg/mL",
    criticalValue: "TSH: < 0.1 mIU/L (Thyroid Storm risk) or TSH: > 20.0 mIU/L (Myxedema Coma risk)",
    clinicalSignificance: "Elevated TSH with low Free T4 confirms primary hypothyroidism. Low TSH with high Free T4 indicates hyperthyroidism."
  },
  {
    name: "Cortisol Level (8:00 AM Baseline)",
    category: "Endocrinology & Hormones",
    dept: "LAB",
    indication: "Unexplained orthostatic hypotension, hyperpigmentation, severe refractory fatigue, suspected Addison's or Cushing's",
    specimen: "Serum Yellow Top Tube (8 AM Blood Draw)",
    clinicalUtility: "Measures peak daily glucocorticoid levels. Baseline screening for adrenal insufficiency or hypercortisolism.",
    referenceRange: "8:00 AM draw: 6.0 - 23.0 mcg/dL (Normal diurnal peak)",
    criticalValue: "AM Cortisol: < 3.0 mcg/dL (Suggestive of primary or secondary adrenal crisis risk)",
    clinicalSignificance: "Low morning cortisol indicates adrenal insufficiency. Confirmed with ACTH stimulation test. High cortisol suggests Cushing's syndrome."
  },
  {
    name: "Fasting Serum Insulin & C-Peptide",
    category: "Endocrinology & Hormones",
    dept: "LAB",
    indication: "Evaluating insulin resistance, recurrent hypoglycemia workup, type 1 vs type 2 diabetes differentiation",
    specimen: "Serum Yellow Top Tube",
    clinicalUtility: "Insulin and C-peptide are produced in equimolar amounts. Distinguishes endogenous insulin production from exogenous intake.",
    referenceRange: "Insulin (Fasting): 2.6 - 24.9 uIU/mL | C-Peptide: 1.1 - 4.4 ng/mL",
    criticalValue: "Fasting glucose < 50 mg/dL with Insulin > 6.0 uIU/mL (Evidence of insulinoma or sulfonylurea abuse)",
    clinicalSignificance: "Low C-peptide with high sugars represents Type 1 DM (lack of insulin synthesis). High insulin and C-peptide suggest insulin resistance (Type 2 DM)."
  },
  {
    name: "Reproductive Hormones (FSH, LH, Prolactin)",
    category: "Endocrinology & Hormones",
    dept: "LAB",
    indication: "Secondary amenorrhea, galactorrhea, erectile dysfunction, infertility evaluation",
    specimen: "Serum Yellow Top Tube",
    clinicalUtility: "Assesses anterior pituitary gonadotropins and prolapse metrics. Key for prolactinoma and hyperprolactinemic evaluation.",
    referenceRange: "FSH (Adult): 1.5 - 12.4 mIU/mL | LH: 1.7 - 8.6 mIU/mL | Prolactin: 4.0 - 15.2 ng/mL (M), 4.8 - 23.3 ng/mL (F)",
    criticalValue: "Prolactin: > 200.0 ng/mL (Strongly indicative of pituitary prolactinoma adenoma)",
    clinicalSignificance: "Elevated FSH/LH indicates primary hypogonadism. Elevated prolactin with suppressed gonadotropins suggests hyperprolactinemia."
  },
  {
    name: "Total & Free Testosterone Profiling",
    category: "Endocrinology & Hormones",
    dept: "LAB",
    indication: "Symptomatic hypogonadism, loss of libido, sarcopenia, gynecomastia, hirsutism in females",
    specimen: "Serum Yellow Top Tube (Prior to 10:00 AM)",
    clinicalUtility: "Measures total circulating testosterone and bioactive androgen unbound fraction.",
    referenceRange: "Total Test: 280 - 1100 ng/dL (M), 15 - 70 ng/dL (F)",
    clinicalSignificance: "Decreased testosterone in males indicates primary or secondary hypogonadism, requiring morning confirmation and clinical monitoring."
  },  // --- IMMUNOLOGY & SEROLOGY ---
  {
    name: "Antinuclear Antibodies (ANA) Screen",
    category: "Immunology & Serology",
    dept: "LAB",
    indication: "Malar rash, photosensitivity, unexplained arthralgia, suspicion of Systemic Lupus Erythematosus (SLE)",
    specimen: "Serum Yellow Top Tube",
    clinicalUtility: "High sensitivity screen for autoimmune connective tissue diseases. Positives warrant further antibody subtyping (anti-dsDNA, anti-Smith).",
    referenceRange: "Negative (Titer < 1:40 or < 1:80 by IFA)",
    criticalValue: "ANA: Titer >= 1:320 with homogeneous or nucleolar pattern (Strongly suggests active connective tissue disease)",
    clinicalSignificance: "Extremely sensitive for SLE (95%+), but lacks specificity. Positive screens require specific nuclear antibodies evaluation (e.g. anti-Smith, anti-dsDNA, anti-Ro, anti-La)."
  },
  {
    name: "Rheumatoid Factor (RF) & Anti-CCP Panel",
    category: "Immunology & Serology",
    dept: "LAB",
    indication: "Symmetrical peripheral peripheral polyarthritis, morning stiffness exceeding 1 hour",
    specimen: "Serum Yellow Top Tube",
    clinicalUtility: "Highly specific diagnostic marker (Anti-CCP) for Rheumatoid Arthritis aiding early disease-modifying treatment (DMARDs) startup.",
    referenceRange: "RF: < 14 IU/mL | Anti-CCP: < 20 Units",
    criticalValue: "Anti-CCP: > 60 Units (Highly diagnostic and predictive of aggressive joint erosion)",
    clinicalSignificance: "Anti-CCP antibody is 96% specific for Rheumatoid Arthritis and is elevated years before clinical symptoms manifest."
  },
  {
    name: "HIV 1/2 Antigen/Antibody Fourth-Generation Combo Assay",
    category: "Immunology & Serology",
    dept: "LAB",
    indication: "High-risk exposure, persistent lymphadenopathy, chronic weight loss, candidiasis",
    specimen: "Serum Yellow Top Tube",
    clinicalUtility: "Detects both HIV-1 p24 antigen and HIV-1/2 antibodies, significantly shortening the diagnostic window period.",
    referenceRange: "Non-Reactive (Negative)",
    criticalValue: "Reactive (Indicates presumptive positive; requires mandatory Western Blot/viral load confirmation)",
    clinicalSignificance: "Combines p24 antigen and antibody checks to identify transmission cases within 2 to 3 weeks of potential exposure."
  },
  {
    name: "Hepatitis Viral Panel (HBsAg, Anti-HCV)",
    category: "Immunology & Serology",
    dept: "LAB",
    indication: "Elevated transaminases, needle stick exposure, chronic jaundice signs",
    specimen: "Serum Yellow Top Tube",
    clinicalUtility: "Screens for acute/chronic Hepatitis B surface antigen and active immunoglobulins against Hepatitis C.",
    referenceRange: "HBsAg: Non-Reactive | Anti-HCV: Non-Reactive",
    criticalValue: "HBsAg Reactive (indicates acute or chronic Hepatitis B infection) | Anti-HCV Reactive (requires HCV RNA PCR load validation)",
    clinicalSignificance: "Core screen for occupational exposure and hepatitis diagnostic pathways."
  },
 
  // --- MICROBIOLOGY & FLUIDS ---
  {
    name: "Urinalysis (Dipstick & Microscopy Analysis)",
    category: "Microbiology & Biofluids",
    dept: "LAB",
    indication: "Dysuria, urinary frequency, diabetic screening, suspected acute pyelonephritis",
    specimen: "Clean Catch Mid-stream Sterile Urine Container",
    clinicalUtility: "Detects nitrites, leukocyte esterase, protein, glucose, and microscopically assesses cast levels and bacterial presence.",
    referenceRange: "pH: 4.5 - 8.0 | Sp. Gravity: 1.005 - 1.030 | Protein/Glucose/Ketones/Blood/Bilirubin/Nitrite/Leukocyte: Negative",
    criticalValue: "Numerous RBC casts (Glomerulonephritis) or heavy proteinuria (>300 mg/dL)",
    clinicalSignificance: "Positive Nitrites and Leukocyte Esterase are highly suggestive of standard bacterial Urinary Tract Infection."
  },
  {
    name: "Urine Culture & Sensitivity Testing",
    category: "Microbiology & Biofluids",
    dept: "LAB",
    indication: "Recurrent cystitis, pregnancy with bacteriuria, suspected pyelonephritis, post-treatment failure",
    specimen: "Sterile urine container",
    clinicalUtility: "Identifies pathogenic bacterial strains (>10^5 CFU/mL) and maps optimal therapeutic drug antimicrobial sensitivities.",
    referenceRange: "No growth at 24 - 48 hours",
    criticalValue: "Presence of multi-drug resistant strains (e.g. ESBL E. coli or MRSA in urine)",
    clinicalSignificance: "Invaluable for picking targeted oral or IV antibiotic therapies instead of empirical treatments."
  },
  {
    name: "Blood Cultures (Aerobic & Anaerobic Bottles)",
    category: "Microbiology & Biofluids",
    dept: "LAB",
    indication: "Suspected systemic inflammatory response (SIRS), sepsis, bacteremia, endocarditis",
    specimen: "Direct dual-site venipuncture (minimum 10ml/bottle)",
    clinicalUtility: "Gold standard for identifying systemic microbial pathogens guiding narrow-spectrum IV antibiotic selections."
  },
  {
    name: "Stool PCR Panel & C. difficile toxin assay",
    category: "Microbiology & Biofluids",
    dept: "LAB",
    indication: "Persistent watery diarrhea following systemic clindamycin/quinolone therapy, suspected colitis",
    specimen: "Fresh stool transport container",
    clinicalUtility: "PCR assay for Clostridioides difficile toxins A and B genes. Prevents toxic megacolon via early directed oral Vancomycin."
  },

  // --- IMAGING / RADIOLOGY ---
  {
    name: "X-Ray Chest Posteroanterior & Lateral (PA/Lat)",
    category: "Imaging & Plain Radiography",
    dept: "X_RAY",
    indication: "Productive cough, crackles on auscultation, trauma, hemoptysis, suspected pleural effusion",
    specimen: "Not Applicable (Direct Optical Radiography)",
    clinicalUtility: "Differentiates lung consolidations, cardiomegaly, effusions, pneumothorax, and skeletal trauma."
  },
  {
    name: "X-Ray Abdomen Erect & Supine (KUB Layout)",
    category: "Imaging & Plain Radiography",
    dept: "X_RAY",
    indication: "Sudden abdominal distension, severe collinear abdominal colic, absent bowel sounds",
    specimen: "Not Applicable (Direct Optical Radiography)",
    clinicalUtility: "Evaluates intestinal air-fluid levels, bowel loops dilation (volvulus/ileus), and radio-opaque renal calculi."
  },
  {
    name: "Ultrasound Abdomen Complete (HPB & Renal Focus)",
    category: "Imaging & Plain Radiography",
    dept: "X_RAY",
    indication: "Right upper quadrant pain (Murphy's focus), suspected gallstones, unexplained ascites",
    specimen: "Not Applicable (High Frequency Acoustic Probe)",
    clinicalUtility: "Evaluates liver parenchyma, gallstones, biliary tract dilation, pancreatic pathology, spleen size, and renal outlines."
  },
  {
    name: "Ultrasound Doppler Lower Extremity (DVT Screen)",
    category: "Imaging & Plain Radiography",
    dept: "X_RAY",
    indication: "Unilateral lower calf swelling, warmth, pain, calf compression tenderness (Well's Score high)",
    specimen: "Not Applicable (High Frequency Acoustic Probe)",
    clinicalUtility: "Assesses femoral and popliteal vein flow/compressibility. Highly accurate diagnostic modality for ruling out Deep Vein Thrombosis."
  },
  {
    name: "CT Brain & Skull (Non-Contrast / Stroke Protocol)",
    category: "Imaging & Plain Radiography",
    dept: "X_RAY",
    indication: "Acute onset hemiparesis, sudden thunderclap headache, primary trauma with loss of consciousness",
    specimen: "Not Applicable (Computed Tomography X-Ray Assembly)",
    clinicalUtility: "Crucial first-line emergency study to exclude active hemorrhage before initiating thrombolytic (tPA) therapies under acute ischemic stroke."
  },
  {
    name: "CT Pulmonary Angiography (CTPA Protocol)",
    category: "Imaging & Plain Radiography",
    dept: "X_RAY",
    indication: "Sudden dyspnea, pleuritic chest pain, elevated D-dimer, Wells Score indicating high PE probability",
    specimen: "Not Applicable (Computed Tomography with IV Contrast)",
    clinicalUtility: "Gold standard imaging diagnostic reference for detecting filling defects within pulmonary arterial trunks indicating embolizations."
  },
  {
    name: "MRI Brain & Cerebral Vessels (With/Without Contrast)",
    category: "Imaging & Plain Radiography",
    dept: "X_RAY",
    indication: "Progressive neurological deficits, focal seizures, suspicion of demyelinating disease (Multiple Sclerosis) or space-occupying lesions",
    specimen: "Not Applicable (Magnetic Resonance Scan)",
    clinicalUtility: "Superb soft tissue resolution. Ideal for demyelinating plaques, vascular micro-malformations, and intracranial tumor staging."
  },
  {
    name: "MRI Magnetic Resonance Cholangiopancreatography (MRCP)",
    category: "Imaging & Plain Radiography",
    dept: "X_RAY",
    indication: "Obstructive jaundice with common bile duct dilation seen on Ultrasound, high serum alkaline phosphatase",
    specimen: "Not Applicable (Magnetic Resonance Scan)",
    clinicalUtility: "Non-invasive visualization of biliary and pancreatic ducts. Detects choledocholithiasis, strictures, or tumors."
  },
  {
    name: "12-Lead Electrocardiography (Diagnostic ECG)",
    category: "Imaging & Plain Radiography",
    dept: "X_RAY",
    indication: "Retrosternal chest tightness, unexplained syncope, palpitations, drug safety monitoring",
    specimen: "Not Applicable (Microvolt Bioelectric Terminals)",
    clinicalUtility: "Evaluates cardiac rhythm, conduction delays, acute ischemia (ST elevation/depression), or systemic electrolyte changes impact."
  },
  // --- EXTENDED RHEUMATOLOGY & DERMATOLOGY ---
  {
    name: "Anti-dsDNA & Anti-Smith (Sm) Antibodies",
    category: "Immunology & Serology",
    dept: "LAB",
    indication: "Positive ANA, suspected Systemic Lupus Erythematosus (SLE), lupus nephritis monitoring.",
    specimen: "Serum Yellow Top Tube",
    clinicalUtility: "Anti-dsDNA is highly specific for SLE and correlates with disease activity. Anti-Smith is specific but lacks sensitivity."
  },
  {
    name: "ANCA Panel (p-ANCA / MPO, c-ANCA / PR3)",
    category: "Immunology & Serology",
    dept: "LAB",
    indication: "Suspected systemic vasculitis (Wegener's, Microscopic polyangiitis, Churg-Strauss).",
    specimen: "Serum Yellow Top Tube",
    clinicalUtility: "Crucial for diagnosing and monitoring small-vessel vasculitides."
  },
  {
    name: "Complement C3 & C4",
    category: "Immunology & Serology",
    dept: "LAB",
    indication: "Monitoring SLE disease activity, cryoglobulinemia, suspected complement deficiency.",
    specimen: "Serum Yellow Top Tube",
    clinicalUtility: "Low levels indicate active immune complex consumption (flare)."
  },
  {
    name: "Skin Biopsy (H&E, Direct Immunofluorescence)",
    category: "Dermatopathology",
    dept: "LAB",
    indication: "Suspected blistering disorders (Pemphigus/Pemphigoid), cutaneous lupus, undetermined rashes.",
    specimen: "Skin punch or incisional biopsy in formalin/Michel's medium",
    clinicalUtility: "Gold standard for diagnosing inflammatory dermatoses and cutaneous malignancies."
  },
  {
    name: "KOH Preparation (Fungal scraping)",
    category: "Microbiology & Fluids",
    dept: "LAB",
    indication: "Suspected tinea (ringworm), onychomycosis, candidiasis, pityriasis versicolor.",
    specimen: "Skin scrapings, nail clippings, hair plucks",
    clinicalUtility: "Rapid bedside/lab visualization of fungal hyphae and spores."
  },
  {
    name: "Total IgE & Specific IgE (RAST Panel)",
    category: "Immunology & Serology",
    dept: "LAB",
    indication: "Atopic dermatitis, chronic urticaria, allergic rhinitis, suspected food/environmental allergies.",
    specimen: "Serum Yellow Top Tube",
    clinicalUtility: "Identifies systemic atopy and specific allergen triggers without risk of anaphylaxis (unlike skin pricks)."
  },
  // --- EXTENDED CARDIOLOGY & GASTROENTEROLOGY ---
  {
    name: "Creatine Kinase-MB (CK-MB) & Myoglobin",
    category: "Cardiology",
    dept: "LAB",
    indication: "Suspected acute myocardial infarction (AMI), re-infarction evaluation.",
    specimen: "Serum Yellow Top Tube",
    clinicalUtility: "Myoglobin rises early (1-4 hours). CK-MB is useful for diagnosing re-infarction due to its shorter half-life compared to Troponin."
  },
  {
    name: "Lipoprotein (a) & Apolipoproteins (A1, B)",
    category: "Cardiology",
    dept: "LAB",
    indication: "Premature coronary artery disease, strong family history of ASCVD, risk stratification.",
    specimen: "Serum Yellow Top Tube",
    clinicalUtility: "Advanced lipid profiling for assessing genetic cardiovascular risk independent of standard LDL levels."
  },
  {
    name: "Fecal Elastase",
    category: "Gastroenterology",
    dept: "LAB",
    indication: "Chronic diarrhea, steatorrhea, suspected exocrine pancreatic insufficiency (e.g., chronic pancreatitis, cystic fibrosis).",
    specimen: "Stool sample",
    clinicalUtility: "Highly specific non-invasive marker for pancreatic exocrine function."
  },
  {
    name: "ASCA (Anti-Saccharomyces cerevisiae antibodies)",
    category: "Gastroenterology",
    dept: "LAB",
    indication: "Inflammatory Bowel Disease (IBD) differentiation (Crohn's vs. Ulcerative Colitis).",
    specimen: "Serum Yellow Top Tube",
    clinicalUtility: "ASCA positive / p-ANCA negative strongly suggests Crohn's disease."
  },
  {
    name: "Urea Breath Test",
    category: "Gastroenterology",
    dept: "LAB",
    indication: "Active H. pylori infection diagnosis, confirming eradication post-treatment.",
    specimen: "Breath sample after swallowing urea capsule",
    clinicalUtility: "Gold standard non-invasive test for active H. pylori; more accurate than serology."
  },
  // --- EXTENDED ENDOCRINOLOGY & IMMUNOLOGY ---
  {
    name: "ACTH & Cortisol Profiling",
    category: "Endocrinology & Hormones",
    dept: "LAB",
    indication: "Suspected Addison's disease, Cushing's syndrome, adrenal incidentalomas.",
    specimen: "Plasma Purple Top (ACTH on ice), Serum Yellow Top (Cortisol)",
    clinicalUtility: "Differentiates primary from secondary adrenal insufficiency/hypercortisolism."
  },
  {
    name: "Aldosterone & Plasma Renin Activity",
    category: "Endocrinology & Hormones",
    dept: "LAB",
    indication: "Resistant hypertension, severe unexplained hypokalemia (suspected primary aldosteronism).",
    specimen: "Plasma Purple/Green Top",
    clinicalUtility: "Aldosterone-to-Renin Ratio (ARR) is the gold standard screening test for Conn's syndrome."
  },
  {
    name: "TSH Receptor Antibodies (TRAb/TSI)",
    category: "Endocrinology & Autoimmune",
    dept: "LAB",
    indication: "Suspected Graves' disease, differentiation of hyperthyroid states, neonatal risk assessment.",
    specimen: "Serum Yellow Top Tube",
    clinicalUtility: "Highly specific for Graves' disease pathophysiology."
  },
  {
    name: "Immunoglobulins Profile (IgA, IgG, IgM)",
    category: "Immunology & Serology",
    dept: "LAB",
    indication: "Recurrent infections, suspected primary immunodeficiency, multiple myeloma workup.",
    specimen: "Serum Yellow Top Tube",
    clinicalUtility: "Quantifies the major antibody classes to diagnose hypo- or hypergammaglobulinemia."
  },
  {
    name: "CD4/CD8 Lymphocyte Count (Flow Cytometry)",
    category: "Immunology & Serology",
    dept: "LAB",
    indication: "HIV infection monitoring, primary immunodeficiency evaluation, post-transplant monitoring.",
    specimen: "Whole Blood Purple Top (EDTA)",
    clinicalUtility: "Crucial for staging HIV progression and determining opportunistic infection prophylaxis."
  },
  {
    name: "AMA, ASMA, LKM-1 Antibodies Panel",
    category: "Immunology & Serology",
    dept: "LAB",
    indication: "Unexplained chronic hepatitis, cirrhosis, suspected autoimmune liver disease.",
    specimen: "Serum Yellow Top Tube",
    clinicalUtility: "AMA specific for Primary Biliary Cholangitis (PBC). ASMA and LKM-1 are specific for Autoimmune Hepatitis (AIH)."
  },
  // --- EXTENDED INFECTIOUS DISEASES & INFERTILITY ---
  {
    name: "TORCH Panel (Toxo, Rubella, CMV, HSV)",
    category: "Microbiology & Infectious Diseases",
    dept: "LAB",
    indication: "Congenital anomalies screening during pregnancy, neonatal infections.",
    specimen: "Serum Yellow Top Tube",
    clinicalUtility: "Crucial for identifying teratogenic infections impacting fetal development and maternal health."
  },
  {
    name: "QuantiFERON-TB Gold",
    category: "Microbiology & Infectious Diseases",
    dept: "LAB",
    indication: "Suspected latent Tuberculosis, pre-immunosuppressive therapy screening.",
    specimen: "Specialized QFT Blood Tubes",
    clinicalUtility: "Highly specific interferon-gamma release assay (IGRA) unaffected by prior BCG vaccination."
  },
  {
    name: "Anti-Mullerian Hormone (AMH)",
    category: "Infertility & Reproduction",
    dept: "LAB",
    indication: "Ovarian reserve assessment, premature ovarian failure, PCOS evaluation, IVF planning.",
    specimen: "Serum Yellow Top Tube",
    clinicalUtility: "Best biomarker for estimating the remaining follicular pool (ovarian reserve) regardless of the menstrual cycle day."
  },
  {
    name: "Sperm DNA Fragmentation Index (DFI)",
    category: "Infertility & Reproduction",
    dept: "LAB",
    indication: "Unexplained male infertility, recurrent IVF/ICSI failures, recurrent pregnancy loss.",
    specimen: "Fresh Semen Sample",
    clinicalUtility: "Evaluates the integrity of sperm genetic material, which standard seminal fluid analysis (SFA) cannot detect."
  },
  {
    name: "Thrombophilia Screen Profile",
    category: "Hematology & Infertility",
    dept: "LAB",
    indication: "Recurrent miscarriage, unprovoked DVT/PE, strong family history of coagulopathy.",
    specimen: "Plasma Blue Top (Citrate)",
    clinicalUtility: "Tests for Factor V Leiden, Prothrombin mutation, Protein C/S deficiency, and Antithrombin III to explain recurrent fetal loss."
  },
  // --- EXTENDED HEMATOLOGY & GENETICS ---
  {
    name: "Hemoglobin Electrophoresis",
    category: "Hematology & Blood Disorders",
    dept: "LAB",
    indication: "Unexplained microcytic anemia with normal iron studies, suspected Thalassemia or Sickle Cell Disease.",
    specimen: "Whole Blood Purple Top (EDTA)",
    clinicalUtility: "Separates and quantifies abnormal hemoglobins (HbS, HbC) and elevates HbA2/HbF for Thalassemia trait diagnosis."
  },
  {
    name: "G6PD Assay (Quantitative)",
    category: "Hematology & Blood Disorders",
    dept: "LAB",
    indication: "Episodic hemolytic anemia following exposure to fava beans, antimalarials, or sulfa drugs.",
    specimen: "Whole Blood Purple Top (EDTA)",
    clinicalUtility: "Definitive diagnosis of G6PD deficiency, the most common red blood cell enzyme defect."
  },
  {
    name: "JAK2 V617F & BCR-ABL1 Mutations",
    category: "Hematology / Molecular Oncology",
    dept: "LAB",
    indication: "Unexplained polycythemia, thrombocytosis, or suspected Chronic Myeloid Leukemia (CML).",
    specimen: "Whole Blood Purple Top or Bone Marrow Aspirate",
    clinicalUtility: "JAK2 is diagnostic for Polycythemia Vera/Essential Thrombocythemia. BCR-ABL1 (Philadelphia chromosome) is diagnostic for CML."
  },
  {
    name: "Whole Exome Sequencing (WES)",
    category: "Genetics & Molecular Pathology",
    dept: "LAB",
    indication: "Complex pediatric developmental delays, undiagnosed rare congenital syndromes.",
    specimen: "Whole Blood Purple Top (EDTA)",
    clinicalUtility: "Sequences all protein-coding regions of the genome (~20,000 genes) to identify rare monogenic disorders."
  },
  {
    name: "Chromosomal Microarray Analysis (CMA)",
    category: "Genetics & Molecular Pathology",
    dept: "LAB",
    indication: "Autism spectrum disorder, multiple congenital anomalies, intellectual disability.",
    specimen: "Whole Blood Purple Top (EDTA)",
    clinicalUtility: "First-tier genetic test replacing standard karyotyping for microdeletions and microduplications."
  }
];

// ==========================================
// IRAQI PRIVATE PHARMACY TRADE NAMES DATABASE
// ==========================================
export const iraqiTradeNamesMap: Record<string, string[]> = {
  "Omeprazole": ["Losec", "Gasec", "Omedar", "Omeprex", "Risek", "Omiz", "Sopral"],
  "Lansoprazole": ["Lanzor", "Prevacid", "Lansor", "Lanzotec", "Lansoprol"],
  "Pantoprazole": ["Controloc", "Protium", "Pantomax", "Panto-Samir", "Pansec", "Gastrazol"],
  "Loperamide": ["Imodium", "Lopemid", "Diarstop", "Lodin"],
  "Ranitidine": ["Zantac", "Rani-Samir", "Rantidine SDI", "Racid", "Histac"],
  "Famotidine": ["Pepcid", "Famosamir", "Gaster", "Famodar", "Noflux"],
  "Esomeprazole": ["Nexium", "Esocare", "Nexpro", "EsoSamar", "Colizole", "Esomax"],
  "Amoxicillin": ["Amoxil", "Amoxicillin SDI", "Pionoxil", "Eomox", "Amoxypen"],
  "Amoxicillin + Clavulanate": ["Augmentin", "Julmentin", "Amoclan", "Curam", "Klavox", "Megamox", "Co-Amoxin"],
  "Clarithromycin": ["Klacid", "Clar Samer", "Crixan", "Claribid"],
  "Azithromycin": ["Zithromax", "Azomycine", "Azi-Once", "Zonamax", "Azadose"],
  "Ciprofloxacin": ["Ciprobay", "Cipro Pioneer", "Ciprodar", "Cipro-Samara"],
  "Metronidazole": ["Flagyl", "Metro SDI", "Metrogyl", "Flagesol", "Dumazole"],
  "Paracetamol": ["Panadol", "Rowadon", "Emadol", "Adol", "Feveradol", "Apadol", "Revanin", "Paracetamol Samara"],
  "Ibuprofen": ["Brufen", "Profen Samara", "Profenal", "Ibuprof", "Advil"],
  "Aspirin": ["Aspirin", "Cardiprin", "Aspegic", "Thrombo-ASP"],
  "Atenolol": ["Tenormin", "Ateno SDI", "Atenodar"],
  "Metformin": ["Glucophage", "Glucamica", "Diophage", "Metfor", "Formin"],
  "Atorvastatin": ["Lipitor", "Ator", "Aledor", "Lipomax", "Atoridin", "Atorva Pioneer"],
  "Amlodipine": ["Norvasc", "Amlor", "Amlopin", "Myodura"],
  "Lisinopril": ["Zestril", "Lisino SDI", "Lisipril", "Lisinostad"],
  "Cetirizine": ["Zyrtec", "Histazine", "Cetira", "Zetron"],
  "Loratadine": ["Clarityne", "Loratin", "Lohist", "Lorado"],
  "Salbutamol": ["Ventolin", "Butalin", "Aerolin", "Asthalin"],
  "Montelukast": ["Singulair", "Airfast", "Monas-Pioneer", "Montel"],
  "Fluconazole": ["Diflucan", "Fluzol", "Fungican", "Flucandest"],
  "Hydrocortisone 1% Cream": ["Hydrocort Cream", "Microcort", "Cortiderm", "Sopol"],
  "Betamethasone Valerate 0.1% Cream (Betnovate)": ["Betnovate", "Betasone", "Betacort", "Betascon"],
  "Clobetasol Propionate 0.05% Ointment (Dermovate)": ["Dermovate", "Clobet", "Dermacort", "Dermasol", "Movate"],
  "Fusidic Acid 2% Cream (Fucidin)": ["Fucidin", "Fusibact", "Bio-Fucin", "Fusiderm", "Fucicream"],
  "Fusidic Acid 2% + Hydrocortisone 1% Cream (Fucidin H)": ["Fucidin H", "Fusibact H", "Fusiderm H", "Fucizone", "Fucicort"],
  "Mupirocin 2% Ointment (Bactroban)": ["Bactroban", "Mupiderm", "Mupiroban", "Supirocin"],
  "Clotrimazole 1% Cream (Canesten)": ["Canesten", "Fungiderm", "Cloderm", "Candid", "Gyno-Canesten"],
  "Ketoconazole 2% Shampoo (Nizoral)": ["Nizoral", "Ketozal", "Konazol", "Ketomed", "Dandrazol"],
  "Terbinafine 1% Cream (Lamisil)": ["Lamisil", "Fungisil", "Terbisil", "Tebina", "Lamiderm"],
  "Permethrin 5% Cream (Lyclear)": ["Lyclear", "Scabicid", "Permethrin Awamedica", "Elimite"],
  "Benzoyl Peroxide 5% Gel (Acnecide)": ["Acnecide", "Benzac AC", "Brevoxyl", "Oxyderm"],
  "Adapalene 0.1% Gel (Differin)": ["Differin", "Ada-Gel", "Adiff", "Adapal Awamedica"],
  "Tretinoin 0.05% Cream (Retin-A)": ["Retin-A", "Acretin", "Avotin", "Tretin", "Torno-A"],
  "Tacrolimus 0.1% Ointment (Protopic)": ["Protopic", "Tacrose", "Takrozem", "Tacrolis"],
  "Urea 10% Cream (Dermalibour / Cetaphil)": ["Urea Cream", "Carmol", "Kerella", "Ureacare"],
  "Aqueous Cream (Cetomacrogol Emollient)": ["Aqueous Cream", "Cetomacrogol Cream"],
  "Calamine Topical Cream / Lotion": ["Calamine Lotion", "Caladryl", "Histacalamine"],
  "Minoxidil 5% Topical Spray (Regaine)": ["Regaine", "Hairgrow", " Rogaine", "Minoxigrow", "Neoxidil"],
  "Calcipotriol 50 mcg/g Ointment (Dovonex)": ["Dovonex", "Daivonex", "Psorcutan", "Calcitriol Ointment"],
  "Isotretinoin 0.05% Gel (Isotrexin)": ["Isotrexin", "Isotre Gel", "Roaccutane Gel"],
  "Zinc Oxide Ointment (Sudocrem)": ["Sudocrem", "Rash Cream", "Zinco-Samara", "Zinsol"],
  "Coal Tar 5% Topical Solution (Psoriderm Cream/Gel)": ["Psoriderm", "Polytar", "Coal Tar Solution"],
  "Ciclopirox Olamine 1% Cream (Loprox)": ["Loprox", "Ciclopirox Awamedica", "Batrafen"],
  "Econazole Nitrate 1% Cream (Pevaryl)": ["Pevaryl", "Econazole Cream", "Ecoderm"],
  "Salicylic Acid 10% in Vaseline Ointment": ["Keratolytic Ointment", "Salicylic Vaseline"],
  "Dermovate Scalp Application (Clobetasol Propionate 0.05%)": ["Dermovate Scalp", "Clobet Scalp", "Dermacort Scalp"],
  "Elica Cream (Mometasone Furoate 0.1%)": ["Elica cream", "Elocom Cream", "Momecon Cream"],
  "Elocom Ointment (Mometasone Furoate 0.1%)": ["Elocom Ointment", "Momecon Ointment", "Elica Ointment"],
  "Fusibact Cream (Fusidic Acid 2%)": ["Fusibact Cream", "Fucidin Cream", "Fusiderm Cream"],
  "Nystatin 100,000 U/g Cream (Mycostatin)": ["Mycostatin Cream", "Nystatin Cream Awamedica", "Candistatin"],
  "Diprogenta Cream (Betamethasone Valerate + Gentamicin)": ["Diprogenta", "Betagent Cream", "Betamethasone Gentamicin Cream"],
  "Diprosalic Ointment (Betamethasone Dipropionate + Salicylic Acid)": ["Diprosalic", "Betasalic Ointment", "Salicort Ointment"],
  "Daivobet Ointment (Calcipotriol + Betamethasone Dipropionate)": ["Daivobet", "Dovobet", "Calcipotriol Betamethasone"],
  "Differin 0.1% Cream (Adapalene)": ["Differin Cream", "Adapalene Cream Awamedica"],
  "Moisturizing Cream (Cetaphil / CeraVe / Physiogel)": ["Cetaphil Cream", "CeraVe Moisturizing Cream", "Physiogel Cream"],
  "Avène Cicalfate+ Restorative Protective Cream": ["Cicalfate+", "Avène Cicalfate"],
  "La Roche-Posay Cicaplast Baume B5+": ["Cicaplast Baume B5", "Cicaplast Cream"],
  "Biafine Emulsion (Trolamine 0.67%)": ["Biafine", "Biafine Emulsion"],
  "Silon Cream (Barrier Cream)": ["Silon Cream", "Silicone Barrier Cream"],
  "Sebocur Shampoo (Anti-Seborrheic)": ["Sebocur Shampoo", "Sebocur Anti-Dandruff"],
  "Gliclazide": ["Diamicron", "Glicron", "Gliclazide Awamedica"],
  "Sitagliptin": ["Januvia", "Sitavia", "Zanovia"],
  "Pioglitazone": ["Actos", "Glizone", "PioSamar"],
  "Simvastatin": ["Zocor", "Simgal", "Simva Pioneer"],
  "Rosuvastatin": ["Crestor", "Rosusamer", "Rosu Pioneer", "Crestor Samarra"],
  "Ramipril": ["Tritace", "Ramipril Pioneer", "Ramipress"],
  "Valsartan": ["Diovan", "Valza", "Valsartan Pioneer"],
  "Sildenafil": ["Viagra", "Erec", "Silda", "Vigoran"],
  "Tadalafil": ["Cialis", "Tada", "Regalis", "Tadacip"],
  "Warfarin": ["Coumadin", "Warfarin SDI", "Marevan"],
  "Clopidogrel": ["Plavix", "Clopilet", "Clopi Awamedica", "Plogrel"],
  "Alendronic Acid": ["Fosamax", "Alendronate Samson", "Osteofos"],
  "Levothyroxine": ["Euthyrox", "Thyrax", "Eltroxin"],
  "Prednisolone": ["Prednisolone SDI", "Precor", "Sopolone", "Meticorten"],
  "Latanoprost Eye Drops 0.005%": ["Xalatan", "Latabi", "Latanoprost Awamedica", "Latanoph", "Xalacom"],
  "Timolol Eye Drops 0.5%": ["Nyolol", "Timoptol", "Cusimolol", "Timo-COUP"],
  "Tobramycin Eye Drops 0.3%": ["Tobrex", "Tobrex SDI", "Tobrasol", "Tobra-Samara"],
  "Prednisolone Acetate Eye Drops 1%": ["Pred Forte", "Pred-Forte SDI", "Optipred", "Prednipred"],
  "Sodium Hyaluronate 0.15% Eye Drops (Lubricant)": ["Hylo-Comod", "Artelac", "Tear Naturale", "Refresh Tears", "Systane Ultra", "Optive", "Biotears"],
  "Olopatadine Eye Drops 0.1%": ["Patanol", "Olopat", "Opatanol", "Olo-Drops"],
  "Chloramphenicol 1% Eye Ointment": ["Chloromycetin", "Opticort", "Chloro-Ophthal", "Fenicol Eye Ointment"],
  "Tobramycin 0.3% + Dexamethasone 0.1% Eye Ointment": ["Tobradex", "Tobradex Ointment", "Spectradex"],
  "Tetracycline 1% Eye Ointment": ["Tetracycline SDI", "Achromycin", "Tetramed Ophthalmic"],
  "Xylometazoline 0.1% Nasal Spray": ["Otrivin", "Otrivine SDI", "Nasolin", "Xylomet", "Sinutab Nasal"],
  "Fluticasone Propionate Nasal Spray": ["Flixonase", "Flonase", "Avamys", "Nazonex", "Nasofan", "Flutinas"],
  "Mometasone Furoate Nasal Spray": ["Nasonex", "Momet Nasal", "Metaspray", "Nazoster"],
  "Ciprofloxacin 0.3% + Dexamethasone 0.1% Ear Drops": ["Ciprodex", "Cipro-Dex Otic", "Otocip", "Dexacip Otic"],
  "Sodium Bicarbonate 5% Ear Drops (Wax Softener)": ["Waxsol", "Cerumol", "Soda-Ear SDI", "Sodabicarb Drops"],
  "Betamethasone 0.1% + Neomycin 0.5% Ear/Eye Drops": ["Betnesol-N", "Vista-Methasone N", "Betasone-N", "Neo-Betacor"],
  "Sunscreen SPF 50+ Cream/Fluid": ["La Roche-Posay Anthelios", "Bioderma Photoderm", "Eucerin Sun", "Vichy Capital Soleil", "Isdin Fusion Water"],
  "Daily Moisturizing Cream / Lotion": ["CeraVe Moisturizer", "Cetaphil Lotion", "Physiogel", "QV Cream", "Eucerin UreaRepair"],
  "Vitamin C 10-20% Serum": ["Vichy Vitamin C", "La Roche-Posay Pure Vitamin C", "Garnier Vitamin C", "Skinceuticals CE Ferulic"],
  "Hyaluronic Acid Serum": ["L'Oreal Revitalift Filler", "Vichy Minéral 89", "La Roche-Posay Hyalu B5", "The Ordinary Hyaluronic Acid"],
  "Niacinamide 10% Serum": ["The Ordinary Niacinamide", "La Roche-Posay Effaclar Serum", "Paula's Choice Niacinamide"],
  "Dexpanthenol 5% Cream": ["Bepanthen Cream", "Panthophil", "Panthenol"],
  "Salicylic Acid 2% Cleanser": ["CeraVe SA Cleanser", "La Roche-Posay Effaclar Gel", "Neutrogena Oil-Free Acne Wash"],
  "Glycolic Acid 7% Toning Solution": ["The Ordinary Glycolic Acid", "Pixi Glow Tonic", "L'Oreal Glycolic Toner"],
  "Tetracycline": ["Tetracyn", "Samacycline", "Achromycin"],
  "Tetracycline Topical Ointment": ["Tetra Ointment SDI", "Samacycline Ointment"],
  "Neomycin Topical Ointment": ["Neocin", "Neomycin SDI", "Baneocin"],
  "Triamcinolone Acetonide 0.1% Dental Paste": ["Kenalog in Orabase", "Kenacort-A Orabase", "Trinolone", "Oralone"],
  "Choline Salicylate Dental Gel": ["Bonjela", "Mundisal Gel", "Oral-Jel"],
  "Hyaluronic Acid 0.2% Oral Gel/Spray": ["Gengigel", "Hyalugel", "Curasan", "Aftamed"],
  "Chlorhexidine Gluconate 0.2% Mouthwash": ["Corsodyl", "Kina", "Hexidine", "Chlorhex"],
  "Beta-sitosterol 0.25% Ointment (MEBO)": ["MEBO", "MEBO Burn", "Avalon Burn Ointment", "Burnaid"],
  "Triticum Vulgare Extract Cream": ["Fito Cream", "Fitostimoline"],
  "Collagenase + Chloramphenicol Ointment": ["Iruxol", "Novuxol", "Bionect"],
  "Silver Sulfadiazine 1% Cream": ["Flamazine", "Dermazin", "Silverdin", "Silvadene"],
  "Povidone-Iodine 10% Ointment/Solution": ["Betadine", "Septadine", "Poviderm"],
  "Imiquimod 5% Cream": ["Aldara", "Vyloma", "Zyclara"],
  "Podophyllotoxin 0.5% Solution/Cream": ["Condyline", "Wartec", "Condylox"],
  "Clotrimazole 2% Vaginal Cream / 500mg Pessary": ["Gyno-Canesten", "Candid-V", "Cloderm Vaginal", "Canesten Pessary"],
  "Miconazole 2% Vaginal Cream": ["Gyno-Daktarin", "Monistat", "Micazole Vaginal"],
  "Metronidazole 0.75% Vaginal Gel": ["MetroGel Vaginal", "Vandazole", "Flagyl Vaginal"],
  "Clindamycin 2% Vaginal Cream": ["Dalacin V", "Cleocin Vaginal", "Clindesse"],
  "Conjugated Estrogens Vaginal Cream": ["Premarin Vaginal", "Ovestin", "Estriol Vaginal"],
  "Hyoscine Butylbromide 10mg Tablet": ["Buscopan", "Hyoscine SDI", "Spasmopan", "Riabal"],
  "Mebeverine 135mg Tablet": ["Duspatalin", "Colofac", "Mebadil", "Duspatalin Retard"],
  "Ondansetron 4mg/8mg Tablet": ["Zofran", "Danset", "Vomigo", "Ondavell"],
  "Metoclopramide 10mg Tablet": ["Plasil", "Meclodin", "Pramin", "Metoclopramide SDI"],
  "Domperidone 10mg Tablet": ["Motilium", "Dompy", "Moti-Samer", "Domperidone SDI"],
  "Esomeprazole 20mg/40mg Capsule": ["Nexium", "Esomax", "Ezomep", "Nexpro"],
  "Pantoprazole 20mg/40mg Tablet": ["Controloc", "Pantazol", "Panto-Pioneer", "Toprazole"],
  "Lactulose Syrup (3.3g/5ml)": ["Duphalac", "Lactulose SDI", "Lactu", "Sedalac"],
  "Loperamide 2mg Capsule": ["Imodium", "Lopermid", "Loperamide SDI", "Imotil"],
  "Ivy Leaf Extract Syrup": ["Prospan", "Pectosol", "Ivy Syrup", "Zecuf"],
  "Desloratadine 5mg Tablet": ["Aerius", "Deslor", "Neoloridin", "Lora-D"],
  "Levocetirizine 5mg Tablet": ["Xyzal", "Levocet", "Zyncet", "Levo-Zyrtec"],
  "Fexofenadine 120mg Tablet": ["Telfast", "Fexo", "Allerfen", "Fexofenadine SDI"],
  "Budesonide/Formoterol Turbuhaler": ["Symbicort", "Foracort", "Bufomix"],
  "Fluticasone/Salmeterol Inhaler": ["Seretide", "Combitide", "Seroflo"],
  "Thiocolchicoside 4mg Capsule": ["Muscoril", "Coltrax", "Thio-Relax"],
  "Orphenadrine + Paracetamol Tablet": ["Myogesic", "Muscodol", "Orphenadol", "Relaxon"],
  "Tizanidine 2mg Tablet": ["Sirdalud", "Tizan", "Zanaflex", "Tizanidine Pioneer"],
  "Diclofenac Sodium 50mg Tablet": ["Voltaren", "Cataflam", "Olfen", "Diclogesic", "Diclofenac SDI"],
  "Meloxicam 15mg Tablet": ["Mobic", "Melox", "Mobitil", "Mobicam"],
  "Celecoxib 200mg Capsule": ["Celebrex", "Celoxib", "Celecox"],
  "Pregabalin 75mg Capsule": ["Lyrica", "Gabanet", "Neurolin", "Pregaba", "Pregabalin Pioneer"],
  "Betahistine 16mg Tablet": ["Betaserc", "Microser", "Verserc", "Betahistine SDI"],
  "Vitamin B Complex (B1, B6, B12)": ["Neurobion", "Neurovit", "Milgamma", "Tri-B"],
  "Vitamin D3 50,000 IU Capsule": ["Vitamin D3 50000", "Biodal", "Hi-D", "Decal", "Vidrop"],
  "Iron Polymaltose Complex": ["Maltofer", "Feroglobuline", "Ferose", "Iro-Max"],

  // --- GI & CONSTIPATION ---
  "Lactulose": ["Duphalac", "Ezilax", "Lactu"],
  "Bisacodyl": ["Dulcolax", "Laxocodyl"],
  "Senna": ["Senokot", "Pursennid"],
  "Senna + Ispaghula": ["Agiolax"],
  "Macrogol": ["Movicol"],
  "Ispaghula Husk": ["Fybogel", "Mucofalk"],
  "Sodium Picosulfate": ["Laxoberal", "Skilax"],
  "Glycerin": ["Glycerin Suppositories"],
  
  // --- Hemorrhoids ---
  "Diosmin / Hesperidin": ["Daflon 500mg", "Daflon"],
  "Tribenoside / Lidocaine": ["Procto-Glyvenol"],
  "Cinchocaine / Hydrocortisone": ["Proctosedyl", "Scheriproct"],
  "Lupinus / Vateria / Mentha / Aloe": ["Neo-Healar"],
  "Bismuth Subgallate / Zinc Oxide / Hydrocortisone": ["Anusol"],
  "Policresulen / Cinchocaine": ["Faktu"],

  // --- MEDICAL SHAMPOOS & CLEANSERS ---
  "Ketoconazole Shampoo": ["Nizoral", "Ketorel", "Sebizole", "Kenazole"],
  "Selenium Sulfide Shampoo": ["Selsun Blue", "Selsun", "Selsun Gold"],
  "Coal Tar Shampoo": ["Polytar", "Neutrogena T/Gel", "Pinetarsol"],
  "Ciclopirox Shampoo": ["Stieprox", "Kelual DS"],
  "Emollient Wash": ["QV Gentle Wash", "Cetaphil Cleanser", "CeraVe Hydrating Cleanser", "Lipikar Syndet AP+", "Sebamed Wash"],
  "Benzoyl Peroxide Wash": ["PanOxyl Wash", "Benzac AC Wash", "AcneCide Wash"],
  "Salicylic Acid Cleanser": ["CeraVe SA Smoothening Cleanser", "Neutrogena Oil-Free Acne Wash", "Ionil T"],
  "Chlorhexidine Wash": ["Hibiscrub", "Microshield"],

  // --- DERMATOLOGY SPRAYS ---
  "Minoxidil Spray": ["Regaine", "Rogaine", "Hairgrow", "Alopexy", "Neoxidil", "Minoxidil Spray"],
  "Terbinafine Spray": ["Lamisil Spray", "Terbinafine Spray"],
  "Clotrimazole Spray": ["Canesten Spray", "Candistan Spray"],
  "Panthenol Spray": ["Panthenol Spray", "Bepanthen Spray"],
  "Clobetasol Spray": ["Clobex Spray", "Clobetasol Spray"],
  "Oxytetracycline / Hydrocortisone Spray": ["Terra-Cortril Spray", "Oxycort Spray", "Cortril Spray"],
  "Povidone-Iodine Spray": ["Betadine Dry Powder Spray", "Betadine Spray"],
  "Lidocaine Spray": ["Xylocaine Spray", "Lidocaine Spray"],

  // --- DERMATOLOGY SUPPLEMENTS ---
  "Betamethasone Valerate": ["Betnovate", "Betamethasone", "Betaderm"],
  "Clobetasol Propionate": ["Dermovate", "Clobetasol", "Clobex", "Dermoxin"],
  "Fusidic Acid + Betamethasone": ["Fucicort", "Fucibet", "Zemacort"],
  "Triamcinolone + Antibiotics": ["Kenacomb", "Pandex", "Kenacort-A", "Nystatin Compound"],
  "Tacrolimus": ["Protopic", "Tacrolimus Ointment"],
  "Pimecrolimus": ["Elidel"],
  "Adapalene": ["Differin", "Adapalene Gel"],
  "Adapalene + Benzoyl Peroxide": ["Epiduo"],
  "Tretinoin": ["Acretin", "Retin-A", "Tretinoin Cream", "Avita"],
  "Erythromycin + Zinc": ["Zineryt", "Erythromycin Lotion"],
  "Fusidic Acid": ["Fucidin", "Fucidin Ointment", "Zeta", "Fucidin Cream"],
  "Mupirocin": ["Bactroban", "Mupirocin Ointment", "Supirocin"],
  "Miconazole": ["Daktarin", "Miconaz", "Micot"],
  "Permethrin": ["Lyclear", "Scabene", "Permethrin Cream", "Nix"],
  "Salicylic Acid Paint": ["Duofilm", "Collomack", "Wart-Off"],
  "Dexpanthenol": ["Bepanthen", "Panthenol", "Bepanthen Plus"],

  "Calcipotriol + Betamethasone": ["Enstilar", "Daivobet", "Xamiol"],
  "Amoxicillin 250mg/5ml Suspension": ["Amoxil", "Ospamox", "Julphamox", "Amoxicillin SDI"],
  "Amoxicillin + Clavulanic Acid 228mg/5ml Suspension": ["Augmentin", "Megamox", "Curam", "Klavox", "Amoxiclan"],
  "Amoxicillin + Clavulanic Acid 457mg/5ml Suspension": ["Augmentin Forte", "Megamox Forte", "Curam Forte", "Klavox Forte"],
  "Azithromycin 200mg/5ml Suspension": ["Zithromax", "Azomax", "Zinco", "Azithromycin SDI"],
  "Cefixime 100mg/5ml Suspension": ["Suprax", "Cefix", "Magnum", "Ximacef"],
  "Cefdinir 125mg/5ml Suspension": ["Omnicef", "Dinir", "Cefdin", "Kefnir"],
  "Cephalexin 250mg/5ml Suspension": ["Keflex", "Cephalexin SDI", "Lexin", "Osapex"],
  "Trimethoprim/Sulfamethoxazole 240mg/5ml Suspension": ["Bactrim", "Septrin", "Co-trimoxazole SDI", "Trimethoprim SDI"],
  "Metronidazole 125mg/5ml Suspension": ["Flagyl", "Negazole", "Metronidazole SDI", "Entamizole"],
  "Salbutamol 100mcg Inhaler": ["Ventolin", "Butalin", "Salbutamol SDI"],
  "Salbutamol Nebulizer Solution (Respirator Solution)": ["Ventolin Nebules", "Butalin Solution", "Farcolin"],
  "Fluticasone 50mcg Inhaler": ["Flixotide", "Fluticasone Pioneer"],
  "Budesonide 0.25mg/2ml Nebulizer Suspension": ["Pulmicort", "Miflonide", "Budecort"],
  "Ipratropium Bromide Nebulizer Solution": ["Atrovent", "Apovent"],
  "Normal Saline 0.9% Nasal Drops": ["Apisal", "Ocean Drops", "Salinose", "Nasal Saline SDI"],
  "Xylometazoline 0.05% Nasal Drops": ["Otrivin Pediatric", "Decozal Pediatric", "Xylo-Comod", "Xylometazoline SDI"],
  "Mometasone 50mcg Nasal Spray": ["Nasonex", "Momet", "Nazomac", "Rhinex"]
};